"use strict";

var Utility = function () {
  /** ********************************** */

  /*
  /* DEBOUNCE
  /* Returns a function, that, as long as it continues to be invoked, will not
  /* be triggered. The function will be called after it stops being called for
  /* N milliseconds. If `immediate` is passed, trigger the function on the
  /* leading edge, instead of the trailing.
  /*
  /******************************************************** */
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  /** ********************************** */

  /*
  /* LOG, DEBUG, WARN, ERROR
  /* removes Utility.log, console.debug, console.warn & console.error calls
  /*   in production environment
  /* see: https://gist.github.com/nathansmith/5631193
  /*
  /*
  /* TODO: Use the spread operator (...args) as soon as we introduce TypeScript or stop supporting IE instead of using the arguments object
  /******************************************************** */


  function doLog(method, args) {
    // Debug on localhost
    var host = window.location.hostname;
    var debug = host.match(/localhost|127.0.0.1|dev.acura.corp.possible.com|qa.acura.corp.possible.com/);

    if (debug && console && typeof console[method] === 'function') {
      for (var i in args) {
        console[method](args[i]);
      }
    }
  } // Safely log things


  function log(obj) {
    doLog('log', arguments);
  } // Safely log things in blue


  function logBlue(obj) {
    doLog('debug', arguments);
  } // Safely warn things


  function warn(obj) {
    doLog('warn', arguments);
  } // Safely error things


  function error(obj) {
    doLog('error', arguments);
  }
  /** ********************************** */

  /*
  /* CREATE HTML
  /* Create an HTML string to be inserted into the DOM.
  /*
  /* htmlStr: the HTML to be inserted into a root element
  /* rootElement: the element type to insert the htmlStr
  /*    into (e.g. 'section', 'div', 'ul')
  /* rootClass: (optional) a class name to add to the root element
  /* data: (optional) JSON object of attributes, like HTML 5 "data-*"
  /* attributes.
  /*
  /******************************************************** */


  function createHTML(htmlStr, rootElement, rootClass, attributes) {
    if (rootElement !== null) {
      var fragment = document.createDocumentFragment();
      var newElement = document.createElement(rootElement);
      newElement.innerHTML = htmlStr;

      if (rootClass !== null) {
        newElement.setAttribute('class', rootClass);
      }

      if (attributes) {
        for (var key in attributes) {
          newElement.setAttribute(key, attributes[key]);
        }
      }

      fragment.appendChild(newElement);
      return fragment;
    }

    Utility.error('Utility.createHTML() requires that you send it a root element' + ' (rootElement) to insert the html string (htmlStr) into.');
  }

  function loadSvgInMemory() {
    var svgPath = '/Areas/AcuraPlatform/icons/systems.svg';
    var svgsLoadedEvent = createEvent('svgsLoaded', {});

    if (Acr && Acr.svgLoadedInMemory !== true) {
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        if (this.status.toString() !== '404') {
          Acr.svgLoadedInMemory = true;
          Acr.SvgList = parseSVGString(this.responseText);
          window.dispatchEvent(svgsLoadedEvent);
        }
      };

      xhr.onerror = function (e) {
        Utility.error('loadSVGs() Error:' + JSON.stringify(e));
      };

      xhr.open('get', svgPath, true);
      xhr.send();
    }
  }

  function svgLoader() {
    var scripts = document.getElementsByTagName('script');
    var script = scripts.length ? scripts[scripts.length - 1] : undefined;

    if (script && Acr && Acr.svgLoaded !== true) {
      Acr.svgLoaded = true;

      for (var i in arguments) {
        var xhr = new XMLHttpRequest();

        xhr.onload = function () {
          if (this.status.toString() !== '404') {
            var div = document.createElement('div');
            div.id = 'svgs-container';
            div.innerHTML = this.responseText;
            div.style.display = 'none';
            script.parentNode.insertBefore(div, script);
          }
        };

        xhr.onerror = function (e) {
          Utility.error('Utility.svgLoader() Error:' + JSON.stringify(e));
        };

        xhr.open('get', arguments[i], true);
        xhr.send();
      }
    }
  }

  function parseSVGString(svgString) {
    var parser = new DOMParser();
    var xmlDoc = parser.parseFromString(svgString, 'text/xml');
    var symbolList = xmlDoc.getElementsByTagName('symbol');
    var svgObject = {};

    for (var i in symbolList) {
      if (symbolList[i] && symbolList[i].id && typeof symbolList[i].getAttribute === 'function') {
        svgObject[symbolList[i].id] = {
          viewBox: symbolList[i].getAttribute('viewBox'),
          content: symbolList[i]
        };
      }
    }

    return svgObject;
  }

  function removeClassFromSvg(svg, className) {
    if (svg[0]) {
      removeClass(className, svg[0]);
    }
  }

  function addClassToSvg(svg, className) {
    if (svg[0]) {
      addClass(className, svg[0]);
    }
  }
  /** ********************************** */

  /*
  /* CLASS
  /* Add class name to an element.
  /*
  /* className: the name of the class you want to add
  /* elem: the element you want to add the className on
  /*
  /******************************************************** */


  function addClass(className, elem) {
    if (elem.classList) {
      elem.classList.add(className);
    } else {
      var elementClass = elem.getAttribute('class');

      if (!(elementClass.indexOf(className) > -1)) {
        elem.setAttribute('class', elementClass + ' ' + className);
      }
    }
  }
  /** ********************************** */

  /*
  /* REMOVE CLASS
  /* Remove class name to an element.
  /*
  /* className: the name of the class you want to remove
  /* elem: the element you want to remove the className from
  /*
  /******************************************************** */


  function removeClass(className, elem) {
    if (elem.classList) {
      elem.classList.remove(className);
    } else {
      var elementClass = elem.getAttribute('class');
      var newClass = elementClass.replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');

      if (elementClass.indexOf(className) > -1) {
        elem.setAttribute('class', newClass);
      }
    }
  }
  /** ********************************** */

  /*
  /* HAS CLASS
  /* Returns true if element has class name.
  /*
  /* className: the name of the class you want to remove
  /* elem: the element you want to remove the className from
  /*
  /******************************************************** */


  function hasClass(className, elem) {
    if (elem !== null) {
      return new RegExp('(\\s|^)' + className + '(\\s|$)').test(elem.getAttribute('class'));
    }

    return false;
  }
  /** ********************************** */

  /*
  /* TOGGLE CLASS
  /* Add/remove class name to all elements that have a particular class name.
  /*
  /* className: the name of the class you want to toggle
  /* elementName: the class name of the elements you want to find
  /*   and toggle the className on
  /*
  /******************************************************** */


  function toggleClass(className, elementName) {
    var elements = document.querySelectorAll('.' + elementName);

    for (var i = 0; i < elements.length; i++) {
      var currentElement = elements[i];

      if (currentElement.classList) {
        currentElement.classList.toggle(className);
      } else {
        var classList = currentElement.getAttribute('class').split(' ');
        var existingIndex = classList.indexOf(className);

        if (existingIndex >= 0) {
          classList.splice(existingIndex, 1);
        } else {
          classList.push(className);
        }

        currentElement.setAttribute('class', classList.join(' '));
      }
    }
  }
  /**
   * SLIDE UP
   /* @public
   * Animation to disappear an element.
   * @param Target: the element that is going to disappear
   * @param duration: The duration of the animation, if there's no duration animation will
   *  not be shown.
   *
   */


  function slideUp(target, duration) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight; //eslint-disable-line

    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(function () {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  /**
   * SLIDE DOWN
   * @public
   * Animation to appear an element.
   * @param Target: the element that is going to appear
   * @param durarion: The duration of the animation, if there's no duration animation will
   *  not be shown.
   */


  function slideDown(target, duration) {
    var display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'block';
    target.style.removeProperty('display');
    target.style.display = window.getComputedStyle(target).display === 'none' ? display : window.getComputedStyle(target).display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight; //eslint-disable-line

    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(function () {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  /**
   * SLIDE TOGGLE
   /* @public
   /* Animation to appear/disappear an element.
   /* @param target: the element that is going to appear/disappear
   /* @param duration: The duration of the animation, if there's no duration animation will
   /*  not be shown.
   /*
   */


  function slideToggle(target) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var display = arguments.length > 2 ? arguments[2] : undefined;

    if (window.getComputedStyle(target).display === 'none') {
      slideDown(target, duration, display);
    } else {
      slideUp(target, duration);
    }
  }
  /**
   * Returns the element's siblings.
   * @public
   * @param {HTMLElement} elem The child element with whom the siblings will be found.
   * @param selector The filter to search for an specific class or attribute or id.
   *    If not included, is undefined by default.
   * @return {Object[]} An array of HTMLElement objects that are siblings.
   *
   */


  function siblings(elem) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var siblingList = [];
    var parentChild = elem.parentNode.firstElementChild;

    if (selector === undefined) {
      for (; parentChild; parentChild = parentChild.nextElementSibling) {
        if (parentChild !== elem) {
          siblingList.push(parentChild);
        }
      }
    } else {
      for (; parentChild; parentChild = parentChild.nextElementSibling) {
        if (parentChild !== elem && parentChild.matches(selector)) {
          siblingList.push(parentChild);
        }
      }
    }

    return siblingList;
  }
  /** ********************************** */

  /*
  /* OUTER WIDTH WITH MARGIN
  /* Returns outer width with the calculated margin.
  /*
  /* elem: the element you want to find the width of
  /*
  /******************************************************** */


  function outerWidthWithMargin(elem) {
    var width = elem.offsetWidth;
    var style = getComputedStyle(elem);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
  }
  /** ********************************** */

  /*
  /* MOBILE vs. TABLET vs. DESKTOP Checks.
  /* Returns variables for use with JS code,
  /* which needs to target specific devices based on
  /* resolutions.
  /*
  /******************************************************** */


  function isMobile() {
    // iOS uses screen.width. However the Desktop (mobile size)
    // uses window.innerWidth & not screen.width.
    var isMobile = false;

    if (window.innerWidth < 550) {
      // Desktop Resized Browser Check
      isMobile = true;
    } else if (screen.width < window.innerWidth && screen.width < 550) {
      // iOS Check
      isMobile = true;
    }

    return isMobile;
    /* Here is what's happening.
     * In these scenarios, window.innerWidth is reporting a retina display &
     * isn't the correct pixel value for what we need:
     * iPhone 4 portrait:     window.innerWidth:980,  screen.width:320,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 4 landscape:    window.innerWidth:981,  screen.width:480,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 5 portrait:     window.innerWidth:980,  screen.width:320,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 5 landscape:    window.innerWidth:835,  screen.width:637,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPhone 6 portrait:     window.innerWidth:981,  screen.width:375,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 6 landscape:    window.innerWidth:980,  screen.width:667,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPhone 6+ portrait:    window.innerWidth:980,  screen.width:414,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 6+ landscape:   window.innerWidth:980,  screen.width:736,
     * isMobile:false, isTablet:true,  isDesktop:false
     *
     * In these scenarios, screen.width is incorrect & we need to use the
     * window.innerWidth value:
     * Desktop (full window): window.innerWidth:1600, screen.width:1600,
     * isMobile:false, isTablet:false, isDesktop:true
     * Desktop (tablet size): window.innerWidth:783,  screen.width:1600,
     * isMobile:false, isTablet:true,  isDesktop:false
     * Desktop (mobile size): window.innerWidth:494,  screen.width:1600,
     * isMobile:true,  isTablet:false, isDesktop:false
     */
    // Utility.log('isMobile: ' + isMobile + '|' + window.innerWidth + '|' +
    // screen.width);
  }

  function isTablet() {
    var isTablet = false;

    if (!Utility.isMobile()) {
      // Desktop Resized Browser Check
      if (window.innerWidth >= 550 && window.innerWidth < 1024) {
        isTablet = true;
      } else if (screen.width < window.innerWidth && screen.width >= 550 && screen.width <= 1024) {
        // iOS Check
        isTablet = true;
      }
    }

    return isTablet;
    /*
     * iPad portrait:         window.innerWidth:980,  screen.width:768,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPad landscape:        window.innerWidth:1024, screen.width:1024,
     * isMobile:false, isTablet:false, isDesktop:true
     * iPad mini portrait:    window.innerWidth:980,  screen.width:768,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPad mini landscape:   window.innerWidth:1024, screen.width:1024,
     * isMobile:false, isTablet:false, isDesktop:true
     */
    // Utility.log('isTablet: ' + isTablet + '|' + window.innerWidth + '|'
    // + screen.width);
  }

  function isDesktop() {
    var isDesktop = !!(!Utility.isMobile() && !Utility.isTablet()); // Utility.log('isDesktop: ' + isDesktop + '|' + window.innerWidth + '|'
    // + screen.width);

    return isDesktop;
  }

  function isAndroid() {
    return hasClass('android', document.documentElement);
  }

  var isIE = function isIE() {
    var rv = false;
    var ua;
    var re;

    if (navigator.appName === 'Microsoft Internet Explorer') {
      ua = navigator.userAgent;
      re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');

      if (re.exec(ua) !== null) {
        rv = true;
      }
    } else if (navigator.appName === 'Netscape') {
      ua = navigator.userAgent;
      re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
      var re2 = new RegExp('Edge/([0-9]{1,}[.0-9]{0,})');

      if (re.exec(ua) !== null || re2.exec(ua) !== null) {
        rv = true;
      }
    }

    return rv;
  };

  var isEdge = function isEdge() {
    return hasClass('ieedge', document.documentElement);
  };

  function isWinEdge() {
    return navigator.platform.toLowerCase().indexOf('win') !== -1 && navigator.userAgent.toLowerCase().indexOf('edge') !== -1;
  }
  /*
   * This is a hack to enable the :active state on iphone
   * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
   */


  function enableActive() {
    if (isMobile()) {
      document.documentElement.addEventListener('touchstart', function () {});
    }
  }
  /*
   * This is a hack to enable acr-focus-disabled and show the focus state only with keyboard users
   */


  function focusEnable() {
    window.addEventListener('keydown', function (event) {
      var key = event.key || event.keyCode;

      if (key === 9 || key === 'Tab') {
        document.body.classList.remove('acr-focus-disabled');
      }
    });
  }

  function focusDisable() {
    document.addEventListener('click', function () {
      document.body.classList.add('acr-focus-disabled');
    });
  }
  /*
  * This attach a calback function to be trigger when
  * all images are loaded inside an element.
  *
  * It only works for <img tag.
  *
  * TODO: Remove this function once the MultiFeatures component has been migrated to Vanilla JS
  */


  function imagesReady(element, callback) {
    $(element).each(function (index, el) {
      var $images = $('img', el);
      var totalImages = $images.length;
      var count = 0;
      $images.on('load', function () {
        if (++count === totalImages) {
          $images.off('load');
          callback(el);
        }
      });
    });
  }

  function prefix() {
    var styles = window.getComputedStyle(document.documentElement, '');
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
    var dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + pre + ')', 'i'))[1];
    return {
      dom: dom,
      lowercase: pre,
      css: '-' + pre + '-',
      js: pre[0].toUpperCase() + pre.substr(1)
    };
  }

  function getTanDeg(deg) {
    var rad = deg * Math.PI / 180;
    return Math.tan(rad);
  }

  function getMonthNameFromNbr(nbr) {
    // returns full name of month based on nbr (January for 1);
    var monthNameArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNameArr[nbr - 1];
  }

  function isIE11() {
    return Utility.hasClass('ie11', document.documentElement) || window.navigator.userAgent.match(/MSIE|Trident/) !== null;
  }

  function isIOS() {
    return Utility.hasClass('ios', document.documentElement);
  }

  function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    var isSafari = false;

    try {
      isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      }(!window.safari || safari.pushNotification);
    } catch (err) {
      Utility.error(JSON.stringify(err));
    }

    isSafari = isSafari || ua.indexOf('safari') !== -1 && !(ua.indexOf('chrome') !== -1) && ua.indexOf('version/') !== -1;
    return isSafari;
  }

  function getClickCoords(evt) {
    var posX;
    var posY;

    if (evt.pageX || evt.pageY) {
      posX = evt.pageX;
      posY = evt.pageY;
    } else {
      posX = evt.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posY = evt.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    return {
      x: posX,
      y: posY
    };
  }
  /** ********************************** */

  /*
  /* initLazyLoadingIO
  /* Triggered when element is nearly to be visible using IntersectionObserver
  /*
  /******************************************************** */


  function initLazyLoadingIO(elements, callbackFn) {
    var options = {
      root: null,
      rootMargin: screen.height / 2 + 'px'
    };

    if ('IntersectionObserver' in window) {
      var lazyElementObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyElement = entry.target;

            if (callbackFn) {
              callbackFn(lazyElement);
            }

            lazyElementObserver.unobserve(lazyElement);
          }
        });
      }, options);
      elements.forEach(function (lazyElement) {
        lazyElementObserver.observe(lazyElement);
      });
    }
  }
  /** ********************************** */

  /*
  /* initDeferLoading
  /* Triggered when page has been downloaded
  /*
  /******************************************************** */


  function initDeferLoading(callbackFn) {
    window.addEventListener('load', function () {
      callbackFn();
    });
  } // Create a render event


  function createEvent(eventName, data) {
    var event;

    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent(eventName, {
        bubbles: true,
        detail: data
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, false, data);
    }

    return event;
  }

  function isElementInView(elem, fullyInView, offset) {
    if (elem) {
      var pageTop = window.scrollY ? window.scrollY : window.pageYOffset;
      var pageBottom = pageTop + window.innerHeight + (offset || 0);
      var elementTop = elem.getBoundingClientRect().top + window.pageYOffset;
      var elementBottom = elementTop + Number(window.getComputedStyle(elem).height.replace('px', ''));
      var inView;
      pageTop -= offset || 0;

      if (fullyInView === true) {
        inView = pageTop < elementTop && pageBottom > elementBottom;
      } else {
        inView = elementTop <= pageBottom && elementBottom >= pageTop;
      }

      return inView;
    }
  }

  function getCurrentBreakpoint() {
    var breakpoint;
    var width = window.innerWidth; // get the size of the image

    if (width < Constants.breakpoints.sm) {
      breakpoint = 'xsmall';
    } else if (width < Constants.breakpoints.lg) {
      breakpoint = 'medium';
    } else if (width <= Constants.breakpoints.xl) {
      breakpoint = 'large';
    } else {
      breakpoint = 'xlarge';
    }

    return {
      breakpoint: breakpoint,
      ratio: window.devicePixelRatio <= 1 ? 1 : 2
    };
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    }

    return uri + separator + key + '=' + value;
  }

  function formatPhone(phone) {
    var numbers = phone.replace(/\D/g, '');
    var char = {
      0: '(',
      3: ') ',
      6: '-'
    };
    var formattedPhone = '';
    var i;

    for (i = 0; i < numbers.length; i++) {
      formattedPhone += (char[i] || '') + numbers[i];
    }

    return formattedPhone;
  }
  /**
   * Get the url parameters.
   * @return {Object} Parameters from the URL.
   */


  function getUrlParameters() {
    var regex = /(\?|&)([^=]+)=([^&]+)/gm;
    var urlParams = window.location.search;
    var match;
    var params = {};

    while ((match = regex.exec(urlParams)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (match.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      var key = match[2];
      var value = match[3];
      params[key] = value;
    }

    return params;
  }
  /**
   * Get the url parameter value, depending on the parameter name.
   * @param {String} parameter Parameter name to look for.
   * @return {String} Parameter value from the parameter being searched for.
   */


  function getUrlParameterValue(parameter) {
    var params = getUrlParameters();

    for (var key in params) {
      if (key.toLowerCase() === parameter.toLowerCase()) {
        return params[key];
      }
    }

    return false;
  }
  /**
   * Set the url parameter value, depending on the parameter name.
   * @param {String} parameter Parameter name to look for.
   * @param {String} newVal New value for the url parameter.
   * @return {String} Url value with the new/modifed parameter value.
   */


  function setUrlParameterValue(url, parameterKey, parameterValue, updateUrl) {
    var urlQueryString;
    var key = encodeURIComponent(parameterKey);
    var value = encodeURIComponent(parameterValue);
    var baseUrl = url.split('?')[0];
    var newParam = key + '=' + value;
    var params = '?' + newParam;

    if (url.split('?')[1] === undefined) {
      // if there are no query strings, make urlQueryString empty
      urlQueryString = '';
    } else {
      urlQueryString = '?' + url.split('?')[1];
    } // If the "search" string exists, then build params from it


    if (urlQueryString) {
      var updateRegex = new RegExp('([?&])' + key + '[^&]*');
      var removeRegex = new RegExp('([?&])' + key + '=[^&;]+[&;]?');

      if (typeof value === 'undefined' || value === null || value === '') {
        // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, '$1');
        params = params.replace(/[&;]$/, '');
      } else if (urlQueryString.match(updateRegex) !== null) {
        // If param exists already, update it
        params = urlQueryString.replace(updateRegex, '$1' + newParam);
      } else if (urlQueryString === '') {
        // If there are no query strings
        params = '?' + newParam;
      } else {
        // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    } // no parameter was set so we don't need the question mark


    params = params === '?' ? '' : params;

    if (updateUrl) {
      var hash = window.location.hash;
      window.history.replaceState({}, null, baseUrl + params + hash);
    }

    return baseUrl + params;
  }

  function reevaluatePictureFill() {
    if (isIE11()) {
      picturefill({
        reevaluate: true
      });
    }
  }
  /**
   * Generic function to set a cookie. When cookie must expires with the session, expDays should be null or zero
   * @param {String} key.
   * @param {String} value.
   * @param {Number} expDays expiration days that will be used to create a date. When no expiration date es necessary
   *                 expDays should be zero or null
   *
   */


  function setCookie(key, value, expDays) {
    var expires = ';';

    if (expDays && expDays > 0) {
      var d = new Date();
      d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
      expires = ';expires=' + d.toUTCString() + ';';
    }

    document.cookie = key + '=' + value + expires + 'path=/';
  }
  /*
  * Generic function to obtain a cookie value.
  * @param {String} key.
  */


  function getCookie(name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  }

  function validateZipcode(zipValue, successCallback, errorCallback) {
    var zipUrl = '/platform/api/v1/address/citystate/' + zipValue;
    var validZipcode = new RegExp(/^\d{5}$/);
    var isZipcodeRegexApproved = zipValue.match(validZipcode);

    if (isZipcodeRegexApproved) {
      var request = new XMLHttpRequest();
      request.open('GET', zipUrl);

      request.onload = function () {
        if (request.status === 200) {
          var data = JSON.parse(request.response);
          var zipData = data && data[zipValue] ? data[zipValue] : false;
          var result = zipData !== null && zipData.address && zipData.address.countryRegion === 'United States';

          if (result) {
            successCallback();
          } else {
            errorCallback();
          }
        } else {
          errorCallback();
        }
      };

      request.onerror = function () {
        errorCallback();
      };

      request.send(); // send the request
    } else {
      errorCallback();
    }
  }
  /**
   * Scrolls the page to the desired position on the required duration.
   * @param {Int} targetPositon Position to scroll to.
   * @param {Int} duration Duration of the scroll to do.
   */


  function scrollTo(targetPositon, duration) {
    var startPosition = window.pageYOffset;
    var distance = targetPositon - startPosition;
    var startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);

      if (timeElapsed <= duration) {
        requestAnimationFrame(animation);
      } else {
        window.scrollTo(0, targetPositon);
      }
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }
  /**
   * Returns the first element based on the given class.
   * @param {string} className Position to scroll to.
   */


  function getFirstElementFromClass(className) {
    return document.getElementsByClassName(className)[0];
  }
  /**
   * Helper to fire an event on an element.
   * @param  {HTMLElement} elem   Element to trigger event.
   * @param  {String} event   Event name.
   */


  function fireEvent(elem, event) {
    var evt;

    if (document.createEventObject) {
      // dispatch for IE
      evt = document.createEventObject();
      return elem.fireEvent('on' + event, evt);
    } // dispatch for firefox + others


    evt = document.createEvent('HTMLEvents');
    evt.initEvent(event, true, true); // event type,bubbling,cancelable

    return !elem.dispatchEvent(evt);
  }
  /**
   * Returns the domain of a url.
   * @param {string} url Url direction.
   */


  function getUrlDomain(url) {
    var domain = '';

    if (url) {
      domain = url.match(/:\/\/(.[^/]+)/)[1];
    }

    return domain;
  }
  /**
   * Adds an intersection observer to an HTMLObject so that when this HTMLObject enters the visual screen area,
   * the passed callback function parameter is called.
   * @param {HTMLElement} observedObject HTMLElement object.
   * @param {callback} callback Function.
   */


  function addIntersectionObserver(observedObject, callback) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        callback(observedObject);
      }
    });
    observer.observe(observedObject);
  }
  /**
   * It's the Jquery Function index() alike on Vanilla JS
   * @param {HTMLElement} elem is the one who's index will be return.
   * @returns index of element.
   */


  function index(elem) {
    var index = [].slice.call(elem.parentNode.children).indexOf(elem);
    return index;
  }
  /**
  * It's the Jquery Function on() alike on Vanilla JS
  * @param {HTMLElement} ele is the one who's function will be apply.
  * @param evt is the event who will trigger the function.
  * @param sel is the selector.
  */


  function delegate(el, evt, sels, handler) {
    var selectors = sels.split(',');
    el.addEventListener(evt, function (event) {
      var t = event.target;

      while (t && t !== this) {
        selectors.forEach(function (sel) {
          if (t.matches(sel)) {
            handler.call(t, event);
          }
        });
        t = t.parentNode;
      }
    });
  }
  /**
  * It's the Jquery Function next() alike on Vanilla JS
  * @param {HTMLElement} el is the one who's function will be apply.
  * @param sel is the selector
  * @param sel is the selector.
  */


  function next(el, selector) {
    // Get the next element
    var nextElem = el.nextElementSibling; // If there's no selector, return the next element

    if (!selector) {
      return nextElem;
    } // Otherwise, check if the element matches the selector


    if (nextElem && nextElem.matches(selector)) {
      return nextElem;
    } // if it's not a match, return null


    return null;
  }
  /**
  * It's the Jquery Function prev() alike on Vanilla JS
  * @param {HTMLElement} el is the one who's function will be apply.
  * @param sel is the selector
  * @param sel is the selector.
  */


  function prev(el, selector) {
    // Get the next element
    var prevElem = el.previousElementSibling; // If there's no selector, return the next element

    if (!selector) {
      return prevElem;
    } // Otherwise, check if the element matches the selector


    if (prevElem && prevElem.matches(selector)) {
      return prevElem;
    } // if it's not a match, return null


    return null;
  } // Expose the following variables and functions


  return {
    // variables
    // methods
    debounce: debounce,
    log: log,
    logBlue: logBlue,
    warn: warn,
    error: error,
    toggleClass: toggleClass,
    addClass: addClass,
    removeClass: removeClass,
    svgLoader: svgLoader,
    loadSvgInMemory: loadSvgInMemory,
    hasClass: hasClass,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isAndroid: isAndroid,
    isIE: isIE,
    isEdge: isEdge,
    isWinEdge: isWinEdge,
    outerWidthWithMargin: outerWidthWithMargin,
    siblings: siblings,
    createHTML: createHTML,
    enableActive: enableActive,
    focusDisable: focusDisable,
    focusEnable: focusEnable,
    prefix: prefix,
    getTanDeg: getTanDeg,
    getMonthNameFromNumber: getMonthNameFromNbr,
    isIE11: isIE11,
    isIOS: isIOS,
    isSafari: isSafari,
    isElementInView: isElementInView,
    initLazyLoadingIO: initLazyLoadingIO,
    initDeferLoading: initDeferLoading,
    createEvent: createEvent,
    getCurrentBreakpoint: getCurrentBreakpoint,
    updateQueryStringParameter: updateQueryStringParameter,
    formatPhone: formatPhone,
    index: index,
    slideDown: slideDown,
    slideUp: slideUp,
    slideToggle: slideToggle,
    imagesReady: imagesReady,
    delegate: delegate,
    next: next,
    prev: prev,
    // This line comes from Shopping Tools Branch
    getClickCoordinates: getClickCoords,
    getUrlParameters: getUrlParameters,
    getUrlParameterValue: getUrlParameterValue,
    setUrlParameterValue: setUrlParameterValue,
    reevaluatePictureFill: reevaluatePictureFill,
    getCookie: getCookie,
    setCookie: setCookie,
    validateZipcode: validateZipcode,
    scrollTo: scrollTo,
    removeClassFromSvg: removeClassFromSvg,
    addClassToSvg: addClassToSvg,
    getFirstElementFromClass: getFirstElementFromClass,
    fireEvent: fireEvent,
    getUrlDomain: getUrlDomain,
    addIntersectionObserver: addIntersectionObserver
  };
}();
"use strict";

var Acr = Acr || {};

Acr.CampaignManager = function () {
  var campaignKeyNames;
  var Utility;

  function saveCampaignInCookie() {
    for (var i = 0; i < campaignKeyNames.length; i++) {
      if (Utility.getUrlParameterValue(campaignKeyNames[i])) {
        Utility.setCookie('campaignName', Utility.getUrlParameterValue(campaignKeyNames[i]), 0);
      }
    }
  }

  function init() {
    campaignKeyNames = ['cid', 'cmpid'];
    Utility = window.Utility || {};
    saveCampaignInCookie();
  }
  /**
  * Set the campaign name based on a URL attribute.
  * @param {String} text data to append the campaing name obtained from the URL.
  * @return {String} formatted data with the campaign name appended.
  */


  function appendCampaignName(text) {
    var result = text;
    var campaignNameValue = Utility.getCookie('campaignName');

    if (campaignNameValue) {
      result += '&campaignName=' + campaignNameValue;
    }

    return result;
  }

  return {
    init: init,
    appendCampaignName: appendCampaignName
  };
}();
"use strict";

Acr = window.Acr || {};

Acr.DeepLinking = function () {
  var Utility = window.Utility || {};
  var navHelperInitialized = false;
  var hasDeepLink = false;

  var calculateOffset = function calculateOffset(elementScrollTo) {
    var isOnLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    Utility = Utility || window.Utility;
    Utility.log('DeepLinking.js scrollDeepLink');
    var wrapper = Utility.getFirstElementFromClass('wrapper');
    var mainNav = Utility.getFirstElementFromClass('acr-nav');
    var stickyNav = Utility.getFirstElementFromClass('acr-sticky-nav');
    var mlpHeader = Utility.getFirstElementFromClass('mlp-nav');
    var gryCompNav = Utility.getFirstElementFromClass('rzf-gry-navigation-links-container'); // TODO: Remove this after the gry-navigation component is removed from the site

    var accordionNav = Utility.getFirstElementFromClass('js-acr-accordion-navigation'); // Getting current header, stickyNav, navbar and accordionNav height

    var offsetMainNav = mainNav ? mainNav.offsetHeight : 0;
    var offsetMlpNav = mlpHeader ? mlpHeader.offsetHeight : 0;
    var offsetAccNav = accordionNav ? accordionNav.offsetHeight : 0;
    var offsetStickyNav = 0; // Getting gry component nav size - TODO: this will be deprecated

    var gryCompNavList = gryCompNav ? gryCompNav.firstElementChild : null;
    var gryOffset = gryCompNavList ? gryCompNavList.offsetHeight : 0;
    var offsetAccNavOrGryNav = offsetAccNav === 0 ? gryOffset : offsetAccNav; // Set size of main header

    var offsetMainHeader = offsetMainNav;

    if ((offsetMlpNav || offsetAccNavOrGryNav) && !wrapper.classList.contains('expanded-nav')) {
      offsetMainHeader = 0;
    } // Checkig for sticky nav only on desktop, due to on mobile as it started expanded it generate unnecesary space


    if (stickyNav) {
      var stickyItem = stickyNav.querySelector('.acr-sticky-nav__item');
      var stickyItemHeight = stickyItem ? stickyItem.offsetHeight : 0;
      offsetStickyNav = !Utility.isDesktop() ? stickyNav.offsetHeight + stickyItemHeight : stickyNav.offsetHeight;
    }

    var offset = elementScrollTo.offsetTop - offsetMainHeader - offsetMlpNav - offsetAccNavOrGryNav - offsetStickyNav;

    if (isOnLoad) {
      offset -= offsetMainHeader;
    }

    return offset;
  };

  var inPageDeepLink = function inPageDeepLink(deepLinkTo, offsetParam, navSelectorParam) {
    if (deepLinkTo) {
      var hashSelector = !Utility.isIE11() ? '[id="' + deepLinkTo + '" i]' : '[id="' + deepLinkTo + '"]';
      var elementScrollTo = document.querySelector(hashSelector);

      if (elementScrollTo) {
        var offset = calculateOffset(elementScrollTo);
        var navSelector = navSelectorParam.replace('.', '');
        var navSelectorItem = Utility.getFirstElementFromClass(navSelector);
        var navSelectorSize = navSelectorItem ? navSelectorItem.offsetHeight : 0;
        offset -= navSelectorSize;
        Utility.scrollTo(offset, 750);
      }
    }
  };

  var deepLink = function deepLink(initial) {
    var isOnLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Search for deeplink parameter to activate the deep linking functionality
    var params = new URLSearchParams(window.location.search);
    var deepLinkParam = params.get('deeplink'); // Search for hash to support old functionality

    var hash = window.location.hash.replace('#', '');
    var deepLinkTo = hash || deepLinkParam;

    if (deepLinkTo) {
      var hashSelector = !Utility.isIE11() ? '[id="' + deepLinkTo + '" i]' : '[id="' + deepLinkTo + '"]';
      var elementScrollTo = document.querySelector(hashSelector);

      if (elementScrollTo && initial) {
        hasDeepLink = true;
        var offset = calculateOffset(elementScrollTo, isOnLoad);

        if (isOnLoad) {
          Utility.scrollTo(offset, 1000);
        } else {
          Utility.scrollTo(offset, 750);
        }
      }
    }

    if (!navHelperInitialized) {
      navHelperInitialized = true;
      Acr.NavHelper.init();
    }
  };

  var initDeepLinkEvent = function initDeepLinkEvent() {
    // Add event listener for internal hash links in the same page
    var btns = document.querySelectorAll('[data-deep-link]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        var internalDeepLink = evt.currentTarget.dataset.deepLink;
        var hashSelector = !Utility.isIE11() ? '[id="' + internalDeepLink + '" i]' : '[id="' + internalDeepLink + '"]';
        var elementScrollTo = document.querySelector(hashSelector);

        if (elementScrollTo) {
          var offset = calculateOffset(elementScrollTo);
          Utility.scrollTo(offset, 750);
        } else {
          window.location = evt.currentTarget.href;
        }
      });
    });
  };

  var initByElement = function initByElement(deeplinkTo) {
    if (deeplinkTo) {
      var offset = calculateOffset(deeplinkTo);
      Utility.scrollTo(offset, 750);
    }
  };

  var getTabIdHashElement = function getTabIdHashElement(tabContainer) {
    var hashTab = null;

    if (location.hash) {
      var hash = location.hash.replace('#', '');
      var hashSelector = !Utility.isIE11() ? '.js-tab-link[tab-id="' + hash + '" i]' : '.js-tab-link[tab-id="' + hash + '"]';
      hashTab = tabContainer.querySelector(hashSelector);

      if (hashTab) {
        initByElement(tabContainer);
      }
    }

    return hashTab;
  };

  var init = function init() {
    // Reset scroll top - Prevent automatic browser scroll on refresh
    history.scrollRestoration = 'manual';
    window.addEventListener('unload', function () {
      if (hasDeepLink) {
        window.scrollTo(0, 0);
      }
    });
    initDeepLinkEvent();
    Utility.log('DeepLinking.js inited');

    try {
      if (document.readyState === 'interactive') {
        deepLink(true, true);
      } else {
        document.onreadystatechange = function () {
          if (document.readyState === 'interactive') {
            deepLink(true, true);
          }
        };
      }
    } catch (e) {
      Utility.error(e.message);
    }
  };

  return {
    init: init,
    inPageDeepLink: inPageDeepLink,
    initByElement: initByElement,
    getTabIdHashElement: getTabIdHashElement
  };
}();
"use strict";

var IconSwitch = function () {
  Utility.log('IconSwitch.js loaded');

  function init() {
    Utility.log('IconSwitch.js inited');

    try {
      var iconList;
      iconList = $('.acr-icon-change-js');
      bindEvent(iconList);
    } catch (e) {
      Utility.error(e.message);
    }
  }

  function bindEvent(iconList) {
    for (var x = 0; x < iconList.length; x++) {
      var item;
      item = iconList[x];

      if (item.dataset.acrIconChangeH) {
        var inSvg;
        var outSvg;
        inSvg = item.dataset.acrIconChangeH;
        outSvg = $(item).find('.acr-icon use').attr('xlink:href');
        bindHover(item, inSvg, outSvg);
      }
    }
  }

  function bindHover(element, inSvg, outSvg) {
    var $element;
    $element = $(element);
    $element.on('mouseenter', function () {
      $element.find('.acr-icon use').attr('xlink:href', inSvg);
    });
    $element.on('mouseleave', function () {
      $element.find('.acr-icon use').attr('xlink:href', outSvg);
    });
  } // Expose the following variables and functions


  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};
/**
  * @desc Checks for Pre Hidden elements and sets the functionality to show the hidden component
*/

Acr.ShowPreHiddenComponents = function () {
  var showRightNow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var preHiddenElements = document.querySelectorAll('[pre-hidden]');
  preHiddenElements.forEach(function (preHiddenElement) {
    var duration = preHiddenElement.getAttribute('pre-hidden') || 3000;

    if (showRightNow) {
      preHiddenElement.removeAttribute('pre-hidden');
    } else {
      setTimeout(function () {
        preHiddenElement.removeAttribute('pre-hidden');
      }, duration);
    }
  });
};

Acr.ShowPreHiddenComponents(false);
"use strict";

var ResponsiveBackground = function () {
  var currentBreakpoint;
  Utility.log('ResponsiveBackground.js loaded');
  /* * **************************************************************************
   * EXECUTE
   * Loops through the elements in the site that contain the class name of
   * 'acr-responsive-background-behavior' and runs the render() function.
   * The function expects to get 6 images from the data attributes of the
   * element in the form of 'data-img-small-1x' The size identifiers are
   * small, medium and large. The pixel dfensity identifier is 1 and 2.
   * For example you can setup this responsive background behavior like this:
     <section class="acr-responsive-background-behavior"
        data-img-xsmall-1x="../../img/awards-xsmall-1x.jpg"
        data-img-xsmall-2x="../../img/awards-xsmall-2x.jpg"
        data-img-medium-1x="../../img/awards-medium-1x.jpg"
        data-img-medium-2x="../../img/awards-medium-2x.jpg"
        data-img-large-1x="../../img/awards-large-1x.jpg"
        data-img-large-2x="../../img/awards-large-2x.jpg"
        data-img-xlarge-1x="../../img/awards-xlarge-1x.jpg"
        data-img-xlarge-2x="../../img/awards-xlarge-2x.jpg"
     </section>
   *************************************************************************** */

  function execute() {
    var $element;
    $('.acr-responsive-background-behavior[responsified!="true"]:not(.shown)').each(function () {
      // Will only execute if the element is in view, i.e.: lazy loading
      if (Utility.isElementInView(this, false, 300) // Don't Lazy Load while on Sitecore's Experience Editor
      || window.location.href.match(/sc_mode/) !== null) {
        $element = $(this);
        render(this);
        $element.addClass('shown');

        if ($element.hasClass('acr-responsive-background-setheight')) {
          setHeight(this);
        } else if (Grid && $element.hasClass('hmc-grid-100')) {
          Grid.resize();
        }

        if ($element.hasClass('broadcast-image-load')) {
          broadcastImageLoad(this, $element.data('type'));
        }
      }
    });
  }

  function render(element, attribute) {
    try {
      var bkg;
      var currentBreakpoint;
      var currentRatio;
      var attr = '';
      var $element;
      $element = $(element);

      if (attribute) {
        if (Object.prototype.toString.call(attribute) === '[object String]') {
          attr = attribute;
        } else {
          Utility.error('ResponsiveBackground.apply(selector, attribute) is ' + 'expecting a String as an attribute but received a ' + Object.prototype.toString.call(attribute));
        }
      } else {
        currentBreakpoint = Utility.getCurrentBreakpoint();
        currentRatio = currentBreakpoint.ratio; // TODO: REMOVE THIS IF WHEN RETINA APPROACH BECOMES GLOBAL

        if ($(element).data('retina') === 'off') {
          currentBreakpoint.ratio = 1;
        }

        attr = 'data-img-' + currentBreakpoint.breakpoint + '-' + currentBreakpoint.ratio + 'x';
      } // get the data attribute from the section element


      bkg = $element.attr(attr);

      if (bkg) {
        // check to make sure the image isn't the same so we're not
        // unnecessarily calling the css() function from jQuery
        if ($element.data('acrVarCurrentResponsiveBkg') !== bkg) {
          $element.data('acrVarCurrentResponsiveBkg', bkg);
          $element.css('background-image', 'url(\'' + bkg + '\')');
        }
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }
  /* * **************************************************************************
   * SETHEIGHT
   * If the element has the class "acr-responsive-background-setheight
   * then set its height automatically remaining the image aspect ratio
     <section
     class="
       acr-responsive-background-behavior
       acr-responsive-background-setheight
       "
       ...
     </section>
   *************************************************************************** */


  function setHeight(element) {
    try {
      var width;
      var height;
      var widthEle;
      var heightEle;
      var ratio;
      var imageSrc = element.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
      var image;

      if (imageSrc && imageSrc !== '') {
        image = new Image();

        image.onload = function () {
          width = image.width;
          height = image.height;
          ratio = width / height;
          widthEle = $(element).width();
          heightEle = Math.floor(widthEle / ratio);

          if (heightEle !== $(element).height()) {
            $(element).css({
              height: heightEle + 'px'
            });
          }
        };

        image.src = imageSrc;
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }

  function broadcastImageLoad(element, type) {
    try {
      var image;
      var imageSrc = element.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];

      if (imageSrc && imageSrc !== '') {
        image = new Image();

        image.onload = function () {
          $(document).trigger(type, imageSrc);
        };

        image.src = imageSrc;
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }

  function init() {
    try {
      // only call resize function every 250ms if multiple resize events are
      // detected so that the browser doesn't freeze from overloaded event calls
      var resizeFunc = Utility.debounce(function () {
        var checkBreakpoint = Utility.getCurrentBreakpoint();

        if (checkBreakpoint.breakpoint !== currentBreakpoint) {
          $('.acr-responsive-background-behavior[responsified!="true"]').removeClass('shown');
          currentBreakpoint = checkBreakpoint.breakpoint;
          execute();
        }
      }, 250); // onscroll - debounced 100ms

      $(window).on('scroll', Utility.debounce(function () {
        execute();
      }, 100));
      $(window).resize(resizeFunc); // add resize handler to window

      execute();
    } catch (e) {
      Utility.error('ResponsiveBackground.init() can only be called after ' + 'DOMContentLoaded Event is triggered. Try calling from Main.js ready ' + 'function. Error: ' + e.message);
    }
  } // Expose the following variables and functions


  return {
    execute: execute,
    setHeight: setHeight,
    init: init
  };
}();
"use strict";

var Acr = Acr || {};
/**
  * @desc Gets the Trim Package Names info from window.Acr.TrimPackageNamesData
*/

Acr.TrimPackageNames = function () {
  function getTrimPackageName(modelId) {
    return Acr.TrimPackageNamesData[modelId] || '';
  }

  return {
    getTrimPackageName: getTrimPackageName
  };
}();
"use strict";

/* global Vimeo */
var Acr = Acr || {};

Acr.VimeoPlayerManager = function () {
  function vimeoPlayerObject(sourceId, playerContainer, autoplay, background, loop, muted) {
    var player = this;
    var vimeoOptions = {
      id: sourceId,
      autoplay: autoplay,
      background: background,
      controls: false,
      loop: loop,
      responsive: true,
      muted: muted
    };
    player.playerObject = new Vimeo.Player(playerContainer, vimeoOptions);

    player.play = function () {
      if (player.playerObject.play) {
        player.playerObject.play();
      }
    };

    player.pause = function () {
      if (player.playerObject.pause) {
        player.playerObject.pause();
      }
    };
  }

  return {
    vimeoPlayerObject: vimeoPlayerObject
  };
}();
"use strict";

var Acr = Acr || {};

Acr.YouTubeManager = function () {
  var players = [];
  var videoCount = 0;
  var APILoaded = false;
  var videoPercentages;

  window.setVideoPercentages = function () {
    videoPercentages = [100, 75, 50, 25, 10];
  };

  function loadAPI() {
    if (!APILoaded) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      APILoaded = true;
    }
  }

  function initPlayers() {
    var options = {
      bladeContainerSelector: '[video-blade]',
      triggerSelector: '[video-trigger]',
      instanceIdAttribute: 'video-id',
      instanceSourceAttribute: 'video-source',
      targetAreaSelector: '[video-target]',
      targetAreaWrapperSelector: '[video-target-container]',
      targetAreaCloseSelector: '[video-action-close]'
    };
    var playerElements = $(options.bladeContainerSelector);

    if (playerElements.length) {
      for (var i = 0; i < playerElements.length; i++) {
        var blade = $(playerElements[i]);
        var trigger = blade.find(options.triggerSelector);
        var close = blade.find(options.targetAreaCloseSelector);
        var target = blade.find(options.targetAreaSelector);
        var container = blade.find(options.targetAreaWrapperSelector);
        var thisPlayer = new YouTubePlayerObject(trigger.attr(options.instanceSourceAttribute), close, target, container, 0);
        thisPlayer.init();
        players.push(thisPlayer);
      }
    }
  }

  function YouTubePlayerObject(sourceId, closeButton, componentTarget, componentContainer, autoplay) {
    var player = this;
    player.id = 'youTubeEmbed_' + sourceId + '_' + videoCount;
    player.sourceId = sourceId;
    player.autoplay = autoplay;
    player.$closeButton = closeButton;
    player.$componentTarget = componentTarget;
    player.$componentContainer = componentContainer;
    player.playerObject = null;
    player.initialized = false;
    player.options = {
      videoOpenClass: 'video-open'
    };
    videoCount += 1;

    player.init = function () {
      // Append dummy div and assign ID
      var videoDomElement = $('<div>', {
        id: player.id
      });
      player.$componentContainer.append(videoDomElement); // Initialize IFRAME Embedding using YT API

      if (typeof YT !== 'undefined') {
        player.playerObject = new YT.Player(player.id, {
          videoId: player.sourceId,
          height: '100%',
          width: '100%',
          playerVars: {
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            wmode: 'opaque',
            iv_load_policy: 3,
            autoplay: player.autoplay
          },
          events: {
            onReady: player.onPlayerReady,
            onStateChange: onPlayerStateChange
          }
        });
        player.initialized = true;
      }
    };

    player.onPlayerReady = function () {
      player.bindEvents();
    };

    player.bindEvents = function () {
      if (player.$closeButton) {
        player.$closeButton.on('click', function (event) {
          player.$componentTarget.removeClass(player.options.videoOpenClass);
          player.stop();
        });
      }
    };

    player.play = function () {
      clearInterval(window.percentageInterval);

      if (player.playerObject.pauseVideo) {
        player.playerObject.playVideo();
      }
    };

    player.pause = function () {
      clearInterval(window.percentageInterval);

      if (player.playerObject.pauseVideo) {
        player.playerObject.pauseVideo();
      }
    };

    player.stop = function () {
      clearInterval(window.percentageInterval);
      window.setVideoPercentages();

      if (player.playerObject.stopVideo) {
        player.playerObject.stopVideo();
      }
    };
  }

  function onPlayerStateChange(event) {
    // checks if tracking data is present
    if ($(event.target.getIframe()).parent().attr('data-video-tracking')) {
      var trackingData = JSON.parse($(event.target.getIframe()).parent().attr('data-video-tracking').split("'").join('"'));

      if (trackingData['Video Metadata'].video_title) {
        trackingData['Video Metadata'].video_title = event.target.getVideoData().title;
      }

      if (trackingData['Video Metadata'].video_event_duration) {
        trackingData['Video Metadata'].video_event_duration = event.target.getDuration();
      }

      if (trackingData['Video Metadata'].video_id) {
        trackingData['Video Metadata'].video_id = event.target.getVideoData().video_id;
        trackingData['Video Metadata'].video_link = event.target.getVideoUrl();
      } // deleting video_milestone attribute for play/pause events


      if (trackingData['Video Metadata'].video_milestone) {
        delete trackingData['Video Metadata'].video_milestone;
      } // Video Play


      if (event.data === YT.PlayerState.PLAYING) {
        if (trackingData['Video Metadata'].video_action) {
          trackingData['Video Metadata'].video_action = 'Play';
        }

        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }

        clearInterval(window.percentageInterval); // Interval to check the percentages watched on the video

        window.percentageInterval = setInterval(function () {
          var currentPercentage = event.target.getCurrentTime() * 100 / event.target.getDuration();

          if (videoPercentages.length > 0 && videoPercentages[videoPercentages.length - 1] <= currentPercentage) {
            var videoCheckpoint = getCheckpointPercentage(currentPercentage);
            trackingData['Video Metadata'].video_milestone = Math.floor(currentPercentage) + '%';
            trackingData['Video Metadata'].video_action = 'milestone';

            if (window.Acr && window.Acr.TrackingManager) {
              triggerClickActivity(trackingData);
            }
          }
        }, 200);
      } else if (event.data === YT.PlayerState.PAUSED) {
        // video pause
        if (trackingData['Video Metadata'].video_action) {
          trackingData['Video Metadata'].video_action = 'Paused';
        }

        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }

        clearInterval(window.percentageInterval);
      } else if (event.data === YT.PlayerState.ENDED) {
        // video end
        // sending 100% checkpoint event
        trackingData['Video Metadata'].video_action = 'milestone';
        trackingData['Video Metadata'].video_milestone = '100%';

        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }

        clearInterval(window.percentageInterval);
        window.setVideoPercentages();
        event.target.stopVideo();
      }
    }
  }

  function getCheckpointPercentage(currentPercentage) {
    var checkpointPorcentage = 0;

    for (var i = videoPercentages.length - 1; i >= 0; i--) {
      if (currentPercentage > videoPercentages[i]) {
        checkpointPorcentage = videoPercentages.pop();
      } else {
        return checkpointPorcentage;
      }
    }
  }

  function triggerClickActivity(object) {
    if (window.Acr && window.Acr.TrackingManager) {
      window.Acr.TrackingManager.sendTrackingActivity(JSON.parse(JSON.stringify(object)));
    }
  }

  function init() {
    loadAPI();
    initPlayers();
    window.setVideoPercentages();
  }

  return {
    init: init,
    YouTubePlayerObject: YouTubePlayerObject,
    onPlayerStateChange: onPlayerStateChange
  };
}();
"use strict";

Acr = window.Acr || {};

Acr.WebVitals = function (window) {
  function sendPerformanceActivity(object) {
    if (window.Acr.trackingObject && !window.Acr.trackingObject.initialize_in_code) {
      var performanceObject = {
        Page: {
          page_name: Acr.trackingObject ? Acr.trackingObject.Page.page_name : '',
          full_url: window.location.href,
          device_name: '',
          viewport: '',
          browser: '',
          date: new Date()
        },
        WebVitals: {}
      };
      Object.keys(window.Acr.TrackingManager.webVitals).forEach(function (key) {
        var measure = {
          metric_name: window.Acr.TrackingManager.webVitals[key].name,
          metric_value: window.Acr.TrackingManager.webVitals[key].value,
          metric_delta: window.Acr.TrackingManager.webVitals[key].delta
        };
        performanceObject.WebVitals[key] = measure;
      });

      if (window.ModelData) {
        performanceObject.Model = {};
        performanceObject.Model.model_name = window.ModelData.model;
        performanceObject.Model.model_year = window.ModelData.modelYear;
      }

      Acr.TrackingManager.sendPerformanceActivity(performanceObject);
    }
  }

  function updateWebVitalsObject(object) {
    if (window && window.Acr && window.Acr.TrackingManager) {
      window.Acr.TrackingManager.webVitals[object.name] = object;
    }
  }

  function init() {
    var webVitals = window.webVitals || undefined;

    if (window.Acr && window.Acr.TrackingManager) {
      window.Acr.TrackingManager.webVitals = [];
    }

    var Acr = window.Acr || {};

    if (webVitals && Acr.isWebVitalsEnabled) {
      webVitals.getCLS(updateWebVitalsObject, true);
      webVitals.getFID(updateWebVitalsObject);
      webVitals.getLCP(updateWebVitalsObject, true);
    }

    window.addEventListener('beforeunload', function () {
      if (Acr && Acr.TrackingManager && Acr.TrackingManager.webVitals) {
        sendPerformanceActivity(Acr.TrackingManager.webVitals);
      }
    });
  }

  return {
    init: init
  };
}(window);

addEventListener('DOMContentLoaded', function () {
  Acr.WebVitals.init();
});
"use strict";

var Acr = Acr || {};

Acr.Accessories = function ($element) {
  var currentBreakpoint;
  var $accessoriesSliders;

  function initSlick() {
    $accessoriesSliders = $($element).slick({
      dots: true,
      prevArrow: '<svg class="acr-icon slick-prev slick-arrow"' + ' viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink"' + ' xlink:href="#arrow-left">' + ' </use></svg>',
      nextArrow: '<svg class="acr-icon slick-next slick-arrow"' + ' viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink"' + ' xlink:href="#arrow-right">' + '</use></svg>',
      useTransform: true
    });
  }

  function removeSlick() {
    if ($accessoriesSliders) {
      $($element).slick('unslick');
    }
  }

  function attachResize() {
    $(window).off('resize', resize);
    $(window).resize(resize);
  }

  function resize() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.lg && currentBreakpoint !== 'small') {
      currentBreakpoint = 'small';
      initSlick();
      ResponsiveBackground.execute();
    } else if (width >= Constants.breakpoints.lg && currentBreakpoint !== 'large') {
      currentBreakpoint = 'large';
      removeSlick();
    }
  }

  function init() {
    attachResize();
    resize();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.AccordionNavigation = function () {
  var $navigation;
  var $navigationList;
  var $navigationItemClone;
  var isJustCta = false;
  var activeSelectorClass = '.active';
  var cloneClass = 'acr-accordion-navigation__clone';
  var expandedClass = 'expanded';
  var justCtaClass = 'just-cta';
  var navigationListSelectorClass = '.js-acr-accordion-navigation__items';
  var navigationItemSelectorClass = '.js-acr-accordion-navigation__item';

  function toggleAccordion(e) {
    e.preventDefault();
    var toogleNav = $navigation.classList.contains(expandedClass);

    if (toogleNav) {
      $navigationList.style.removeProperty('height');
      $navigation.classList.remove(expandedClass);
    } else {
      $navigation.classList.add(expandedClass);
      var navigationListSize = $navigationList.scrollHeight;
      var viewHeight = document.documentElement.clientHeight;
      var parentPositionSize = $navigationList.parentElement.offsetTop + $navigationList.parentElement.offsetHeight;
      var calcViewSize = viewHeight - parentPositionSize;
      var finalHeightSize = calcViewSize > navigationListSize ? calcViewSize : navigationListSize;
      $navigationList.style.height = finalHeightSize + 'px';
    }
  }

  function initSelectors(element) {
    $navigation = element;
    var navigationItemActive = $navigation.querySelector(navigationItemSelectorClass + activeSelectorClass);
    var navigationItemActiveLink = navigationItemActive.querySelector('.acr-accordion-navigation__item__link');
    var cloneActiveLink = navigationItemActiveLink.cloneNode(true);
    $navigationItemClone = document.createElement('span');
    $navigationItemClone.appendChild(cloneActiveLink);
    $navigationItemClone.classList.add(cloneClass);
    $navigationList = $navigation.querySelector(navigationListSelectorClass);
    $navigation.insertBefore($navigationItemClone, $navigationList);
    isJustCta = $navigation.classList.contains(justCtaClass);
  }

  function bindEvents() {
    if (!isJustCta) {
      $navigationItemClone.addEventListener('click', toggleAccordion);
    }
  }

  function init(element) {
    console.log('this is acr navigation');
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.CarouselText = function () {
  var $carouselText;
  var $carouselTextSwiperContainer;
  var $carouselNavigationItems;
  var $swiperPagination;
  var $sliderShadow;
  var $arrowLeft;
  var $arrowRight;
  var carouselTextSwiper;
  var matchMedia;
  var swiperContainerSelector = '.js-swiper-container';
  var swiperPaginationSelector = '.js-swiper-pagination';
  var arrowLeftSelector = '.js-arrow-left';
  var arrowRightSelector = '.js-arrow-right';
  var navigationItemSelector = '.js-carousel-text-nav-item';
  var sliderShadowSelector = '.js-slider-shadow';
  var navItemActiveClass = 'acr-carousel-text__nav-item--active'; // Initialize all HTML selectors

  function initSelectors(element) {
    $carouselText = element;
    $carouselTextSwiperContainer = $carouselText.querySelector(swiperContainerSelector);
    $carouselNavigationItems = $carouselText.querySelectorAll(navigationItemSelector);
    $swiperPagination = $carouselText.querySelector(swiperPaginationSelector);
    $sliderShadow = $carouselText.querySelector(sliderShadowSelector);
    $arrowLeft = $carouselText.querySelector(arrowLeftSelector);
    $arrowRight = $carouselText.querySelector(arrowRightSelector);
  } // Initialize all necessary global variables in the component


  function initGlobalVariables() {
    matchMedia = window.matchMedia('(min-width: ' + Constants.breakpoints.lg + 'px)');
  } // Initialize the swiper slider for the carouse-text


  function initCarouseTextSliderSwiper() {
    carouselTextSwiper = new Swiper($carouselTextSwiperContainer, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft
      },
      init: true
    }); // Every time the slide changes, the navigation item outside the carousel are updated (if the navigation item are available)

    carouselTextSwiper.on('slideChange', function () {
      var swiperIndex = carouselTextSwiper.realIndex;
      updateNavigationItems(swiperIndex);

      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, carouselTextSwiper);
      }
    });
  } // Update the navigation item for the carousel text when the slide changes.


  function updateNavigationItems(swiperIndex) {
    $carouselNavigationItems.forEach(function (item) {
      var itemIndex = parseInt(item.getAttribute('data-slide-index'), 10);

      if (swiperIndex === itemIndex) {
        item.classList.add(navItemActiveClass);
      } else {
        item.classList.remove(navItemActiveClass);
      }
    });
  }

  function bindEvents() {
    // Events only for Desktop size
    if (Utility.isDesktop()) {
      assignNavigationItemsClickEvent();
      $arrowLeft.addEventListener('mouseover', showArrowShadow);
      $arrowRight.addEventListener('mouseover', showArrowShadow);
      $arrowLeft.addEventListener('mouseout', hideArrowShadow);
      $arrowRight.addEventListener('mouseout', hideArrowShadow);
      $arrowLeft.addEventListener('click', hideArrowShadow);
      $arrowRight.addEventListener('click', hideArrowShadow);
    } // Using matchMedia to check if it is desktop size, to avoid window.resize


    matchMedia.addListener(matchMediaHandler);
  } // If it is desktop size, add the click events to each navigation item, otherwise delete the click event


  function matchMediaHandler() {
    if (matchMedia.matches) {
      assignNavigationItemsClickEvent();
      $arrowLeft.addEventListener('mouseover', showArrowShadow);
      $arrowRight.addEventListener('mouseover', showArrowShadow);
      $arrowLeft.addEventListener('mouseout', hideArrowShadow);
      $arrowRight.addEventListener('mouseout', hideArrowShadow);
      $arrowLeft.addEventListener('click', hideArrowShadow);
      $arrowRight.addEventListener('click', hideArrowShadow);
    } else {
      $carouselNavigationItems.forEach(function (item) {
        item.removeEventListener('click', changeSwiperSlide);
      });
      $arrowLeft.removeEventListener('mouseover', showArrowShadow);
      $arrowRight.removeEventListener('mouseover', showArrowShadow);
      $arrowLeft.removeEventListener('mouseout', hideArrowShadow);
      $arrowRight.removeEventListener('mouseout', hideArrowShadow);
      $arrowLeft.removeEventListener('click', hideArrowShadow);
      $arrowRight.removeEventListener('click', hideArrowShadow);
    }
  } // Attachment of click events for each navigation item


  function assignNavigationItemsClickEvent() {
    $carouselNavigationItems.forEach(function (item) {
      item.addEventListener('click', changeSwiperSlide);
    });
  } // Switch to the swiper slide related to the item that was clicked, using the index of both elements


  function changeSwiperSlide() {
    event.preventDefault();
    var slideIndex = parseInt(this.getAttribute('data-slide-index'), 10);
    $carouselNavigationItems.forEach(function (item) {
      item.classList.remove(navItemActiveClass);
    });
    this.classList.add(navItemActiveClass);
    carouselTextSwiper.slideToLoop(slideIndex);
  } // Show arrow shadows when arrows hover


  function showArrowShadow() {
    $sliderShadow.style.zIndex = '2';
    $sliderShadow.style.opacity = '0.6';
  } // Hide arrow shadows when arrows hover


  function hideArrowShadow() {
    $sliderShadow.style.removeProperty('opacity');
    setTimeout(function () {
      $sliderShadow.style.removeProperty('z-index');
    }, 300);
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initCarouseTextSliderSwiper();
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.Drawer = function () {
  var $element;
  var hash;
  var drawerSection = '.js-drawer-section';
  var drawerBody = '.js-drawer-body';
  var drawerLink = '.js-drawer-link';
  var drawerIconMinus = '.js-drawer-icon-minus';
  var drawerIconPlus = '.js-drawer-icon-plus';

  function openDrawer(target) {
    var drawerElements;
    drawerElements = [].slice.call(target);
    drawerElements.forEach(function (drawerElement) {
      var $drawerElement;
      $drawerElement = $(drawerElement);
      $drawerElement.removeClass('acr-drawer__section--collapsed');
      $drawerElement.find(drawerBody).slideDown().removeClass('acr-drawer__body--collapsed');
      $drawerElement.find(drawerIconMinus).css('display', 'block');
      $drawerElement.find(drawerIconPlus).css('display', 'none');
      $drawerElement.find(drawerLink).attr('aria-expanded', 'true');
    });
  }

  function closeDrawer(target, noCloseId) {
    var drawerElements;
    drawerElements = [].slice.call(target);
    drawerElements.forEach(function (drawerElement) {
      var $drawerElement;
      $drawerElement = $(drawerElement);

      if (noCloseId !== '#' + $drawerElement.find(drawerBody).attr('id')) {
        $drawerElement.addClass('acr-drawer__section--collapsed');
        $drawerElement.find(drawerBody).slideUp().addClass('acr-drawer__body--collapsed');
        $drawerElement.find(drawerIconMinus).css('display', 'none');
        $drawerElement.find(drawerIconPlus).css('display', 'block');
        $drawerElement.find(drawerLink).attr('aria-expanded', 'false');
      }
    });
  }

  function onClickDrawer() {
    $element.find(drawerLink).on('click', function (e) {
      var target = $(this).closest(drawerSection);
      e.preventDefault();

      if (target.hasClass('acr-drawer__section--collapsed')) {
        openDrawer(target);
      } else {
        closeDrawer(target);
      }
    });
  }

  function initSelectors(element) {
    $element = $(element);
    hash = window.location.hash;
  }

  function bindEvents(element) {
    initSelectors(element);
    onClickDrawer();
    closeDrawer($element.find(drawerSection), hash);
  }

  function init(element) {
    bindEvents(element);
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};
var Ut = window.Utility;

Acr.Footer = function () {
  var languages = {
    en: {
      name: 'English',
      subDomain: 'www'
    },
    es: {
      name: 'Español',
      subDomain: 'spanish'
    },
    zh: {
      name: '中文',
      subDomain: 'chinese'
    }
  };
  var currentLanguage;
  var matchMedia;
  var hostname;
  var $footer;
  var $footerPanel;
  var $footerAccordion;
  var $collapseIcon;
  var $expandIcon;
  var $availableLanguages;
  var $footerAccordionContainer;
  var footerPanel = '.js-footer-panel';
  var footerAccordion = '.js-footer-accordion';
  var collapseIcon = '.js-icon-collapse';
  var expandIcon = '.js-icon-expand';
  var availableLanguage = '.js-available-language';
  var footerAccordionContainer = '.js-footer-accordion-container';

  function initSelectors(element) {
    $footer = element;
    $footerPanel = $footer.querySelector(footerPanel);
    $footerAccordion = $footer.querySelector(footerAccordion);
    $collapseIcon = $footer.querySelector(collapseIcon);
    $expandIcon = $footer.querySelector(expandIcon);
    $availableLanguages = $footer.querySelectorAll(availableLanguage);
    $footerAccordionContainer = $footer.querySelector(footerAccordionContainer);
  }

  function initGlobalVariables() {
    matchMedia = window.matchMedia('(min-width: ' + Constants.breakpoints.lg + 'px)');
    hostname = window.location.hostname;
    currentLanguage = 'English';
  }

  function bindEvents() {
    matchMedia.addListener(enableAccordion);
    $footerAccordionContainer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        toggleAccordion();
      }
    });
  }

  function enableAccordion() {
    if (matchMedia.matches) {
      $footerAccordion.removeEventListener('click', toggleAccordion);
      $footerPanel.removeAttribute('style');
      $collapseIcon.removeAttribute('style');
      $expandIcon.removeAttribute('style');
    } else {
      $footerAccordion.addEventListener('click', toggleAccordion);
    }
  }

  function toggleAccordion() {
    Ut.slideToggle($footerPanel, 400);
    Ut.slideToggle($expandIcon);
    Ut.slideToggle($collapseIcon);
  }

  function updateLanguageLink() {
    Object.entries(languages).forEach(function (el) {
      if (hostname.indexOf(el[1].subDomain) !== -1) {
        currentLanguage = el[1].name;
      }
    });
    $availableLanguages.forEach(function (item) {
      var $item = item;

      if ($item.innerText === currentLanguage) {
        $item.style.textDecoration = 'underline';
      }
    });
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    bindEvents();
    enableAccordion();
    updateLanguageLink();
  }

  return {
    init: init
  };
};
"use strict";

/**
 * Module: GalleryDetail
 *
 * Calls Utility.isElementInViewIO in order to add Lazyloading
 *
 * Returned Functions: init, openDetailview
 *
 */
var Acr = Acr || {};

Acr.GalleryDetail = function () {
  var $element;
  var $acrDetailVideoPlayer;
  var $acrDetailPictureSlick;
  var $acrDetailFilmstripSlick;
  var $acrDetailFilmstripPrev;
  var $acrDetailFilmstripNext;
  var $acrDetailCloseBtn;
  var $acrGalleryDetailFilmstrip;
  var $acrGalleryDetailFilmstripWrapper;
  var $acrDetailFilmstripItem;
  var $acrDetailIndex;
  var $acrDetailPictureShadow;
  var $galleryDetailText;
  var $showPictureInfoBtn;
  var $enlargePictureBtn;
  var $detailBackgroundImage;
  var $detailVideoWrapper;
  var $detailWrapper;
  var $pictureContainer;
  var $videoContainer;
  var $galleryDetailLightbox;
  var $hashLinks;
  var $documentBody;
  var $window;
  var direction = '';
  var resizeTimer;
  var ieResizeTimer;
  var ieOrWinEdge;
  var acrDetailVideoPlayerList;
  var acrDetailFilmstripItemClassName;
  var acrDetailFilmstripSlickClass = '.js-acr-detail-filmstrip-slick';
  var acrDetailCarouselSlickClass = '.js-acr-detail-carousel-slick';
  var acrDetailIndexClass = '.js-acr-detail-index';
  var acrDetailCloseBtnClass = '.js-acr-detail-close-btn';
  var svgDefiniion = 'http://www.w3.org/2000/svg';
  var acrDetailLoadedClass = 'acr-gallery-detail--loaded';
  var acrDetailOpenedClass = 'acr-gallery-detail--opened';
  var modalOpenClass = 'modal-open';
  var arrowRightClass = 'arrow-right';
  var arrowLeftClass = 'arrow-left';
  var acrDetailFilmstripItemClass = '.js-acr-detail-filmstrip-item';
  var acrDetailVideoPlayerClass = '.js-acr-detail-video';
  var acrDetailFilmstripPrevClass = '.js-acr-detail-filmstrip-prev';
  var acrDetailFilmstripNextClass = '.js-acr-detail-filmstrip-next';
  var acrGalleryDetailFilmstripClass = '.js-gallery-detail-filmstrip';
  var acrGalleryDetailFilmstripWrapperClass = '.js-gallery-detail-filmstrip-wrapper';
  var acrGalleryDetailTextClass = '.js-gallery-detail-text';
  var acrDetailhoverClass = 'js-shadow-hover';
  var acrDetailPictureShadowClass = '.acr-gallery-detail__picture-shadow';
  var detailWrapperClass = '.js-acr-detail-wrapper';
  var showPictureInfoBtnSelectorClass = '.js-show-picture-info-btn';
  var visibleShowPictureInfoBtnStyleClass = 'acr-gallery-detail__pic-info-btn-show--visible';
  var enlargePictureBtnSelectorClass = '.js-enlarge-picture-btn';
  var visibleEnlargePictureBtnStyleClass = 'acr-gallery-detail__pic-info-btn-enlarge--visible';
  var backgroundImageSelectorClass = '.js-gallery-detail-background-image';
  var videoWrapperSelectorClass = '.js-gallery-detail-video-wrapper';
  var pictureContainerSelectorClass = '.js-gallery-detail-picture-container';
  var videoContainerSelectorClass = '.js-gallery-detail-video-container';
  var lightboxSelectorClass = '.js-gallery-detail-lightbox';
  var detailWrapperModifierClass = 'acr-gallery-detail__wrapper--full';
  var backgroundImageModifierClass = 'acr-gallery-detail__background-image--large';
  var videoWrapperModifierClass = 'acr-gallery-detail__video-wrapper--large';
  var pictureContainerModifierClass = 'acr-gallery-detail__picture-container--large';
  var videoContainerModifierClass = 'acr-gallery-detail__video-container--large';
  var galleryDetailTextModifierClass = 'acr-gallery-detail__detail--hidden';
  var lightboxModifierClass = 'acr-gallery-detail__lightbox--large';
  var hashLinks = 'a[href*="#"]';
  var fullViewPaddingTop = 0.51; // This is the padding top for full view of the "acr-gallery-detail__background-image" class that is in the scss file.

  var detailViewPaddingTop = 0.57; // This is the padding top for detail view of the "acr-gallery-detail__background-image" class that is in the scss file.

  function openDetailview(imageId, index, isCustomIndex) {
    // If isCustomIndex, the component opens the image associated with the imageId parameter
    var indexTarget;

    if (isCustomIndex) {
      var imageToGo = $acrDetailPictureSlick.find('#' + imageId);
      var imageIndex = imageToGo.data('index');
      indexTarget = imageIndex !== undefined ? imageIndex : 0;
    } else {
      indexTarget = index !== undefined ? index : 0;
    }

    $element.addClass(acrDetailOpenedClass);
    $documentBody.addClass(modalOpenClass);
    history.replaceState('', document.title, window.location.pathname + window.location.search);

    if (!$element.hasClass(acrDetailLoadedClass)) {
      initDetailSlick();
      initDetailAdditionalSelectors();
      attachFilmstripWidth();
      bindFilmstripEvents();
      bindDetailPictureEvents();
      startVideos();
      $element.addClass(acrDetailLoadedClass);
    }

    if (ieOrWinEdge) {
      $($window).on('resize', bindEdgeIEEvents);

      if (Utility.isDesktop()) {
        var detailWrapperWidth = $detailWrapper.outerWidth();
        var carouselHeight = parseInt(detailWrapperWidth * fullViewPaddingTop, 10);
        $detailWrapper.css('height', carouselHeight);
      }
    }

    slickDetailGoTo(indexTarget);
    slickFilmstripGoTo(indexTarget);
    attachKeyboardInput();
    $($window).on('resize', modalResizeHandler);
    $showPictureInfoBtn.attr('slide-index', 'Slide ' + (indexTarget + 1));
    $enlargePictureBtn.attr('slide-index', 'Slide ' + (indexTarget + 1));
  }

  function updateIndex(number) {
    var currentNumber = number || 0;
    $acrDetailIndex.text(currentNumber);
  }

  function goToNextPage() {
    var currentItems;
    var currentVisibleItems;
    var currentSlide;
    var filmstripWidth;
    var filmstripItemWidth;
    var slideMargin = 5;
    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    currentSlide = $acrDetailFilmstripSlick.slick('slickCurrentSlide');
    currentItems = $acrDetailFilmstripItem.length;
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));
    slickFilmstripGoTo((currentVisibleItems + currentSlide) % currentItems);
  }

  function goToPrevPage() {
    var currentItems;
    var currentVisibleItems;
    var currentSlide;
    var filmstripWidth;
    var filmstripItemWidth;
    var position;
    var slideMargin = 5;
    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    currentSlide = $acrDetailFilmstripSlick.slick('slickCurrentSlide');
    currentItems = $acrDetailFilmstripItem.length;
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));
    position = currentSlide - currentVisibleItems;
    slickFilmstripGoTo(position < 0 ? currentItems + position : position);
  }

  function slickFilmstripGoTo(index, dontAnimate) {
    var dontAnimateTransition = dontAnimate || true;
    var filmstripWidth = $acrDetailFilmstripSlick.width();
    var filmstripItemWidth = $acrDetailFilmstripItem.width();

    if (filmstripItemWidth * $acrDetailFilmstripItem.length > filmstripWidth) {
      $acrDetailFilmstripSlick.slick('slickGoTo', index, dontAnimateTransition);
    }

    executeLazyLoading();
  }

  function executeLazyLoading() {
    var imagesToLoad = [].slice.call(document.querySelectorAll(acrDetailFilmstripItemClass + ' img[loading="lazy"]'));
    Utility.initLazyLoadingIO(imagesToLoad, Acr.LazyLoadingHelper.loadImage);
  }

  function slickDetailGoTo(index, dontAnimate) {
    var dontAnimateTransition = dontAnimate || true;
    $acrDetailPictureSlick.slick('slickGoTo', index, dontAnimateTransition);
  }

  function addFakeSlickCurrent() {
    var index;
    index = $acrDetailPictureSlick.find('.slick-current').attr('data-slick-index');
    $acrDetailFilmstripSlick.find('.slick-slide').removeClass('slick-fake-current');
    $acrDetailFilmstripSlick.find('[data-index="' + index + '"]').addClass('slick-fake-current');
  }

  function isSelectedItemVisible() {
    var currentVisibleItems;
    var minIndex;
    var maxIndex;
    var currentIndex;
    var fakeDataIndex;
    var filmstripWidth;
    var filmstripItemWidth;
    var slideMargin = 5;
    fakeDataIndex = $acrDetailFilmstripSlick.find('.slick-fake-current.slick-active').attr('data-slick-index');
    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    minIndex = $acrDetailFilmstripSlick.slick('slickCurrentSlide');
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));
    maxIndex = currentVisibleItems + minIndex;
    currentIndex = fakeDataIndex;

    if (currentIndex) {
      return !(currentIndex >= maxIndex || currentIndex < minIndex);
    }

    return false;
  }

  function getPagePosition(direction) {
    var currentDirection;
    var index;
    var filmstripWidth;
    var filmstripItemWidth;
    var currentVisibleItems;
    var currentItems;
    var slideOffset;
    var slideMargin = 5;
    currentDirection = direction === 'left' ? 'left' : 'right';
    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    index = $acrDetailFilmstripSlick.find('.slick-fake-current').attr('data-index');
    currentItems = $acrDetailFilmstripItem.length;
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));

    if (currentDirection === 'right') {
      return index;
    }

    index = index - currentVisibleItems + 1;
    slideOffset = currentItems + ((currentVisibleItems + index) % currentItems - currentVisibleItems);
    return index > 0 ? index : slideOffset;
  }

  function addModalMeasures() {
    var filmstripHeight;
    var carouselHeight;
    var galleryDetailTextWidth;
    var detailWrapperWidth;
    filmstripHeight = $acrGalleryDetailFilmstrip.outerHeight();
    galleryDetailTextWidth = $galleryDetailText.outerWidth();
    detailWrapperWidth = $detailWrapper.outerWidth();

    if (Utility.isDesktop()) {
      if ($detailWrapper.hasClass(detailWrapperModifierClass)) {
        $pictureContainer.css('width', detailWrapperWidth);
        $videoContainer.css('width', detailWrapperWidth);
        $detailBackgroundImage.addClass(backgroundImageModifierClass);
        $detailVideoWrapper.addClass(videoWrapperModifierClass);
        $galleryDetailText.css('left', detailWrapperWidth);
        carouselHeight = parseInt(detailWrapperWidth * fullViewPaddingTop, 10);
        $detailWrapper.css('height', carouselHeight);
        $galleryDetailLightbox.css('height', carouselHeight);
        $enlargePictureBtn.removeClass(visibleEnlargePictureBtnStyleClass);
        $showPictureInfoBtn.addClass(visibleShowPictureInfoBtnStyleClass);
      } else {
        $pictureContainer.css('width', detailWrapperWidth - galleryDetailTextWidth);
        $videoContainer.css('width', detailWrapperWidth - galleryDetailTextWidth);
        $detailBackgroundImage.removeClass(backgroundImageModifierClass);
        $detailVideoWrapper.removeClass(videoWrapperModifierClass);
        $galleryDetailText.css('left', detailWrapperWidth - galleryDetailTextWidth);
        carouselHeight = parseInt((detailWrapperWidth - galleryDetailTextWidth) * detailViewPaddingTop, 10);
        $detailWrapper.css('height', filmstripHeight + carouselHeight);
        $galleryDetailLightbox.css('height', carouselHeight);
        $showPictureInfoBtn.removeClass(visibleShowPictureInfoBtnStyleClass);
        $enlargePictureBtn.addClass(visibleEnlargePictureBtnStyleClass);
      }
    } else {
      removeEdgeIEInlineStyles();
      $detailBackgroundImage.removeClass(backgroundImageModifierClass);
      $detailVideoWrapper.removeClass(videoWrapperModifierClass);
    }
  }

  function removeEdgeIEInlineStyles() {
    $pictureContainer.removeAttr('style');
    $videoContainer.removeAttr('style');
    $galleryDetailText.removeAttr('style');
    $detailWrapper.removeAttr('style');
    $galleryDetailLightbox.removeAttr('style');
  }

  function bindEdgeIEEvents() {
    clearTimeout(ieResizeTimer);
    ieResizeTimer = setTimeout(function () {
      addModalMeasures();
    }, 250);
  }

  function bindDetailPictureEvents() {
    $acrDetailPictureSlick.on('afterChange', function () {
      var isSelectedItemVisibleFlag;
      var index;
      pauseVideos();
      addFakeSlickCurrent();
      isSelectedItemVisibleFlag = isSelectedItemVisible();

      if (!isSelectedItemVisibleFlag && direction === 'right') {
        index = getPagePosition(direction);
        slickFilmstripGoTo(index);
      } else if (!isSelectedItemVisibleFlag && direction === 'left') {
        index = getPagePosition(direction);
        slickFilmstripGoTo(index);
      }
    });
    $acrDetailPictureSlick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var decl = currentSlide - nextSlide;

      if (decl === 1 || decl === (slick.slideCount - 1) * -1) {
        direction = 'left';
      } else {
        direction = 'right';
      }

      updateIndex(nextSlide + 1);
      $showPictureInfoBtn.attr('slide-index', 'Slide ' + (nextSlide + 1));
      $enlargePictureBtn.attr('slide-index', 'Slide ' + (nextSlide + 1));
      $acrDetailPictureShadow.removeAttr('style');
    });
    $('.' + acrDetailhoverClass).hover(function () {
      $acrDetailPictureShadow.css('opacity', 0.6);
    }, function () {
      $acrDetailPictureShadow.removeAttr('style');
    });
  }

  function bindFilmstripEvents() {
    $acrDetailFilmstripSlick.on('click', acrDetailFilmstripItemClassName, function (e) {
      e.preventDefault();
      var $target;
      var index;
      $target = $(this);
      index = $target.data('index');
      slickDetailGoTo(index, false);
      addFakeSlickCurrent();
    });
    $acrDetailFilmstripNext.on('click', function (e) {
      e.preventDefault();
      goToNextPage();
    });
    $acrDetailFilmstripPrev.on('click', function (e) {
      e.preventDefault();
      goToPrevPage();
    });
  }

  function initPictureInfoBtns() {
    if (!ieOrWinEdge) {
      $showPictureInfoBtn.on('click', function (event) {
        event.preventDefault();
        showPictureInfoHandler();
      });
      $enlargePictureBtn.on('click', function (event) {
        event.preventDefault();
        enlargePictureHandler();
      });
    } else {
      $showPictureInfoBtn.on('click', function (event) {
        event.preventDefault();
        showPictureInfoIEHandler();
      });
      $enlargePictureBtn.on('click', function (event) {
        event.preventDefault();
        enlargePictureIEHandler();
      });
    }
  }

  function showPictureInfoHandler() {
    $detailWrapper.removeClass(detailWrapperModifierClass);
    $pictureContainer.removeClass(pictureContainerModifierClass);
    $videoContainer.removeClass(videoContainerModifierClass);
    $detailBackgroundImage.removeClass(backgroundImageModifierClass);
    $detailVideoWrapper.removeClass(videoWrapperModifierClass);
    $galleryDetailText.removeClass(galleryDetailTextModifierClass);
    $galleryDetailLightbox.removeClass(lightboxModifierClass);
    $showPictureInfoBtn.removeClass(visibleShowPictureInfoBtnStyleClass);
    $enlargePictureBtn.addClass(visibleEnlargePictureBtnStyleClass);
  }

  function enlargePictureHandler() {
    $detailWrapper.addClass(detailWrapperModifierClass);
    $detailBackgroundImage.addClass(backgroundImageModifierClass);
    $detailVideoWrapper.addClass(videoWrapperModifierClass);
    $pictureContainer.addClass(pictureContainerModifierClass);
    $videoContainer.addClass(videoContainerModifierClass);
    $galleryDetailText.addClass(galleryDetailTextModifierClass);
    $galleryDetailLightbox.addClass(lightboxModifierClass);
    $enlargePictureBtn.removeClass(visibleEnlargePictureBtnStyleClass);
    $showPictureInfoBtn.addClass(visibleShowPictureInfoBtnStyleClass);
  }

  function showPictureInfoIEHandler() {
    $detailWrapper.removeClass(detailWrapperModifierClass);
    addModalMeasures();
  }

  function enlargePictureIEHandler() {
    $detailWrapper.addClass(detailWrapperModifierClass);
    addModalMeasures();
  }

  function initCloseBtn() {
    $acrDetailCloseBtn.on('click', function (event) {
      event.preventDefault();
      closeHandler();
    });
  }

  function closeHandler() {
    $documentBody.removeClass(modalOpenClass);
    $element.removeClass(acrDetailOpenedClass);
    stopVideos();
    $(document).off('keyup', keyboardHandler);
    $($window).off('resize', modalResizeHandler);
    $($window).off('resize', bindEdgeIEEvents);
    enlargePictureHandler();

    if (ieOrWinEdge) {
      removeEdgeIEInlineStyles();
    }
  }

  function initDeeplink() {
    $hashLinks.on('click', function (event) {
      var currentUrl = window.location.pathname;
      currentUrl = currentUrl.substr(currentUrl.length - 1) === '/' ? currentUrl.pop() : currentUrl;

      if (currentUrl === event.target.pathname) {
        $documentBody.removeClass(modalOpenClass);
        $element.removeClass(acrDetailOpenedClass);
        stopVideos();
      }
    });
  }

  function initSelectors(element) {
    $element = $(element);
    $acrDetailPictureSlick = $element.find(acrDetailCarouselSlickClass);
    $acrDetailFilmstripSlick = $element.find(acrDetailFilmstripSlickClass);
    $acrDetailVideoPlayer = $element.find(acrDetailVideoPlayerClass);
    $acrDetailCloseBtn = $element.find(acrDetailCloseBtnClass);
    $acrDetailFilmstripNext = $element.find(acrDetailFilmstripNextClass);
    $acrDetailFilmstripPrev = $element.find(acrDetailFilmstripPrevClass);
    $acrDetailFilmstripItem = $element.find(acrDetailFilmstripItemClass);
    $acrDetailIndex = $element.find(acrDetailIndexClass);
    $acrDetailPictureShadow = $element.find(acrDetailPictureShadowClass);
    $acrGalleryDetailFilmstrip = $element.find(acrGalleryDetailFilmstripClass);
    $acrGalleryDetailFilmstripWrapper = $element.find(acrGalleryDetailFilmstripWrapperClass);
    $showPictureInfoBtn = $element.find(showPictureInfoBtnSelectorClass);
    $enlargePictureBtn = $element.find(enlargePictureBtnSelectorClass);
    $hashLinks = $element.find(hashLinks);
    $documentBody = $('body');
    $window = window;
  }

  function initDetailAdditionalSelectors() {
    $detailWrapper = $element.find(detailWrapperClass);
    $detailBackgroundImage = $element.find(backgroundImageSelectorClass);
    $detailVideoWrapper = $element.find(videoWrapperSelectorClass);
    $pictureContainer = $element.find(pictureContainerSelectorClass);
    $videoContainer = $element.find(videoContainerSelectorClass);
    $galleryDetailText = $element.find(acrGalleryDetailTextClass);
    $galleryDetailLightbox = $element.find(lightboxSelectorClass);
  }

  function initGlobalVariables() {
    acrDetailVideoPlayerList = [];
    acrDetailFilmstripItemClassName = acrDetailFilmstripItemClass;
    ieOrWinEdge = Utility.isIE11() || Utility.isWinEdge();
  }

  function createArrow(orientation, icon, className) {
    var $arrowContainer;
    var arrowContainer;
    var $svg;
    var svg;
    var use;
    var orientationTarget;
    var iconTarget;
    var customClass;
    orientationTarget = orientation !== undefined ? orientation : 'next';
    customClass = className !== undefined ? ' ' + className : '';
    iconTarget = icon !== undefined ? icon : arrowRightClass;
    svg = document.createElementNS(svgDefiniion, 'svg');
    $svg = $(svg);
    use = document.createElement('use');
    $svg.attr('class', 'acr-icon');
    $svg.attr('viewBox', '0 0 26 26');
    use.setAttribute('xlink:href', '#' + iconTarget);
    $svg.append(use);
    $svg.first().append(orientationTarget);
    arrowContainer = document.createElement('div');
    $arrowContainer = $(arrowContainer);
    $arrowContainer.attr('class', 'slick-arrow slick-' + orientationTarget + customClass);
    $arrowContainer.append($svg[0].outerHTML || new XMLSerializer().serializeToString($svg[0]).replace('NS1:', ''));
    return $arrowContainer[0].outerHTML;
  }

  function stopVideos() {
    for (var x = 0; x < acrDetailVideoPlayerList.length; x++) {
      var $target;
      $target = acrDetailVideoPlayerList[x];

      if ($target.stop != null) {
        $target.stop();
      }
    }
  }

  function pauseVideos() {
    for (var x = 0; x < acrDetailVideoPlayerList.length; x++) {
      var $target;
      $target = acrDetailVideoPlayerList[x];

      if ($target.stop != null) {
        $target.pause();
      }
    }
  }

  function startVideos() {
    for (var x = 0; x < $acrDetailVideoPlayer.length; x++) {
      var $target;
      var targetId;
      $target = $($acrDetailVideoPlayer[x]);
      targetId = $target.id;
      var videoID = $target.data('video-src');
      var container = $target;
      var autoplay = false;
      var player = new Acr.YouTubeManager.YouTubePlayerObject(videoID, null, container, container, autoplay);
      player.init();
      acrDetailVideoPlayerList[x] = player;
    }
  }

  function initDetailSlick() {
    // Init Slick for Detail Picture
    $acrDetailPictureSlick.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      responsive: [{
        breakpoint: 0,
        settings: {
          draggable: true
        }
      }, {
        breakpoint: 768,
        settings: {
          draggable: false
        }
      }],
      nextArrow: createArrow('next', arrowRightClass, acrDetailhoverClass),
      prevArrow: createArrow('prev', arrowLeftClass, acrDetailhoverClass)
    });
  }

  function initFilsmtripSlick(slidesToShowParam) {
    // Init Slick for Filmstrip
    $acrDetailFilmstripSlick.slick({
      slidesToShow: slidesToShowParam,
      variableWidth: true,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      dots: false,
      responsive: [{
        breakpoint: 0,
        settings: {
          draggable: true,
          arrows: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          draggable: false,
          arrows: false,
          slidesToScroll: 1
        }
      }]
    });
  }

  function modalResizeHandler() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $acrDetailFilmstripSlick.slick('unslick');
      attachFilmstripWidth();
    }, 250);
  }

  function attachFilmstripWidth() {
    // Calculate how many items can be displayed on the filmstrip, if the total images are less the
    // than the calculated number, the images will be centered on the available space
    var filmstripItemWidth;
    var filmstripItemLength;
    var filmstripWidth;
    var currentVisibleItems;
    var slideMargin = 5;
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    filmstripItemLength = $acrDetailFilmstripItem.not('.slick-cloned').length;
    $acrGalleryDetailFilmstripWrapper.css('width', '');
    filmstripWidth = $acrDetailFilmstripSlick.width();
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));

    if (filmstripItemLength <= currentVisibleItems) {
      $acrGalleryDetailFilmstripWrapper.css('width', filmstripItemLength * (filmstripItemWidth + slideMargin));
    }

    initFilsmtripSlick(currentVisibleItems);
  }

  function attachKeyboardInput() {
    $(document).on('keyup', keyboardHandler);
  }

  function keyboardHandler(e) {
    switch (e.which) {
      case 27:
        // esc key
        closeHandler();
        break;

      case 37:
        // left arrow
        $acrDetailPictureSlick.slick('slickPrev');
        break;

      case 39:
        // right arrow
        $acrDetailPictureSlick.slick('slickNext');
        break;
    }
  }

  function bindInitialEvents() {
    initCloseBtn();
    initDeeplink();
    initPictureInfoBtns();
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    bindInitialEvents();
  }

  return {
    init: init,
    openDetailview: openDetailview
  };
};
"use strict";

var Acr = Acr || {};

Acr.GallerySlider = function () {
  var $gallerySlider;
  var $gallerySwiperContainer;
  var $gallerySliderItems;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $gallerySliderDetail;
  var gallerySwiper;
  var acrGalleryDetail;
  var galleryDetailId;
  var mobilePaginationType;
  var gallerySliderItemSelector = '.js-gallery-slider-item';
  var swiperContainerSelector = '.js-swiper-container';
  var swiperPaginationSelector = '.js-swiper-pagination';
  var arrowLeftSelector = '.js-arrow-left';
  var arrowRightSelector = '.js-arrow-right';
  var mobileMaxCards = 9; // Maximum card limit to show dots pagination, if the number of cards is greater, fractional pagination is shown
  // Initialize all HTML selectors

  function initSelectors(element) {
    $gallerySlider = element;
    $gallerySwiperContainer = $gallerySlider.querySelector(swiperContainerSelector);
    $swiperPagination = $gallerySlider.querySelector(swiperPaginationSelector);
    $arrowLeft = $gallerySlider.querySelector(arrowLeftSelector);
    $arrowRight = $gallerySlider.querySelector(arrowRightSelector);
  } // Initialize all necessary global variables in the component


  function initGlobalVariables() {
    var numberOfCards = $gallerySlider.querySelectorAll(gallerySliderItemSelector).length;
    mobilePaginationType = numberOfCards > mobileMaxCards ? 'fraction' : 'bullets';
  } // Initialize the swiper slider for the gallery


  function initGallerySliderSwiper() {
    gallerySwiper = new Swiper($gallerySwiperContainer, {
      slidesPerView: 1,
      spaceBetween: 27,
      // 27px of margin
      loop: true,
      pagination: {
        el: $swiperPagination,
        type: mobilePaginationType,
        clickable: true
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true
          }
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true
          }
        },
        // when window width is >= 1400px
        1400: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true
          }
        }
      },
      init: true
    });
    gallerySwiper.on('slideChange', function () {
      if (Acr.TrackingManager && event.type !== 'resize') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
    $gallerySliderItems = $gallerySlider.querySelectorAll(gallerySliderItemSelector);
  } // Initialize the gallery detail component


  function initGalleryDetail() {
    galleryDetailId = $gallerySlider.getAttribute('data-gallery-detail');

    if (galleryDetailId !== undefined) {
      acrGalleryDetail = new Acr.GalleryDetail();
      $gallerySliderDetail = document.getElementById(galleryDetailId);
      acrGalleryDetail.init($gallerySliderDetail);
    }
  }

  function bindEvents() {
    // Attachment of click events for each image item
    $gallerySliderItems.forEach(function (item) {
      item.addEventListener('click', openGalleryDetail);
    });
  } // Function to open the gallery details every time an item is clicked


  function openGalleryDetail() {
    if (galleryDetailId !== undefined) {
      var imageId = this.getAttribute('data-image-id');
      var index = this.getAttribute('data-index');
      acrGalleryDetail.openDetailview(imageId, index, true); // We set isCustomIndex to 'true', because the component could open a gallery details with more images than those shown in the slider
    }
  }

  function reset() {
    gallerySwiper.update();
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initGallerySliderSwiper();
    initGalleryDetail();
    bindEvents();
  }

  return {
    init: init,
    reset: reset
  };
};
"use strict";

var Acr = Acr || {};

Acr.HeroVideo = function () {
  var $heroVideo;
  var $playButton;
  var $videoTags;
  var $videoPlayerContainer;
  var $firstBackground;
  var $secondBackground;
  var videoPlayer;
  var hiddenClass = 'hidden';
  var playButtonSelector = '.js-play-button';
  var videoTagSelector = '.js-video-tag';
  var videoPlayerContainerSelector = '.js-video-player-container';
  var firstBackgroundSelector = '.js-first-background';
  var secondBackgroundSelector = '.js-second-background';
  var videoAsBackgroundClass = 'acr-hero-video--background'; // Initialize all HTML selectors

  function initSelectors(element) {
    $heroVideo = element;
    $playButton = $heroVideo.querySelector(playButtonSelector);
    $videoTags = $heroVideo.querySelectorAll(videoTagSelector);
    $videoPlayerContainer = $heroVideo.querySelector(videoPlayerContainerSelector);
    $firstBackground = $heroVideo.querySelector(firstBackgroundSelector);
    $secondBackground = $heroVideo.querySelector(secondBackgroundSelector);
  }

  function initVideoPlayer() {
    if ($videoPlayerContainer) {
      var videoType = $videoPlayerContainer.getAttribute('data-video-type');
      var videoId = $videoPlayerContainer.getAttribute('data-video-id');
      var loop = $videoPlayerContainer.getAttribute('data-video-loop');
      var autoplay = $videoPlayerContainer.getAttribute('data-video-autoplay');
      var muted = $videoPlayerContainer.getAttribute('data-video-muted');
      var background = $heroVideo.classList.contains(videoAsBackgroundClass);

      if (videoType === 'vimeo') {
        videoPlayer = new Acr.VimeoPlayerManager.vimeoPlayerObject(videoId, $videoPlayerContainer, autoplay, background, loop, muted);
      } else {
        window.onYouTubeIframeAPIReady = function () {
          var container = $($videoPlayerContainer); // Convert the "videoPlayerContainer" into a jQuery object because it is necessary for the YouTube Manager

          videoPlayer = new Acr.YouTubeManager.YouTubePlayerObject(videoId, null, container, container, autoplay);
          videoPlayer.init();
        };
      }
    }
  }

  function bindEvents() {
    if ($playButton) {
      // Event for the play button
      $playButton.addEventListener('click', playButtonClickHandler);
      $playButton.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          playButtonClickHandler();
        }
      });
    }

    if ($videoTags.length > 0) {
      // Event triggered when MP4 video ends
      $videoTags.forEach(function (video) {
        video.addEventListener('ended', endedVideoHandler);
      });
    }
  }

  function playButtonClickHandler() {
    $firstBackground.classList.add(hiddenClass);
    $secondBackground.classList.remove(hiddenClass);
    $playButton.classList.add(hiddenClass);

    if ($videoTags.length > 0) {
      $videoTags.forEach(function (video) {
        video.classList.remove(hiddenClass);
        video.play();
      });
    } else {
      $videoPlayerContainer.classList.remove(hiddenClass);
      videoPlayer.play();
    }
  }

  function endedVideoHandler() {
    $videoTags.forEach(function (video) {
      video.classList.add(hiddenClass);
    });
    $secondBackground.classList.add(hiddenClass);
    $firstBackground.classList.remove(hiddenClass);
    $playButton.classList.remove(hiddenClass);
  }

  function init(element) {
    initSelectors(element);
    initVideoPlayer();
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.HorizontalMultitab = function () {
  var $horizontalMultitab;
  var $horizontalMultitabTabs;
  var $horizontalMultitabTabsContent;
  var $desktopMedia;
  var horizontalMultitabCurrentTheme;
  var tabSelectorClass = '.js-multitab-tab-item';
  var tabContentSelectorClass = '.js-multitab-tab-content';
  var desktopMediaSelectorClass = '.js-desktop-media';
  var tabActiveClass = 'acr-horizontal-multitab__tab-item--active';
  var tabContentActiveClass = 'acr-horizontal-multitab__tab-content--active';
  var desktopMediaActiveClass = 'acr-horizontal-multitab__desktop-media--active';
  var jsModuleClass = '.js-module';
  var lightTheme = 'light-theme';

  function initSelectors(element) {
    $horizontalMultitab = element;
    $horizontalMultitabTabs = $horizontalMultitab.querySelectorAll(tabSelectorClass);
    $horizontalMultitabTabsContent = $horizontalMultitab.querySelectorAll(tabContentSelectorClass);
    $desktopMedia = $horizontalMultitab.querySelectorAll(desktopMediaSelectorClass);
  }

  function bindEvents() {
    // Attachment of click events for each of the tabs
    $horizontalMultitabTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  } // Function that is called when a tab is clicked


  function tabClickHandler() {
    var clickedTabId = this.getAttribute('tab-id');
    updateTabsStatus(clickedTabId);
    updateDesktopMedia(clickedTabId);

    if (horizontalMultitabCurrentTheme) {
      updateTheme(clickedTabId);
    }

    resetContent(clickedTabId);
  } // Function to set a tab and its content as an "active" tab when a new tab is clicked.


  function updateTabsStatus(paramTargetTab) {
    $horizontalMultitabTabs.forEach(function (tab) {
      var tabId = tab.getAttribute('tab-id');

      if (tabId === paramTargetTab) {
        tab.classList.add(tabActiveClass);
      } else {
        tab.classList.remove(tabActiveClass);
      }
    });
    $horizontalMultitabTabsContent.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');

      if (tabContentId === paramTargetTab) {
        tabContent.classList.add(tabContentActiveClass);
      } else {
        tabContent.classList.remove(tabContentActiveClass);
      }
    });
  } // Function to change a desktop media element as "active" when a new tab is clicked.


  function updateDesktopMedia(paramTargetTab) {
    $desktopMedia.forEach(function (item) {
      var relatedTabId = item.getAttribute('related-tab-id');

      if (relatedTabId === paramTargetTab) {
        item.classList.add(desktopMediaActiveClass);
      } else {
        item.classList.remove(desktopMediaActiveClass);
      }
    });
  } // Function that is called to change the theme of the component


  function updateTheme(paramTargetTab) {
    var $horizontalMultitabTab = $horizontalMultitab.querySelector('#' + paramTargetTab);
    var dataTheme = $horizontalMultitabTab.getAttribute('data-theme');
    var dataBgColor = $horizontalMultitabTab.getAttribute('data-bg-color');
    $horizontalMultitab.classList.remove(horizontalMultitabCurrentTheme);

    if (dataTheme === '') {
      horizontalMultitabCurrentTheme = lightTheme;
    } else {
      horizontalMultitabCurrentTheme = dataTheme;
    }

    $horizontalMultitab.classList.add(horizontalMultitabCurrentTheme);
    $horizontalMultitab.style.backgroundColor = dataBgColor;
  } // Function that sets the current theme being used when the page loads


  function setInitialTheme() {
    var $currentActiveTab = $horizontalMultitab.querySelector('.' + tabContentActiveClass);
    var horizontalMultitabCurrentBg = $currentActiveTab.getAttribute('data-bg-color');
    horizontalMultitabCurrentTheme = $currentActiveTab.getAttribute('data-theme');

    if (horizontalMultitabCurrentTheme === '') {
      horizontalMultitabCurrentTheme = lightTheme;
    }

    if (horizontalMultitabCurrentBg) {
      $horizontalMultitab.style.backgroundColor = horizontalMultitabCurrentBg;
    }

    if (horizontalMultitabCurrentTheme) {
      $horizontalMultitab.classList.add(horizontalMultitabCurrentTheme);
    }
  }

  function resetContent(paramTargetTab) {
    var $horizontalMultitabTab = $horizontalMultitab.querySelector('#' + paramTargetTab);
    var $modules = $horizontalMultitabTab.querySelectorAll(jsModuleClass);

    for (var modulesIndex = 0; modulesIndex < $modules.length; modulesIndex++) {
      var moduleId = $modules[modulesIndex].dataset.moduleId;

      if (moduleId) {
        var currentModule = Acr.Modules[moduleId];

        if (currentModule.reset) {
          currentModule.reset();
        }
      }
    }
  }

  function init(element) {
    initSelectors(element);

    if ($horizontalMultitab.querySelector('.' + tabContentActiveClass)) {
      setInitialTheme();
      bindEvents();
    }
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.InputCard = function () {
  Acr = window.Acr || {};
  var $element;
  var $form;
  var $input;
  var $submitButton;
  var $errorMessage;
  var $inputSettings;
  var placeHoldText;
  var formInput = '.js-form-input';
  var submBtn = '.js-submit-btn';
  var inputSettings = '.js-input-settings';
  var errorMessage = '.js-error-message';

  function inputZip() {
    this.value = this.value.replace(/\D/m, '');

    if (this.value.length > 5) {
      this.value = this.value.slice(0, 5);
    }
  }

  function showError() {
    var errorMessageText = $inputSettings.data('errorMessage');
    $errorMessage.text(errorMessageText);
  }

  function clearError() {
    $errorMessage.text('');
  }

  function validZipcodeSubmit() {
    $form.submit();
  }

  function validateZipcode(e) {
    var value = $input.val();
    e.preventDefault();
    callTrackingClick();
    Utility.validateZipcode(value, validZipcodeSubmit, showError);
  }

  function initSelectors(element) {
    $element = $(element);
    $form = $(element).find('form');
    $input = $(element).find(formInput);
    $submitButton = $(element).find(submBtn);
    $inputSettings = $element.find(inputSettings);
    $errorMessage = $element.find(errorMessage);
    placeHoldText = $input.attr('placeholder');
  }

  function callTrackingClick() {
    var stringObject = $submitButton.attr('data-form-submit-tracking') ? $submitButton.attr('data-form-submit-tracking') : '';
    var clickObject = JSON.parse(stringObject.split("'").join('"'));

    if (clickObject && Acr.TrackingManager) {
      Acr.TrackingManager.clickActivity(clickObject);
    }
  }

  function inputFocus() {
    $input.attr('placeholder', '');
    clearError();
  }

  function inputBlur() {
    clearError();

    if ($input.val() === '') {
      $input.attr('placeholder', placeHoldText);
    }
  }

  function bindEvents() {
    $input.on('focus', inputFocus);
    $input.on('blur', inputBlur);
    $input.on('input', inputZip);
    $submitButton.on('click', validateZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.InterstitialModal = function () {
  var $element;
  var $documentBody;
  var $interstitialClose;
  var $interstitialBtn;
  var modalOpenClass = 'modal-open';
  var interstitialClose = '.js-interstitial-close';
  var interstitialBtn = '.js-interstitial-btn';

  function openRedirect(event) {
    $element.css('display', 'block');
    $interstitialBtn.attr('data-model-name', event.detail.model);
    $interstitialBtn.attr('data-model-year', event.detail.year);
    $interstitialBtn.attr('href', event.detail.url);
    $documentBody.addClass(modalOpenClass);
    window.Acr.TrackingManager.savePageLoadObject();
    triggerTaggingPage(event.detail.taggingJson);
  }

  function closeRedirect() {
    $element.css('display', 'none');
    $documentBody.removeClass(modalOpenClass);
    window.Acr.TrackingManager.restorePageLoadObject();
  }

  function triggerRedirect() {
    closeRedirect();
  }

  function triggerTaggingPage(trackingObject) {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad(trackingObject);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $documentBody = $('body');
    $interstitialClose = $(interstitialClose);
    $interstitialBtn = $(interstitialBtn);
  }

  function bindEvents() {
    window.addEventListener('openInterstitialModal', openRedirect);
    $interstitialClose.click(closeRedirect);
    $interstitialBtn.click(triggerRedirect);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.Location = function () {
  var utility = window.Utility;
  var formVisible = false;
  var zipcodeUpdateEvent;
  var zipcodeValue;
  var $element;
  var $locationButton;
  var $locationForm;
  var $locationFormInput;
  var $locationFormButton;
  var $locationPlaceholder;
  var $locationZipcode;
  var $locationError;
  var locationButton = '.js-location-button';
  var locationForm = '.js-location-form';
  var locationFormInput = '.js-location-form-input';
  var locationFormButton = '.js-location-form-button';
  var locationPlaceholder = '.js-location-placeholder';
  var locationZipcode = '.js-location-zipcode';
  var locationError = '.js-location-error';
  var locationFormError = 'acr-location__form--error';
  var currentClass = 'acr-location__button--current';

  function validateZipCode() {
    var $this = $(this);
    var inputValue = $this.val();
    var antiRegex = new RegExp(/[^0-9]+/g);
    var validZipcode = new RegExp(/^\d{5}$/);
    $locationError.hide();
    $locationForm.removeClass(locationFormError);
    $this.val(inputValue.replace(antiRegex, ''));

    if (inputValue.match(validZipcode)) {
      $locationFormButton.prop('disabled', false);
      zipcodeValue = inputValue;
    } else {
      $locationFormButton.prop('disabled', true);
      zipcodeValue = false;
    }
  }

  function setZipcode(zipcode) {
    if (zipcode) {
      $locationPlaceholder.hide();
      $locationZipcode.show();
      $locationZipcode.text(getLocationZipcodeText(zipcode));
    }
  }

  function getLocationZipcodeText(zipcode) {
    var locationZipcodeText = $locationZipcode.text().split(':');
    locationZipcodeText[1] = zipcode;
    return locationZipcodeText.join(': ');
  }

  function setEventZipcode(event) {
    if (event.detail && event.detail.zipcode) {
      setZipcode(event.detail.zipcode);
    }
  }

  function showZipcodeError() {
    $locationForm.addClass(locationFormError);
    $locationError.show();
  }

  function validZipcodeSubmit() {
    $locationButton.removeClass(currentClass);
    $locationForm.slideUp();
    formVisible = false;
    zipcodeUpdateEvent = utility.createEvent('zipcodeUpdate', {
      zipcode: zipcodeValue
    });
    utility.setCookie('zipcode', zipcodeValue);
    window.dispatchEvent(zipcodeUpdateEvent);
  }

  function submitZipcode(event) {
    event.preventDefault();
    Utility.validateZipcode(zipcodeValue, validZipcodeSubmit, showZipcodeError);
  }

  function openZipgate() {
    Acr.zipgateComponent.openZipgate();
    $locationButton.removeClass(currentClass);
    $locationForm.slideUp();
    $locationFormInput.val('');
    $locationPlaceholder.hide();
    $locationZipcode.show();
    formVisible = false;
  }

  function showForm() {
    $locationButton.addClass(currentClass);
    $locationForm.slideDown();
    $locationPlaceholder.show();
    $locationZipcode.hide();
    formVisible = true;
  }

  function buttonActions() {
    if (!formVisible) {
      showForm();
    } else {
      openZipgate();
    }
  }

  function initZipcode() {
    zipcodeValue = utility.getCookie('zipcode');

    if (zipcodeValue) {
      setZipcode(zipcodeValue);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $locationButton = $element.find(locationButton);
    $locationForm = $element.find(locationForm);
    $locationFormInput = $element.find(locationFormInput);
    $locationFormButton = $element.find(locationFormButton);
    $locationPlaceholder = $element.find(locationPlaceholder);
    $locationZipcode = $element.find(locationZipcode);
    $locationError = $element.find(locationError);
  }

  function bindEvents() {
    $locationButton.click(buttonActions);
    $locationFormButton.click(submitZipcode);
    $locationFormInput.on('input', validateZipCode);
    window.addEventListener('zipcodeUpdate', setEventZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    initZipcode();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.MultiAccordion = function () {
  var $multiAccordion;
  var $multiAccordionLinks;
  var $multiAccordionBodies;
  var resizeWindow;
  var multiAccordionBody = '.js-multi-accordion-body';
  var multiAccordionLink = '.js-multi-accordion-link';
  var multiAccordionActive = 'acr-multi-accordion__section--active';
  var multiAccordionLook1 = 'acr-multi-accordion--look-1';

  function initSelectors(element) {
    $multiAccordion = element;
    $multiAccordionBodies = $multiAccordion.querySelectorAll(multiAccordionBody);
    $multiAccordionLinks = $multiAccordion.querySelectorAll(multiAccordionLink);
  } // Start video function when the accordion opens up


  function startVideo(video) {
    if (video) {
      video.play();
    }
  } // Stop video function when the accorion closes up


  function stopVideo(video) {
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function onClickMultiAccordion() {
    event.preventDefault();
    var accordionSection = this.parentElement.parentElement; // Select acr-multi-accordion__section

    if (accordionSection.classList.contains(multiAccordionActive)) {
      slideUp(accordionSection);
      this.setAttribute('aria-expanded', false);
    } else {
      // Check if another accordion is open for default look
      if (!$multiAccordion.classList.contains(multiAccordionLook1)) {
        var accordionContainer = accordionSection.parentElement;
        var currentActive = accordionContainer.querySelector('.' + multiAccordionActive);

        if (currentActive) {
          slideUp(currentActive);
        }
      }

      slideDown(accordionSection);
      this.setAttribute('aria-expanded', true);
    }
  } // Slide up function, close up the accordion


  function slideUp(accordionSection) {
    var accordionBody = accordionSection.querySelector(multiAccordionBody);
    var accordionVideo = accordionSection.querySelector('video');
    accordionBody.style.height = accordionBody.offsetHeight + 'px';
    /* eslint-disable no-unused-expressions */

    accordionBody.offsetHeight;
    /* eslint-enable no-unused-expressions */

    accordionBody.style.removeProperty('height');
    accordionSection.classList.remove(multiAccordionActive); // stop video

    stopVideo(accordionVideo);
  } // Slide down function, open up the accordion


  function slideDown(accordionSection) {
    var accordionBody = accordionSection.querySelector(multiAccordionBody);
    var accordionVideo = accordionSection.querySelector('video');
    accordionBody.style.height = 0;
    /* eslint-disable no-unused-expressions */

    accordionBody.offsetHeight;
    /* eslint-enable no-unused-expressions */

    accordionBody.style.height = accordionBody.scrollHeight + 'px';
    accordionSection.classList.add(multiAccordionActive); // start video

    startVideo(accordionVideo);
  } // Callback function when resizing occurs on desktop


  function onResizeMultiAccordion() {
    // If there's a timer, cancel it
    if (resizeWindow) {
      window.cancelAnimationFrame(resizeWindow);
    } // Setup the new requestAnimationFrame()


    resizeWindow = window.requestAnimationFrame(function () {
      $multiAccordionBodies.forEach(function (accordionBody) {
        accordionBody.style.removeProperty('height');
      });
    });
  }

  function bindEvents() {
    // Attachment of click events for each of the accordions
    $multiAccordionLinks.forEach(function (link) {
      link.addEventListener('click', onClickMultiAccordion);
    });
    window.addEventListener('resize', onResizeMultiAccordion);
  }

  function init(element) {
    Utility = window.Utility || {};
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.Nav = function () {
  var utility = window.Utility;
  var $element;
  var $body;
  var $toggleDropDown;
  var $navDropDown;
  var $searchForm;
  var $searchSubmitBtn;
  var $geoForm;
  var $geoZipInput;
  var $geoZipButton;
  var $currentZip;
  var $navSearch;
  var $navActionContainer;
  var zipcodeUpdateEvent;
  var observer;
  var $acrNotificationContainer;
  var $acrNotificationPagination;
  var $acrNotificationBannerItems;
  var $arrowRight;
  var $arrowLeft;
  var $acrNotificationBannerSwiper;
  var currentOfferEndpoint = Acr.currentOfferEndPoint;
  var zipcodeUpdateEventName = 'zipcodeUpdate';
  var bodyTagSelector = 'body';
  var navDropdownClassSelector = '.js-nav-dropdown';
  var toggleDropDownClassSelector = '.js-toggle-dropdown';
  var toggleLangChooserBtnSelector = '.js-lang-chooser-btn';
  var searchBtnSelector = '.js-search-btn';
  var geoBtnSelector = '.js-geo-btn';
  var shadowSelector = '.js-shadow';
  var currentZipSelector = '.js-current-zip';
  var searchFormSelector = '.js-search-form';
  var searchSubmitBtnSelector = '.js-acr-nav-search-submit';
  var openZipGateSelector = '.js-open-zipgate';
  var geoFormSelector = '.js-geo-form';
  var toggleBarClassSelector = '.js-toggle-btn';
  var acrNavInputSelector = '.js-search-form input';
  var acrNavGeoInputSelector = '.js-geo-form input';
  var acrNavGeoButtonSelector = '.js-geo-form button';
  var navSearchSelector = 'nav-search';
  var acrNavActionContainerSelector = '.acr-nav__action-container';
  var acrNavGeoErrorClassName = 'acr-nav--geo-error';
  var noValidClassName = 'no-valid';
  var acrNavShadowClassName = 'acr-nav--shadow-visible';
  var modalOpenClassName = 'modal-open';
  var noScrollSmall = 'no-scroll-small';
  var acrNavExpandedClassName = 'acr-nav--opened';
  var acrNavSearchExpandedClassName = 'acr-nav--search-opened';
  var acrNavGeoExpandedClassName = 'acr-nav--geo-opened';
  var acrNavLangExpandedClassName = 'acr-nav-lang-chooser--expanded';
  var acrNavItemLinkExpandedClassName = 'acr-nav__item-link--expanded';
  var acrNavDropdownExpandedClassName = 'acr-nav__dropdown--expanded';
  var arrowRightSelector = '.js-arrow-right';
  var arrowLeftSelector = '.js-arrow-left';
  var acrNotificationPaginationSelector = '.js-swiper-pagination';
  var acrNotificationContainerSelector = '.js-swiper-container';
  var acrNotificationBannerItemSelector = '.js-acr-notification-banner-item';
  var formSubmitTracking = 'data-form-submit-tracking';

  function initSelectors(el) {
    $element = el;
    $toggleDropDown = $element.querySelectorAll(toggleDropDownClassSelector);
    $navDropDown = $element.querySelectorAll(navDropdownClassSelector);
    $searchForm = $element.querySelector(searchFormSelector);
    $searchSubmitBtn = $element.querySelector(searchSubmitBtnSelector);
    $navActionContainer = $element.querySelector(acrNavActionContainerSelector);
    $geoForm = $element.querySelector(geoFormSelector);
    $geoZipInput = $element.querySelector(acrNavGeoInputSelector);
    $geoZipButton = $element.querySelector(acrNavGeoButtonSelector);
    $body = document.querySelector(bodyTagSelector);
    $currentZip = $element.querySelector(currentZipSelector);
    $navSearch = document.getElementById(navSearchSelector);
    $acrNotificationContainer = $element.querySelector(acrNotificationContainerSelector);
    $acrNotificationBannerItems = $element.querySelectorAll(acrNotificationBannerItemSelector);
    $acrNotificationPagination = $element.querySelector(acrNotificationPaginationSelector);
    $arrowLeft = $element.querySelector(arrowLeftSelector);
    $arrowRight = $element.querySelector(arrowRightSelector);
  } // Close Menu


  function closeMenu(el) {
    closeSubMenu(el);
    setClosedState(el);
  } // Set Closed State (Only necessary for Desktop)


  function setClosedState(el) {
    $body.classList.remove(modalOpenClassName);
    el.classList.remove(acrNavShadowClassName);
  } // Set Opened State (Only necessary for Desktop)


  function setOpenedState(el) {
    $body.classList.add(modalOpenClassName);
    el.classList.add(acrNavShadowClassName);
  } // Bind Menu Toggle events (Open/ Close)


  function toggleMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(toggleBarClassSelector) > 0 ? self : undefined || self.closest(toggleBarClassSelector);
      }

      if (!mappedSelf) return;

      if (el.classList.contains(acrNavExpandedClassName)) {
        el.classList.remove(acrNavExpandedClassName);
        $body.classList.remove(noScrollSmall);
        $body.classList.remove(modalOpenClassName);
        closeSubMenu(el);
        setClosedState(el);
      } else {
        el.classList.add(acrNavExpandedClassName);
        $body.classList.add(noScrollSmall);
      }
    });
  } // When Shadow is clicked menu must close


  function toggleShadowMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(shadowSelector) > 0 ? self : undefined || self.closest(shadowSelector);
      }

      if (mappedSelf) {
        closeMenu(el);
      }
    });
  } // Bind Sub Menus Toggle events (Open/ Close)


  function toggleSubMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      var $target;
      var targetId;
      event.stopPropagation();
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(toggleDropDownClassSelector) > 0 ? event.target : undefined || self.closest(toggleDropDownClassSelector);
      }

      if (!mappedSelf) return;
      targetId = mappedSelf.getAttribute('href');
      $target = document.querySelector(targetId);

      if ($target.classList.contains(acrNavDropdownExpandedClassName)) {
        closeSubMenu(el);
        $target.classList.remove(acrNavDropdownExpandedClassName);
        mappedSelf.classList.remove(acrNavItemLinkExpandedClassName);
        setClosedState(el);
      } else {
        closeSubMenu(el);
        $target.classList.add(acrNavDropdownExpandedClassName);
        mappedSelf.classList.add(acrNavItemLinkExpandedClassName);
        setOpenedState(el);
      }
    });
  } // Bind Lang Choser Toggle events (Open/ Close)


  function toggleLangMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(toggleLangChooserBtnSelector) > 0 ? self : undefined || self.closest(toggleLangChooserBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavLangExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavLangExpandedClassName);
        setOpenedState(el);
      } else {
        closeSubMenu(el);
        el.classList.remove(acrNavLangExpandedClassName);
        setClosedState(el);
      }
    });
  } // Bind Search Toggle events (Open/ Close)


  function toggleSearch(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(searchBtnSelector) > 0 ? self : undefined || self.closest(searchBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavSearchExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavSearchExpandedClassName);
        $navSearch.focus();
        setClosedState(el);
      } else {
        closeSubMenu(el);
        el.classList.remove(acrNavSearchExpandedClassName);
        setClosedState(el);
      }
    });
  }

  function closeGeo() {
    $element.classList.remove(acrNavGeoExpandedClassName);
    $geoForm.classList.remove(noValidClassName);
    $geoZipInput.classList.remove(noValidClassName);
    $geoZipInput.value = '';
    setClosedState($element);
  } // Bind Search Toggle events (Open/ Close)


  function toggleGeo(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (!observer) {
        observer = new IntersectionObserver(inputObserverHandler);
      }

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(geoBtnSelector) > 0 ? self : undefined || self.closest(geoBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavGeoExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavGeoExpandedClassName);
        $geoZipButton.disabled = true;
        $geoZipInput.focus();
        setClosedState(el);
      } else {
        closeSubMenu(el);
        closeGeo();
        observer.unobserve($geoZipInput);
      }
    });
  } // Close all SubMenu Items - Includes Lang Chooser


  function closeSubMenu(el) {
    el.classList.remove(acrNavLangExpandedClassName);

    for (var i = 0; i < $toggleDropDown.length; i++) {
      $toggleDropDown[i].classList.remove(acrNavItemLinkExpandedClassName);
    }

    for (var j = 0; j < $navDropDown.length; j++) {
      $navDropDown[j].classList.remove(acrNavDropdownExpandedClassName);
    }
  }

  function onSubmitSearchForm() {
    $searchForm.addEventListener('submit', function (e) {
      if (e.target.querySelector(acrNavInputSelector).value === '') {
        e.preventDefault();
        $searchForm.classList.add(noValidClassName);
        return;
      }

      var stringObject = $searchSubmitBtn.hasAttribute(formSubmitTracking) ? $searchSubmitBtn.getAttribute(formSubmitTracking) : '';

      if (Acr.TrackingManager && stringObject) {
        try {
          var object = JSON.parse(stringObject.split("'").join('"'));
          Acr.TrackingManager.clickActivity(object);
        } catch (err) {
          console.warn('ERROR AT TRACKING OBJECT: ' + err);
        }
      }
    });
  }

  function updateGeoZipCodeUI(zipCode) {
    $currentZip.innerText = zipCode;
  }

  function updateGeoZipCode(zipcode) {
    zipcodeUpdateEvent = utility.createEvent(zipcodeUpdateEventName, {
      zipcode: zipcode
    });
    utility.setCookie('zipcode', zipcode);
    window.dispatchEvent(zipcodeUpdateEvent);
    updateGeoZipCodeUI(zipcode);
  }

  function onChangeGeoForm() {
    $geoZipInput.addEventListener('input', function (event) {
      var inputValue = this.value;
      var antiRegex = new RegExp(/[^0-9]+/g);
      var validZipcode = new RegExp(/^\d{5}$/);
      $geoForm.classList.remove(noValidClassName);
      $element.classList.remove(acrNavGeoErrorClassName);
      this.value = inputValue.replace(antiRegex, '');

      if (inputValue.match(validZipcode)) {
        $geoZipButton.disabled = false;
      } else {
        $geoZipButton.disabled = true;
      }
    });
  }

  function showGeoFormError() {
    $geoForm.classList.add(noValidClassName);
    $element.classList.add(acrNavGeoErrorClassName);
  }

  function validZipcodeSubmit() {
    var inputValue = $geoZipInput.value;
    updateGeoZipCode(inputValue);
    closeGeo();
  }

  function onSubmitGeoForm() {
    var inputValue;

    if ($geoForm.addEventListener) {
      $geoForm.addEventListener('submit', function (event) {
        event.preventDefault();
        inputValue = $geoZipInput.value;
        Utility.validateZipcode(inputValue, validZipcodeSubmit, showGeoFormError);
      }, true);
    }
  }

  function initZipcode() {
    var zipcode;
    window.addEventListener('zipcodeUpdate', function (event) {
      updateGeoZipCodeUI(event.detail.zipcode);
    });
    zipcode = utility.getUrlParameterValue('zipcode') || utility.getCookie('zipcode');

    if (zipcode) {
      updateGeoZipCode(zipcode);
    }
  }

  function onClickLocationbtn() {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class') && self.getAttribute('class').search(openZipGateSelector) > 0 ? self : undefined || self.closest(openZipGateSelector);
      }

      if (mappedSelf) {
        Acr.zipgateComponent.openZipgate();
        $element.classList.remove(acrNavExpandedClassName);
        $body.classList.remove(noScrollSmall);
        $body.classList.remove(modalOpenClassName);
        closeGeo();
        closeSubMenu($element);
        setClosedState($element);
      }
    });
  }

  function onGeoZipInputFocus() {
    if (utility.isAndroid()) {
      $geoZipInput.addEventListener('focus', function () {
        $navActionContainer.style.paddingBottom = '6rem';
        observer.observe($geoZipInput);
      });
    }
  }

  function inputObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        observer.unobserve($geoZipInput);
        window.setTimeout(function () {
          $geoZipButton.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
        }, 500);
      }
    });
  }

  function bindEvents(el) {
    toggleMenu(el);
    toggleShadowMenu(el);
    toggleSubMenu(el);
    toggleLangMenu(el);
    toggleSearch(el);
    toggleGeo(el);
    initZipcode();
    onChangeGeoForm();
    onSubmitSearchForm();
    onSubmitGeoForm();
    onClickLocationbtn();
    onGeoZipInputFocus();
  }

  function initNotificationBanner(el) {
    if ($acrNotificationContainer && $acrNotificationBannerItems.length > 1) {
      $acrNotificationBannerSwiper = new Swiper($acrNotificationContainer, {
        // Optional parameters
        loop: false,
        // If we need pagination
        pagination: {
          el: $acrNotificationPagination,
          type: 'fraction'
        },
        // Navigation arrows
        navigation: {
          nextEl: $arrowRight,
          prevEl: $arrowLeft
        },
        init: true
      });
      $acrNotificationPagination.childNodes[1].nodeValue = ' of ';
    }
  }

  function init(el) {
    initSelectors(el);
    bindEvents(el);
    initNotificationBanner(el);
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.NavHelper = function () {
  var Utility = window.Utility || {};
  var $wrapper = $('.wrapper');
  var hideMenuOnScroll = Acr.hideMenuOnScroll || false;
  var $window = $(window);
  var lastScrollTop = 0;

  function peekABoo() {
    var st = $window.scrollTop();

    if (st + 180 < lastScrollTop || st <= 0) {
      if ($wrapper.hasClass('collapsed-nav')) {
        $wrapper.removeClass('collapsed-nav');
      }

      if (!$wrapper.hasClass('expanded-nav')) {
        $wrapper.addClass('expanded-nav'); // Add an event to the document when Global Nav is expands or collapses

        Utility.fireEvent(document, 'expandedGlobalNav');
      }

      lastScrollTop = st;
    }

    if (st - 180 > lastScrollTop) {
      if ($wrapper.hasClass('expanded-nav')) {
        $wrapper.removeClass('expanded-nav');
      }

      if (!$wrapper.hasClass('collapsed-nav')) {
        $wrapper.addClass('collapsed-nav'); // Add an event to the document when Global Nav is expands or collapses

        Utility.fireEvent(document, 'expandedGlobalNav');
      }

      lastScrollTop = st;
    }
  }

  function init() {
    try {
      if (hideMenuOnScroll) {
        $window.on('scroll orientationchange', $.throttle(250, peekABoo));
        $wrapper.addClass('expanded-nav');
      }
    } catch (e) {
      Utility.error(e);
    }
  }

  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};

Acr.SignUp = function () {
  var $signUp;
  var $signUpForm;
  var $signUpBody;
  var $signUpProcessing;
  var $signUpResponse;
  var $signUpResponseCopy;
  var $signUpFormInputs;
  var $signUpFormCheckboxes;
  var $signUpSubmitBtn;
  var $signUpZipCodeInput;
  var $signUpZipCodeField;
  var $signUpZipCodeFieldError;
  var $dynamicModelTracking;
  var $contactDealerTracking;
  var $labelsForm;
  var formSelectorClass = '.js-acr-sign-up-form';
  var bodySelectorClass = '.js-acr-sign-up-body';
  var processingSelectorClass = '.js-acr-sign-up-processing';
  var responseSelectorClass = '.js-acr-sign-up-response';
  var responseCopySelectorClass = '.js-acr-sign-up-copy';
  var inputSelectorClass = '.js-acr-sign-up-input';
  var checkboxSelectorClass = '.js-acr-sign-up-checkbox';
  var submitBtnSelectorClass = '.js-acr-sign-up-submit';
  var labelFormSelector = '.js-acr-sign-up-label';
  var requiredClass = 'acr-required';
  var requiredAttr = 'required';
  var conditionalRequiredAttr = 'data-conditional-required';
  var conditionalRequiredCountAttr = 'data-conditional-required-count';
  var formSubmitTracking = 'data-form-submit-tracking';
  var formCheckboxTracking = 'data-form-checkbox-tracking';
  var formcontactDealerTracking = 'data-lead-metadata';
  var fieldErrorClass = 'acr-form-element-error';
  var fieldErrorMessage = '.acr-sign-up__error';
  var errorFieldAttr = 'data-error-text';
  var zipCodeRegex = '[zipcode]';

  function sendSuccessTrackingObject(isSuccess) {
    var stringObject = $signUpSubmitBtn.hasAttribute(formSubmitTracking) ? $signUpSubmitBtn.getAttribute(formSubmitTracking) : '';

    if (Acr.TrackingManager && stringObject) {
      try {
        var object = JSON.parse(stringObject.split("'").join('"'));
        object['Event Metadata'].contact_dealer = $contactDealerTracking;

        if ($dynamicModelTracking && object) {
          object.Model = $dynamicModelTracking.Model;
        }

        if (isSuccess && object) {
          object.dynamic_variables[0].search += ' success';
        }

        Acr.TrackingManager.clickActivity(object);
      } catch (err) {
        console.warn('ERROR AT TRACKING OBJECT: ' + err);
      }
    }
  }

  function send(form) {
    var method = form.getAttribute('method');
    var url = form.getAttribute('action');
    var data = getFormElements(form);
    sendSuccessTrackingObject(false);

    var beforeSend = function beforeSend() {
      $signUpProcessing.classList.add('show');
      $signUpBody.classList.add('hide');
    };

    var request = new XMLHttpRequest();
    request.open(method, url, true);

    request.onload = function (data) {
      var response = JSON.parse(data.currentTarget.response);

      if (response.Status === 'success') {
        sendSuccessTrackingObject(true);
      }

      $signUpProcessing.classList.remove('show');
      $signUpResponseCopy.innerHTML += response.Message;
      $signUpResponse.classList.add('show');
    };

    request.setRequestHeader('Content-Type', 'application/json');
    beforeSend();
    request.send(data);
  }

  function getFormElements(form) {
    var dataJSON = {};
    dataJSON.checkboxes = [];
    $contactDealerTracking = 'false';
    var formElements = form.elements;
    Array.prototype.forEach.call(formElements, function (element) {
      if (element.nodeName === 'INPUT') {
        if (element.type === 'checkbox') {
          var checkboxElement = {};
          checkboxElement.name = element.name;
          checkboxElement.value = element.checked;
          dataJSON.checkboxes.push(checkboxElement);

          if (element.hasAttribute(formCheckboxTracking) && element.checked) {
            var stringObject = element.getAttribute(formCheckboxTracking);
            var checkboxTracking = JSON.parse(stringObject.split("'").join('"'));

            if (!$dynamicModelTracking) {
              $dynamicModelTracking = checkboxTracking;
            } else {
              $dynamicModelTracking.Model.model_name += ';' + checkboxTracking.Model.model_name;

              if (!$dynamicModelTracking.Model.model_year.includes(checkboxTracking.Model.model_year)) {
                $dynamicModelTracking.Model.model_year += ';' + checkboxTracking.Model.model_year;
              }

              if (!$dynamicModelTracking.Model.body_style.includes(checkboxTracking.Model.body_style)) {
                $dynamicModelTracking.Model.body_style += ';' + checkboxTracking.Model.body_style;
              }
            }
          }

          if (element.hasAttribute(formcontactDealerTracking) && element.checked && $contactDealerTracking === 'false') {
            $contactDealerTracking = element.getAttribute(formcontactDealerTracking);
          }
        } else {
          dataJSON[element.name] = element.value;
        }
      }
    });
    return JSON.stringify(dataJSON);
  }

  function onSubmit(e) {
    e.preventDefault();
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e); // validate zip code

    if (ValidateZipCode()) {
      var successZipCode = function successZipCode() {
        $signUpZipCodeFieldError.innerText = '';

        if ($signUpZipCodeField.classList.contains(fieldErrorClass)) {
          $signUpZipCodeField.classList.remove(fieldErrorClass);
        }

        if (success) {
          send(e.target);
        }
      };

      var errorZipCode = function errorZipCode() {
        var errorMsj = $signUpZipCodeInput.getAttribute(errorFieldAttr);
        $signUpZipCodeFieldError.innerText = errorMsj;

        if (!$signUpZipCodeField.classList.contains(fieldErrorClass)) {
          $signUpZipCodeField.classList.add(fieldErrorClass);
        }
      };

      Utility.validateZipcode($signUpZipCodeInput.value, successZipCode, errorZipCode);
    } else if (success) {
      send(e.target);
    }
  }

  function ValidateZipCode() {
    var validateZipCode = false;

    if (!$signUpZipCodeInput) {
      return validateZipCode;
    }

    if ($signUpZipCodeInput.value !== '') {
      validateZipCode = true;
    }

    return validateZipCode;
  }

  function OnChangeCheckbox(evt) {
    var checkbox = evt.target;
    var dataConditionRequired = checkbox.getAttribute(conditionalRequiredAttr);
    var inputRequiredIds = dataConditionRequired.split(',');
    inputRequiredIds.forEach(function (inputId) {
      var requiredLabel;
      $labelsForm.forEach(function (element) {
        if (element.htmlFor === inputId) {
          requiredLabel = element;
        }
      });
      var inputRequired = document.getElementById(inputId);

      if (inputRequired) {
        var hasRequiredCount = inputRequired.hasAttribute(conditionalRequiredCountAttr);
        var isRequired = inputRequired.hasAttribute(requiredAttr);

        if (isRequired && !hasRequiredCount) {
          return;
        }

        var countRequired = hasRequiredCount ? inputRequired.getAttribute(conditionalRequiredCountAttr) : 0;

        if (checkbox.checked) {
          inputRequired.classList.add(requiredClass);
          inputRequired.setAttribute(requiredAttr, requiredAttr);
          requiredLabel.classList.add(requiredClass);
          requiredLabel.setAttribute(requiredAttr, requiredAttr);
          countRequired++;
          inputRequired.setAttribute(conditionalRequiredCountAttr, countRequired);
        } else {
          countRequired--;

          if (countRequired === 0) {
            inputRequired.classList.remove(requiredClass);
            inputRequired.removeAttribute(requiredAttr);
            requiredLabel.classList.remove(requiredClass);
            requiredLabel.removeAttribute(requiredAttr);
            inputRequired.removeAttribute(conditionalRequiredCountAttr);
          } else {
            inputRequired.setAttribute(conditionalRequiredCountAttr, countRequired);
          }
        }
      }
    });
  }

  function initSelectors(element) {
    $signUp = element;
    $signUpForm = $signUp.querySelector(formSelectorClass);
    $signUpBody = $signUp.querySelector(bodySelectorClass);
    $signUpProcessing = $signUp.querySelector(processingSelectorClass);
    $signUpResponse = $signUp.querySelector(responseSelectorClass);
    $signUpResponseCopy = $signUpResponse.querySelector(responseCopySelectorClass);
    $signUpFormInputs = $signUpForm.querySelectorAll(inputSelectorClass);
    $signUpFormCheckboxes = $signUpForm.querySelectorAll(checkboxSelectorClass);
    $signUpSubmitBtn = $signUp.querySelector(submitBtnSelectorClass);
    $labelsForm = $signUp.querySelectorAll(labelFormSelector);
  }

  function bindEvents() {
    $signUpFormInputs.forEach(function (inputText) {
      inputText.addEventListener('keypress', Validation.onKeypress);
      inputText.addEventListener('keyup', Validation.onKeyup);
      inputText.addEventListener('focus', Validation.onFocus);
      inputText.addEventListener('blur', Validation.onBlur);

      if (inputText.getAttribute('data-regexkey') === zipCodeRegex) {
        $signUpZipCodeInput = inputText;
        $signUpZipCodeField = $signUpZipCodeInput.parentElement;
        $signUpZipCodeFieldError = $signUpZipCodeField.querySelector(fieldErrorMessage);
      }
    });
    var isIE = Utility.isIE11();
    $signUpFormCheckboxes.forEach(function (checkbox) {
      if (isIE) checkbox.classList.add('ie11');
      var dataConditionRequired = checkbox.getAttribute(conditionalRequiredAttr);

      if (dataConditionRequired) {
        var checkboxElement = document.getElementById(checkbox.id);
        checkboxElement.addEventListener('change', OnChangeCheckbox, false);
      }
    });
    $signUpForm.addEventListener('submit', onSubmit);
  }

  function init(element) {
    initSelectors(element);
    bindEvents(element);
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.Slider = function () {
  var $quotesSlider;
  var $quotesSwiperContainer;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $swiperSlides;
  var quotesSwiper;
  var swiperContainerSelector = '.js-swiper-container';
  var swiperPaginationSelector = '.js-swiper-pagination';
  var arrowLeftSelector = '.js-arrow-left';
  var arrowRightSelector = '.js-arrow-right';
  var swiperSlideSelector = '.js-swiper-slide';
  var arrowDisabledClass = 'quotes-container__arrow--disabled'; // Initialize all HTML selectors

  function initSelectors(element) {
    $quotesSlider = element;
    $quotesSwiperContainer = $quotesSlider.querySelector(swiperContainerSelector);
    $swiperPagination = $quotesSlider.querySelector(swiperPaginationSelector);
    $arrowLeft = $quotesSlider.querySelector(arrowLeftSelector);
    $arrowRight = $quotesSlider.querySelector(arrowRightSelector);
    $swiperSlides = $quotesSlider.querySelectorAll(swiperSlideSelector);
  } // Initialize the swiper slider


  function initQuotesSliderSwiper() {
    quotesSwiper = new Swiper($quotesSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft
      },
      init: false
    });

    if ($swiperSlides.length > 1) {
      quotesSwiper.init();
    } else {
      $arrowLeft.classList.add(arrowDisabledClass);
      $arrowRight.classList.add(arrowDisabledClass);
    }

    quotesSwiper.on('slideChange', function () {
      if (Acr.TrackingManager && event.type !== 'resize') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function init(element) {
    initSelectors(element);
    initQuotesSliderSwiper();
  }

  return {
    init: init
  };
};
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Acr = Acr || {};

Acr.SocialGrid = function () {
  var utility = window.Utility;
  var $body;
  var $socialGrid;
  var $socialCardsSlider;
  var $socialModalSlider;
  var $socialModalVideo;
  var $socialModal;
  var resizeTimer;
  var showDots;
  var showArrows;
  var slidesToShow;
  var slidesToScroll;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $socialGridSwiper;
  var $socialGridSwiperContainer;
  var $swiperSlide;
  var focusableElements = 'button, [href]:not(.modal-cta), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var selectorAnchorVideo = '[href], svg.js-play-video';
  var selectorModalVisible = '.js-social-modal.visible';
  var swiperSlideActiveSelector = '.swiper-slide.swiper-slide-active';
  var modalOverlaySelector = '.acr-social-modal__overlay';
  var socialModalCloseSelector = '.acr-icon.acr-social-modal__close';
  var focusableEls = document.querySelectorAll(focusableElements);
  var firstFocusableEl = focusableEls[0];
  var lastFocusableEl = focusableEls[focusableEls.length - 1];

  function initSocialGridSwiper() {
    var navigation = false;
    var pagination = false;

    if ($socialGrid.classList.contains('social-grid--look-2') || $socialGrid.classList.contains('social-grid--look-3')) {
      if ($arrowLeft && $arrowRight) {
        Utility.removeClass('hide', $arrowLeft);
        Utility.removeClass('hide', $arrowRight);
      }
    }

    if ($socialGrid.classList.contains('social-grid--look-3')) {
      slidesToShow = 1.5;
      slidesToScroll = 1;
    } else {
      slidesToShow = 3;
      slidesToScroll = 3;
    }

    if (showArrows) {
      navigation = {
        nextEl: $arrowRight,
        prevEl: $arrowLeft
      };
    }

    if (showDots) {
      pagination = {
        el: $swiperPagination,
        clickable: true
      };
    }

    $socialGridSwiper = new Swiper($socialGridSwiperContainer, {
      slidesPerView: 1,
      watchSlidesVisibility: true,
      centeredSlides: false,
      loop: true,
      pagination: pagination,
      navigation: navigation,
      init: true,
      breakpoints: {
        550: {
          slidesPerView: slidesToShow
        }
      },
      on: {
        init: function init() {
          setTabIndex();
        }
      }
    });
    $socialGridSwiper.on('click', function (event) {
      var goToSingleSlide = this.clickedSlide.dataset.swiperSlideIndex;

      if ($socialModal) {
        openHandler(goToSingleSlide);
      }
    });
    $socialGridSwiper.$el.on('keydown', function (event) {
      if (event.keyCode !== 13 && event.keyCode !== 32) return;
      var goToSingleSlide = event.target.dataset.swiperSlideIndex;

      if ($socialModal) {
        openHandler(goToSingleSlide);
      }
    });
    $socialGridSwiper.on('slideChange', function () {
      setTabIndex();

      if (Acr.TrackingManager && event.type === 'click') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function setTabIndex() {
    $swiperSlide.forEach(function (element) {
      if (element.classList.contains('swiper-slide-visible')) {
        element.setAttribute('tabindex', '0');
      } else {
        element.removeAttribute('tabindex');
      }
    });
  }

  function attachEnters() {
    $socialModal.querySelector(socialModalCloseSelector).removeEventListener('keydown', function (e) {
      if (e.key === 'Enter') closeHandler();
    });
    $socialModal.querySelector(socialModalCloseSelector).addEventListener('keydown', function (e) {
      if (e.key === 'Enter') closeHandler();
    });
    $socialModal.querySelectorAll('.js-play-video').forEach(function (el) {
      el.removeEventListener('keydown', function (e) {
        if (e.key === 'Enter') playVideo(e);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') playVideo(e);
      });
    });
  }

  function attachClicks() {
    $socialModal.querySelector(socialModalCloseSelector).removeEventListener('click', closeHandler);
    $socialModal.querySelector(socialModalCloseSelector).addEventListener('click', closeHandler);
    $socialModal.querySelector(modalOverlaySelector).removeEventListener('click', closeHandler);
    $socialModal.querySelector(modalOverlaySelector).addEventListener('click', closeHandler);
    $socialModal.querySelector(modalOverlaySelector).removeEventListener('click', stopPropagation);
    $socialModal.querySelector(modalOverlaySelector).addEventListener('click', stopPropagation);
    $socialModal.querySelectorAll('.js-play-video').forEach(function (el) {
      el.removeEventListener('click', playVideo);
      el.addEventListener('click', playVideo);
    });

    if ($socialModalVideo) {
      $socialModalVideo.forEach(function (el) {
        el.removeEventListener('ended', resetVideo);
        el.addEventListener('ended', resetVideo);
      });
    }
  }

  function openHandler(slideToGo) {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, {
      passive: false
    });
    $body.classList.add('modal-open');
    $socialModal.classList.add('visible');
    $socialModal.focus();
    setModalHeight();
    setModalSwiper(slideToGo);
  }

  var trapFocus = function trapFocus(e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.style['-ms-user-select'] = 'text';
        lastFocusableEl.focus();
        lastFocusableEl.style['-ms-user-select'] = '';
        e.preventDefault();
      }
    }

    if (!e.shiftKey) {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.style['-ms-user-select'] = 'text';
        firstFocusableEl.focus();
        firstFocusableEl.style['-ms-user-select'] = '';
        e.preventDefault();
      }
    }
  };

  function closeHandler() {
    var currrentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector); // Enable scrolling.

    document.removeEventListener('touchmove', handleTouchLock);
    $socialModal.classList.remove('visible');
    $body.classList.remove('modal-open');
    $socialModalSlider.destroy(true, true);
    resetVideoSlide(currrentModalSlideElem, true);
  }

  function playVideo(event) {
    var $videoButton = event.currentTarget;
    var $video = Utility.prev(event.currentTarget, '.js-video');

    if (window.getComputedStyle($video, null).getPropertyValue('display') === 'none') {
      $video = Utility.prev($video, '.js-video');
    }

    if ($video) {
      $video.play();
      $videoButton.style.display = 'none';
    }
  }

  function resetVideo(event) {
    event.target.parentElement.querySelector('.js-play-video').style.display = 'block';

    if (document.activeElement.classList.contains('modal-open')) {
      $socialModal.querySelector(swiperSlideActiveSelector).querySelector('svg.js-play-video').focus();
      event.preventDefault();
    } // shows the video poster after the video ends


    var videoUrl = event.target.currentSrc;
    event.target.src = '';
    event.target.src = videoUrl;
  }

  function resetVideoSlide(slide, force) {
    var videos;

    if (slide.querySelectorAll('.js-video').length > 0) {
      slide.querySelectorAll('.js-video').forEach(function (el) {
        if (el.offsetWidth > 0 && el.offsetHeight > 0) {
          videos = [el];
        }
      });
    }

    if (force) {
      videos = _toConsumableArray(slide.querySelectorAll('.js-video'));
    }

    if (videos) {
      videos.map(function (video, index) {
        if (!video.paused) {
          var videoUrl = video.currentSrc;
          video.src = '';
          video.src = videoUrl;
        }
      });
    }

    var video = slide.querySelector('.js-play-video');

    if (video) {
      video.style.display = 'block';
    }
  }

  function setModalHeight() {
    var windowHeight = document.body.getBoundingClientRect().height;
    var modalPadding = 100; // Modal should have 50px of padding-top and 50px of padding-bottom

    var imgHeight = $socialModal.querySelector('.acr-social-modal__content-container .acr-social-modal__media-container').getBoundingClientRect().height;

    if (utility.isMobile()) {
      var headerHeight = $socialModal.querySelector('.acr-social-modal__header.header--mobile').height;
      $socialModal.querySelector('.acr-social-modal__content').innerHeight = windowHeight - headerHeight - imgHeight - modalPadding;
    } else {
      $socialModal.querySelector('.acr-social-modal__content').innerHeight = imgHeight;
    }
  }

  function setModalSwiper(slideToGo) {
    $socialModalSlider = new Swiper($socialModal.querySelector('.swiper-container'), {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: $socialModal.querySelector('.js-arrow-right'),
        prevEl: $socialModal.querySelector('.js-arrow-left')
      },
      initialSlide: parseInt(slideToGo, 10),
      on: {
        init: function init() {
          var currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector).querySelectorAll(selectorAnchorVideo);
          disableTabOnSlides();
          currentModalSlideElem.forEach(function (el) {
            el.setAttribute('tabindex', '0');
          });
          updateFocusableElements();
        }
      }
    });

    function disableTabOnSlides() {
      var elementsToDisable = $socialModal.querySelectorAll(selectorAnchorVideo);
      elementsToDisable.forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('focusable', 'false');
      });
    }

    function updateFocusableElements() {
      focusableEls = document.querySelector(selectorModalVisible).querySelectorAll(focusableElements);
      focusableEls.forEach(function (element) {
        element.removeAttribute('focusable');
      });
      firstFocusableEl = focusableEls[0];
      lastFocusableEl = focusableEls[focusableEls.length - 1];
    }

    $socialModalSlider.on('transitionEnd', function () {
      $socialGridSwiper.slideToLoop($socialModalSlider.realIndex);
    });
    $socialModalSlider.on('slideChange', function () {
      var currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector);
      resetVideoSlide(currentModalSlideElem);

      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
    $socialModalSlider.on('slideChangeTransitionEnd', function () {
      disableTabOnSlides();
      var currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector).querySelectorAll(selectorAnchorVideo);
      currentModalSlideElem.forEach(function (el) {
        el.setAttribute('tabindex', '0');
      });
      updateFocusableElements();
    });
    attachClicks();
    attachEnters();
    executeLazyLoading();
  }

  function stopPropagation(e) {
    e.stopPropagation();
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function attachKeyboardInput() {
    document.removeEventListener('keyup', keyboardHandler);
    document.addEventListener('keyup', keyboardHandler);
  }

  function keyboardHandler(e) {
    if (e.which === 27 && $socialModal.classList.contains('visible')) {
      // esc key
      closeHandler();
    }
  }

  function attachResize() {
    window.addEventListener('resize', function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!$socialModal.classList.contains('visible') && $socialModalSlider) {
          $socialModalSlider.destroy(true, true);
        }

        if ($socialModal.length && $socialModal.classList.contains('visible')) {
          var currrentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector);
          setModalHeight();
          resetVideoSlide(currrentModalSlideElem);
        }
      }, 250);
    });
  }

  function executeLazyLoading() {
    var videosToLoad = [].slice.call(document.querySelectorAll('.swiper-slide video.lazy'));
    Utility.initLazyLoadingIO(videosToLoad, Acr.LazyLoadingHelper.loadVideo);
  } // This function initializes the selectors and the data attributes required in other functions


  function initSelectors(element) {
    $body = document.body;
    $socialGrid = element;
    $socialCardsSlider = $socialGrid.querySelector('.js-social-cards-slider');
    $socialModal = Utility.next($socialGrid, '.js-social-modal');
    showDots = $socialCardsSlider.dataset.showDots === 'true';
    showArrows = $socialCardsSlider.dataset.showArrows === 'true';
    $swiperPagination = $socialGrid.querySelector('.js-swiper-pagination');
    $arrowLeft = $socialGrid.querySelector('.js-arrow-left');
    $arrowRight = $socialGrid.querySelector('.js-arrow-right');
    $socialGridSwiperContainer = $socialGrid.querySelector('.swiper-container');
    $swiperSlide = $socialGrid.querySelectorAll('.swiper-slide');

    if ($socialModal) {
      $socialModalVideo = $socialModal.querySelectorAll('.js-video');
      var closeElement = $socialModal.querySelector(socialModalCloseSelector);

      if (closeElement) {
        closeElement.setAttribute('tabindex', '0');
      }

      $socialModal.removeEventListener('keydown', trapFocus);
      $socialModal.addEventListener('keydown', trapFocus);
    }
  }

  function init(element) {
    initSelectors(element);
    initSocialGridSwiper();
    attachClicks();
    attachKeyboardInput();
    attachResize();
    executeLazyLoading();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.StickyNav = function () {
  var $stickyNav;
  var $stickyNavItemsContainer;
  var $stickyNavSentinel;
  var $stickyNavLinks;
  var $mlpNav;
  var $globalNav;
  var $mainWrapper;
  var stickyNavObserver;
  var componentsObserver;
  var resizeTimer;
  var mlpNavHeight;
  var globalNavHeight;
  var stickyNavMobileHeight;
  var stickyNavDesktopWidth;
  var stickyNavHasLook = false;
  var matchMedia;
  var itemsContainerSelectorClass = '.js-sticky-nav-items-container';
  var itemsContainerFixedClass = 'acr-sticky-nav__items-container--fixed';
  var itemsContainerExpandedClass = 'acr-sticky-nav__items-container--expanded';
  var navSentinelSelectorClass = '.js-sticky-nav-sentinel';
  var navLinkSelectorClass = '.js-sticky-nav-link';
  var mlpNavSelectorClass = '.js-mlp-nav';
  var globalNavSelectorClass = '.js-acr-nav';
  var mainWrapperSelectorClass = '.wrapper';
  var mainWrapperCollapsedClass = 'collapsed-nav';
  var activeClass = 'acr-sticky-nav__item--active';
  var look1 = 'acr-sticky-nav--sticky-look-1';
  var stickyNavHeightConstant = 50; // Height in px of the sticky nav when is fixed to the top

  function initSelectors(element) {
    $stickyNav = element;
    $stickyNavItemsContainer = $stickyNav.querySelector(itemsContainerSelectorClass);
    $stickyNavSentinel = $stickyNav.querySelector(navSentinelSelectorClass);
    $stickyNavLinks = $stickyNav.querySelectorAll(navLinkSelectorClass);
    $mlpNav = document.querySelector(mlpNavSelectorClass);
    $globalNav = document.querySelector(globalNavSelectorClass);
    $mainWrapper = document.querySelector(mainWrapperSelectorClass);
  }

  function initGlobalVariables() {
    mlpNavHeight = $mlpNav ? $mlpNav.offsetHeight : 0;
    globalNavHeight = $globalNav ? $globalNav.offsetHeight : 0;
    stickyNavHasLook = $stickyNav.classList.contains(look1);
    matchMedia = window.matchMedia('(min-width: ' + Constants.breakpoints.lg + 'px)');
  }

  function initStickyNavObserver() {
    // Options used by the IntersectionObserver assigned to Sticky Nav
    var stickyNavOptions = {
      rootMargin: setRootMarginStickyNavObserver(),
      threshold: [0, 1]
    }; // Creation of IntersectionObserver assigned to Sticky Nav

    stickyNavObserver = new IntersectionObserver(stickyNavObserverHandler, stickyNavOptions);
    stickyNavObserver.observe($stickyNavSentinel);
  }

  function initComponentsObserver() {
    // Options used by the IntersectionObserver assigned to all the page componentes that activate sticky nav title change
    var componentsOptions = {
      rootMargin: setRootMarginComponentsObserver(),
      threshold: [0, 1]
    }; // Creation of IntersectionObserver assigned to all the page componentes that activate sticky nav title change

    if (!componentsObserver) {
      componentsObserver = new IntersectionObserver(componentsObserverHandler, componentsOptions);
    } // Here all the page componentes that activate sticky nav title change are assigned to the observer


    $stickyNavLinks.forEach(function (link) {
      var componentId = link.getAttribute('data-component-id');
      var $elementToObserve = document.getElementById(componentId);

      if ($elementToObserve) {
        componentsObserver.observe($elementToObserve);
      }
    });
  } // Callback function used by the sticky nav observer


  function stickyNavObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio === 0 && entry.boundingClientRect.top < window.innerHeight) {
        if (!Utility.isDesktop()) {
          $stickyNav.style.height = '0';
        }

        $stickyNavItemsContainer.classList.add(itemsContainerFixedClass);

        if (!$stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
          $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
        }

        $stickyNavItemsContainer.style.width = '100%';
        setStickyTopPosition();
      } else if (entry.intersectionRatio === 1) {
        if (Utility.isDesktop()) {
          if (stickyNavHasLook) {
            $stickyNavItemsContainer.style.removeProperty('width');
          } else {
            $stickyNavItemsContainer.style.width = stickyNavDesktopWidth + 'px';
          }

          $stickyNavItemsContainer.style.removeProperty('height');
        } else {
          setStickyNavHeight();
        }

        $stickyNavItemsContainer.classList.remove(itemsContainerFixedClass);
        $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
        $stickyNavItemsContainer.style.removeProperty('top');
      }
    });
  }

  function setStickyTopPosition() {
    mlpNavHeight = $mlpNav ? $mlpNav.offsetHeight : 0;

    if ($mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      $stickyNavItemsContainer.style.top = mlpNavHeight + 'px';
    } else {
      globalNavHeight = $globalNav ? $globalNav.offsetHeight : 0;
      $stickyNavItemsContainer.style.top = globalNavHeight + mlpNavHeight + 'px';
    }
  }

  function matchMediaHandler() {
    setStickyTopPosition();

    if (matchMedia.matches) {
      // Attachment of resize event for Desktop Size
      window.addEventListener('resize', windowResizeStickyNavHandler);
    } else {
      if ($stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
        stickyNavMobileHeight = 0;
        $stickyNavLinks.forEach(function (link) {
          stickyNavMobileHeight += link.offsetHeight;
        });
      } else {
        setStickyNavHeight();
      } // Remove of resize event for mobile size


      window.removeEventListener('resize', windowResizeStickyNavHandler);
    }
  } // Callback function used by the general components observer


  function componentsObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        updateLinksStatus(entry.target.id);
      }
    });
  } // Function to calculate the top margin used for options in the stickyNav observer


  function setRootMarginStickyNavObserver() {
    var marginTop;
    var marginsString; // If $globalNav is collapsed, only take the height of $mlpNav

    if ($mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      marginTop = mlpNavHeight;
    } else {
      marginTop = mlpNavHeight + globalNavHeight;
    }

    marginsString = '-' + marginTop + 'px 0px 0px 0px';
    return marginsString;
  } // Function to calculate the top and bottom margin used for options in the component observer


  function setRootMarginComponentsObserver() {
    var navigatorsHeight;
    var marginTop;
    var marginBottom;
    var marginsString;
    navigatorsHeight = $mlpNav ? mlpNavHeight : globalNavHeight; // If $mlpNav exists, only take the height of $mlpNav (because the global nav is collapse in that case

    marginTop = navigatorsHeight + (stickyNavHeightConstant + 5); // "5px" is added to "stickyNavHeightConstant" to add a little more space and avoid unwanted title changes

    marginBottom = window.innerHeight - navigatorsHeight - stickyNavHeightConstant * 2; // We multiply "stickyNavHeightConstant" by 2, to have more space to the observer

    marginsString = '-' + marginTop + 'px 0px -' + marginBottom + 'px 0px';
    return marginsString;
  }

  function bindEvents() {
    // Attachment of click events for each of the sticky nav links
    $stickyNavLinks.forEach(function (link) {
      link.addEventListener('click', linkClickHandler);
    }); // Attachment of resize event for Desktop Size

    if (Utility.isDesktop()) {
      window.addEventListener('resize', windowResizeStickyNavHandler);
    } // Using matchMedia to check window size, to avoid window.resize


    matchMedia.addListener(matchMediaHandler); // Attachment of "expandedGlobalNav" listener to execute "globalNavChangeHandler" when global nav changes

    document.addEventListener('expandedGlobalNav', globalNavChangeHandler);
  } // Function called every time the Global Nav changes from "expanded" or "collapsed" state


  function globalNavChangeHandler() {
    stickyNavObserver.unobserve($stickyNavSentinel);
    initStickyNavObserver();
    setStickyTopPosition();
  } // Function that is called when a link is clicked


  function linkClickHandler() {
    event.preventDefault();

    if (!Utility.isDesktop() && $stickyNavItemsContainer.classList.contains(itemsContainerFixedClass) && !$stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
      document.addEventListener('click', clickOutsideLinkHandler);
      $stickyNavItemsContainer.style.height = stickyNavMobileHeight + 'px';
      $stickyNavItemsContainer.classList.add(itemsContainerExpandedClass);
    } else {
      var clickedComponentId = this.getAttribute('data-component-id');
      var $elementToGo = document.getElementById(clickedComponentId);
      var scrollPosition;

      if ($stickyNavItemsContainer.classList.contains(itemsContainerExpandedClass)) {
        $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
        $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
      }

      document.removeEventListener('click', clickOutsideLinkHandler);

      if ($elementToGo) {
        updateLinksStatus(clickedComponentId);
        scrollPosition = calculateScrollPosition($elementToGo);
        Utility.scrollTo(scrollPosition, 1000);
      }
    }
  } // Function to calculate the scroll position, using the element to go position and adding the global, mlp and sticky navigation heights


  function calculateScrollPosition(element) {
    var elementPosition;
    var stickyNavCurrentHeight;
    var positionToScroll;
    stickyNavCurrentHeight = $stickyNavItemsContainer.offsetHeight;

    if ($stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
      elementPosition = element.offsetTop;
    } else {
      elementPosition = element.offsetTop - stickyNavCurrentHeight;
    }

    if (!$mainWrapper.classList.contains(mainWrapperCollapsedClass)) {
      positionToScroll = elementPosition - globalNavHeight - mlpNavHeight - stickyNavHeightConstant;
    } else {
      positionToScroll = elementPosition - mlpNavHeight - stickyNavHeightConstant;
    }

    return positionToScroll;
  } // Function that is called when is clicked outside the sticky navigation while is expanded


  function clickOutsideLinkHandler() {
    event.preventDefault();

    if (!$stickyNavItemsContainer.contains(event.target)) {
      $stickyNavItemsContainer.classList.remove(itemsContainerExpandedClass);
      $stickyNavItemsContainer.style.height = stickyNavHeightConstant + 'px';
      document.removeEventListener('click', clickOutsideLinkHandler);
    }
  } // Function to set the new "active" link when the page scrolls or an element is clicked


  function updateLinksStatus(paramTargetComponent) {
    $stickyNavLinks.forEach(function (link) {
      var componentId = link.getAttribute('data-component-id');

      if (componentId === paramTargetComponent) {
        link.parentElement.classList.add(activeClass);
      } else {
        link.parentElement.classList.remove(activeClass);
      }
    });
  } // Callback function when resizing occurs on desktop


  function windowResizeStickyNavHandler() {
    // If there's a timer, cancel it
    if (resizeTimer) {
      window.cancelAnimationFrame(resizeTimer);
    } // Setup the new requestAnimationFrame()


    resizeTimer = window.requestAnimationFrame(function () {
      stickyNavWidthDesktopHandler();
    });
  }

  function stickyNavWidthDesktopHandler() {
    if (!$stickyNavItemsContainer.classList.contains(itemsContainerFixedClass)) {
      if (!stickyNavHasLook) {
        setStickyNavWidth();
      } else {
        $stickyNav.style.removeProperty('height');
        $stickyNavItemsContainer.style.removeProperty('height');
        $stickyNavItemsContainer.style.removeProperty('width');
      }
    }
  } // Sets the size for the sticky nav, height for mobile and tablet and width only for desktop


  function setStickyNavSize() {
    if (Utility.isDesktop()) {
      stickyNavWidthDesktopHandler();
    } else {
      setStickyNavHeight();
    }
  }

  function setStickyNavWidth() {
    stickyNavDesktopWidth = 1;
    $stickyNav.style.removeProperty('height');
    $stickyNavItemsContainer.style.removeProperty('height');
    $stickyNavItemsContainer.style.removeProperty('width');
    $stickyNavLinks.forEach(function (link) {
      stickyNavDesktopWidth += link.parentElement.offsetWidth + 1; // offsetWidth + 1 to add the border right of the li element
    });
    $stickyNavItemsContainer.style.width = stickyNavDesktopWidth + 'px';
  }

  function setStickyNavHeight() {
    stickyNavMobileHeight = 0;
    $stickyNavLinks.forEach(function (link) {
      stickyNavMobileHeight += link.offsetHeight;
    });
    $stickyNavItemsContainer.style.removeProperty('width');
    $stickyNav.style.height = stickyNavMobileHeight + 'px';
    $stickyNavItemsContainer.style.height = stickyNavMobileHeight + 'px';
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initStickyNavObserver();
    initComponentsObserver();
    setStickyNavSize();
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.StickySideNav = function () {
  var $stickySideNav;
  var $stickySideNavList;
  var $backToTopButton;
  var $openChatButton;
  var $chatBotTitle;
  var backToTopButton = '.js-back-to-top-button';
  var stickySideNavList = '.js-sticky-side-nav-list';
  var openChatButton = '.js-open-chat-button';
  var chatBotTitle = '.js-chatbot-title';
  var stickySideNavItemVisible = 'sticky-side-nav__item--visible';
  var stickySideNavItemExpanded = 'sticky-side-nav__item--expanded';
  var stickySideNavListExpanded = 'sticky-side-nav__list--expanded';

  function openChat() {
    event.preventDefault();

    if (typeof carlaBot !== 'undefined') {
      $stickySideNav.addClass('hidden');
      carlaBot.openChat();
      setTimeout(function () {
        $stickySideNav.removeClass('hidden');
      }, 1500);
    }
  }

  function backToTop(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, '300');
    $backToTopButton.removeClass(stickySideNavItemVisible);
    $backToTopButton.removeClass(stickySideNavItemExpanded);
  }

  function eventHandler(event) {
    if (event.type === 'touchend' && !$stickySideNavList.hasClass(stickySideNavListExpanded)) {
      event.preventDefault();
      $stickySideNavList.addClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'true');
      $(document).on('touchend', hideStickySideNavList);
    } else if ($(event.currentTarget.parentElement).is($openChatButton)) {
      openChat();
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    } else {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    }
  }

  function onScroll() {
    if ($stickySideNavList.hasClass(stickySideNavListExpanded)) {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click', hideStickySideNavList);
    }

    if (!$backToTopButton.hasClass(stickySideNavItemVisible)) {
      $backToTopButton.addClass(stickySideNavItemVisible);
    }

    if (($backToTopButton.hasClass(stickySideNavItemVisible) || $backToTopButton.hasClass(stickySideNavItemExpanded)) && $(document).scrollTop() === 0) {
      $backToTopButton.removeClass(stickySideNavItemExpanded);
      $backToTopButton.removeClass(stickySideNavItemVisible);
    }
  }

  function hideStickySideNavList() {
    if (!$(event.target).parents().is($stickySideNavList)) {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList[0].setAttribute('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    }
  }

  function initSelectors(element) {
    $stickySideNav = $(element);
    $stickySideNavList = $stickySideNav.find(stickySideNavList);
    $backToTopButton = $stickySideNav.find(backToTopButton);
    $openChatButton = $stickySideNav.find(openChatButton);
    $chatBotTitle = $stickySideNav.find(chatBotTitle);
  }

  function bindEvents() {
    $stickySideNavList.hover(function () {
      $(this).addClass(stickySideNavListExpanded);
      $(this)[0].setAttribute('aria-expanded', 'true');
      $(document).off('click', hideStickySideNavList);
      $(document).on('click', hideStickySideNavList);
    });
    $(window).scroll(function () {
      onScroll();
    });
    $stickySideNavList.find('a').on('click touchend', eventHandler);
    $backToTopButton.find('a').on('click touchend', backToTop);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    $stickySideNav.css('display', 'flex');
  }

  return {
    init: init
  };
};
"use strict";

/* global pannellum */
var Acr = Acr || {};

Acr.ThreeSixty = function () {
  var $threeSixty;
  var $threeSixtyGalleries;
  var $clickAndDragBtn;
  var $threeSixtyTabs;
  var $threeSixtyTabsDisclaimers;
  var $threeSixtyColorSelectors;
  var $threeSixtyCTABtn;
  var galleriesArray = [];
  var clickAndDragBtnEnabled = true;
  var threeSixtyGallerySelector = '.js-three-sixty-gallery';
  var clickAndDragBtnSelector = '.js-click-and-drag-btn';
  var spinnerSelector = '.js-three-sixty-spinner';
  var galleryImgSelector = '.js-three-sixty-img';
  var galleryPanoramaSelector = '.js-three-sixty-panorama';
  var panoPictureSelector = '.js-three-sixty-pano-picture';
  var panoramaControlsSelector = '.js-panorama-controls';
  var panoramaZoomInSelector = '.js-panorama-zoom-in';
  var panoramaZoomOutSelector = '.js-panorama-zoom-out';
  var threeSixtyTabSelector = '.js-three-sixty-tab';
  var tabDisclaimerSelector = '.js-tab-disclaimer';
  var colorsContainerSelector = '.js-colors-container';
  var colorSelector = '.js-three-sixty-color';
  var colorsDescriptionSelector = '.js-color-description';
  var ctaBtn = '.js-cta-btn';
  var activeClass = 'is-active';
  var hideClass = 'hide';
  var loadedClass = 'loaded';
  var imgExt = '.jpg';

  function initSelectors(element) {
    $threeSixty = element;
    $clickAndDragBtn = $threeSixty.querySelector(clickAndDragBtnSelector);
    $threeSixtyGalleries = $threeSixty.querySelectorAll(threeSixtyGallerySelector);
    $threeSixtyTabs = $threeSixty.querySelectorAll(threeSixtyTabSelector);
    $threeSixtyTabsDisclaimers = $threeSixty.querySelectorAll(tabDisclaimerSelector);
    $threeSixtyColorSelectors = $threeSixty.querySelectorAll(colorsContainerSelector);
    $threeSixtyCTABtn = $threeSixty.querySelector(ctaBtn);
  } // Init each gallery of the 360


  function initGalleries() {
    $threeSixtyGalleries.forEach(function ($gallery) {
      var galleryId = $gallery.id;
      var threeSixtyGallery = new Gallery($gallery); // One "Gallery" instance for each gallery (exterior/interior)

      galleriesArray[galleryId] = threeSixtyGallery; // The the gallery instance to the galleries array
    });
  }

  function bindEvents() {
    // Attachment of click event for the "Click and Drag Button"
    $clickAndDragBtn.addEventListener('click', clickAndDragBtnHandler); // Attachment of click events for each of the tabs

    $threeSixtyTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  } // Function that is triggered when the "Click and Drag" button is clicked


  function clickAndDragBtnHandler() {
    var activeGalleryId;
    var $threeSixtyActiveGallery = $threeSixty.querySelector('.' + activeClass); // Gets the active gallery

    activeGalleryId = $threeSixtyActiveGallery.id;
    galleriesArray[activeGalleryId].initGallery(); // Find the active gallery in the galleries array to init the active gallery

    clickAndDragBtnEnabled = false;
    $clickAndDragBtn.classList.add(hideClass);
  } // Function that is triggered when a "Tab" is clicked


  function tabClickHandler(event) {
    var tabGalleryId = event.currentTarget.getAttribute('data-gallery-id'); // Add the "active" class to the tab that was clicked and removes the class to the others
    // If the tab gallery is not initialized, init all the content of the tab

    $threeSixtyGalleries.forEach(function ($gallery) {
      var galleryId = $gallery.id;

      if (galleryId === tabGalleryId) {
        $gallery.classList.add(activeClass);

        if (!$gallery.classList.contains(loadedClass) && !clickAndDragBtnEnabled) {
          galleriesArray[galleryId].initGallery();
        }
      } else {
        $gallery.classList.remove(activeClass);
      }
    }); // Change the "disclaimer" text according to the selected tab

    $threeSixtyTabsDisclaimers.forEach(function ($disclaimer) {
      var disclaimerId = $disclaimer.getAttribute('data-gallery-id');

      if (disclaimerId === tabGalleryId) {
        $disclaimer.classList.add(activeClass);
      } else {
        $disclaimer.classList.remove(activeClass);
      }
    }); // Change the "colors" container according to the selected tab

    $threeSixtyColorSelectors.forEach(function ($container) {
      var containerId = $container.getAttribute('data-gallery-id');

      if (containerId === tabGalleryId) {
        $container.classList.add(activeClass);
      } else {
        $container.classList.remove(activeClass);
      }
    }); // Add styles for the selected tab

    $threeSixtyTabs.forEach(function (tab) {
      tab.classList.remove(activeClass);
    });
    event.currentTarget.classList.add(activeClass);
  }

  function Gallery(pGallery) {
    var $gallery = pGallery;
    var $threeSixtyGalleryImg;
    var $spinner;
    var $galleryColors;
    var $galleryColorDescription;
    var $panoStaticPicture;
    var $panoStaticPictureSource;
    var $panoStaticPictureImg;
    var galleryId = $gallery.id;
    var dataFrames;
    var pointerStartPosX = 0;
    var pointerEndPosX = 0;
    var monitorStartTime = 0;
    var monitorInt = 10;
    var pointerDistance = 0;
    var pointerSpeed = 10; // Speed of the pointer

    var framesPerGallery = 0; // Frames for the gallery

    var currentFrame = 0;
    var expectedFrame = 0;
    var dataSource = '';
    var galleryType = $gallery.getAttribute('data-type');
    var matchMedia = window.matchMedia('(min-width: ' + Constants.breakpoints.lg + 'px)');
    var colorsStringSelector = "".concat(colorsContainerSelector, '[data-gallery-id="').concat(galleryId, '"]'); // Get only the colors for the current gallery instance

    var $colorsContainer = $threeSixty.querySelector(colorsStringSelector);
    var panoView;
    var panoColorScenes = {}; // Empty object for storing interior color scenes
    // Add the matchMedia listener and load the first image only if the gallery type is "threesixty"

    if (galleryType === 'threesixty') {
      matchMedia.addListener(updateImgDataSource);
      loadFirstImgSrc();
    } // If the color container exists in the markup, attach the click event for each color


    if ($colorsContainer) {
      var activeColorSwatch = null;
      $galleryColors = $colorsContainer.querySelectorAll(colorSelector);
      $galleryColorDescription = $colorsContainer.querySelectorAll(colorsDescriptionSelector); // Attachment of click events for each color depending on the gallery type

      if (galleryType === 'threesixty') {
        $galleryColors.forEach(function (color) {
          // Search for the active swatch in order to add the color swatch code to the cta
          if (color.classList.contains(activeClass)) {
            activeColorSwatch = color;
          }

          color.addEventListener('click', changeColorThreeSixtyHandler);
        });

        if (activeColorSwatch) {
          updateColorSwatchCode(activeColorSwatch);
        }
      } else {
        $galleryColors.forEach(function (color) {
          color.addEventListener('click', changeColorPanoramaHandler);
          var interiorImg = color.getAttribute('data-pano-img');
          var interiorColorId = color.getAttribute('data-id'); // Adding color keys and images to the "panoColorScenes" object

          panoColorScenes[interiorColorId] = {
            panorama: interiorImg
          };
        });
        $panoStaticPicture = $threeSixty.querySelector(panoPictureSelector);
        $panoStaticPictureSource = $panoStaticPicture.querySelector('source');
        $panoStaticPictureImg = $panoStaticPicture.querySelector('img');
      }
    } // Load the "static" img for the 360 gallery depending on the screen size, img that is showed when the 360 is not initialized


    function loadFirstImgSrc() {
      var firstImgNumber = '01';
      $threeSixtyGalleryImg = $gallery.querySelector(galleryImgSelector);
      updateImgDataSource();

      if ($threeSixtyGalleryImg.getAttribute('loading') === 'lazy' && !Acr.LazyLoadingHelper.isLazyLoadingNative()) {
        $threeSixtyGalleryImg.setAttribute('data-src', "".concat(dataSource).concat(firstImgNumber).concat(imgExt));
      } else {
        $threeSixtyGalleryImg.src = "".concat(dataSource).concat(firstImgNumber).concat(imgExt);
      }

      $threeSixtyGalleryImg.classList.remove(hideClass);
    } // Get the data source for the Img depending on the size of the screen


    function updateImgDataSource() {
      var previousDataSource = dataSource;

      if (matchMedia.matches) {
        dataSource = $gallery.getAttribute('data-source-large');
      } else {
        dataSource = $gallery.getAttribute('data-source-small');
      }

      if (previousDataSource !== '') {
        $threeSixtyGalleryImg.src = $threeSixtyGalleryImg.src.replace(previousDataSource, dataSource);
      }
    } // Function that is activated when a "color" of a gallery type "threesixty" is clicked


    function changeColorThreeSixtyHandler(event) {
      var dataSourceSmall = event.currentTarget.getAttribute('data-source-small');
      var dataSourceLarge = event.currentTarget.getAttribute('data-source-large');
      $gallery.setAttribute('data-source-small', dataSourceSmall);
      $gallery.setAttribute('data-source-large', dataSourceLarge);
      updateActiveColor(event.currentTarget);
      updateImgDataSource();

      if ($gallery.classList.contains(loadedClass)) {
        var imagesToLoad = dataFrames;
        $spinner.classList.remove(hideClass); // Load one image per frame

        for (var i = 1; i <= dataFrames; i++) {
          var newImage = new Image();
          var formattedIndex = ('0' + i).slice(-2); // Format the index in two digits, example: 1 --> 01

          var newUrl = "".concat(dataSource).concat(formattedIndex).concat(imgExt);
          newImage.src = newUrl;

          newImage.onload = function () {
            imagesToLoad--;

            if (imagesToLoad === 0) {
              // Lines executed when all images are ready
              $spinner.classList.add(hideClass);
            }
          };
        }
      }

      updateColorSwatchCode(event.currentTarget);
    } // Function that is activated when a "color" of a gallery type "pano" is clicked


    function changeColorPanoramaHandler(event) {
      var dataSourceSmall = event.currentTarget.getAttribute('data-source-small');
      var dataSourceLarge = event.currentTarget.getAttribute('data-source-large');
      var newPanoImg = event.currentTarget.getAttribute('data-pano-img');
      var selectedColor = event.currentTarget.getAttribute('data-id'); // Update the data attributes for the current gallery

      $gallery.setAttribute('data-pano-img', newPanoImg);
      $gallery.setAttribute('data-color-id', selectedColor);
      updateActiveColor(event.currentTarget);

      if ($gallery.classList.contains(loadedClass)) {
        $spinner.classList.remove(hideClass); // Switch to the "pannellum" scene with the new color, keeping the same position and zoom

        panoView.loadScene(selectedColor, panoView.getPitch(), panoView.getYaw(), panoView.getHfov());
        panoView.on('load', function () {
          $spinner.classList.add(hideClass);
        });
      } else {
        // Update the pictures attributes and image source
        $panoStaticPictureSource.setAttribute('srcset', dataSourceLarge);
        $panoStaticPictureImg.setAttribute('srcset', dataSourceSmall);
        $panoStaticPictureImg.setAttribute('src', dataSourceSmall);
      }
    }

    function updateActiveColor(selectedColor) {
      var colorId = selectedColor.getAttribute('data-id'); // Add styles for the selected color

      $galleryColors.forEach(function (color) {
        color.classList.remove(activeClass);
      });
      selectedColor.classList.add(activeClass); // Update the color description text

      $galleryColorDescription.forEach(function (description) {
        var descriptionId = description.getAttribute('data-id');

        if (descriptionId === colorId) {
          description.classList.add(activeClass);
        } else {
          description.classList.remove(activeClass);
        }
      });
    } // Function that update the color swatch code in the CTA href base on the active color swatch


    function updateColorSwatchCode(colorSwatch) {
      if ($threeSixtyCTABtn) {
        var ctaHrefParams = new URL($threeSixtyCTABtn.href).searchParams;
        var colorCode = colorSwatch.getAttribute('data-color-code');

        if (ctaHrefParams.has('exterior')) {
          var extParam = ctaHrefParams.get('exterior');
          $threeSixtyCTABtn.href = $threeSixtyCTABtn.href.replace(extParam, colorCode);
        } else {
          var oldParams = ctaHrefParams.toString();
          ctaHrefParams.append('exterior', colorCode);
          var newParams = ctaHrefParams.toString();

          if (oldParams === '') {
            $threeSixtyCTABtn.href += '?' + newParams;
          } else {
            $threeSixtyCTABtn.href = $threeSixtyCTABtn.href.replace(oldParams, newParams);
          }
        }
      }
    } // Function to init the "active" gallery depending on the type of gallery


    function initGallery() {
      if (galleryType === 'threesixty') {
        initThreeSixty();
      } else {
        initPannellum();
      }
    } // Function to init the "exterior three sixty" and load all required images


    function initThreeSixty() {
      dataFrames = parseInt($gallery.getAttribute('data-frames'), 10);
      var imagesToLoad = dataFrames;
      $spinner = $gallery.querySelector(spinnerSelector);
      framesPerGallery = dataFrames;
      $spinner.classList.remove(hideClass); // Load one image per frame

      for (var i = 1; i <= dataFrames; i++) {
        var newImage = new Image();
        var formattedIndex = ('0' + i).slice(-2); // Format the index in two digits, example: 1 --> 01

        var newUrl = "".concat(dataSource).concat(formattedIndex).concat(imgExt);
        newImage.src = newUrl;

        newImage.onload = function () {
          imagesToLoad--;

          if (imagesToLoad === 0) {
            // Lines executed when all images are ready
            $spinner.classList.add(hideClass);
            addThreeSixtyListeners();
            galleryLoaded();
          }
        };
      }
    } // Add the class "loaded" to the active gallery when the content is loaded


    function galleryLoaded() {
      $gallery.classList.add(loadedClass);
    } // Event listeners for the exterior gallery


    function addThreeSixtyListeners() {
      $gallery.addEventListener('mousedown', mouseDownHandler);
      $gallery.addEventListener('mouseup', mouseUpHandler);
      $gallery.addEventListener('touchstart', mouseDownHandler);
      $gallery.addEventListener('touchend', mouseUpHandler);
    } // Events that are executed when the user presses the mouse or touches the screen and keeps pressing


    function mouseDownHandler(event) {
      event.preventDefault();
      pointerStartPosX = getPointerEvent(event).pageX; // Assign the mouse pointer X position

      event.currentTarget.addEventListener('mousemove', mouseMoveHandler);
      event.currentTarget.addEventListener('touchmove', mouseMoveHandler);
    } // Events that are executed when the user releases the mouse or stops pressing the screen


    function mouseUpHandler(event) {
      event.preventDefault();
      event.currentTarget.removeEventListener('mousemove', mouseMoveHandler);
      event.currentTarget.removeEventListener('touchmove', mouseMoveHandler);
    } // Events that are executed when the user moves the mouse while holding it down or moves the finger while holding down the screen


    function mouseMoveHandler(event) {
      event.preventDefault();
      var currentPosition;
      var currentGallery = event.currentTarget;
      pointerEndPosX = getPointerEvent(event).pageX; // Assign the mouse pointer X position

      if (monitorStartTime < new Date().getTime() - monitorInt) {
        var sign; // used to convert the "currentPosition" to a positive or negative number

        pointerDistance = pointerEndPosX - pointerStartPosX; // pointer position from initial pressure to stop

        sign = pointerDistance < 0 ? -1 : 1; // Applying "Math.abs" to remove the negative symbol from "pointerDistance", then after the "Math.ceil" on the calculation, multiply the result by "sign (1 or -1)" to add the symbol

        currentPosition = Math.ceil(framesPerGallery * pointerSpeed * (Math.abs(pointerDistance) / currentGallery.offsetWidth)) * sign;
        expectedFrame = currentFrame + currentPosition;
        refreshFrame();
        monitorStartTime = new Date().getTime();
        pointerStartPosX = getPointerEvent(event).pageX;
      }
    } // Refresh currentFrame when the user moves the mouse


    function refreshFrame() {
      var framesDiff;
      var ease;

      if (currentFrame !== expectedFrame) {
        framesDiff = Math.ceil((expectedFrame - currentFrame) * 0.1);
        ease = expectedFrame < currentFrame ? Math.floor((expectedFrame - currentFrame) * 0.1) : framesDiff;
        currentFrame += ease;
        changeImageSource();
      }
    } // Change the image source depending on the current frame and the frames per gallery


    function changeImageSource() {
      var imgNumber = -Math.ceil(currentFrame % framesPerGallery) + 1;

      if (imgNumber <= 0) {
        imgNumber += framesPerGallery;
      }

      var formattedNumber = ('0' + imgNumber).slice(-2); // Format the number in two digits, example: 1 --> 01

      var newSrc = "".concat(dataSource).concat(formattedNumber).concat(imgExt);
      $threeSixtyGalleryImg.src = newSrc;
    }

    function getPointerEvent(event) {
      return event.targetTouches ? event.targetTouches[0] : event;
    }

    function initPannellum() {
      $spinner = $gallery.querySelector(spinnerSelector);
      var $panorama = $gallery.querySelector(galleryPanoramaSelector);
      var $panoramaControls = $panorama.querySelector(panoramaControlsSelector);
      var $panoramaZoomIn = $panorama.querySelector(panoramaZoomInSelector);
      var $panoramaZoomOut = $panorama.querySelector(panoramaZoomOutSelector);
      var interiorImg = $gallery.getAttribute('data-pano-img');
      var interiorColorId = $gallery.getAttribute('data-color-id');
      var zoomButtonsDisabled = false;
      var initialScenes = {}; // Empty object for storing interior color scenes
      // Adding color keys and images to the "initialScenes" object

      initialScenes[interiorColorId] = {
        panorama: interiorImg
      };
      $spinner.classList.remove(hideClass); // Create a "pannellum" object with its properties

      panoView = pannellum.viewer($panorama, {
        autoLoad: true,
        showControls: false,
        mouseZoom: false,
        hfov: 90,
        // Initial zoom level. minimum 50 / maximum 120.
        pitch: -12,
        // Sets the panorama’s starting pitch position in degrees
        default: {
          firstScene: interiorColorId
        },
        scenes: Object.keys(panoColorScenes).length !== 0 ? panoColorScenes : initialScenes // Use "panoColorScenes" if it has colors, otherwise use "initialScenes"

      }); // Actions executed when the panoramic view is ready

      panoView.on('load', function () {
        $spinner.classList.add(hideClass);
        $panoramaControls.classList.remove(hideClass);
        galleryLoaded();
        attachControlsEvents();
      });

      function attachControlsEvents() {
        // Attachment of click event for the "Zoom In" button
        $panoramaZoomIn.addEventListener('click', zoomInButtonHandler); // Attachment of click event for the "Zoom Out" button

        $panoramaZoomOut.addEventListener('click', zoomOutButtonHandler);
      } // Actions executed when the zoom-in button is clicked


      function zoomInButtonHandler() {
        panoView.setHfov(panoView.getHfov() - 15); // This block removes click event listener for the zoom buttons to avoid strange "multiple click" behavior

        $panoramaZoomIn.removeEventListener('click', zoomInButtonHandler);
        $panoramaZoomOut.removeEventListener('click', zoomOutButtonHandler);
        zoomButtonsDisabled = true;
      } // Actions executed when the zoom-out button is clicked


      function zoomOutButtonHandler() {
        panoView.setHfov(panoView.getHfov() + 15); // This block removes click event listener for the zoom buttons to avoid strange "multiple click" behavior

        $panoramaZoomIn.removeEventListener('click', zoomInButtonHandler);
        $panoramaZoomOut.removeEventListener('click', zoomOutButtonHandler);
        zoomButtonsDisabled = true;
      } // Actions executed when the zoom animation is finished


      panoView.on('animatefinished', function () {
        // This block adds click event listener for the zoom buttons when the zoom finish
        if (zoomButtonsDisabled) {
          zoomButtonsDisabled = false;
          $panoramaZoomIn.addEventListener('click', zoomInButtonHandler);
          $panoramaZoomOut.addEventListener('click', zoomOutButtonHandler);
        }
      });
    }

    return {
      initGallery: initGallery
    };
  }

  function init(element) {
    initSelectors(element);
    initGalleries();
    bindEvents();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.ThreeSixtySmall = function () {
  var mainContainer = $('.acr-threesixty-small');
  var galleriesContainer = mainContainer.find('.galleries-container');
  var buttonsTabContainer = mainContainer.find('.color-selector .row.buttons');
  var buttonsColorsContainer = mainContainer.find('.color-selector');
  var buildCTAs = mainContainer.find('.build-n-price .acr-cta-btn');
  var cutline = mainContainer.find('.js-threesixty-cutline');
  var activeGallery = true;
  var btnClass = 'btn-color-select';
  var colorName = 'color-name';
  var pClass = 'previous-image';
  var currentClass = 'current-image';
  var ext = '.jpg';
  var aspectW = 16;
  var aspectH = 9;
  var defaultTotalFrames = 72;
  var isActive = 'is-active';
  var prevCur = 'acr-threesixty-small-prev-current';
  var dButtons = '.btn-display-selector';
  var lazyClass360 = 'lazy-360';
  var lazyClassPano = 'lazy-pano';

  function Gallery(gallery) {
    this.id = gallery.name.replace(/\s/g, '_');
    this.colorId = 0;
    this.name = gallery.name;
    this.type = gallery.type;
    this.framePerGallery = gallery.frames ? parseInt(gallery.frames, 10) : defaultTotalFrames;
    this.vehicles = gallery.vehicles;
    this.disclaimer = gallery.disclaimer;
    this.activeGallery = '';
    this.ldImages = 0;
    this.frames = [];
    this.galleryContainer = '';
    this.imagesContainer = '';
    this.colorsContainer = '';
    this.spinner = '';
    this.threesixtyIcon = '';
    this.selectedFrame = 0;
    this.lWinW = 0;
    this.pointerStartPosX = 0;
    this.pointerEndPosX = 0;
    this.dragging = false;
    this.ready = false;
    this.monitorStartTime = 0;
    this.monitorInt = 10;
    this.pDist = 0;
    this.sPd = 10; // Speed

    this.cFrame = 0;
    this.eFrame = 0;
    this.ticker = 0;
    this.isLoaded = false;
    var oThis = this;

    if (activeGallery) {
      activeGallery = false;
      this.activeGallery = 'is-active';
    }

    this.initialize = function () {
      this.addTabBtnChangeGallery();
      this.addColorBtnsAndDisclaimer();

      if (this.type === 'iframe') {
        this.initIframe();
      } else if (this.type === 'pano') {
        this.initPano();
      } else {
        this.initThreesixty();
      }
    };

    this.initThreesixty = function () {
      this.addThreesixtyDom();
      this.loadImage(0);
      this.attachListeners();
      this.selectGalleryListener();
    };

    this.initIframe = function () {
      this.addIframeDom();
      this.imagesContainer.attr({
        src: this.vehicles[0].baseUrl
      });
      this.setSizes();
      this.setColorName(0);
      this.attachIntListeners();
      this.selectGalleryListener();
    };

    this.initPano = function () {
      this.addPanoDom();
      var panoUrl = galleriesContainer.data('panohtml');
      this.setSizes();
      this.setColorName(0);
      this.attachPanoListeners();
      this.selectGalleryListener();
    };

    this.attachIntListeners = function () {
      var that = this;
      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');
        e.preventDefault(); // This function doesn't exist anywhere! Commenting for now,
        // probably can be removed next time this file needs an update
        // that.updateInterior(selected);

        that.setColorName(selected);
      });
      $(window).on('resize', that.resizeHandler);
    };

    this.attachPanoListeners = function () {
      var that = this;
      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');
        e.preventDefault();

        if (that.colorId !== selected) {
          window.pano.readConfigUrlAsync(that.vehicles[selected].baseUrl);
          that.setColorName(selected);
        }
      });
      $(window).on('resize', that.resizeHandler);
    };

    this.addIframeDom = function () {
      var templateIframe = '<div class="iframe360 ' + this.id + ' item ' + this.activeGallery + ' "><iframe id="iframeSpin-' + this.id + '" /></div>';
      galleriesContainer.append(templateIframe);
      this.galleryContainer = galleriesContainer.find('.iframe360.' + this.id);
      this.imagesContainer = galleriesContainer.find('#iframeSpin-' + this.id);
      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
    };

    this.addPanoDom = function () {
      var that = this;
      var templateIframe = '<div class="pano360 ' + this.id + ' item ' + lazyClassPano + ' ' + this.activeGallery + ' "></div>';
      galleriesContainer.append(templateIframe);
      this.galleryContainer = galleriesContainer.find('.pano360.' + this.id);
      $.ajax({
        url: galleriesContainer.data('panohtml'),
        type: 'GET',
        dataType: 'html',
        xhrFields: {
          withCredentials: true
        },
        success: function success(resp) {
          that.galleryContainer.html(resp);
          window.pano.setBasePath(galleriesContainer.data('absolute-url'));
          that.initLazyLoadingPano();
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(xhr.responseText);
        }
      });
      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
    };

    this.selectGalleryListener = function () {
      var toggleTimeout;
      var that = this;
      buttonsTabContainer.on('click', '[data-target="' + this.id + '"]', function (event) {
        event.preventDefault();

        if (!$(this).hasClass(isActive)) {
          var target = $(this).data('target');
          clearTimeout(toggleTimeout);
          $(dButtons).removeClass(isActive);
          $(this).addClass(isActive);
          galleriesContainer.find('.item').removeClass(isActive);
          buttonsColorsContainer.find('.item').removeClass(isActive);
          galleriesContainer.find('.' + target).addClass(isActive);
          buttonsColorsContainer.find('.' + target).addClass(isActive); // If the pano wasn't loaded on component load is reloaded with the current selected color

          if (target.toLowerCase() === 'interior' && !that.isLoaded) {
            that.isLoaded = true;
          }

          toggleTimeout = setTimeout(function () {
            that.resizeHandler();
          }, 500);
        }
      });
    };

    this.attachListeners = function () {
      var that = this;
      this.galleryContainer.mousedown(function (event) {
        event.preventDefault();
        that.pointerStartPosX = that.getPointerEvent(event).pageX;
        that.dragging = true;
      });
      this.galleryContainer.mouseup(function (event) {
        event.preventDefault();
        that.dragging = false;
      });
      this.galleryContainer.mousemove(function (event) {
        event.preventDefault();
        that.trackPointer(event);
      });
      this.galleryContainer.on('touchstart', function (event) {
        that.pointerStartPosX = that.getPointerEvent(event).pageX;
        that.dragging = true;
      });
      this.galleryContainer.on('touchmove', function (event) {
        that.trackPointer(event);
      });
      this.galleryContainer.on('touchend', function (event) {
        event.preventDefault();
        that.dragging = false;
      });
      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');
        e.preventDefault();
        that.frames = [];
        that.eFrame = 0;
        that.ldImages = 0;
        that.clearContainer();
        that.loadImage(selected);
        that.setColorName(selected);
      });
      $(window).on('resize', that.resizeHandler);
    }; // Handling window resize event


    this.resizeHandler = function () {
      oThis.setSizes();
    }; // Cleaning DOM elements when changing colors


    this.clearContainer = function () {
      var $current;
      this.spinner.fadeIn();
      $current = this.imagesContainer.find('li .current-image').parent('li');
      $current.addClass(prevCur);
      this.imagesContainer.find('li:not(.' + prevCur + ')').remove();
    };

    this.trackPointer = function (event) {
      var cLc;

      if (this.ready && this.dragging) {
        this.pointerEndPosX = this.getPointerEvent(event).pageX;

        if (this.monitorStartTime < new Date().getTime() - this.monitorInt) {
          this.pDist = this.pointerEndPosX - this.pointerStartPosX;
          cLc = Math.ceil((this.framePerGallery - 1) * this.sPd * (this.pDist / this.galleryContainer.width()));
          this.eFrame = this.cFrame + cLc;
          this.refresh();
          this.monitorStartTime = new Date().getTime();
          this.pointerStartPosX = this.getPointerEvent(event).pageX;
        }
      }
    };

    this.refresh = function () {
      this.renderFrame();
    };

    this.renderFrame = function () {
      var deft;
      var ease;

      if (this.cFrame !== this.eFrame) {
        deft = Math.ceil((this.eFrame - this.cFrame) * 0.1);
        ease = this.eFrame < this.cFrame ? Math.floor((this.eFrame - this.cFrame) * 0.1) : deft;
        this.hidePreviousFrame();
        this.cFrame += ease;
        this.showCFrame();
        this.selectedFrame = this.getCurrFrame();
      }
    };

    this.hidePreviousFrame = function () {
      this.frames[this.getCurrFrame()].removeClass(currentClass).addClass(pClass);
    };

    this.showCFrame = function () {
      this.frames[this.getCurrFrame()].removeClass(pClass).addClass(currentClass);
    };

    this.getCurrFrame = function () {
      var c = -Math.ceil(this.cFrame % this.framePerGallery);

      if (c < 0) {
        c += this.framePerGallery - 1;
      }

      return c;
    };

    this.getPointerEvent = function (event) {
      var e = event;
      var oE = e.originalEvent;
      return oE.targetTouches ? oE.targetTouches[0] : e;
    };

    this.addThreesixtyDom = function () {
      var templateThreeixty = '<div class="threesixty ' + this.id + ' item ' + this.activeGallery + ' "><ol class="threesixty-images ' + lazyClass360 + ' " ' + 'id="threesixty_images"></ol><div class="spinner"><div ' + 'class="animated-spinner"></div></div><div ' + 'class="threesixty-icon"><svg ' + 'viewBox="0 0 45 20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#360-arrows"></use></svg></div></div>';
      galleriesContainer.append(templateThreeixty);
      this.galleryContainer = galleriesContainer.find('.threesixty.' + this.id);
      this.imagesContainer = this.galleryContainer.find('.threesixty-images');
      this.spinner = this.galleryContainer.find('.spinner');
      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
      this.threesixtyIcon = this.galleryContainer.find('.threesixty-icon');
    }; // Adding + Loading images based on provided DATA


    this.loadImage = function (index) {
      var that;
      var li;
      var imageN;
      var image;

      if (this.vehicles[index]) {
        that = this;
        li = document.createElement('li');
        imageN = this.vehicles[index].baseUrl + ('0' + (this.ldImages + 1)).slice(-2) + ext;
        image = $('<img>').attr({
          'data-src': imageN,
          'data-index': that.ldImages,
          alt: this.vehicles[index].colorName
        }).addClass(pClass).appendTo(li);
        this.frames.push(image);
        this.imagesContainer.append(li);
        that.imageLoaded(index);
        $(image).load(function () {
          if (parseInt($(this).attr('data-index'), 10) === that.selectedFrame) {
            that.spinner.fadeOut(500);
          }
        });
      }
    };

    this.setSizes = function () {
      var containerWidth;
      var newHeight;

      if (window.innerWidth !== this.lWinW) {
        this.lWinW = window.innerWidth;
        containerWidth = galleriesContainer.width();
        newHeight = aspectH / aspectW * containerWidth;
        this.galleryContainer.height(newHeight);
      }
    }; // Checking loaded images against total images to start 360


    this.imageLoaded = function (index) {
      var that = this;
      this.ldImages += 1;

      if (this.ldImages === this.framePerGallery) {
        this.frames[this.selectedFrame].removeClass(pClass).addClass(currentClass);
        this.setColorName(index);
        that.initLazyLoading360();
        that.setSizes();
        that.showThreeSixty();
      } else {
        this.loadImage(index);
      }
    }; // Updating color name text based on selection


    this.setColorName = function (i) {
      var selectedColorConfig = this.vehicles[i];
      var configurationType = this.name.toLowerCase();
      this.colorId = i;
      this.colorsContainer.find('.' + this.id + '.' + colorName + ' .text').text(selectedColorConfig.colorName);
      this.setActiveButton(i); // Updates the URL for the Build CTA

      if (selectedColorConfig.colorCode) {
        buildCTAs.each(function (index, item) {
          var url = $(item).attr('href');
          $(item).attr('href', Utility.updateQueryStringParameter(url, configurationType, selectedColorConfig.colorCode));
        });
      }
    }; // Updating active color button based on selection


    this.setActiveButton = function (i) {
      this.colorsContainer.find('.' + btnClass).removeClass(isActive);
      this.colorsContainer.find('[data-item="' + i + '"]').addClass(isActive);
    }; // Showing 360 when all is ready


    this.showThreeSixty = function () {
      var that = this;
      this.imagesContainer.fadeIn('slow', function () {
        that.imagesContainer.find('.' + prevCur).remove();
      });
      this.ready = true;
    };

    this.addTabBtnChangeGallery = function () {
      var trackingData = $('.color-selector .threesixty-tabs').attr('data-tab-tracking');
      var trackingAttribute = '';

      if (trackingData) {
        trackingAttribute = 'data-tracking="' + trackingData + '"';
      }

      var btn = '<a href="#" ' + trackingAttribute + ' class="acr-label-3 tab-button ' + 'btn-display-selector ' + this.activeGallery + '" data-target="' + this.id + '">' + this.name + '</a>';
      buttonsTabContainer.append(btn);
    };

    this.addColorBtnsAndDisclaimer = function () {
      var buttons = '<div class="' + this.id + ' item color-swatches ' + this.activeGallery + ' ">';
      buttons += '<div class="text-container">' + '<div class="' + this.id + ' ' + colorName + '">' + '<span class="text acr-paragraph-7"></span>' + '</div>';

      if (this.disclaimer) {
        buttons += '<div class="gallery-disclaimer">' + '<span class="acr-paragraph-10">' + this.disclaimer + '</span> </div>';
      }

      buttons += '</div><div class="color-buttons">';
      $.each(this.vehicles, function (index) {
        buttons += '<a href="#" class="' + btnClass;
        buttons += '" title="' + this.colorName;
        buttons += '" data-name="' + this.colorName;
        buttons += '" data-item="' + index;
        buttons += '" style="' + (this.colorSwatch.indexOf('/') >= 0 ? 'background-image: url(' + this.colorSwatch + ')' : 'background-color: ' + this.colorSwatch + '') + '">';
        buttons += '<svg viewBox="0 0 200 200">';
        buttons += '<use xmlns:xlink="http://www.w3.org/1999/xlink"';
        buttons += ' xlink:href="#checkmark"></use></svg></a>';
      });
      buttons += '</div></div>';
      buttonsColorsContainer.append(buttons);
      buttonsColorsContainer.append(cutline);
    };

    this.addLazy360 = function (element) {
      var elementChildren = [].slice.call(element.querySelectorAll('img'));
      elementChildren.forEach(function (elementChild) {
        elementChild.src = elementChild.dataset.src;
      });
    };

    this.addLazyPano = function () {
      var galleries;
      var baseUrl;
      galleries = [].slice.call(document.querySelectorAll('.acr-threesixty-small'));
      baseUrl = JSON.parse(galleries[0].dataset.galleries.replace(/[']/g, '"'))[1].vehicles[0].baseUrl;
      window.pano.readConfigUrlAsync(baseUrl);
    };

    this.initLazyLoading360 = function () {
      var that = this;
      var lazyElements360 = [].slice.call(document.querySelectorAll('.threesixty-images.' + lazyClass360));
      Utility.initLazyLoadingIO(lazyElements360, this.addLazy360);
    };

    this.initLazyLoadingPano = function () {
      var that = this;
      var lazyElementsPano = [].slice.call(document.querySelectorAll('.pano360.' + lazyClassPano));
      Utility.initLazyLoadingIO(lazyElementsPano, this.addLazyPano);
    };

    this.initialize();
  }

  function init() {
    var galleries;

    if (mainContainer.length) {
      galleries = mainContainer.data('galleries');

      if (galleries && galleries.length) {
        galleries = $.parseJSON(galleries.replace(/[']/g, '"'));
        galleries.forEach(function (gallery) {
          new Gallery(gallery);
        });
      }
    }
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.VehicleLineup = function () {
  var $vehicleLineup;
  var $vehicleLineupList;
  var $vehicleLineupTiles;
  var lineupListSelectorClass = '.js-lineup-list';
  var lineupTileSelectorClass = '.js-lineup-tile';
  var animatedClass = 'animated';
  var fadeInUpScatterClass = 'acr-fade-in-up-scatter';

  function initSelectors(element) {
    $vehicleLineup = element;
    $vehicleLineupList = $vehicleLineup.querySelector(lineupListSelectorClass);
    $vehicleLineupTiles = $vehicleLineup.querySelectorAll(lineupTileSelectorClass);
  }

  function addClassesToObject(observedObject) {
    var classListObserver = [animatedClass, fadeInUpScatterClass];
    classListObserver.forEach(function (observerClass) {
      observedObject.classList.add(observerClass);
    });
  }

  function initObservers() {
    Utility.addIntersectionObserver($vehicleLineupList, addClassesToObject);
    $vehicleLineupTiles.forEach(function ($vehicleLineupTile) {
      return Utility.addIntersectionObserver($vehicleLineupTile, addClassesToObject);
    });
  }

  function init(element) {
    initSelectors(element);
    initObservers();
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.VerticalMultitab = function () {
  var $verticalMultitab;
  var $imgSliderSwiperContainer;
  var $textSliderSwiperContainer;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $verticalMultitabTabs;
  var $verticalMultitabImageSlides;
  var $tabsContainer;
  var $currentActiveTab;
  var $currentSlide;
  var $verticalMultitabTextContainer;
  var $verticalMultitabTextSlides;
  var $verticalMultitabHeading;
  var currentDataIndex;
  var currentSlideId;
  var matchMedia;
  var verticalMultitabCurrentTheme;
  var verticalMultitabCurrentHeadingTheme;
  var verticalMultitabImgSwiper;
  var verticalMultitabTextSwiper;
  var tabSelectorClass = '.js-vertical-multitab-tab-item';
  var imageSlideSelectorClass = '.js-vertical-multitab-image-slide';
  var swiperImgContainerSelector = '.js-img-swiper-container';
  var swiperTextContainerSelector = '.js-text-swiper-container';
  var swiperPaginationSelector = '.js-swiper-pagination';
  var arrowLeftSelector = '.js-arrow-left';
  var arrowRightSelector = '.js-arrow-right';
  var tabContentTabsContainer = '.js-vertical-multitab-tabs-container';
  var textContainerSelectorClass = '.js-vertical-multitab-text-container';
  var textSlideSelectorClass = '.js-vertical-multitab-text-slide';
  var headingSelectorClass = '.js-vertical-multitab-heading';
  var swiperSlideActive = '.swiper-slide-active';
  var tabActiveClass = 'acr-vertical-multitab__tab-item--active';
  var slideActiveClass = 'active-slide';
  var scrollAnimationsClass = 'scroll-animations';

  function initSelectors(element) {
    $verticalMultitab = element;
    $imgSliderSwiperContainer = $verticalMultitab.querySelector(swiperImgContainerSelector);
    $textSliderSwiperContainer = $verticalMultitab.querySelector(swiperTextContainerSelector);
    $swiperPagination = $verticalMultitab.querySelector(swiperPaginationSelector);
    $arrowLeft = $verticalMultitab.querySelector(arrowLeftSelector);
    $arrowRight = $verticalMultitab.querySelector(arrowRightSelector);
    $verticalMultitabTabs = $verticalMultitab.querySelectorAll(tabSelectorClass);
    $verticalMultitabImageSlides = $verticalMultitab.querySelectorAll(imageSlideSelectorClass);
    $verticalMultitabTextContainer = $verticalMultitab.querySelector(textContainerSelectorClass);
    $verticalMultitabTextSlides = $verticalMultitab.querySelectorAll(textSlideSelectorClass);
    $tabsContainer = $verticalMultitab.querySelector(tabContentTabsContainer);
    $verticalMultitabHeading = $verticalMultitab.querySelector(headingSelectorClass);
  }

  function bindEvents() {
    matchMedia.addListener(toggleVerticalSliderSwiper); // Attachment of click events for each of the tabs

    $verticalMultitabTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  } // Function that is called when a tab is clicked


  function tabClickHandler() {
    var clickedTabId = this.getAttribute('tab-id');
    updateTabsStatus(clickedTabId);
    updateTheme(clickedTabId);
  } // Function that is called when an arrow is clicked


  function swipeSlideClickHandler() {
    var currentSlide = $verticalMultitab.querySelector(swiperSlideActive);
    var slideId = currentSlide.getAttribute('id');
    $verticalMultitabImageSlides.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');

      if (tabContentId === slideId) {
        tabContent.classList.add(slideActiveClass);
      } else {
        tabContent.classList.remove(slideActiveClass);
      }
    });
    $verticalMultitabTextSlides.forEach(function (tabText) {
      var tabTextId = tabText.getAttribute('data-id');

      if (tabTextId === slideId) {
        tabText.classList.add(slideActiveClass);
      } else {
        tabText.classList.remove(slideActiveClass);
      }
    });
    updateTheme(slideId);
    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);
    currentDataIndex = $currentActiveTab.getAttribute('data-index');
  } // Function to set a tab and its content as an "active" tab when a new tab is clicked.


  function updateTabsStatus(paramTargetTab) {
    $verticalMultitabTabs.forEach(function (tab) {
      var tabId = tab.getAttribute('tab-id');

      if (tabId === paramTargetTab) {
        tab.classList.add(tabActiveClass);
      } else {
        tab.classList.remove(tabActiveClass);
      }
    });
    $verticalMultitabImageSlides.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');

      if (tabContentId === paramTargetTab) {
        tabContent.classList.add(slideActiveClass);
      } else {
        tabContent.classList.remove(slideActiveClass);
      }
    });
    $verticalMultitabTextSlides.forEach(function (tabText) {
      var tabTextId = tabText.getAttribute('data-id');

      if (tabTextId === paramTargetTab) {
        tabText.classList.add(slideActiveClass);
      } else {
        tabText.classList.remove(slideActiveClass);
      }
    });
    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);
    currentDataIndex = $currentActiveTab.getAttribute('data-index');
  } // Function that is called to change the theme of the component


  function updateTheme(paramTargetTab) {
    var $verticalMultitabTab = $verticalMultitab.querySelector('#' + paramTargetTab);

    if (verticalMultitabCurrentTheme) {
      var dataTheme = $verticalMultitabTab.getAttribute('data-theme');
      $tabsContainer.classList.remove(verticalMultitabCurrentTheme);
      $tabsContainer.classList.add(dataTheme);
      verticalMultitabCurrentTheme = dataTheme;
    }

    if (verticalMultitabCurrentHeadingTheme) {
      var dataHeadingTheme = $verticalMultitabTab.getAttribute('data-heading-theme');
      $verticalMultitabHeading.classList.remove(verticalMultitabCurrentHeadingTheme);
      $verticalMultitabHeading.classList.add(dataHeadingTheme);
      verticalMultitabCurrentHeadingTheme = dataHeadingTheme;
    }

    var dataBgColor = $verticalMultitabTab.getAttribute('data-bg-color');
    setBackgroundColor(dataBgColor);
  } // Function that sets the current theme being used when the page loads


  function setInitialTheme() {
    var verticalMultitabCurrentBg = $currentActiveTab.getAttribute('data-bg-color');
    verticalMultitabCurrentTheme = $currentActiveTab.getAttribute('data-theme');
    verticalMultitabCurrentHeadingTheme = $currentActiveTab.getAttribute('data-heading-theme');

    if (verticalMultitabCurrentBg) {
      setBackgroundColor(verticalMultitabCurrentBg);
    }

    if (verticalMultitabCurrentTheme) {
      $tabsContainer.classList.add(verticalMultitabCurrentTheme);
    }

    if (verticalMultitabCurrentHeadingTheme) {
      $verticalMultitabHeading.classList.add(verticalMultitabCurrentHeadingTheme);
    }
  } // Function that sets the current background color of the component


  function setBackgroundColor(backgroundColor) {
    if (!Utility.isDesktop()) {
      $verticalMultitab.style.backgroundColor = backgroundColor;
    } else {
      $verticalMultitab.style.backgroundColor = 'transparent';
    }
  } // Function that enables or disables the Swiper Slider depending on screen size


  function toggleVerticalSliderSwiper() {
    var deleteInstance = false;
    var cleanStyles = true;

    if (matchMedia.matches) {
      $currentSlide = $verticalMultitab.querySelector(swiperSlideActive);

      if ($currentSlide) {
        currentSlideId = $currentSlide.getAttribute('id');
        verticalMultitabImgSwiper.destroy(deleteInstance, cleanStyles);
        verticalMultitabTextSwiper.destroy(deleteInstance, cleanStyles);
        updateTabsStatus(currentSlideId);
        updateTheme(currentSlideId);
      }
    } else {
      initVerticalSliderSwiper();
      verticalMultitabImgSwiper.slideToLoop(parseInt(currentDataIndex, 10));
      $currentSlide = $verticalMultitab.querySelector(swiperSlideActive);

      if ($currentSlide) {
        currentSlideId = $currentSlide.getAttribute('id');
        $verticalMultitab.style.backgroundImage = 'none';
        setInitialTheme();
      }
    }
  } // Initialize the swiper slider


  function initVerticalSliderSwiper() {
    // Create a swiper for the mobile images
    verticalMultitabImgSwiper = new Swiper($imgSliderSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft
      },
      init: false,
      initialSlide: parseInt(currentDataIndex, 10),
      on: {
        slideChangeTransitionStart: function slideChangeTransitionStart() {
          swipeSlideClickHandler();
        }
      }
    }); // Create a swiper for the mobile text below the images

    verticalMultitabTextSwiper = new Swiper($textSliderSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      init: false,
      initialSlide: parseInt(currentDataIndex, 10)
    }); // Each of the swipers controlls the other

    verticalMultitabImgSwiper.controller.control = verticalMultitabTextSwiper;
    verticalMultitabTextSwiper.controller.control = verticalMultitabImgSwiper;

    if (!Utility.isDesktop()) {
      verticalMultitabImgSwiper.init();
      verticalMultitabTextSwiper.init();
    }

    verticalMultitabImgSwiper.on('slideChange', function () {
      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function initObservers() {
    var observer = new IntersectionObserver(function (entries, observer) {
      if (entries[0].isIntersecting) {
        $verticalMultitabTextContainer.classList.add(scrollAnimationsClass);
      } else {
        $verticalMultitabTextContainer.classList.remove(scrollAnimationsClass);
      }
    });
    observer.observe($verticalMultitabTextContainer);
  }

  function initGlobalVariables() {
    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);

    if ($currentActiveTab) {
      currentDataIndex = $currentActiveTab.getAttribute('data-index');
      matchMedia = window.matchMedia('(min-width: ' + Constants.breakpoints.lg + 'px)');
    }
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();

    if ($currentActiveTab) {
      initObservers();
      initVerticalSliderSwiper();
      setInitialTheme();
      bindEvents();
    }
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.Zipgate = function () {
  var $body;
  var $zipGate;
  var $zipGateCloseBtn;
  var $zipGateSpinner;
  var $zipGateGeoError;
  var $zipGateZipCodeError;
  var $zipGateFormInput;
  var $zipGateFormBtn;
  var $zipGateAllowBtn;
  var closeButtonSelectorClass = '.js-zipgate-close';
  var zipgateSelectorClass = '.js-zipgate';
  var spinnerSelectorClass = '.js-zipgate-spinner';
  var geoErrorSelectorClass = '.js-zipgate-geo-error';
  var zipCodeErrorSelectorClass = '.js-zipgate-code-error';
  var formInputSelectorClass = '.js-zipgate-form-input';
  var formButtonSelectorClass = '.js-zipgate-form-button';
  var allowButtonSelectorClass = '.js-zipgate-allow';
  var showZipgate = '.js-zipgate.show';
  var bodyTagSelector = 'body';
  var showClass = 'show';
  var modalOpenClass = 'modal-open';
  var geoService = '/platform/api/v1/zipcode/ip';
  var zipcodeValue;
  var zipcodeUpdateEvent;
  var callback;
  var callbackEvent;
  var zipgateElement = document.querySelector(zipgateSelectorClass);
  var focusableElements = '.js-zipgate-close:not([style*="display: none"]), button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var closeElement = zipgateElement.querySelector(closeButtonSelectorClass);
  var focusableContent = zipgateElement.querySelectorAll(focusableElements);
  var firstFocusableElement = closeElement && window.getComputedStyle(closeElement).display !== 'none' ? focusableContent[0] : focusableContent[1]; // get first element to be focused inside modal

  var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

  var preFocusableElement = focusableContent[focusableContent.length - 2];
  document.addEventListener('keydown', function (e) {
    if (closeElement) {
      closeElement.removeAttribute('focusable');
      closeElement.setAttribute('tabindex', '0');
    }

    var activeElementClass = document.activeElement.getAttribute('class');
    var currentElement = zipgateElement.getElementsByClassName(activeElementClass);
    var isZipgateOpen = document.querySelector(showZipgate);
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    var isIE = Utility.isIE11();

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey && !isIE) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        if (lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null) {
          preFocusableElement.focus(); // add focus for the last focusable element

          e.preventDefault();
        } else {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      }
    }

    if (!e.shiftKey && !isIE) {
      if (document.activeElement === lastFocusableElement || lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null && document.activeElement === preFocusableElement && isZipgateOpen !== null) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element

        e.preventDefault();
      } else if (currentElement.length === 0 && isZipgateOpen !== null) {
        firstFocusableElement.focus(); // add focus for the first focusable element

        e.preventDefault();
      }
    }
  });

  function triggerFormTaggingClick() {
    try {
      var stringObject = $zipGateFormBtn.getAttribute('data-form-submit-tracking') || '';
      var clickObject = JSON.parse(stringObject.split("'").join('"'));

      if (clickObject && Acr.TrackingManager) {
        Acr.TrackingManager.clickActivity(clickObject);
      }
    } catch (err) {
      console.warn('ERROR AT TRACKING OBJECT: ' + err);
    }
  }

  function getZipcode() {
    var zipcode = Utility.getUrlParameterValue('zipcode');

    if (typeof zipcode === 'string') {
      zipcode = zipcode.replace(/\D/g, '');
    }

    if (!zipcode) {
      zipcode = Utility.getCookie('zipcode');

      if (zipcode && zipcode !== 'false') {
        return zipcode;
      }

      return false;
    }

    return zipcode;
  }

  function triggerTaggingPage(trackingObject) {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad(trackingObject);
    } else {
      // this event will be triggered once that
      // TrackingManager.js is loaded. Used to avoid dependencies issues.
      window.addEventListener('trackingPageload', function runPageLoad() {
        if (Acr.TrackingManager) {
          Acr.TrackingManager.pageLoad(trackingObject);
        }
      });
    }
  }

  function trackingOpenZipgate() {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.savePageLoadObject();
    }

    var tempTrackingObject = window.Acr.trackingObject;
    var trackingObject = {
      // eslint-disable-line no-unused-vars
      Model: {
        model_name: 'no model',
        model_year: 'no model',
        body_style: 'no model'
      },
      Page: {
        site_section: 'global',
        page_name: window.Acr.pageName ? window.Acr.pageName + ' Location Access Modal' : '',
        sub_section: window.Acr && window.Acr.trackingObject ? window.Acr.trackingObject.Page.sub_section : '',
        sub_section2: window.Acr && window.Acr.trackingObject ? window.Acr.trackingObject.Page.sub_section2 : ''
      }
    };

    if (tempTrackingObject) {
      if (tempTrackingObject.Model) {
        trackingObject.Model = tempTrackingObject.Model;
      }

      if (tempTrackingObject.Page && tempTrackingObject.Page.page_name && tempTrackingObject.Page.sub_section) {
        trackingObject.Page.page_name = tempTrackingObject.Page.page_name + ' Location Access Modal';
        trackingObject.Page.sub_section = tempTrackingObject.Page.sub_section;
      }
    }

    triggerTaggingPage(trackingObject);
  }

  function setZipcode(zipcode) {
    var url = document.location.href;
    var redirect = $zipGate.getAttribute('data-redirect');
    Utility.setCookie('zipcode', zipcode);
    $zipGateGeoError.classList.remove(showClass);

    if (callback && callbackEvent) {
      callback(callbackEvent);
      zipcodeUpdateEvent = Utility.createEvent('zipcodeUpdate', {
        zipcode: zipcode
      });
      window.dispatchEvent(zipcodeUpdateEvent);
      closeZipgate();
    } else if (String(redirect).toLowerCase() === 'true') {
      closeZipgate();

      if (url.indexOf('?') !== -1) {
        url = url + '&zipcode=' + zipcode;
      } else {
        url = url + '?zipcode=' + zipcode;
      }

      document.location = url;
    } else {
      closeZipgate();
      zipcodeUpdateEvent = Utility.createEvent('zipcodeUpdate', {
        zipcode: zipcode
      });
      window.dispatchEvent(zipcodeUpdateEvent);
    }
  }

  function showError() {
    $zipGateZipCodeError.classList.add(showClass);
  }

  function validZipcodeSubmit() {
    setZipcode(zipcodeValue);
  }

  function sendZipcode(e) {
    e.stopPropagation();
    e.preventDefault();
    triggerFormTaggingClick();
    Utility.validateZipcode(zipcodeValue, validZipcodeSubmit, showError);
  }

  function validateZipCode() {
    var inputValue = $zipGateFormInput.value;
    var validZipcode = new RegExp(/^\d{5}$/);
    $zipGateZipCodeError.classList.remove(showClass);

    if (inputValue.match(validZipcode)) {
      $zipGateFormBtn.disabled = false;
      zipcodeValue = inputValue;
    } else {
      $zipGateFormBtn.disabled = true;
      zipcodeValue = false;
    }
  }

  function allowGeolocation() {
    var beforeSend = function beforeSend() {
      $zipGateSpinner.classList.add(showClass);
    };

    var request = new XMLHttpRequest();
    request.open('GET', geoService, true);

    request.onload = function (data) {
      var response = JSON.parse(data.currentTarget.response);
      var zipCode = response.GeoIpData.postalCode;

      if (response.ResolveState === 1) {
        setZipcode(zipCode);
      } else {
        $zipGateGeoError.classList.add(showClass);
      }

      $zipGateSpinner.classList.remove(showClass);
    };

    request.setRequestHeader('Content-Type', 'application/json');
    beforeSend();
    request.send();
  }

  function closeZipgate() {
    $body.classList.remove(modalOpenClass);
    $zipGate.classList.remove(showClass);
    $zipGateFormInput.value = null;
    $zipGateFormBtn.disabled = true;

    if (Acr.TrackingManager) {
      Acr.TrackingManager.restorePageLoadObject();
    }
  }

  function openZipgate(callbackParam, event) {
    var cloneEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var hideCloseButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    trackingOpenZipgate();

    if (callbackParam) {
      callback = callbackParam;
      callbackEvent = cloneEvent ? Object.assign({}, event) : event;
    }

    $zipGate.classList.add(showClass);
    $body.classList.add(modalOpenClass);

    if (hideCloseButton) {
      $zipGateCloseBtn.classList.add('hide');
    }
  }

  function initSelectors(element) {
    $zipGate = element;
    $zipGateCloseBtn = $zipGate.querySelector(closeButtonSelectorClass);
    $zipGateSpinner = $zipGate.querySelector(spinnerSelectorClass);
    $zipGateGeoError = $zipGate.querySelector(geoErrorSelectorClass);
    $zipGateZipCodeError = $zipGate.querySelector(zipCodeErrorSelectorClass);
    $zipGateFormInput = $zipGate.querySelector(formInputSelectorClass);
    $zipGateFormBtn = $zipGate.querySelector(formButtonSelectorClass);
    $zipGateAllowBtn = $zipGate.querySelector(allowButtonSelectorClass);
    $body = document.querySelector(bodyTagSelector);
  }

  function bindEvents() {
    if ($zipGateCloseBtn) {
      $zipGateCloseBtn.addEventListener('click', closeZipgate);
      $zipGateCloseBtn.addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          closeZipgate();
        }
      });
    }

    $zipGateAllowBtn.addEventListener('click', allowGeolocation);
    $zipGateFormInput.addEventListener('keyup', validateZipCode);
    $zipGateFormBtn.addEventListener('click', sendZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
    getZipcode: getZipcode,
    openZipgate: openZipgate
  };
};
"use strict";

var ButtonLine = function () {
  var $buttonLines;
  var $line;
  var defaultScrollFactor;
  var defaultColor = 'white';

  function init() {
    $buttonLines = $('[data-acr-button-line]');
    defaultScrollFactor = 0.7;
    createLine();
    attachScroll();
    attachResize();
    scroll();
  }

  function createLine() {
    $line = $('<div/>', {
      class: 'acr-button-line'
    });
    $('body').prepend($line);
  }

  function attachScroll() {
    $(window).off('scroll', scroll).on('scroll', scroll);
  }

  function attachResize() {
    $(window).off('resize', scroll).on('resize', scroll);
  }

  function drawLine($anchor, $window, elHeight, scrollFactor, color) {
    var winTop = $window.scrollTop();
    var winBottom = winTop + $window.height();
    var elTop = $anchor.offset().top;
    var elBottom = elTop + $anchor.outerHeight();

    if (elTop < winBottom) {
      var height = (winBottom - elTop) * scrollFactor;

      if (elHeight > height) {
        $line.height(height);
      } else {
        $line.height(elHeight);
      }

      $line.css({
        top: elBottom,
        'background-image': 'linear-gradient(to bottom,' + color + ', transparent)'
      });
    }
  }

  function scroll() {
    var $window = $(window);

    if ($window.innerWidth() < Constants.breakpoints.sm) {
      return;
    }

    $buttonLines.each(function (i, lineAnchor) {
      var elHeight;
      var $lineAnchor = $(lineAnchor);

      if ($lineAnchor.attr('data-enable') === undefined) {
        return;
      }

      var scrollFactor = $lineAnchor.data('scrollFactor') || defaultScrollFactor;
      var color = $lineAnchor.data('color') || defaultColor;

      if ($window.innerWidth() < Constants.breakpoints.sm) {
        elHeight = $lineAnchor.data('smHeight');
      } else if ($window.innerWidth() < Constants.breakpoints.lg) {
        elHeight = $lineAnchor.data('mdHeight');
      } else if ($window.innerWidth() < Constants.breakpoints.xl) {
        elHeight = $lineAnchor.data('lgHeight');
      } else {
        elHeight = $lineAnchor.data('xlHeight');
      }

      drawLine($lineAnchor, $window, elHeight, scrollFactor, color);
    });
  }

  return {
    init: init,
    scroll: scroll
  };
}();
"use strict";

var Chart = function () {
  var $packages;

  function init() {
    attachClick();
    layout();
  }

  function attachClick() {
    $packages = $('.acr-chart .package');
    $packages.on('click', clickHandler);
    $packages.find('.acr-cta-text').on('click', readMoreHandler);
  }

  function clickHandler() {
    var $this = $(this);
    var relatedPackages = $this.data('relatedPackages');
    $('.acr-chart .package').removeClass('active related');

    if (relatedPackages) {
      relatedPackages = relatedPackages.split(',');
      $.each(relatedPackages, function (i, id) {
        $('#' + id).addClass('related');
      });
    }

    $this.addClass('active');
  }

  function readMoreHandler(e) {
    e.preventDefault();
    var id = e.currentTarget.href.split('#')[1];
    var headerHeight = $('.acr-header').innerHeight();
    $('html, body').animate({
      scrollTop: $('#' + id).offset().top - headerHeight
    }, 1000);
  }

  function layout() {
    $('.acr-chart').each(function (i, container) {
      var $container = $(container);
      var numPackages = 0;
      var $containerDiv = $('<div class="package-container"></div>');
      var pkgs = $container.find('.package');
      var pkgDivs = [];
      var limit; // Each row should have between 3 and 5 packages

      if (pkgs.length <= 5) {
        limit = pkgs.length;
      } else if (pkgs.length > 5 && pkgs.length <= 8) {
        limit = pkgs.length - 3;
      } else {
        limit = 5;
      }

      while (pkgs.length > 0) {
        var pkg = pkgs.splice(0, 1);
        numPackages += 1;
        $containerDiv.append(pkg);

        if (numPackages === limit) {
          pkgDivs.push($containerDiv);
          numPackages = 0;
          $containerDiv = $('<div class="package-container"></div>');
        }
      }

      if (!$containerDiv.is(':empty')) {
        pkgDivs.push($containerDiv);
      }

      pkgDivs.reverse();

      for (var j = 0; j < pkgDivs.length; j++) {
        pkgDivs[j].prependTo($container);
      }
    });
  }

  return {
    init: init
  };
}();
"use strict";

var CompareTool = function (window, $) {
  Utility.log('CompareTool.js loaded');
  var compUI;
  var $compWrapper;
  var lastCardOpened;

  var setActiveFeaturesLinks = function setActiveFeaturesLinks(linkHref
  /* optional */
  ) {
    // Make compare-table section jump-link the active one (first link by
    // default)
    var $featuresLinks = $('.features-links-link', $compWrapper);
    var $selectedFeaturesLink;
    $featuresLinks.removeClass('is-active');

    if (linkHref) {
      $featuresLinks.each(function () {
        // For some reason, attribute-selector doesn't work, so using a loop
        // here
        var $currLink = $(this);

        if ($currLink.prop('href').indexOf(linkHref) !== -1) {
          $currLink.addClass('is-active');
        }
      });
    } else {
      $selectedFeaturesLink = $('.features-links-link:first-child', $compWrapper);
      $selectedFeaturesLink.addClass('is-active');
    }
  };

  var modifyFeaturesLinks = function modifyFeaturesLinks() {
    // put the last two visible links into a wrapper div
    //  so that they wrap onto a new line together - preventing widow links
    var $container = $('features-links .compare-content');
    $container.find('div').remove();
    $container.each(function () {
      var $links = $('a:not(.no-advantage-flag)', $(this));
      var len = $links.length;
      $($links[len - 3]).after('<div class="line-break"></div>');
      $(this).children('div').append($($links[len - 2]), $($links[len - 1]));
    });
  };

  var prependAddVehicleArrowhead = function prependAddVehicleArrowhead($avForm) {
    // Injects arrowhead into add-vehicle section.
    var $arrowhead = $('<div class="add-vehicle-arrowhead"></div>');
    $arrowhead.prependTo($avForm);
  };

  var positionFormArrowhead = function positionFormArrowhead($clickedCardSlot) {
    // Sets left position of add-vehicle form's arrowhead.
    var screenWidth = document.body.clientWidth;
    var $vehicleSelector = $clickedCardSlot.closest('.vehicle-selector');
    var $cardsSlotsCntr = $('.selector-cards', $vehicleSelector);
    var $formArrowhead = $('#addVehicle .add-vehicle-arrowhead', $compWrapper);
    var vehSelMaxWidth = parseInt($vehicleSelector.css('max-width'), 10);
    var cntrLeftMargin = screenWidth > vehSelMaxWidth ? (screenWidth - vehSelMaxWidth) / 2 : 0;
    var cntrLeftPadding = parseInt($cardsSlotsCntr.css('padding-left'), 10);
    var cntrWidth = screenWidth - (cntrLeftMargin + cntrLeftPadding) * 2;
    var prevCards = $clickedCardSlot.prevAll('vehicle-card').length;
    var cardsVisible = $('vehicle-card:visible', $cardsSlotsCntr).length;
    var slotsVisible = $('.compare-empty-slot:visible', $cardsSlotsCntr).length;
    var cardsSlotsVisibleTotal = cardsVisible + slotsVisible;
    var cardSlotCntrFactor = (prevCards + 0.5) / cardsSlotsVisibleTotal;
    var posX = Math.round(cntrLeftPadding + cntrWidth * cardSlotCntrFactor - $formArrowhead.outerWidth() / 2);
    $formArrowhead.css('left', posX + 'px');
  };

  var attachChangeVehicleListener = function attachChangeVehicleListener(ctaSelector) {
    $(document).on('click', ctaSelector, function (evt) {
      var $clickedCard = $(evt.originalEvent.target).closest('vehicle-card');
      var $refineVehicles;
      positionFormArrowhead($clickedCard);
      $refineVehicles = $('#addVehicle .refine-vehicles', $compWrapper);

      if ($clickedCard.prev('vehicle-card').length === 0) {
        $refineVehicles.addClass('refine-anchor');
      } else {
        $refineVehicles.removeClass('refine-anchor');
      }
    });
  };

  var attachAddVehicleListener = function attachAddVehicleListener(ctaSelector) {
    $(document).on('click', ctaSelector, function (evt) {
      var $clickedSlot = $(evt.originalEvent.target).closest('.compare-empty-slot');
      positionFormArrowhead($clickedSlot);
      $('#addVehicle .refine-vehicles', $compWrapper).removeClass('refine-anchor');
    });
  };

  var attachCustomDropdownListener = function attachCustomDropdownListener($customDropdownCntr) {
    // When User changes Year/Model (by clicking custom-dropdown list-item),
    // clear subsequent dropdown-customizations except one immediately following
    var $customOptions = $customDropdownCntr.find('.acr-select-box-options li');
    $customOptions.on('click', function (e) {
      var $customOption = $(e.target);
      var $customDropdownCntr = $customOption.closest('.acr-select-box-cloned');
      var dataId = $customDropdownCntr.data('id');
      var nativeSelectorPrefix = '.add-vehicle-select#';

      if (dataId === 'year') {
        clearDropdownCustomizations($(nativeSelectorPrefix + 'model, ' + nativeSelectorPrefix + 'trim', $compWrapper));
      } else if (dataId === 'make') {
        clearDropdownCustomizations($(nativeSelectorPrefix + 'trim'), $compWrapper);
      }
    });
  };

  var updateCustomDropdownSelection = function updateCustomDropdownSelection($nativeSelect) {
    // Replicate any gray-tool dynamic* native-dropdown selection to
    // custom-dropdown.
    // *Gray-tool makes native-dropdown selections dynamically after AJAX
    // responses
    var nativeSelectedIdx = $nativeSelect.prop('selectedIndex');
    var $customOptionsList = $nativeSelect.next('.acr-select-box-cloned').find('.acr-select-box-options ul');
    var $customOptionToSelect;

    if ($customOptionsList.length === 1) {
      $customOptionToSelect = $customOptionsList.find('li:eq(' + nativeSelectedIdx + ')');

      if (!$customOptionToSelect.hasClass('selected')) {
        SelectBox.selectOption($customOptionsList.closest('.acr-select-box'), $customOptionsList.closest('.acr-select-box-options'), $customOptionToSelect.find('span'), false);
      }
    }
  };

  var clearDropdownCustomizations = function clearDropdownCustomizations($nativeSelects) {
    $nativeSelects.each(function () {
      var $currSelect = $(this);
      var $currClone = $currSelect.next('.acr-select-box-cloned');

      if ($currClone.length > 0) {
        $currSelect.next('.acr-select-box-cloned').remove();
        $currSelect.closest('.add-vehicle-select-container').removeClass('cloned');
      }

      $currSelect.show();
    });
  };

  var manageRefineVehicleDropdowns = function manageRefineVehicleDropdowns() {
    var $selects = $('.refine-vehicles .add-vehicle-select');
    var cloneSelector = '.acr-select-box-cloned';
    var dropdownTimeouts = {
      inserts: {
        year: null,
        make: null,
        model: null,
        trim: null
      },
      removes: {
        year: null,
        make: null,
        model: null,
        trim: null
      }
    };
    $selects.each(function (idx, ele) {
      var $currSelect = $(ele);
      var $currSelectCntr = $currSelect.closest('.add-vehicle-select-container');
      var currId;
      var currInsertTimeout;
      clearDropdownCustomizations($currSelect); // Get/insert id.

      if (ele.id) {
        currId = ele.id;
      } else {
        currId = $currSelect.attr('name');
        $currSelect.attr('id', currId);
      } // Customize after options have been dynamically inserted into original
      // select


      currInsertTimeout = dropdownTimeouts.inserts[currId];
      $currSelect.on('DOMNodeInserted', function () {
        if ($currSelect.find('option').length >= 2) {
          if (currInsertTimeout) {
            clearTimeout(currInsertTimeout);
          }

          currInsertTimeout = setTimeout(function () {
            SelectBox.createSelect('.refine-vehicles select#' + currId);
            $currSelectCntr.addClass('cloned');
            $(cloneSelector + ' + ' + cloneSelector, $currSelectCntr).remove();
            setTimeout(function () {
              if ($currSelect.is(':disabled')) {
                clearDropdownCustomizations($currSelect);
              } else {
                // Handle any gray-tool dynamic native-select changes (not made
                // by User).
                updateCustomDropdownSelection($currSelect); // Handle clearing/disabling custom-dropdowns after
                // User makes custom-dropdown year/make selection.

                if (currId === 'year' || currId === 'make') {
                  attachCustomDropdownListener($(cloneSelector + '[data-id=' + currId + ']'));
                }
              }
            }, 250);
          }, 100);
        }
      });
    });
  };

  var featureLinksJumpCheckFix = function featureLinksJumpCheckFix(e) {
    // checks Features Jump (to Compare-table section) is accurate, after
    // Gray-tool jump code finishes, then
    // fixes scroll position and link-highlight as needed.
    var $link = $(e.originalEvent.target);
    var linkHref = $link.attr('href');
    var sectionId = linkHref.substring(1);

    function checkFixJump(sectionId) {
      var $stickyHeader = $('sticky-header', $compWrapper);
      var stickyHeaderBottom = $stickyHeader.offset().top + $stickyHeader.height();
      var sectionTop = $('.features-summary-title#' + sectionId).offset().top;
      var scrollDelta = sectionTop - stickyHeaderBottom;

      if (scrollDelta !== 0) {
        window.scrollBy(0, scrollDelta);
      }
    }

    setTimeout(function () {
      checkFixJump(sectionId);
    }, 750);
    setTimeout(function () {
      setActiveFeaturesLinks(linkHref);
    }, 1000);
  };

  var dupFeatureLinksShowHide = Utility.debounce(function () {
    // shows/hides duplicate features jump-links after page-scroll.
    var $stickyHeader = $('sticky-header', $compWrapper);
    var $duplicateFeaturesLinksCntr = $('.compare-details > features-links', $compWrapper);
    var stickyHeaderVisible = $stickyHeader.hasClass('is-visible');

    if (stickyHeaderVisible) {
      $duplicateFeaturesLinksCntr.hide();
    } else {
      $duplicateFeaturesLinksCntr.show();
    }
  }, 50);

  var setListeners = function setListeners() {
    // this functions as a ready event for the tool
    compUI.bus.one(compUI.bus.EVENTS.VEHICLES.LOADED, function () {
      setActiveFeaturesLinks();
    });
    compUI.bus.on(compUI.bus.EVENTS.VEHICLES.LOADED, function () {
      var $stickyHeader = $('sticky-header[empty-slots]');
      var $compareWrapper = $('compare-wrapper');
      modifyFeaturesLinks();

      if ($stickyHeader.length > 0) {
        if ($compareWrapper.length > 0) {
          $compareWrapper.attr('empty-slots', $stickyHeader.attr('empty-slots'));
        }
      }
    });
    $(document).on('click', '.features-links-link', featureLinksJumpCheckFix);
    $(window).on('scroll', dupFeatureLinksShowHide);
    $(document).on('click', '.icon-close', function () {
      $('vehicle-card').removeClass('faded not-faded');
    });
    attachAddVehicleListener('.compare-empty-slot button');
    attachChangeVehicleListener('vehicle-card .change-button');
    compUI.bus.on(compUI.bus.EVENTS.VEHICLES.SHOW_ADD_VEHICLE, function (data) {
      manageRefineVehicleDropdowns();
      shadeUnselectedVehicleCards(data.change);
    });
  };

  var shadeUnselectedVehicleCards = function shadeUnselectedVehicleCards(id) {
    // check if user is closing the same card they just opened
    // prevents issue AR-14032
    if (lastCardOpened !== id) {
      $('.vehicle-card-content:not([vehicle-id="' + id + '"])').closest('vehicle-card').addClass('faded').removeClass('not-faded');
      $('.vehicle-card-content[vehicle-id="' + id + '"]').closest('vehicle-card').removeClass('faded').addClass('not-faded');
      lastCardOpened = id;
    } else {
      $('.vehicle-card-content').closest('vehicle-card').removeClass('faded').addClass('not-faded');
      lastCardOpened = null;
    }
  };

  var init = function init() {
    var sitecoreExpEditor = !!(window.Sitecore && window.Sitecore.WebEditSettings && window.Sitecore.WebEditSettings.editing);
    var $compareWrapper = $('compare-wrapper');

    if ($compareWrapper.length > 0 && !sitecoreExpEditor) {
      compUI = window.platform.compare.init();
      prependAddVehicleArrowhead($('form#addVehicle', $compareWrapper));
      setListeners();
    }
  };

  return {
    init: init
  };
}(window, $);
"use strict";

var Constants = function () {
  var breakpoints = {
    xs: 320,
    sm: 550,
    md: 768,
    lg: 1024,
    lgxl: 1200,
    xl: 1400,
    mega: 1920
  };
  var grid = {
    one36th: 0.0277778,
    two36th: 0.0555556,
    three36th: 0.0833333,
    four36th: 0.1111111,
    five36th: 0.1388889,
    six36th: 0.1666667,
    seven36th: 0.1944444,
    eight36th: 0.2222222,
    nine36th: 0.25,
    ten36th: 0.2777778,
    eleven36th: 0.3055556,
    twelve36th: 0.3333333,
    thirteen36th: 0.3611111,
    fourteen36th: 0.3888889,
    fifteen36th: 0.4166667,
    sixteen36th: 0.4444444,
    seventeen36th: 0.4722222,
    eighteen36th: 0.50,
    nineteen36th: 0.5277778,
    twenty36th: 0.5555556,
    twentyOne36th: 0.5833333,
    twentyTwo36th: 0.6111111,
    twentyThree36th: 0.6388889,
    twentyFour36th: 0.6666667,
    twentyFive36th: 0.6944444,
    twentySix36th: 0.7222222,
    twentySeven36th: 0.75,
    twentyEight36th: 0.7777778,
    twentyNine36th: 0.8055556,
    thirty36th: 0.8333333,
    thirtyOne36th: 0.8611111,
    thirtyTwo36th: 0.8888889,
    thirtyThree36th: 0.9166667,
    thirtyFour36th: 0.9444444,
    thirtyFive36th: 0.9722222,
    thirtySix36th: 0.100
  };
  return {
    breakpoints: breakpoints,
    grid: grid
  };
}();
"use strict";

var DealerLocatorTool = function () {
  Utility.log('DealerLocatorTool loaded');

  var init = function init() {
    var isDealerLocator = $('dealer-locator-container').length > 0;

    if (isDealerLocator) {
      setListeners();
    }
  };

  var setListeners = function setListeners() {
    $(document).on('click', '.dealer-cta-raq', function (e) {
      $(e.currentTarget).attr('data-raq', 'true').attr('data-modal-type', 'large');
      $(document).trigger('activateModal', e); // remove the attribute so we don't trigger the modal twice on the next click

      $(e.currentTarget).removeAttr('data-modal-type');
      e.preventDefault();
    });
  };

  return {
    init: init
  };
}();
"use strict";

/**
 * Module: DeferLoadingHelper
 *
 * Calls Utility.isElementInViewIO in order to add Deferloading
 *
 *
 * Returned Functions: Init
 *
 * CallBack Function sent to IsElementInViewIO
 *
 * 1.loadImage
 * 2.loadPicture
 *
 */
var Acr = Acr || {};

Acr.DeferLoadingHelper = function () {
  function loadImages() {
    var imagesToLoad = [].slice.call(document.querySelectorAll('img.defer'));
    imagesToLoad.forEach(function (element) {
      if (element.dataset.srcset !== undefined) {
        element.srcset = element.dataset.srcset;
      }

      element.src = element.dataset.src;
      element.classList.remove('defer');
    });
  }

  function loadPictures() {
    var picturesToLoad = [].slice.call(document.querySelectorAll('picture.defer'));
    picturesToLoad.forEach(function (pictureElement) {
      var elementChildren = [].slice.call(pictureElement.querySelectorAll('source,img'));
      elementChildren.forEach(function (elementChild) {
        if (elementChild.dataset.srcset) {
          elementChild.setAttribute('srcset', elementChild.dataset.srcset);
        }

        if (elementChild.dataset.src) {
          elementChild.setAttribute('src', elementChild.dataset.src);
        }
      });
      pictureElement.classList.remove('defer');
    });

    if (Utility.isIE11()) {
      Utility.reevaluatePictureFill();
    }
  }

  function loadVideos() {
    var videosToLoad = [].slice.call(document.querySelectorAll('video.defer'));
    videosToLoad.forEach(function (videoElement) {
      var videoSources = [].slice.call(videoElement.querySelectorAll('source'));
      var posterSource = videoElement.dataset.poster;

      if (posterSource) {
        videoElement.setAttribute('poster', posterSource);
      }

      videoSources.forEach(function (videoSource) {
        if (videoSource.dataset.src) {
          videoSource.setAttribute('src', videoSource.dataset.src);
        }
      });
      videoElement.classList.remove('defer');
      videoElement.load();
    });
  }

  function init() {
    Utility.initDeferLoading(function () {
      loadImages();
      loadPictures();
      loadVideos();
    });
  }

  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};

Acr.Disclaimer = function () {
  Utility.log('Disclaimer.js loaded');
  var disclaimer = $('.acr-disclaimer');
  var disclaimerTitle = '.js-disclaimer-title';

  function init() {
    bindDisclaimerEvent('.acr-sup');
    bindDisclaimerEvent('.acr-span');
    $('body').off('click', hideDisclaimer).on('click', hideDisclaimer);
    $('.acr-icon-button-close', '.acr-disclaimer').on('click', function (e) {
      e.stopPropagation();
      $(this).parents('.acr-disclaimer').hide();
    });
    disclaimer.on('click', function (e) {
      e.stopPropagation();
    });
  } // Default value '.acr-sup'
  // Bind the disclaimer click event to a elementSelector
  // Could be called in case a disclaimer is created after the init execution


  function bindDisclaimerEvent(elementSelector) {
    $(elementSelector).click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      var $sup = $(e.originalEvent.target);
      var target = $sup.data('target');
      var title = '<sup>' + $sup.data('number') + '</sup>' + $sup.data('title');
      $(disclaimerTitle, target).html(title);
      $('p', target).html($sup.data('copy'));
      disclaimer.hide();

      if (disclaimer.height() > $(window).height()) {
        disclaimer.addClass('acr-disclaimer-big');
      }

      $(target).show();
    });
  }

  function hideDisclaimer() {
    disclaimer.hide();
  }

  return {
    init: init
  };
}();
"use strict";

var EmailPreferenceCenter = function () {
  var utility = window.Utility;
  var $emailPreferenceCenter;
  var $preferencesListForm;
  var $updateEmailForm;
  var $updateButton;
  var $unsubscribeButton;
  var $updateEmailButton;
  var $emailPreferencesButton;
  var $serverMessage;
  var $successContainer;
  var $formsContainer;
  var $overlay;
  var $updateEmailError;
  var urlData;
  var configurationItem;
  var getCheckboxLegal = 'input[name=legal]'; // Get URL variables and return them as an associative array.

  function getUrlVariables() {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var parametersObject = utility.getUrlParameters();
    var businessEntity = '';
    var email = '';

    if (!jQuery.isEmptyObject(parametersObject)) {
      for (var key in parametersObject) {
        if (base64regex.test(parametersObject[key])) {
          parametersObject[key] = window.atob(parametersObject[key]);
        }

        switch (key.toLowerCase()) {
          case 'qs':
            var dataArray = parametersObject[key].split('&');
            businessEntity = dataArray[0];
            email = dataArray[1];
            break;

          case 'businessentity':
            businessEntity = parametersObject[key];
            break;

          case 'emailid':
            if (parametersObject[key].indexOf('&') >= 0) {
              businessEntity = parametersObject[key].substr(0, parametersObject[key].indexOf('&'));
            }

            email = parametersObject[key].substr(parametersObject[key].indexOf('&') + 1);
            break;
        }
      }
    }

    configurationItem = $emailPreferenceCenter.find('.js-configuration-item').text();
    urlData = {
      businessEntity: businessEntity,
      email: email,
      configurationItem: configurationItem
    };
    $emailPreferenceCenter.find('.js-current-user-email').html(urlData.email);
  } // Gets the data to check the inputs preferences of the user


  function getData() {
    var getDataUrl = $preferencesListForm.attr('get-data-url');
    getUrlVariables();
    $.ajax({
      beforeSend: function beforeSend() {
        showSpinnerOverlay();
      },
      method: 'POST',
      data: JSON.stringify(urlData),
      url: getDataUrl,
      contentType: 'application/json; charset=utf-8',
      success: function success(response) {
        if (response) {
          var options = response.split(',');
          options.forEach(function (option) {
            var $checkbox = $preferencesListForm.find('input[name=' + option + ']'); // Finds the checkbox with the same name of the option

            $checkbox.prop('checked', true); // Set the property "checked" to the checkbox
          });
        }

        hideSpinnerOverlay();
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      }
    });
  }

  function createDataJson(form) {
    var dataJson;

    if (form.className.indexOf('js-preferences-list-form') >= 0) {
      var interests = [];
      var unsubscribe = [];

      for (var key = 0; key < Object.keys(form).length; key++) {
        if (form[key] !== undefined && form[key].type === 'checkbox') {
          if (form[key].checked) {
            interests.push(form[key].name);
          } else {
            unsubscribe.push(form[key].name);
          }
        }
      }

      dataJson = {
        businessEntity: urlData.businessEntity,
        interests: interests,
        unsubscribe: unsubscribe,
        firstName: '',
        lastName: '',
        email: urlData.email,
        configurationItem: configurationItem
      };
    } else {
      var newEmail = form.elements.Email.value;
      dataJson = {
        businessEntity: urlData.businessEntity,
        email: urlData.email,
        newEmail: newEmail,
        configurationItem: configurationItem
      };
    }

    return dataJson;
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = createDataJson(form);
    $.ajax({
      beforeSend: function beforeSend() {
        showSpinnerOverlay();
      },
      data: JSON.stringify(data),
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      },
      success: function success(data) {
        showServerMessage(data);
      },
      url: action
    });
  }

  function enableUpdateEmailButton() {
    var email = this.value;

    if (!Validation.isValidEmail(email)) {
      $updateEmailButton.attr('disabled', true);
    } else {
      $updateEmailButton.removeAttr('disabled');
    }
  }

  function clearForm() {
    $preferencesListForm.find('input').prop('checked', false);
    $updateEmailForm.find('input').val('');
    $updateEmailForm.find('input').removeClass('acr-not-empty');
    $updateEmailButton.attr('disabled', true);
  }

  function updateURL(querystring) {
    if (history.replaceState) {
      var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?qs=' + querystring;
      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    }
  }

  function showForm(event) {
    var querystring = event.currentTarget.getAttribute('querystring');
    clearForm();
    $updateButton.attr('disabled', true);

    if (querystring) {
      updateURL(querystring);
    }

    getData();
    $serverMessage.addClass('hidden');
    $successContainer.addClass('hidden');
    $formsContainer.removeClass('hidden');
  }

  function showSpinnerOverlay() {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, {
      passive: false
    });
    $('body').css('overflow', 'hidden');
    $overlay.removeClass('hidden');
  }

  function hideSpinnerOverlay() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $('body').css('overflow', 'auto');
    $overlay.addClass('hidden');
  }

  function showServerMessage(data) {
    if (data) {
      data = $.parseJSON(data);
    }

    hideSpinnerOverlay();

    if (data.successMsg) {
      if (data.querystring) {
        $emailPreferencesButton.attr('querystring', data.querystring);
      }

      $serverMessage.html(data.successMsg);
      $emailPreferencesButton.html(data.buttonLabel);
      $formsContainer.addClass('hidden');
      $serverMessage.removeClass('message--error');
      $serverMessage.removeClass('hidden');
      $successContainer.removeClass('hidden');
    } else {
      $serverMessage.addClass('message--error');
      $serverMessage.html(data.errorMsg);
      $serverMessage.removeClass('hidden');
    }

    window.scrollTo(0, 0);
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function attachEvents() {
    // Enable the "Update" button when the checkboxes change
    $preferencesListForm.find('input').change(function () {
      $updateButton.removeAttr('disabled');
    }); // Call the method to send the preferences list form data

    $preferencesListForm.submit(function (event) {
      sendData(event.target);
      event.preventDefault();
    }); // Call the method to clear the form data

    $unsubscribeButton.on('click', clearForm); // Call events when new email input changes

    $updateEmailForm.find('input').on('keyup', enableUpdateEmailButton).on('focus', Validation.onFocus).on('blur', Validation.onBlur); // Call the method to send the new email form data

    $updateEmailForm.submit(function (event) {
      var $checkboxLegal = $updateEmailForm.find(getCheckboxLegal);

      if ($checkboxLegal.is(':checked')) {
        sendData(event.target);
      } else {
        $updateEmailError.css('display', 'block');
      }

      event.preventDefault();
    }); // Call the method to show the email preference center form

    $emailPreferencesButton.off('click', showForm).on('click', showForm);
  }

  function getQuerySelectors() {
    $emailPreferenceCenter = $('.js-email-preference-center');
    $preferencesListForm = $emailPreferenceCenter.find('.js-preferences-list-form');
    $updateEmailForm = $emailPreferenceCenter.find('.js-update-email-form');
    $updateButton = $preferencesListForm.find('.js-update-cta');
    $unsubscribeButton = $preferencesListForm.find('.js-unsubscribe-cta');
    $updateEmailButton = $updateEmailForm.find('.js-update-email-cta');
    $emailPreferencesButton = $emailPreferenceCenter.find('.js-email-preferences-button');
    $serverMessage = $emailPreferenceCenter.find('.js-server-message');
    $successContainer = $emailPreferenceCenter.find('.js-success-container');
    $formsContainer = $emailPreferenceCenter.find('.js-forms-container');
    $overlay = $emailPreferenceCenter.find('.js-overlay');
    $updateEmailError = $updateEmailForm.find('.js-update-email-error');
  }

  function init() {
    getQuerySelectors();

    if ($emailPreferenceCenter.length > 0) {
      getData();
      attachEvents();
    }
  }

  return {
    init: init
  };
}();
"use strict";

var EmailSubscription = function () {
  var $emailSubscription;
  var $emailSubscriptionForm;
  var $serverMessage;
  var $successContainer;
  var $primaryButton;
  var $formsContainer;
  var $optionsToReceive;
  var $selectOptionLabel;
  var $overlay;

  function createDataJson(form) {
    var $formInputs = $(form).find('input');
    var dataJson = {};
    var interests = [];
    Object.keys($formInputs).forEach(function (key) {
      if ($formInputs[key].type === 'checkbox') {
        if ($formInputs[key].checked && $formInputs[key].name !== 'TermsAgree') {
          interests.push($formInputs[key].name);
        }
      } else if ($formInputs[key].value) {
        dataJson[$formInputs[key].name] = $formInputs[key].value;
      }
    });
    dataJson.interests = interests;
    dataJson.configurationItem = $emailSubscription.find('.js-configuration-item').text();
    return dataJson;
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = createDataJson(form);
    $.ajax({
      beforeSend: function beforeSend() {
        showSpinnerOverlay();
      },
      data: JSON.stringify(data),
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      },
      success: function success(data) {
        showServerMessage(data);
        var $submitSection = $('.js-email-subscription');
        var stringObject = $submitSection.attr('data-tracking-script') ? $submitSection.attr('data-tracking-script') : '';
        var loadObject = JSON.parse(stringObject.split("'").join('"'));

        if (loadObject && Acr.TrackingManager) {
          Acr.TrackingManager.pageLoad(loadObject);
        }
      },
      url: action
    });
  }

  function showSpinnerOverlay() {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, {
      passive: false
    });
    $('body').css('overflow', 'hidden');
    $overlay.removeClass('hidden');
  }

  function hideSpinnerOverlay() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $('body').css('overflow', 'auto');
    $overlay.addClass('hidden');
  }

  function showServerMessage(data) {
    if (data) {
      data = $.parseJSON(data);
    }

    hideSpinnerOverlay();

    if (data.successMsg) {
      if ($primaryButton.length > 0 && data.primaryCtaParameters) {
        $primaryButton.attr('href', $primaryButton.attr('href').concat(data.primaryCtaParameters));
      }

      $serverMessage.html(data.successMsg);
      $formsContainer.addClass('hidden');
      $serverMessage.removeClass('message--error');
      $serverMessage.removeClass('hidden');
      $successContainer.removeClass('hidden');
    } else {
      $serverMessage.addClass('message--error');
      $serverMessage.html(data.errorMsg);
      $serverMessage.removeClass('hidden');
    }

    window.scrollTo(0, 0);
  }

  function handleTouchLock(e) {
    e.preventDefault();
  } // This function checks if at least one checkbox is selected


  function checkOptions() {
    if ($optionsToReceive.find('input:checked').length > 0) {
      $selectOptionLabel.addClass('hidden');
      return true;
    }

    $selectOptionLabel.removeClass('hidden');
    $optionsToReceive[0].scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
    return false;
  }

  function onSubmit(e) {
    var validForm = Validation.validateForm(e);
    var optionsChecked = checkOptions();

    if (validForm && optionsChecked) {
      sendData(e.target);
    } // Scroll to the section with empty information


    if (!validForm) {
      window.scrollTo(0, 0);
    }

    e.preventDefault();
    return false;
  }

  function attachEvents() {
    // Call the method to send the preferences list form data
    $emailSubscriptionForm.submit(function (event) {
      onSubmit(event);
    }); // Call events when new email input changes

    $emailSubscriptionForm.find('input').on('keypress', Validation.onKeypress).on('keyup', Validation.onKeyup).on('focus', Validation.onFocus).on('blur', Validation.onBlur);
  }

  function getQuerySelectors() {
    $emailSubscription = $('.js-email-subscription');
    $emailSubscriptionForm = $emailSubscription.find('.js-sign-up-emails-form');
    $optionsToReceive = $emailSubscription.find('.js-options-to-receive');
    $selectOptionLabel = $emailSubscription.find('.js-select-option-label');
    $serverMessage = $emailSubscription.find('.js-server-message');
    $successContainer = $emailSubscription.find('.js-success-container');
    $primaryButton = $emailSubscription.find('.js-primary-button');
    $formsContainer = $emailSubscription.find('.js-form-container');
    $overlay = $emailSubscription.find('.js-overlay');
  }

  function init() {
    getQuerySelectors();

    if ($emailSubscription.length > 0) {
      attachEvents();
    }
  }

  return {
    init: init
  };
}();
"use strict";

var FeatureModal = function () {
  var $featureModal;
  var $svgClose;
  var $body;
  var interval;
  var spinner;

  function attachFetch() {
    $featureModal = $('.acr-feature-modal');
    $svgClose = $('.acr-icon.feature-modal-close');
    var $modalAnchors = $('[data-acr-feature-modal]');
    $modalAnchors.off('click', fetch).on('click', fetch);
  }

  function fetch(e) {
    e.preventDefault();
    $featureModal.find('.feature-modal-window').html(spinner);
    $featureModal.addClass('visible');
    Utility.removeClassFromSvg($svgClose, 'hide');
    Utility.addClassToSvg($svgClose, 'hide');

    if (!$(this).hasClass('is-modal-content')) {
      $.get($(this).attr('href') + '?stub=1', function (data) {
        $featureModal.find('.animated-spinner').removeClass('visible');
        $featureModal.find('.feature-modal-window').html(data);

        if ($('html').hasClass('ie')) {
          setTimeout(waitImage, 400);
        } else {
          layout();
          Acr.Disclaimer.init();
        }

        attachModalDeeplinks();
      });
    } else {
      var modalContent = '<div class="acr-modal-page-container">' + '<div class="collapse-content">' + '<div class="header">' + '<h1 class="header-name acr-secondary-title-1">' + $(this).attr('data-title') + '</h5>' + '<svg id="close" class="acr-icon feature-modal-close" viewBox="0 0 211.7 200">' + '<g xmlns="http://www.w3.org/2000/svg">' + '<path d="M107,0C51.8,0,7,44.8,7,100s44.8,100,100,100s100-44.8,100-100S162.2,0,107,0z M107,192c-50.7,0-92-41.3-92-92   S56.3,8,107,8s92,41.3,92,92S157.7,192,107,192z"></path>' + '<polygon points="139.8,62.5 106.6,95.7 73.5,62.5 67.8,68.2 101,101.4 67.8,134.5 73.5,140.2 106.6,107 139.8,140.2 145.5,134.5   112.3,101.4 145.5,68.2  "></polygon>' + '</g>' + '</svg>' + '</div>' + '<div class="content-container">' + '<div class="content-media">' + '<picture class="content-media__picture content-media__picture--internal-js">' + '<img class="content-media__img" src="' + $(this).attr('data-image') + '">' + '</picture>' + '</div>' + '<div class="content">' + '<div class="content__description">' + '<div class="description acr-paragraph-5">' + $(this).attr('data-description') + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      $featureModal.find('.feature-modal-window').html(modalContent);

      if ($('html').hasClass('ie')) {
        setTimeout(waitImage, 400);
      } else {
        layout();
        Acr.Disclaimer.init();
      }
    }
  }

  function attachClicks() {
    $(document).off('click', '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);
    $(document).on('click', '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);
    $(document).off('click', '.acr-feature-modal use', closeHandler);
    $(document).on('click', '.acr-feature-modal use', closeHandler);
    $featureModal.off('click', closeHandler).on('click', closeHandler);
    $featureModal.find('.feature-modal-window').off('click', stopPropagation).on('click', stopPropagation);
  }

  function attachKeyboardInput() {
    $(document).off('keyup', keyboardHandler).on('keyup', keyboardHandler);
  }

  function attachResize() {
    $(window).off('resize', layout);
    $(window).resize(layout);
  }

  function attachModalDeeplinks() {
    $featureModal.find('a[href*=#]').off('click', closeHandler);
    $featureModal.find('a[href*=#]').on('click', closeHandler);
  }

  function closeHandler() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $featureModal.removeClass('visible');
    $body.removeClass('modal-open');
  }

  function stopPropagation(e) {
    var $target = $(e.target);

    if (!$target.is('svg') && !$target.is('use') && !$target.is('a')) {
      e.stopPropagation();
    }
  }

  function keyboardHandler(e) {
    if (e.which === 27) {
      // esc key
      if ($featureModal.hasClass('visible')) {
        closeHandler();
      }
    }
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function layout() {
    var $featureModal = $('.acr-feature-modal');

    if (!$featureModal.hasClass('visible')) {
      return;
    } // Disable scrolling.


    document.addEventListener('touchmove', handleTouchLock, {
      passive: false
    });
    $body.addClass('modal-open');
  }

  function waitImage() {
    if ($featureModal.find('img').length) {
      var src;
      var srcset;
      var breakPImages;
      var image = new Image();
      var bpCurrent = getCurrentBreakpoint();

      switch (bpCurrent) {
        case 'sm':
          breakPImages = $featureModal.find('source[media|="(min-width: 550px)"]');
          break;

        case 'lg':
          breakPImages = $featureModal.find('source[media|="(min-width: 1024px)"]');
          break;

        case 'xl':
          breakPImages = $featureModal.find('source[media|="(min-width: 1400px)"]');
          break;

        default:
          breakPImages = $featureModal.find('img');
          break;
      }

      srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');
      src = srcset.split(',');
      src = src[0];
      $featureModal.find('img').attr('src', src);

      image.onload = function () {
        layout();
        Acr.Disclaimer.init();
      };

      image.src = src;
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  function init() {
    $body = $('body');
    $featureModal = $('.acr-feature-modal');
    spinner = $('<div class="animated-spinner-container">' + '<div class="animated-spinner"></div></div>');
    attachFetch();
    attachClicks();
    attachKeyboardInput();
    attachResize();

    if (Utility.isSafari()) {
      $featureModal.addClass('is-safari');
    }
  }

  return {
    init: init
  };
}();
"use strict";

var FSB = function () {
  Utility.log('FeatureScondaryBlade---.js loaded');
  var size = $.noop;
  var $featuresSlick = $.noop;
  var imgs = [];
  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  function setOnResize() {
    window.addEventListener('resize', resize);
    window.addEventListener('orientationchange', findImages);
  }

  function findImages() {
    imgs = [];
    imgs = $('.features-secondary').find('img');

    if (iOS) {
      $.each(imgs, function (index, value) {
        var url = $(imgs[index]).attr('data-pfsrc');
        $(imgs[index]).removeAttr('src');
        setTimeout(imageChanger($(imgs[index]), url), 3000);
      });
    }
  }

  function resize() {
    var width = window.innerWidth;
    var tiles;

    if (width < Constants.breakpoints.lg) {
      size = 'xs';
      tiles = $('.features-secondary').find('.tile');
      $.each(tiles, function (index) {
        $(tiles[index]).removeClass('tab-pane').removeClass('fade');
      });
      setSlick();
    } else {
      size = 'sm';
      tiles = $('.features-secondary').find('.tile');
      $.each(tiles, function (index) {
        $(tiles[index]).addClass('tab-pane').addClass('fade').removeAttr('style');
      });
      removeSlick();
    }

    findImages();
  }

  function imageChanger(_obj, _url) {
    if (_url && _url !== '') {
      $(_obj).removeAttr('src').attr('src', _url);
    }
  }

  function setSlick() {
    $featuresSlick = $('.component-featured-slick').slick({
      dots: true,
      useTransform: true
    });
    addArrowsStyle();
  }

  function removeSlick() {
    if ($featuresSlick.length) {
      $('.component-featured-slick').slick('unslick');

      if ($('.component-featured-slick article').attr('style') === '') {
        $('.component-featured-slick article').each(function () {
          var bkg = $(this).data('acrVarCurrentResponsiveBkg');
          $(this).css('background-image', 'url(' + bkg + ')');
        });
      }
    }
  }

  function addArrowsStyle() {
    $('.slick-next', $featuresSlick).addClass('acr-icon-arrow-large-right acr-f2 acr-black').text('');
    $('.slick-prev', $featuresSlick).addClass('acr-icon-arrow-large-left acr-f2 acr-black').text('');
  }

  function init() {
    setOnResize();
    findImages();
    resize();
  }

  return {
    init: init
  };
}();
"use strict";

var FormEmailSignup = function () {
  Utility.log('FormEmailSignup loaded');
  var $formCntr;
  var $form;

  var avoidTextCursorPostSubmit = function avoidTextCursorPostSubmit() {
    setTimeout(function () {
      $('input[type=text]:focus', $form).blur(); // console.log('Focused input now blurred.');
    }, 250);
  };

  var attachListeners = function attachListeners() {
    if (Utility.isEdge()) {
      $form.on('submit', avoidTextCursorPostSubmit);
    }
  };

  var init = function init() {
    if ($('.acr-sign-up-form-emails').length > 0) {
      $formCntr = $('.acr-sign-up-form-emails');
      $form = $('form', $formCntr);
      attachListeners(); // console.log('FormEmailSignup initialized');
    }
  };

  return {
    init: init
  };
}();
"use strict";

var Gallery = function () {
  var $galleries;
  var $hoverTriggers;
  var $tabs;
  var $grids;
  var maxFirstRowThumbs;
  var maxSecondRowThumbs;
  var maxThirdRowThumbs;
  var isLazyLoading;
  var debounce;
  var batchSize = 10;
  var maxColumns = 36;
  var aspectRatio = 16 / 9;
  var pendingImages = 0;
  var currentBatchSize = 0;
  var layingOut = false;

  function init(options) {
    if (options && options.batchSize) {
      batchSize = options.batchSize;
    }

    if ($('.acr-gallery').length) {
      $('.acr-gallery').find('.grid').css('visibility', 'hidden');
      layout();
      loadImages();
      attachHover();
      attachResize();
      attachCloseModal();
      attachClick();
      attachTransitionEnd();
    }
  }

  function layout() {
    if (layingOut) {
      return;
    }

    pendingImages = 0;
    layingOut = true;
    $galleries = $('.acr-gallery');

    if (window.innerWidth < Constants.breakpoints.sm) {
      maxFirstRowThumbs = 2;
      maxSecondRowThumbs = 1;
      isLazyLoading = false;
    } else {
      maxFirstRowThumbs = 3;
      maxSecondRowThumbs = 2;
      maxThirdRowThumbs = 1;
      isLazyLoading = false;
    }

    $galleries.each(function (i, gallery) {
      var currentThumbs;
      var $gallery = $(gallery);
      var filters = $gallery.data('filter') || '';
      var thumbs = [];
      var thumbImages = [];
      filters = filters.split('|');
      $.each(filters, function (i, filter) {
        filter = filter ? '*=' + filter : '';
        var partialThumbs = $gallery.find('.thumb:has(".thumb-content[data-type' + filter + ']")');
        var partialThumbImages = $gallery.find('.thumb-content[data-type' + filter + ']');
        $.merge(thumbs, partialThumbs);
        $.merge(thumbImages, partialThumbImages);
      });
      var rowType = 1;
      var animDelay = 0;
      var galleryWidth = $gallery.width();

      while (thumbs.length > 0) {
        if (rowType === 1 && thumbs.length >= maxFirstRowThumbs) {
          currentThumbs = thumbs.splice(0, maxFirstRowThumbs);
        } else if (rowType === 2 && thumbs.length >= maxSecondRowThumbs) {
          currentThumbs = thumbs.splice(0, maxSecondRowThumbs);
        } else if (rowType === 3 && thumbs.length >= maxThirdRowThumbs) {
          currentThumbs = thumbs.splice(0, maxThirdRowThumbs);
        } else {
          currentThumbs = thumbs;
          thumbs = [];
        }

        var height = 0;
        var width = 0;
        $.each(currentThumbs, function (i, thumb) {
          var numCols = maxColumns / currentThumbs.length;
          var $thumb = $(thumb);
          animDelay += 0.1;
          $thumb.removeClass();
          $thumb.addClass('thumb visible col-xs-' + numCols);

          if (width === 0) {
            width = Math.floor(galleryWidth / currentThumbs.length);
          }

          if (height === 0) {
            height = Math.round(width / aspectRatio);
          }

          $thumb.find('.thumb-content').height(height).attr('data-colspan', rowType);
          $thumb.width(width);
        });

        if (window.innerWidth < Constants.breakpoints.sm) {
          rowType = rowType === 1 ? 2 : 1;
        } else {
          rowType = rowType === 3 ? 1 : rowType + 1;
        }
      }

      pendingImages += thumbImages.length;
    });
    layingOut = false;
  }

  function addBackgroundLazyLoading(element) {
    var elemenImageType;
    var currentBreakpoint;
    var currentImage;
    var img;
    elemenImageType = element.dataset.colspan;
    currentBreakpoint = Utility.getCurrentBreakpoint().breakpoint;
    currentImage = 'img' + currentBreakpoint.charAt(0).toUpperCase() + currentBreakpoint.slice(1) + 'C' + elemenImageType;
    img = element.dataset[currentImage];
    element.style.backgroundImage = 'url("' + img + '")';
  }

  function loadImages() {
    var thumbs = $('.acr-gallery .thumb-content:not(.shown)');

    for (var i = 0; i < currentBatchSize; i++) {
      $(thumbs[i]).addClass('acr-responsive-background-behaviorIO').data('type', 'Gallery/imageLoad');
    }

    Utility.initLazyLoadingIO([].slice.call(thumbs), addBackgroundLazyLoading);
  }

  function switchImages() {
    var elemenImageType;
    var currentBreakpoint;
    var currentImage;
    var thumbs;
    var img;
    currentBreakpoint = Utility.getCurrentBreakpoint().breakpoint;
    thumbs = $('.acr-gallery .thumb-content:not(.shown)');
    [].slice.call(thumbs).forEach(function (element) {
      elemenImageType = element.dataset.colspan;
      currentImage = 'img' + currentBreakpoint.charAt(0).toUpperCase() + currentBreakpoint.slice(1) + 'C' + elemenImageType;
      img = element.dataset[currentImage];
      element.style.backgroundImage = 'url("' + img + '")';
    });
  }

  function attachHover() {
    $hoverTriggers = $('.acr-gallery .play,' + '.acr-gallery .rollover-bg,' + '.acr-gallery .acr-icon-direction-45');
    $hoverTriggers.off('hover');
    $hoverTriggers.hover(function () {
      $(this).siblings('.thumb-content').addClass('hover');
    }, function () {
      $(this).siblings('.thumb-content').removeClass('hover');
    });
  }

  function attachResize() {
    $(window).off('resize', onResize);
    $(window).resize(onResize);
    setTimeout(function () {
      layout();
      $('.acr-gallery .grid').css('visibility', 'visible');
    }, 250);
  }

  function onResize() {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      layout();
      switchImages();
      $('.acr-gallery .grid').css('visibility', 'visible');
    }, 250);
  }

  function attachCloseModal() {
    $(window).on('ar.closemodal', layout);
  }

  function attachClick() {
    $tabs = $('.acr-gallery .tab a');
    $tabs.on('click', function () {
      var left;
      var $this = $(this);
      var $container = $this.parents('.tabs');
      var $gallery = $this.parents('.acr-gallery');
      var type = $this.data('type');
      var filter = type === 'all' ? '' : type;
      $gallery.data('filter', filter);
      $container.find('.tab-content').removeClass('active');
      $gallery.find('.grid').addClass('fade-out').css('visibility', 'hidden').trigger('webkitTransitionEnd');
      $this.parent().addClass('active');
      setTimeout(function () {
        layout();
        $gallery.find('.grid').css('visibility', 'visible');
      }, 250);
    });
  }

  function attachTransitionEnd() {
    $grids = $('.acr-gallery .grid');
    $grids.each(function (i, grid) {
      var event = 'webkitTransitionEnd otransitionend oTransitionEnd ' + 'msTransitionEnd transitionend';
      $(grid).on(event, function () {
        var $this = $(this);

        if ($this.hasClass('fade-out') && $this.hasClass('grid')) {
          $this.parents('.acr-gallery').find('.thumb').removeClass().addClass('thumb');
          pendingImages = 0;
          currentBatchSize = 0;
          layout();
          $this.removeClass('fade-out');
        }
      });
    });
  }

  $(document).off('Gallery/imageLoad').on('Gallery/imageLoad', function (e, imageSrc) {
    if (isLazyLoading) {
      currentBatchSize -= 1;
      pendingImages -= 1;

      if (currentBatchSize === 0) {
        loadImages();
      }
    }
  });
  return {
    init: init
  };
}();
"use strict";

var GalleryModal = function () {
  function init() {
    var $galleries = $('.acr-mini-gallery, .acr-gallery');
    $galleries.each(function (i, o) {
      var gallery = InitSingleGallery();
      gallery.init(o);
    });
  }

  var InitSingleGallery = function InitSingleGallery() {
    var $gallery;
    var $galleryModal;
    var $pictureContainer;
    var $picture;
    var $body;
    var $spinner;
    var interval = [];
    var debounce;
    var imgContainerAspectRatio = 46 / 30;
    var videoContainerAspectRatio = 16 / 9;
    var player;
    var playerReady = false;
    var swipeStartX;
    var swipeEndX;
    var swipeThreshold = 20;
    var maxTries = 50;
    var tries = 0;
    var spinner = document.createElement('div');
    var pictureContainer = document.createElement('div');
    var picture = document.createElement('picture');
    var img = document.createElement('img');
    var sourceM = document.createElement('source');
    var sourceL = document.createElement('source');
    var sourceXL = document.createElement('source');
    var svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    function init(g) {
      $gallery = $(g);
      $body = $('body');
      $galleryModal = $gallery.next('.acr-gallery-modal'); // for gallery compatibility

      if ($galleryModal.length === 0) {
        $galleryModal = $gallery.parent().next('.acr-gallery-modal');
      }

      pictureContainer.setAttribute('class', 'picture-container visible');
      $pictureContainer = $galleryModal.find('picture-container');
      createPicture();
      attachClicks();
      attachKeyboardInput();
      attachResize();
      attachLoad();
      attachTouch();
      layout();
    }

    function attachClicks() {
      var $modalAnchors = $gallery.find('[data-acr-gallery-modal]');
      var $modalAnchorIcons = $gallery.find('.grid .acr-icon-direction-45');
      $modalAnchors.off('click', openHandler).on('click', openHandler);
      $modalAnchorIcons.off('click', openHandler).on('click', openHandler);
      $galleryModal.find('.acr-icon.gallery-modal-close').off('click', closeHandler).on('click', closeHandler);
      $galleryModal.find('.acr-icon.gallery-modal-close use').off('click', closeHandler).on('click', closeHandler);
      $galleryModal.find('.next-container').off('click', next).on('click', next);
      $galleryModal.find('.prev-container').off('click', prev).on('click', prev);
    }

    function attachKeyboardInput() {
      $(document).off('keyup', keyboardHandler).on('keyup', keyboardHandler);
    }

    function attachResize() {
      $(window).off('resize', layout);
      $(window).resize(onResize);
    }

    function onResize() {
      clearTimeout(debounce);
      debounce = setTimeout(layout, 250);
    }

    function attachLoad() {
      $galleryModal.find('img').one('load', function () {
        layout();
      }).each(function () {
        if (this.complete) {
          $(this).load();
        }
      });
    }

    function attachTouch() {
      var $gallerySlider = $galleryModal.find('.gallery-slider');
      $gallerySlider.off('touchstart', touchStartHandler).on('touchstart', touchStartHandler);
      $gallerySlider.off('touchmove', touchMoveHandler).on('touchmove', touchMoveHandler);
      $gallerySlider.off('touchend', touchEndHandler).on('touchend', touchEndHandler);
    }

    function touchStartHandler(e) {
      swipeStartX = e.originalEvent.touches[0].clientX;
    }

    function touchMoveHandler(e) {
      swipeEndX = e.originalEvent.touches[0].clientX;
    }

    function touchEndHandler() {
      var dX = swipeStartX - swipeEndX;

      if (!swipeStartX || !swipeEndX || Math.abs(dX) < swipeThreshold) {
        return;
      }

      if (dX > 0) {
        next();
      } else {
        prev();
      }

      swipeStartX = null;
      swipeEndX = null;
    }

    function openHandler(e) {
      e.preventDefault();
      var $anchor = $(this);

      if (typeof $anchor.data('acrGalleryModal') === 'undefined') {
        $anchor = $anchor.siblings('[data-acr-gallery-modal]');
      }

      populateModal($anchor);
      ImageChanger.init();
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
    }

    function populateModal($anchor) {
      var $parent = $anchor.parents('.grid');
      var $siblings = $parent.find('[data-acr-gallery-modal]:visible');
      tries = 0;
      var $image = $galleryModal.find('img');
      $image.removeClass('visible');
      $spinner.addClass('visible');
      $parent.addClass('current-gallery');
      $parent.data('currentIndex', $siblings.index($anchor));

      if ($anchor.data('type') === 'image') {
        if ($anchor.data('retina') === 'off') {
          sourceXL.setAttribute('srcset', $anchor.attr('data-img-xlarge-1x'));
          sourceL.setAttribute('srcset', $anchor.attr('data-img-large-1x'));
          sourceM.setAttribute('srcset', $anchor.attr('data-img-medium-1x'));
          img.setAttribute('srcset', $anchor.attr('data-img-xsmall-1x'));
          img.setAttribute('alt', $anchor.attr('data-alt'));
        } else {
          sourceXL.setAttribute('srcset', $anchor.attr('data-img-xlarge-1x') + ', ' + $anchor.attr('data-img-xlarge-2x') + ' 2x');
          sourceL.setAttribute('srcset', $anchor.attr('data-img-large-1x') + ', ' + $anchor.attr('data-img-large-2x') + ' 2x');
          sourceM.setAttribute('srcset', $anchor.attr('data-img-medium-1x') + ', ' + $anchor.attr('data-img-medium-2x') + ' 2x');
          img.setAttribute('srcset', $anchor.attr('data-img-xsmall-1x') + ', ' + $anchor.attr('data-img-xsmall-2x') + ' 2x');
          img.setAttribute('alt', $anchor.attr('data-alt'));
        }

        $(img).load(function () {
          $image.addClass('visible');
          $spinner.removeClass('visible');
        });
        $picture.addClass('visible');
        $galleryModal.find('iframe').removeClass('visible');
        Utility.reevaluatePictureFill();
      } else {
        // dirty hack
        $('.acr-gallery-modal [id=gallery-modal-youtube]').remove();
        $('<div id="gallery-modal-youtube"></div>').insertAfter($galleryModal.find('picture'));

        if ($anchor.data('videoTracking')) {
          $galleryModal.find('.picture-container').attr('data-video-tracking', $anchor.data('videoTracking'));
        }

        playerReady = false;
        window.setVideoPercentages();
        player = new YT.Player('gallery-modal-youtube', {
          videoId: $anchor.data('videoUrl'),
          events: {
            onReady: onPlayerReady,
            onStateChange: Acr.YouTubeManager.onPlayerStateChange
          },
          playerVars: {
            showinfo: 0,
            theme: 'light',
            color: 'white',
            rel: 0
          }
        });
        $picture.removeClass('visible');
        $galleryModal.find('iframe').addClass('visible');
      }

      $galleryModal.find('.content-name').text($anchor.data('name'));
      $galleryModal.find('.header-name').text($anchor.data('name'));
      $galleryModal.find('.description').html($anchor.data('description').replace(/"/g, '&#34;').replace(/'s/g, '&#39;s'));
      $galleryModal.find('.cta-text').text($anchor.data('ctaText'));
      $galleryModal.find('.cta-anchor').attr('href', $anchor.data('ctaUrl'));

      if ($anchor.data('ctaUrl') && $anchor.data('ctaText')) {
        $galleryModal.find('.cta-anchor').addClass('visible');
      } else {
        $galleryModal.find('.cta-anchor').removeClass('visible');
      }

      $galleryModal.addClass('visible');
      layout();
      createSvg($anchor.data('social-icon'));
      $body.addClass('modal-open');
      Acr.Disclaimer.init();
    }

    function closeHandler() {
      $galleryModal.removeClass('visible');
      clearInterval(window.percentageInterval);
      $body.removeClass('modal-open');

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }

      $('body').unbind('touchmove');
      $(window).trigger('ar.closemodal');
    }

    function keyboardHandler(e) {
      var galleryIsVisible = $galleryModal.hasClass('visible');

      if (e.which === 27) {
        // esc key
        closeHandler();
      } else if (e.which === 37 && galleryIsVisible) {
        // left arrow
        prev();
      } else if (e.which === 39 && galleryIsVisible) {
        // right arrow
        next();
      }
    }

    function layout() {
      if (!$galleryModal.hasClass('visible')) {
        return;
      }

      var $image = $galleryModal.find('img');
      var windowHeight = $(window).height();
      var windowWidth = $(window).width();
      var imgHeight = $image.height();
      var $iframe = $galleryModal.find('iframe');

      if (!$image[0].currentSrc && $picture.hasClass('visible') && tries < maxTries) {
        interval.push(setInterval(layout, 250));
        tries++;
        return;
      }

      for (var i = 0; i < interval.length; i++) {
        clearInterval(interval[i]);
      }

      interval = [];
      var imageAspectRatio = $image[0].naturalWidth / $image[0].naturalHeight;

      if (windowWidth < Constants.breakpoints.sm) {
        var headerHeight = $galleryModal.find('.header').height();
        var sliderHeight = $galleryModal.find('.gallery-slider').height();

        if ($picture.hasClass('visible')) {
          $pictureContainer.innerHeight(windowWidth / imgContainerAspectRatio);

          if (imgContainerAspectRatio > imageAspectRatio) {
            $picture.height(windowWidth / imgContainerAspectRatio);
            $picture.width(windowWidth / imgContainerAspectRatio * imageAspectRatio);
          } else {
            $picture.width(windowWidth);
            $picture.height(windowWidth / imageAspectRatio);
          }
        } else {
          $iframe.innerHeight(windowWidth / imgContainerAspectRatio);
          $iframe.width(windowWidth);
        }

        $galleryModal.find('.content').innerHeight(windowHeight - headerHeight - sliderHeight);
      } else {
        // if the modal height is bigger than 625 the content should be 40%
        // otherwise it should be 150px
        var contentHeight = windowHeight > 625 ? 150 : windowHeight * 0.4;
        var containerAspectRatio = windowWidth / (windowHeight - contentHeight);

        if ($picture.hasClass('visible')) {
          $pictureContainer.innerHeight(windowHeight - contentHeight);

          if (containerAspectRatio > imageAspectRatio) {
            $picture.height(windowHeight - contentHeight);
            $picture.width((windowHeight - contentHeight) * imageAspectRatio);
          } else {
            $picture.width(windowWidth);
            $picture.height(windowWidth / imageAspectRatio);
          }
        } else if (containerAspectRatio > videoContainerAspectRatio) {
          $iframe.innerHeight(windowHeight - contentHeight);
          $iframe.width((windowHeight - contentHeight) * videoContainerAspectRatio);
        } else {
          $iframe.width(windowWidth);
          $iframe.height(windowHeight - contentHeight);
        }

        $galleryModal.find('.content').innerHeight(contentHeight);
        $body.addClass('modal-open');
      }
    }

    function prev() {
      var $parent = $gallery.find('.grid.current-gallery');
      var thumbs = $parent.find('[data-acr-gallery-modal]:visible');
      var currentIndex = $parent.data('currentIndex');
      currentIndex = currentIndex === 0 ? thumbs.length - 1 : currentIndex - 1;
      populateModal($(thumbs[currentIndex]));

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }
    }

    function next() {
      var $parent = $gallery.find('.grid.current-gallery');
      var thumbs = $parent.find('[data-acr-gallery-modal]:visible');
      var currentIndex = $parent.data('currentIndex');
      currentIndex = (currentIndex + 1) % thumbs.length;
      populateModal($(thumbs[currentIndex]));

      if (player && playerReady && player.getPlayerState() === 1) {
        player.stopVideo();
      }
    }

    function onPlayerReady() {
      var $image = $galleryModal.find('img');
      playerReady = true;
      $image.addClass('visible');
      $spinner.removeClass('visible');
      layout();
    }

    function createPicture() {
      sourceXL.setAttribute('media', '(min-width: 1400px)');
      sourceL.setAttribute('media', '(min-width: 1024px)');
      sourceM.setAttribute('media', '(min-width: 550px)');
      spinner.setAttribute('class', 'animated-spinner visible');
      picture.appendChild(sourceXL);
      picture.appendChild(sourceL);
      picture.appendChild(sourceM);
      picture.appendChild(img);
      $picture = $(picture);
      $spinner = $(spinner);
      $pictureContainer = $(pictureContainer);
      pictureContainer.appendChild(spinner);
      pictureContainer.appendChild(picture);
      $(pictureContainer).insertBefore($galleryModal.find('.next-container'));
    }

    function createSvg($svgName) {
      svgIcon.setAttribute('class', 'acr-icon-social-modal');
      useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + $svgName);
      svgIcon.appendChild(useElem);
      picture.appendChild(svgIcon);
    }

    return {
      init: init
    };
  };

  return {
    init: init
  };
}();
"use strict";

var GlobalFooter = function () {
  Utility.log('GlobalFooter.js loaded');
  var $elements = $.noop;

  function init() {
    $elements = $('li', '.acr-footer');
    setOnResize();
    resize();
    addPadding();
  }

  function addPadding() {
    $('.acr-footer.secondary li').not(':has(a)').css('padding-left', '1.5rem');
  }

  function setOnResize() {
    window.addEventListener('resize', resize);
  }

  function resize() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.lg) {
      setTimeout(noBorder, 100);
    }
  }

  function noBorder() {
    var $prev = $elements.eq(0);
    $elements.removeClass('no-border');
    $elements.slice(1).each(function () {
      if ($(this).position().top > $prev.position().top) {
        $(this).addClass('no-border');
      }

      $prev = $(this);
    });
  }

  return {
    init: init
  };
}();
"use strict";

var GrayAllFeaturesPanel = function () {
  var $allFeaturesPanels = $('section.rzf-gry.rzf-gry-all-features-panel');
  var debounce;

  function init() {
    initLoop();
    resizeAll();

    _attachResize();
  }

  function initLoop() {
    $allFeaturesPanels.each(function (i, el) {
      // Set up divs to control heights.
      var $div1 = document.createElement('div');
      $div1.setAttribute('class', 'spacer-div-1');
      var $div2 = document.createElement('div');
      $div2.setAttribute('class', 'spacer-div-2');
      $(el).prepend($div2).prepend($div1); // Set up listeners

      initMutationObserver(el); // Add color theme to controls, if controls are present.

      var $controls = $('.rzf-gry-controls', $(el));

      if ($controls.length > 0) {
        var theme = $('div.rzf-gry-all-features-panel', $(el)).data('rzf-gry-arrow-skin') + '-theme';
        $controls.addClass(theme);
      }
    });
    $('.features', $allFeaturesPanels).addClass('clearfix');
  }

  function initMutationObserver(el) {
    // create an observer instance
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target !== mutation.oldValue) {
          if ($(mutation.target).hasClass('active') && $(el).is(':visible')) {
            $(el).addClass('active');
            resizeOne(el);
          } else {
            $(el).removeClass('active');
          }
        }
      });
    }); // configuration of the observer:

    var mutationObserverConfig = {
      attributes: true,
      attributeOldValue: true
    }; // Observe parent.

    mutationObserver.observe($(el).parent()[0], mutationObserverConfig);
  }

  function resizeAll() {
    $allFeaturesPanels.each(function (i, el) {
      resizeOne(el);
    });
  }

  function resizeOne(el) {
    // If panel is visible and overflowing, set scroll bars on features section.
    if ($(el).is(':visible')) {
      var $featuresSection = $('.features', $(el));
      destroyJspPane($featuresSection);
      doOverflown(el);
    }
  }

  function destroyJspPane($featuresSection) {
    $featuresSection.removeClass('jsp-scrollable');
    var api = $featuresSection.jScrollPane().data('jsp');
    api.destroy();
    $featuresSection.height('auto');
  }

  function doOverflown(el) {
    var $el = $(el);
    var $titlesWrapper = $('.titles-wrapper', $el);
    var $features = $('.features', $el);
    var titlesWrapperHeight = parseInt($titlesWrapper.outerHeight(true), 10);
    var featuresHeight = parseInt($features.outerHeight(true), 10);
    var insideHeight = titlesWrapperHeight + featuresHeight;

    if (insideHeight > $el.height()) {
      var overflownHeight = $el.height() - titlesWrapperHeight; // height left for features.

      $features.height(overflownHeight).jScrollPane({
        autoReinitialise: true
      }).addClass('jsp-scrollable');
    } else {
      destroyJspPane($features);
    }
  } // Setup resize event with debounce.


  function _attachResize() {
    $(window).on('resize', _onResize);
  }

  function _onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(resizeAll, 250);
  }

  return {
    init: init
  };
}();
"use strict";

var GrayContentPanelType3 = function () {
  var $allContentType3Panels = $('section.rzf-gry.rzf-gry-content-panel-type-3');
  var debounce;

  function init() {
    cloneCaptionDiv();
  }

  function cloneCaptionDiv() {
    $allContentType3Panels.each(function (i, el) {
      // $(el).prepend($div2).prepend($div1);
      var $innerCaptionDiv = $('.caption', $(el));

      if ($innerCaptionDiv.length > 0) {
        $innerCaptionDiv.addClass('inner-caption');
        var $outerCaptionDiv = $(document.createElement('div'));
        $outerCaptionDiv.addClass('caption outer-caption').html($innerCaptionDiv.html());
        var $contentPanelDiv = $('div.rzf-gry-content-panel-type-3', $(el));
        $contentPanelDiv.prepend($outerCaptionDiv);
      } // Add color theme to controls, if controls are present.


      var $controls = $('.rzf-gry-controls', $(el));

      if ($controls.length > 0) {
        var theme = $('div.rzf-gry-content-panel-type-3', $(el)).data('rzf-gry-arrow-skin') + '-theme';
        $controls.addClass(theme);
      }
    });
  }

  return {
    init: init
  };
}();
"use strict";

var GrayMultiTabNavContainer = function () {
  var Utility = window.Utility || {};
  var $multiTabNavContainer = $('section.rzf-gry.rzf-gry-multi-tab-nav-container');
  var $multiTabNavContainerTabs = $('.rzf-gry-multi-tab-container', $multiTabNavContainer);
  Utility.log('GrayMultiTabNavContainer js loaded');

  function init() {
    mutationObserver();
    prepDropDownNav();
  }

  function mutationObserver() {
    // create an observer instance
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var el = mutation.target;

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if ($(el).hasClass('active')) {
            // $(el).children(':first').trigger('tab:active');
            tabActiveCases(mutation);
          } else {// $(el).children(':first').trigger('tab:not-active');  
          }
        }
      });
    }); // configuration of the observer:

    var config = {
      attributes: true,
      childList: true,
      characterData: true
    };
    $multiTabNavContainerTabs.each(function (i, el) {
      observer.observe(el, config);
    });
  }

  function prepDropDownNav() {
    $('div.dropdown ul li a', $multiTabNavContainer).each(function (i, el) {
      $(el).html('•');
    });
  }

  function tabActiveCases(mutationObj) {
    var activeElem = mutationObj.target; // If we have an active features panel as the child, pagination dots should be repositioned.

    if ($(activeElem).find('.rzf-gry-all-features-panel.active').length > 0) {
      // Get drop down nav (pagination dots in Acura Skin), should be positioned bottom.
      $('div.dropdown', $(activeElem).parent()).addClass('all-features');
    } else {
      $('div.dropdown', $(activeElem).parent()).removeClass('all-features');
    }
  }

  return {
    init: init
  };
}();
"use strict";

var GrayBgImageScaler = function () {
  var Utility = window.Utility || {};
  Utility.log('GrayBgImageScaler js loaded');
  var bgObserver = null; // configuration of the observer:

  var bgObserverConfig = {
    attributes: true,
    childList: false,
    characterData: false
  };
  var toutSelector = 'section[data-rzf-gry-tout-tier="1"], section[data-rzf-gry-tout-tier="2"], article.rzf-gry.rzf-gry-tout-tile.image-scale-element';
  var $toutBackgroundContainers = $('.tout-background.image-scale-element', toutSelector);
  var toutBackgrounds = [];

  function observeTouts() {
    $toutBackgroundContainers.each(function (i, el) {
      $(el).data('tout-one-bg-observer-index', i);
      toutBackgrounds[i] = null;
      bgObserver.observe(el, bgObserverConfig);
    });
  }

  function scaleToutBg(el, i) {
    var $el = $(el);
    toutBackgrounds[i] = $(el).css('background-image');
    var bgImage = getBgImage(el);

    bgImage.onload = function () {
      var bgRatio = getBgImageRatio(this);
      $el.height('auto');
      $el.parent().height('auto !important');
      $el.css('padding-top', bgRatio * 100 + '%');
    };
  }

  function initBgMutationObserver() {
    // create an observer instance
    bgObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var el = mutation.target;

        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if ($(el).css('background-image')) {
            // Expand if-else here for other components.
            if ($(el).closest(toutSelector)) {
              var index = $(el).data('tout-one-bg-observer-index');

              if (toutBackgrounds[index] !== $(el).css('background-image')) {
                scaleToutBg(el, index);
              }
            }
          }
        }
      });
    });
  }

  function getBgImage(el) {
    var image = new Image();
    var bg = $(el).css('background-image').replace(/.*\s?url\(['"]?/, '').replace(/['"]?\).*/, '');

    if (bg && bg !== '') {
      image.src = bg;
    }

    return image;
  }

  function getBgImageRatio(img) {
    return parseFloat(img.height / img.width).toFixed(4);
  }

  function init() {
    initBgMutationObserver();
    observeTouts();
  }

  return {
    init: init
  };
}();
"use strict";

var Grid = function () {
  var Utility = window.Utility || {};
  var ResponsiveBackground = window.ResponsiveBackground || {};
  var $grids = $('.hmc-grid-100');
  var $items = $('.hmc-grid-item');
  var $bgVideo = $('.hmc-grid-video');
  var $sliderImage = $('.acr-slider-image');
  var debounce;
  var $window = $(window);
  var scrollFactor = 0.5;
  var hasClipPath;
  var prefix;
  var viewports = {
    xs: {
      min: 320,
      max: 550
    },
    sm: {
      min: 550,
      max: 1024
    },
    lg: {
      min: 1024,
      max: 1400
    },
    xl: {
      min: 1400,
      max: Infinity
    }
  };

  function getBreakpoint(wW) {
    var breakpoint;

    if (wW < viewports.xs.max) {
      breakpoint = 'xs';
    } else if (wW < viewports.sm.max) {
      breakpoint = 'sm';
    } else if (wW < viewports.lg.max) {
      breakpoint = 'lg';
    } else {
      breakpoint = 'xl';
    }

    return breakpoint;
  }

  function layout() {
    $grids.each(function (i, grid) {
      var $grid = $(grid);
      var classes = $grid.attr('class').split(/\s+/);
      var wWidth = window.innerWidth;
      var breakpoint = getBreakpoint(wWidth); // Any grid data attributes

      if ($grid.data('height-' + breakpoint)) {
        if ($grid.data('height-' + breakpoint) !== $grid.height()) {
          $grid.css('height', $grid.data('height-' + breakpoint) + 'px');
        }
      } else {
        ResponsiveBackground.setHeight($grid.get(0));
      } // For Carousels


      if ($grid.filter('[class*="hmc-carousel-"]').length > 0) {
        var carouselBreakpoints = classes.filter(function (c) {
          if (c.indexOf('hmc-carousel-') === 0) {
            return true;
          }
        });
        $.each(carouselBreakpoints, function (i, carouselBreakpoint) {
          var viewport = carouselBreakpoint.split('hmc-carousel-')[1];
          var $carousel = $grid.find('.hmc-grid-carousel');
          var $originalTiles = $grid.find('.hmc-carousel-slide');

          if (wWidth > viewports[viewport].min && wWidth < viewports[viewport].max) {
            $originalTiles.css({
              display: 'none'
            });
            $carousel.find('.hmc-carousel-slide').css({
              display: 'block'
            });
            $carousel.addClass('visible');
            return false;
          }

          $originalTiles.css({
            display: ''
          });
          $carousel.removeClass('visible');
        });
      }
    });
  }

  function slideSmage($el) {
    var offsetStart = $el.data('start');
    var xOffset = $el.data('offset');
    var winTop = $window.scrollTop();
    var winBottom = winTop + $window.height();
    var elTop = $el.offset().top;
    var speed = $el.data('speed') === undefined ? scrollFactor : $el.data('speed');

    if (offsetStart === undefined) {
      offsetStart = 0;
    }

    if (xOffset === undefined) {
      xOffset = 0;
    }

    if (elTop < winBottom) {
      var height = (winBottom - elTop) * speed;
      var y = height;
      var propertyName = prefix + 'clip-path';

      if ($el.data('opposite') === undefined) {
        var angle = $el.data('angle');
        var adjacent = $el.width();
        var tan;
        var opposite;
        angle = angle === 90 ? 89 : angle;
        angle = angle > 90 ? 180 - angle : angle;
        tan = Utility.getTanDeg(angle);
        opposite = tan * adjacent;
        $el.data('opposite', opposite);
      }

      y += $el.data('opposite');

      if ($el.data('angle') > 90) {
        // console.log('if 3', elTop < winBottom, elTop, winBottom);
        $el.css(propertyName.toString(), 'polygon(0% 0%, 100% 0%, 100% ' + y + 'px, 0% ' + height + 'px)');
      } else if (winTop > offsetStart) {
        $el.css(propertyName.toString(), 'polygon(0% 0%, 100% 0%, 100% ' + (height - xOffset) + 'px, 0% ' + (y - xOffset) + 'px)');
      }
    }
  }

  function showVideo($el) {
    $el.css('display', 'block');
  }

  function backgroundVideoGrid($el) {
    var winTop = $window.scrollTop();
    var winBottom = winTop + $window.height();
    var elTop = $el.offset().top;
    var elBottom = elTop + $el.outerHeight();
    var play = $el.data('play');
    var stop = $el.data('stop');

    if ($el[0].currentSrc === '') {
      return true;
    }

    if (play === 'viewport' && stop === 'viewport') {
      if (elTop < winBottom && elBottom > winTop) {
        showVideo($el);
        $el[0].play();
      } else {
        $el[0].pause();
      }
    } else if (play === 'viewport' && stop === 'no') {
      if (elTop < winBottom) {
        showVideo($el);
        $el[0].play();
      }
    } else if (play === 'load' && stop === 'viewport') {
      if (elBottom > winTop) {
        showVideo($el);
        $el[0].play();
      } else {
        $el[0].pause();
      }
    } else if (play === 'load' && stop === 'no') {
      showVideo($el);
      $el[0].play();
    }
  }

  function onScroll() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (hasClipPath) {
      $sliderImage.each(function (index, element) {
        slideSmage($(element));
      });
    }

    if (breakpoint === 'lg' || breakpoint === 'xl') {
      $bgVideo.each(function (index, element) {
        backgroundVideoGrid($(element));
      });
    } else {
      $bgVideo.each(function (index, element) {
        element.pause();
      });
    }
  }

  function checkVideoBP() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (breakpoint === 'xs' || breakpoint === 'sm') {
      $bgVideo.css({
        display: 'none'
      });
    } else {
      onScroll();
    }
  }

  function sliderReadyImg(when) {
    if (!when) {
      when = 800;
    }

    setTimeout(function () {
      $sliderImage.each(function () {
        var $parent = $(this).parents('.slider-tile-content');
        $parent.height($(this).outerHeight());
      });
    }, when);
  }

  function resize() {
    layout();
    checkVideoBP();
    $sliderImage.each(function (index, element) {
      $(element).removeData('opposite');
    });
    sliderReadyImg(1);
  }

  function onResize() {
    clearTimeout(debounce);
    debounce = setTimeout(resize, 400);
  }

  function attachResize() {
    $(window).off('resize', layout);
    $(window).on('resize', onResize);
    $(window).on('ar.closemodal', layout);
  }

  function getBootstrapBreakpoint() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (breakpoint === 'lg') {
      breakpoint = 'md';
    } else if (breakpoint === 'xl') {
      breakpoint = 'lg';
    } else if (window.innerWidth >= viewports.xl.min) {
      breakpoint = 'xl';
    }

    return breakpoint;
  }

  function copyTiles() {
    $grids.each(function (i, grid) {
      var $grid = $(grid); // For Carousels

      if ($grid.filter('[class*="hmc-carousel-"]')) {
        var $originalTiles = $grid.find('.hmc-carousel-slide');

        if ($originalTiles.length > 1) {
          var $tiles = $originalTiles.clone();
          var $carousel = $grid.find('.hmc-grid-carousel');
          $carousel.html($tiles);
          $carousel.slick({
            dots: true,
            prevArrow: '<button type="button"' + ' class="acr-icon-arrow-large-left acr-f2 acr-mid-grey ' + 'slick-prev slick-arrow"></button>',
            nextArrow: '<button type="button"' + ' class="acr-icon-arrow-large-right acr-f2 acr-mid-grey ' + 'slick-next slick-arrow"></button>',
            useTransform: true
          });
        }
      }
    });
  }

  function changeId(className) {
    var $visibleItems = $('.hmc-grid-item:not(.' + className + ')');
    $items.attr('id', '');
    $visibleItems.each(function (i, el) {
      if (!$(el).hasClass('slick-slide')) {
        $(el).attr('id', $(el).data('id'));
      }
    });
  }

  function attachScroll() {
    $(window).on('scroll', onScroll);
  }

  function onEnd() {
    $(this).css('display', 'none');
  }

  function attachVideoEnd() {
    $bgVideo.each(function (index, element) {
      element.addEventListener('ended', onEnd);
    });
  }

  function init() {
    if ($grids.length) {
      hasClipPath = $('html').hasClass('cssclippathpolygon');
      prefix = Utility.prefix().css;
      copyTiles();
      resize();
      attachResize();
      attachVideoEnd();
      onScroll();
      attachScroll();
      changeId('hidden-' + getBootstrapBreakpoint());
      sliderReadyImg(); // Just in case we didn't get it

      setTimeout(function () {
        sliderReadyImg(1);
      }, 900);
    }
  }

  return {
    init: init,
    resize: resize
  };
}();
"use strict";

var Acr = Acr || {};

Acr.HeroCarousel = function () {
  Utility.log('HeroCarousel.js loaded'); // Selectors

  var heroSlider;
  var hero;
  var media; // Data

  var changeSlide = function changeSlide() {};

  var canPlayVideo = true;

  var triggerPos = function triggerPos() {};

  var breakpoint = null;
  var ratioWidth = 16;
  var ratioHeight = 9;
  var ratioWidthSM = 1100;
  var ratioHeightSM = 756;
  var playSvg;
  var arrowLeft;
  var arrowRight;
  var heroSwiper;
  var heroCarousel;
  var swiperPagination;
  var contentLoadedClass = 'content-loaded';
  var swiperPaginationSelector = '.js-swiper-pagination';
  var arrowLeftSelector = '.js-arrow-left';
  var arrowRightSelector = '.js-arrow-right';
  var enableParallax = !(Utility.isMobile() || Utility.isIE() || Utility.isTablet());
  var heroSlidesSelector = '.js-hero-slides';
  var heroCarouselSelector = '.js-hero-carousel';
  var heroMediaSelector = '.hero-media';
  var playIconSelector = '.acr-icon.play-icon';
  var heroCtaSelector = '.hero-cta';
  var heroModalSelector = '.hero-modal';
  var slidesMediaSelector = '.hero-slide .hero-media';
  var swiperSlideActiveSelector = '.swiper-slide-active';
  var swiperSlideSelector = '.hero-slide';
  var anchorSelector = '[href]';
  var slidesMedia;
  var observer;
  var isParallaxRunning = false;

  function playVideo(video) {
    var findVideo;
    pauseVideo();
    findVideo = video.querySelector('video');

    if (findVideo && canPlayVideo) {
      findVideo.play();
    }
  }

  function resetVideo(video) {
    var findVideo;
    findVideo = video.querySelector('video');

    if (findVideo && canPlayVideo) {
      findVideo.currentTime = 0;
    }
  }

  document.addEventListener('keydown', function (e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    heroSwiper.autoplay.stop();
  });

  function pauseVideo() {
    hero.find('video').each(function () {
      if (canPlayVideo) {
        this.pause();
      }
    });
  }

  function checkIOS() {
    if (document.querySelector('html').classList.contains('appleios')) {
      canPlayVideo = false;
    }
  }

  function createMobileCTAs() {
    var cloneModal = '';
    var modal = '';
    var iconMarkup;
    hero.querySelectorAll('.hero-slide').forEach(function () {
      if (playSvg) {
        Utility.removeClassFromSvg(playSvg, 'hide');
        iconMarkup = playSvg.outerHTML;
        Utility.addClassToSvg(playSvg, 'hide');
      }

      modal = document.querySelector(heroModalSelector);

      if (modal) {
        cloneModal = modal.cloneNode(true);
        cloneModal.textContent = '';
        cloneModal.className = 'hero-modal';
        cloneModal.innerHTML = iconMarkup;
        media.insertBefore(cloneModal, media.childNodes[0]);
      }
    });
  }

  function setOnResize() {
    window.addEventListener('resize', function () {
      clearTimeout(triggerPos);
      triggerPos = setTimeout(resize, 100);
    });
  }

  function resize() {
    var width = window.innerWidth;
    var heroCta = heroSlider.querySelectorAll(heroCtaSelector);
    resizeMedia(width);
    enableParallax = !(Utility.isMobile() || Utility.isIE() || Utility.isTablet());

    if (enableParallax) {
      if (!isParallaxRunning) {
        initParallax();
      }
    } else {
      stopParallax();
    }

    if (width < Constants.breakpoints.sm) {
      if (breakpoint !== 'xs') {
        heroCta.forEach(function (element) {
          element.classList.add('acr-cta-r-w-b');
        });
        hero.style.height = 'auto';
        breakpoint = 'xs';
      }
    } else if (breakpoint !== 'sm') {
      heroCta.forEach(function (element) {
        element.classList.remove('acr-cta-r-w-b');
      });
      clearTimeout(triggerPos);
      breakpoint = 'sm';
    }
  }

  function stopParallax() {
    slidesMedia.forEach(function (element) {
      element.style.top = '0px';
    });
    window.removeEventListener('scroll', doParallaxEffect);
    isParallaxRunning = false;
  }

  function onModal() {
    var findVideo;
    var acrModal = document.querySelector('.acr-modal');
    acrModal.addEventListener('show.bs.modal', function () {
      findVideo = this.querySelector('video');

      if (findVideo && canPlayVideo) {
        findVideo.play();
      }

      heroSwiper.autoplay.stop();
      clearTimeout(changeSlide);
    });
    acrModal.addEventListener('hidden.bs.modal', function () {
      findVideo = this.querySelector('video');

      if (findVideo && canPlayVideo) {
        findVideo.pause();
      }
    });
  }

  function resizeMedia(width) {
    var heightMedia = 0;
    var innerWidth = 0;

    if (hasScroll()) {
      innerWidth = width - 15;
    }

    if (width > 2000) {
      innerWidth = 2000;
    } else {
      innerWidth = width;
    }

    if (width >= Constants.breakpoints.sm && width < Constants.breakpoints.lg) {
      heightMedia = innerWidth / (ratioWidthSM / ratioHeightSM);
    } else {
      heightMedia = innerWidth / (ratioWidth / ratioHeight);
    }

    slidesMedia.forEach(function (element) {
      element.style.height = "".concat(heightMedia, "px");
    });
  }

  function hasScroll() {
    var html = document.querySelector('html');
    return html.scrollHeight > html.clientHeight;
  }

  function initHeroSwiper() {
    heroSwiper = new Swiper(heroSlider, {
      speed: 400,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 5000
      },
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        bulletClass: 'hero-carousel__bullet',
        renderBullet: function renderBullet(index, className) {
          return "<span class=\"".concat(className, " js-tracking-tab\" >").concat(index + 1, "</span>");
        },
        bulletActiveClass: 'hero-carousel__bullet-active'
      },
      on: {
        init: function init() {
          var swiperActive = document.querySelector(swiperSlideActiveSelector);
          setTheme(swiperActive.classList.contains('light-theme') ? 'light-theme' : 'dark-theme');
          var anchorsToEnable = swiperActive.querySelectorAll(anchorSelector);
          anchorsToEnable.forEach(function (element) {
            element.setAttribute('tabindex', '0');
          });
        }
      }
    });
    heroSwiper.on('slideChangeTransitionEnd', function () {
      var swiperActive = document.querySelector(swiperSlideActiveSelector);
      var swiperSlide = document.querySelectorAll(swiperSlideSelector);
      var currentTheme = swiperActive.classList.contains('light-theme') ? 'light-theme' : 'dark-theme';

      if (!heroCarousel.classList.contains(currentTheme)) {
        setTheme(currentTheme);
      }

      swiperSlide.forEach(function (element) {
        var anchors = element.querySelectorAll(anchorSelector);

        if (element.classList.contains('swiper-slide-active')) {
          anchors.forEach(function (element) {
            element.setAttribute('tabindex', '0');
          });
        } else {
          anchors.forEach(function (element) {
            element.setAttribute('tabindex', '-1');
          });
        }
      });
    }); // stoping autoplay waiting for onload event

    heroSwiper.autoplay.stop();
    slidesMedia = heroSlider.querySelectorAll(slidesMediaSelector);
  }

  function setTheme(theme) {
    var classToRemove = theme === 'light-theme' ? 'dark-theme' : 'light-theme';
    heroCarousel.classList.add(theme);
    heroCarousel.classList.remove(classToRemove);
  }

  function displaySwiper() {
    heroSwiper.autoplay.start();
    heroSlider.classList.add(contentLoadedClass);
  }

  function doParallaxEffect() {
    var windowYOffset = window.pageYOffset;
    slidesMedia.forEach(function (element) {
      element.style.top = "".concat(windowYOffset * 0.3, "px");
    });
  }

  function handler(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', doParallaxEffect);
      } else {
        window.removeEventListener('scroll', doParallaxEffect);
      }
    });
  }

  function initParallax(element) {
    isParallaxRunning = true;
    observer = new IntersectionObserver(handler);
    observer.observe(heroSlider);
  }

  function initSelectors(element) {
    heroSlider = element;
    hero = heroSlider.querySelector(heroSlidesSelector);
    swiperPagination = heroSlider.querySelector(swiperPaginationSelector);
    media = heroSlider.querySelector(heroMediaSelector);
    playSvg = heroSlider.querySelector(playIconSelector);
    arrowLeft = heroSlider.querySelector(arrowLeftSelector);
    arrowRight = heroSlider.querySelector(arrowRightSelector);
    slidesMedia = heroSlider.querySelectorAll(slidesMediaSelector);
    heroCarousel = document.querySelector(heroCarouselSelector);
  }

  function init(element) {
    initSelectors(element);
    checkIOS();
    resize();
    createMobileCTAs();
    setOnResize();
    onModal();
    initHeroSwiper(); // Hero parallax animations

    if (enableParallax) {
      initParallax();
    }

    Utility.initDeferLoading(displaySwiper);
  } // Expose the following variables and functions


  return {
    init: init
  };
};
"use strict";

var ImageChanger = function () {
  Utility.log('ImageChanger.js loaded');
  var debounceResize = $.noop;

  function init() {
    setOnResize();
    onResize();
  }

  function setOnResize() {
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }

  function onResize() {
    clearTimeout(debounceResize);
    debounceResize = setTimeout(findImages, 250);
  }

  function findImages() {
    if (window.devicePixelRatio > 1) {
      var breakPImages;
      var lowresImages = $('picture');
      var bpCurrent = getCurrentBreakpoint();
      lowresImages.each(function (i) {
        switch (bpCurrent) {
          case 'sm':
            breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 550px)"]');
            break;

          case 'lg':
            breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 1024px)"]');
            break;

          case 'xl':
            breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 1400px)"]');
            break;

          default:
            breakPImages = $(lowresImages[i]).find('img');
            break;
        }

        var lowres = $(breakPImages).attr('data-attribute-image1x');

        if (lowres && lowres !== '') {
          var imageToChange = $(this).find('img');
          $(imageToChange).attr('src', lowres);
        }
      });
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  return {
    init: init,
    onResize: onResize
  };
}();
"use strict";

var Acr = window.Acr || {};

Acr.LanguageSelector = function (window, $) {
  var currentLanguage = 'EN';
  var currentLanguageCode = 'EN';
  var languages = {
    en: {
      code: 'EN',
      name: 'English',
      langCode: 'EN',
      subDomain: 'www'
    },
    es: {
      code: 'ES',
      name: 'Espa&ntilde;ol',
      langCode: 'ES',
      subDomain: 'spanish'
    },
    zh: {
      code: '&#x4E2D;&#x6587;',
      name: '&#x4E2D;&#x6587;',
      langCode: 'ZH',
      subDomain: 'chinese'
    }
  }; // Updates the current label to be shown in the Global Nav drop down that sits
  // next to the globe SVG, according to the current URL.
  // Default language will be English: "EN"

  var updateGlobalNavLanguageLabel = function updateGlobalNavLanguageLabel() {
    var $globalNavLanguageLabel = $('.current-language');
    var regex;

    if ($globalNavLanguageLabel.length > 0) {
      $.each(languages, function (idx, val) {
        regex = new RegExp(val.subDomain + '.acura.com');

        if (window.location.href.match(regex)) {
          currentLanguage = val.code;
          currentLanguageCode = val.currentLanguageCode;
        }
      });
      $globalNavLanguageLabel.html(currentLanguage);
    }
  };

  var updateSelectedLanguage = function updateSelectedLanguage() {
    var $languageItems = $('.acr-nav-lang-chooser__list-item');
    $.each($languageItems, function (i) {
      if ($($languageItems[i]).data('language-code') === currentLanguageCode) {
        $($languageItems[i]).find('a').addClass('acr-nav-lang-chooser__item-link--selected');
      }
    });
  };

  var init = function init() {
    updateGlobalNavLanguageLabel();
    updateSelectedLanguage();
  };

  return {
    init: init
  };
}(window, $);
"use strict";

/**
 * Module: LazyLoadingHelper
 *
 * Calls Utility.isElementInViewIO in order to add Lazyloading
 *
 *
 * Returned Functions: Init
 *
 * CallBack Function sent to IsElementInViewIO
 *
 * 1.loadImage
 * 2.loadPicture
 * 3.loadVideo
 *
 */
var Acr = Acr || {};

Acr.LazyLoadingHelper = function () {
  function init() {
    if ('loading' in HTMLImageElement.prototype) {
      var images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(function (img) {
        img.src = img.dataset.src;
      });
    } else {
      var imagesToLoad = [].slice.call(document.querySelectorAll('img[loading="lazy"]'));
      Utility.initLazyLoadingIO(imagesToLoad, loadImage);
    }

    var videosToLoad = [].slice.call(document.querySelectorAll('video.lazy'));
    Utility.initLazyLoadingIO(videosToLoad, loadVideo);
  }
  /** ********************************** */

  /*
  /* isLazyLoadingNative
  /* Return true if browser supports loading=lazy native
  /*
  /******************************************************** */


  function isLazyLoadingNative() {
    return 'loading' in HTMLImageElement.prototype;
  }

  function loadImage(element) {
    if (element.dataset.srcset !== undefined) {
      element.srcset = element.dataset.srcset;
    }

    element.src = element.dataset.src;
    element.removeAttribute('loading');
    Utility.reevaluatePictureFill();
  }

  function loadPicture(element) {
    var elementChildren = [].slice.call(element.querySelectorAll('source,img'));
    elementChildren.forEach(function (elementChild) {
      if (elementChild.dataset.srcset) {
        elementChild.setAttribute('srcset', elementChild.dataset.srcset);
      }

      if (elementChild.dataset.src) {
        elementChild.setAttribute('src', elementChild.dataset.src);
      }
    });
    element.removeAttribute('loading');
    Utility.reevaluatePictureFill();
  }

  function loadVideo(element) {
    for (var source in element.children) {
      var videoSource = element.children[source];
      var posterSource = element.dataset.poster;

      if (posterSource) {
        element.setAttribute('poster', posterSource);
      }

      if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src;
      }
    }

    element.load();
    element.classList.remove('lazy');
  }

  return {
    init: init,
    loadPicture: loadPicture,
    loadImage: loadImage,
    loadVideo: loadVideo,
    isLazyLoadingNative: isLazyLoadingNative
  };
}();
"use strict";

var Modals = function () {
  Acr = window.Acr ? window.Acr : {};
  var Utility = window.Utility || {};
  var Constants = window.Constants || {};
  var HorizontalSlider = window.HorizontalSlider || {};
  var modalBodySelectorClass = '.modal-body';
  var type = 'fullscreen';
  var subtype = '';
  var media = 'video';
  var title = '';
  var hideHeader = false;
  var content = '';
  var loading = false;
  var callbacks = {};
  var _isVisible = false;
  var bapNavItem;
  var doScrolling = true;
  var options = {};
  var modalNavigation = {
    collection: null,
    configuration: null
  };
  var subtypes = {
    brochure: 'brochure'
  };
  var isModalOpened = false;
  var api;
  var interval;
  var debounceResize = $.noop;
  var scrollPosition = 0;
  var autoplay = window.innerWidth < 550 ? 0 : 1;
  var isRaqModal = false;
  var $modal = $('.modal');
  var $modalBody = $modal.find(modalBodySelectorClass);
  var $modalDialog = $modal.find('.modal-dialog');
  var $modalHeader = $modal.find('.modal-header');
  var $modalTitle = $modalHeader.find('.modal-title');
  var $modalContent = $modal.find('.modal-content');
  var $closeButton = $('.acr-modal-close');
  var $trigger = $('m');
  document.addEventListener('keydown', function (e) {
    var zipgateElement = document && document.querySelector(modalBodySelectorClass);

    if (zipgateElement) {
      var focusableElements = 'js-zipgate-close, button:not([style*="display: none"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      var firstFocusableElement = zipgateElement.querySelector(focusableElements); // get first element to be focused inside modal

      var focusableContent = zipgateElement.querySelectorAll(focusableElements);
      var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

      var preFocusableElement = focusableContent[focusableContent.length - 2];
      var activeElementClass = document.activeElement.getAttribute('class');
      var currentElement = zipgateElement.getElementsByClassName(activeElementClass);
      var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      var isIE = Utility.isIE11();

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey && !isIE) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          if (lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null) {
            preFocusableElement.focus(); // add focus for the last focusable element

            e.preventDefault();
          } else {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        }
      }

      if (!e.shiftKey && !isIE) {
        if (document.activeElement === lastFocusableElement || !currentElement.length !== 0 && currentElement[0] === document.activeElement && document.getElementsByClassName('js-zipgate show').length > 0) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element

          e.preventDefault();
        } else if (lastFocusableElement !== null && document.activeElement === preFocusableElement) {
          if (lastFocusableElement.getAttribute('disabled') !== null) {
            firstFocusableElement.focus(); // add focus for the first focusable element

            e.preventDefault();
          }
        }
      }
    }
  });
  Utility.log('Modals.js loaded');

  function show(event) {
    var button = $(event.relatedTarget);
    var videoID = button.data('videoId');
    $modalDialog.removeClass('modal-loading').removeClass('modal-fullscreen').removeClass('modal-large').removeClass('modal-alert');
    $modal.removeClass('modal-loading').removeClass('modal-fullscreen').removeClass('modal-large').removeClass('modal-alert');

    if (videoID) {
      $modalDialog.addClass('video-modal');
      var player = new Acr.YouTubeManager.YouTubePlayerObject(videoID, $closeButton, $modalBody, $modalBody, autoplay);
      player.init();
    }

    if (button.data('videoTracking')) {
      $($modalBody).attr('data-video-tracking', button.data().videoTracking);
    }

    if (Acr.TrackingManager) {
      Acr.TrackingManager.savePageLoadObject();
    }

    scrollPosition = $('html').scrollTop() || window.pageYOffset;
    $('body').css({
      position: 'fixed',
      'margin-top': '-' + scrollPosition + 'px'
    });
  }

  function shown(event) {}

  function hide(event) {
    $('body').removeAttr('style');
    window.scrollBy(0, scrollPosition);
    clearInterval(window.percentageInterval);

    if (window.setVideoPercentages) {
      window.setVideoPercentages();
    }

    if (Acr.TrackingManager) {
      if (isRaqModal) {
        var closeRaqEvent = Utility.createEvent('closeRaq');
        window.dispatchEvent(closeRaqEvent);
      }

      Acr.TrackingManager.restorePageLoadObject();
    }
  }

  function loaded(event) {}

  function hidden() {
    $('.modal-body').html('');
    $(window).trigger('ar.closemodal');
    isModalOpened = false;
  }

  function fireClickEvent(event) {
    var $this = $(event.currentTarget);
    var cookieZipcode = Utility.getCookie('zipcode');
    isRaqModal = $this.data('raq');

    if (event.preventDefault) {
      event.preventDefault();
    } // Deleting sessionStorage bapAccessories


    if (!window.BaP) {
      sessionStorage.removeItem('bapAccessories');
    }

    if ($this.data('modal-video-id')) {
      if ($this.data('videoTracking')) {
        $($modal).find('.modal-body').attr('data-video-tracking', $this.data('videoTracking'));
      }

      Modals.trigger($this.data('modal-title') ? $this.data('modal-title') : 'Acura', $this.data('modal-content'), $this.data('modal-type') ? $this.data('modal-type') : 'large', 'video', {
        hideHeader: $this.data('modal-hide-header'),
        bapNavItem: $this.data('modal-bap-nav-item'),
        url: $this.attr('href'),
        navigation: $this.data('modal-navigation') ? $.parseJSON($this.data('modal-navigation').replace(/&#34;/g, '"')) : null,
        videoId: $this.data('modal-video-id'),
        videoSource: $this.data('modal-video-source')
      }, $this.data('modalbap'), isRaqModal);
    } else if (isRaqModal && !cookieZipcode) {
      if (Acr.zipgateComponent) {
        type = 'large';
        Acr.zipgateComponent.openZipgate(fireClickEvent, event, true);
      }
    } else {
      // if it's not a video modal then check modal-type attribute
      //  if modal-type is not set then default to large
      //  otherwise use data-attr value
      type = $this.data('modal-type') && $this.data('modal-type').length > 0 ? 'large' : $this.data('modal-content');
      subtype = $this.data('modal-subtype');
      Modals.trigger($this.data('modal-title') ? $this.data('modal-title') : 'Acura', $this.data('modal-content'), $this.data('modal-type'), '', // Content is empty, so it will be loaded from url.
      {
        hideHeader: $this.data('modal-hide-header'),
        bapNavItem: $this.data('modal-bap-nav-item'),
        url: $this.attr('href'),
        navigation: $this.data('modal-navigation') ? $.parseJSON($this.data('modal-navigation').replace(/&#34;/g, '"')) : null
      }, $this.data('modalbap'), isRaqModal);
    }

    var modalType = Modals.getType();
    var modalSubType = Modals.getSubType();
    var modalTypeClass = modalType && 'modal-' + modalType;
    var modalSubTypeClass = modalSubType && 'modal-' + modalSubType; // set the classes on the modal elements so our CSS can work its magic

    $modal.removeClass('modal-large modal-fullscreen modal-alert');

    if (!$this.data('modal-video-id')) {
      $modal.addClass(modalTypeClass);
    }

    if (modalSubType) {
      $modal.addClass(modalSubTypeClass);
    }

    $modalDialog.removeClass('modal-large modal-fullscreen modal-alert');

    if (modalType !== 'large') {
      if ($this.data('modal-video-id') && modalType !== 'fullscreen') {
        $modalDialog.addClass(modalTypeClass);
      }
    }

    return false;
  }

  function wireLinks() {
    $(document).on('click', '[data-modal-video-id], [data-modal-type]', function (e) {
      e.preventDefault();
      fireClickEvent(e);
    });
    $(document).on('activateModal', function (e, param) {
      e.preventDefault();
      fireClickEvent(param);
    });
    return Modals;
  }

  function showData() {
    Modals.setLoading(false);
    $modal.removeClass('modal-loading');

    if (Modals.getHideHeader()) {
      $modalHeader.hide();
      $('.modal-no-header-close').show();
    }

    $modalTitle.html(Modals.getTitle());

    if (Modals.getMedia() === 'video') {
      var options = Modals.getOptions();

      if (options.videoId) {
        $modalDialog.addClass('video-modal');
        var player = new Acr.YouTubeManager.YouTubePlayerObject(options.videoId, $closeButton, $modalBody, $modalBody, autoplay);
        player.init();
      }

      $modalBody.show();
    } else {
      $modalBody.html(Modals.getContent());
      ImageFix($modalBody);

      if (Modals.getModalNavigation().collection) {
        configNavigation();
      }
    } // Calling callbacks


    Object.keys(Modals.getCallbacks()).forEach(function (k) {
      Modals.getCallbacks()[k].apply();
    });
    $modalBody.animate({
      scrollTop: 0
    }, 'fast');
  } // This function shows the modal body and calculates the description container height


  function showModalBody() {
    $modalContent.css('display', 'none');
    $modalBody.show(function () {
      var windowHeight = document.body.getBoundingClientRect().height;
      var modalHeader = $modalBody.find('.header');
      var windowWidth = $(window).width();
      var headerHeight = 0;
      var imgHeight = $modalBody.find('img').height();
      var $content = $modalBody.find('.content');
      var modalPadding = 100; // Modal should have 50px of padding-top and 50px of padding-bottom

      $modalContent.css({
        opacity: 0,
        display: 'block'
      });

      if (modalHeader) {
        headerHeight = modalHeader.height();
      }

      if (windowWidth < Constants.breakpoints.sm || subtype) {
        imgHeight = $modalBody.find('img').height();
        $content.innerHeight(windowHeight - headerHeight - imgHeight - modalPadding);
      } else {
        $content.innerHeight('auto');
        imgHeight = $modalBody.find('img').height();

        if (imgHeight > 0 && $content.height() > imgHeight * 1.2) {
          $content.height(imgHeight * 1.2);
        }
      }

      isModalOpened = true;
      $modalContent.css('opacity', 1);
    }); // Init LazyLoading

    Acr.LazyLoadingHelper.init();
    Acr.Disclaimer.init(); // If brochure modal

    if (subtype && subtype === subtypes.brochure) {
      RequestBrochure.init();
      Validation.init();
    }
  }

  function ImageFix($modalBody) {
    // Correct image src from picture srcset for IE
    var bpCurrent = getCurrentBreakpoint();
    var $pictures = $('picture', $modalBody);

    if ($pictures.length > 0) {
      $pictures.each(function (i, el) {
        var src;
        var srcset;
        var newSrc;
        var breakPImages;
        var image = new Image();

        switch (bpCurrent) {
          case 'sm':
            breakPImages = $(el).find('source[media|="(min-width: 550px)"]');
            break;

          case 'lg':
            breakPImages = $(el).find('source[media|="(min-width: 1024px)"]');
            break;

          case 'xl':
            breakPImages = $(el).find('source[media|="(min-width: 1400px)"]');
            break;

          default:
            breakPImages = $(el).find('img');
            break;
        }

        srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');

        if (srcset !== undefined) {
          src = breakPImages.attr('src') || breakPImages.attr('data-src');
          newSrc = srcset ? srcset.split(',') : src.split(',');
          newSrc = newSrc[0];
          $(el).find('img').attr('src', newSrc);
          showModalBody();

          image.onload = function () {
            // Needs improvement here.  We're showing the modal once the first
            // image is loaded, but in all cases so far, there's only one
            // picture element in the (feature) modal.
            showModalBody();
          };

          image.src = newSrc;
        } else {
          showModalBody();
        }
      });
    } else {
      showModalBody();
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  function trigger(title, content, type, media, options, isBap, isRaq) {
    Utility.log('Triggering Modal...');

    if (title === 'undefined' || title === '' || title === null) {
      $.each(options.navigation, function (index, obj) {
        $.each(obj, function (index, option) {
          if (option.selected) {
            title = option.title;
          }
        });
      });
    }

    _isVisible = true;

    if (!options) {
      options = {};
    }

    $modal.removeClass('modal-fullscreen').removeClass('modal-large').removeClass('modal-video').removeClass('modal-raq').removeClass('modal-alert');
    $modalBody.removeClass('modal-with-navigation');
    Modals.setTitle(title).setHideHeader(options.hideHeader && options.hideHeader === true).setContent(content || '').setType(type).setMedia(media).setBapNavItem(options.bapNavItem).setLoading(true).setOptions(options).setModalNavigation('collection', options.navigation);
    $modalHeader.show();
    $('.modal-footer').hide();
    $('.modal-no-header-close').hide();
    var opts = {};

    if (options.modalClass) {
      $modal.addClass(options.modalClass);
    }

    if (Modals.getType() === 'alert' || Modals.getType() === 'zipgate') {
      opts = {
        backdrop: 'static',
        keyboard: false
      };
    }

    $modal.attr('data-keyboard', 'false'); // IE fix to turn off ESC key

    $modal.modal(opts);
    $modal.addClass('modal-loading');

    if (isRaq) {
      $modal.addClass('modal-raq modal-large');
    }

    if (Modals.getType() === 'zipgate') {
      $modal.addClass('modal-zipgate');
    }

    $modalBody.html('').hide();
    $modalTitle.html('');
    $modalHeader.removeClass('modal-alert');
    $('.modal-title-info').html('');

    if (Modals.getContent() === '' && Modals.getMedia() !== 'video') {
      var hash = null;
      var URLArray = options.url.split('#');

      if (URLArray.length > 1) {
        options.url = URLArray[0];
        hash = URLArray[1];
      }

      var URL = options.url + (options.url.indexOf('?') === -1 ? '?' : '&') + 'stub=1';
      $.get(URL, function (data) {
        Modals.setContent(data).addCallback(function () {
          if ($modal.hasClass('modal-raq')) {
            window.RaqTool.initRaq('.modal-body');
            window.RaqTool.initDealerInfo();
          }

          if (hash !== null) {
            window.location.hash = '';
            window.location.hash = hash;

            if ($('.modal .rzf-gry').length > 0 && window.RZF) {
              window.RZF.runAll.init();
            }
          }
        });
        showData(); // Fix HRT 7576

        if (isBap) {
          HorizontalSlider.init();
        }
      });
    } else {
      showData();
    }

    if ($modal.find('.acr-gallery.black').length > 0) {
      $modal.addClass('black');
    } else {
      $modal.removeClass('black');
    }

    if ($(window).width() <= 549) {
      window.cosito = $modal;

      if (type === 'large' || media === 'video') {
        $modal.find('.responsive-table-header-mobile').css({
          display: 'none'
        });
        $('.responsive-table-title-accordion.active.docked.cloned').prev('.responsive-table-header-mobile').remove();
        $('.responsive-table-title-accordion.active.docked.cloned').remove();
      } else if (type === 'fullscreen') {
        $modal.find('.responsive-table-header-mobile').css({
          display: 'block'
        });
        $('.responsive-table-title-accordion.active.docked.cloned').prev('.responsive-table-header-mobile').remove();
        $('.responsive-table-title-accordion.active.docked.cloned').remove();
      }
    }
  }

  function launchErrorAlert(title, description) {
    Modals.setContent('<html></html>').addCallback(function () {
      $('.modal .modal-alert .close').show();
    });
    Modals.trigger(title || ' ', description || ' ', 'alert');
  }

  function setType(t) {
    type = t;
    return Modals;
  }

  function getType() {
    return type;
  }

  function getSubType() {
    return subtype;
  }

  function setMedia(m) {
    media = m;
    return Modals;
  }

  function getMedia() {
    return media;
  }

  function setTitle(t) {
    title = t;
    return Modals;
  }

  function getTitle() {
    return title;
  }

  function setOptions(t) {
    options = t;
    return Modals;
  }

  function getOptions() {
    return options;
  }

  function setHideHeader(hh) {
    hideHeader = hh;
    return Modals;
  }

  function getHideHeader() {
    return hideHeader;
  }

  function setContent(c) {
    content = c;
    return Modals;
  }

  function getContent() {
    return content;
  }

  function setLoading(l) {
    loading = l;
    return Modals;
  }

  function getLoading() {
    return loading;
  }

  function addCallback(cb) {
    callbacks[cb.toString()] = cb;
    return Modals;
  }

  function getCallbacks() {
    return callbacks;
  }

  function setBapNavItem(b) {
    bapNavItem = b;
    return Modals;
  }

  function getBapNavItem() {
    return bapNavItem;
  }

  function setDoScrolling(s) {
    doScrolling = s;
  }

  function getDoScrolling() {
    return doScrolling;
  }

  function setModalNavigation(i, mn) {
    modalNavigation[i] = mn;
  }

  function getModalNavigation() {
    return modalNavigation;
  }

  function navigate(to) {
    var collection = Modals.getModalNavigation().collection;
    var configuration = Modals.getModalNavigation().configuration;
    collection[configuration[to].label][configuration[to].index].selected = true;
    var URL = configuration[to].link + (configuration[to].link.indexOf('?') === -1 ? '?' : '&') + 'stub=1';
    var speed = 500; // URL = '/pages/bp-details-view-non-accessories-stacked-content.html';
    // URL = '/pages/bp-details-view-accessory-modal-2.html';

    $modalBody.append($('<div class="modal-loading-transition"></div>'));
    $modalBody.find('.modal-loading-transition').delay(speed).animate({
      opacity: 1
    });
    $.get(URL, function (data) {
      $modalBody.append($(data));
      var $slides = {
        leaving: $modalBody.find('.buildPriceDetailsView:eq(0)'),
        coming: $modalBody.find('.buildPriceDetailsView:eq(1)')
      };
      $modalBody.find('.modal-loading-transition').remove();
      $modalTitle.animate({
        opacity: 0
      }, speed / 2, function () {
        Modals.setTitle(configuration[to].title);
        $modalTitle.html(Modals.getTitle()).animate({
          opacity: 1
        }, speed / 2);
      });
      $slides.coming.css({
        left: (to === 'next' ? '' : '-') + '100%',
        right: (to === 'next' ? '-' : '') + '100%',
        opacity: 0
      });
      $slides.leaving.animate({
        left: (to === 'next' ? '-' : '') + '85%',
        right: (to === 'next' ? '' : '-') + '85%',
        opacity: 0
      }, {
        duration: speed,
        queue: false
      });
      $slides.coming.animate({
        left: 0,
        right: 0,
        opacity: 1
      }, speed, function () {
        $slides.leaving.remove();
        configNavigation();
        $modalBody.children().not($('.buildPriceDetailsView:last')).remove();
      });
    });
  }

  function handleScrolling() {
    $(document).on('touchmove', function (e) {
      if (!Modals.getDoScrolling()) {
        e.preventDefault();
      } else {
        return true;
      }
    });
    $('body').on('touchmove', '.modal-body, .disclaimers-content p', function (e) {
      if (!Modals.getDoScrolling()) {
        e.stopPropagation();
      } else {
        return true;
      }
    });
  }

  function resize() {
    if (isModalOpened && Modals.getType() === 'large') {
      showModalBody();
    }

    if (api) {
      api.reinitialise();
    }
  }

  function resizeCallback() {
    clearTimeout(debounceResize);
    debounceResize = setTimeout(resize, 700);
  }

  function onResize() {
    $(window).on('resize', resizeCallback);
  }

  function prepareNavigationsModals() {
    // add the support of pagination like modal
    var dfd = $.Deferred();
    var navigationRequest = [];
    $('[data-modal-service-url]').each(function () {
      var $this = $(this);
      var serviceUrl = $this.data('modal-service-url');
      var deeplink = $this.data('modal-deep-link') || $this.attr('href');
      var endpointUrl = serviceUrl + '?currenturl=' + deeplink;
      var request = $.ajax({
        url: endpointUrl,
        success: function success(response) {
          response = {
            '': response
          };
          $this.attr('data-modal-navigation', JSON.stringify(response).replace(/"/g, '&#34;'));
        }
      });
      navigationRequest.push(request);
    });
    $.when.apply(undefined, navigationRequest).then(function () {
      dfd.resolve();
    });
    return dfd;
  }

  function init() {
    $('.acr-modal').on('show.bs.modal', show);
    $('.acr-modal').on('shown.bs.modal', shown);
    $('.acr-modal').on('hide.bs.modal', hide);
    $('.acr-modal').on('hidden.bs.modal', hidden);
    $('.acr-modal').on('hidden.bs.loaded', loaded);

    try {
      prepareNavigationsModals().done(wireLinks);
    } catch (e) {
      Utility.error(e);
    }

    handleScrolling();
    onResize();
    return Modals;
  }

  return {
    init: init,
    hide: hide,
    trigger: trigger,
    setType: setType,
    getType: getType,
    getSubType: getSubType,
    setMedia: setMedia,
    getMedia: getMedia,
    setOptions: setOptions,
    getOptions: getOptions,
    setTitle: setTitle,
    getTitle: getTitle,
    setHideHeader: setHideHeader,
    getHideHeader: getHideHeader,
    setContent: setContent,
    getContent: getContent,
    setLoading: setLoading,
    getLoading: getLoading,
    addCallback: addCallback,
    getCallbacks: getCallbacks,
    getBapNavItem: getBapNavItem,
    setBapNavItem: setBapNavItem,
    isVisible: function isVisible() {
      return _isVisible;
    },
    setDoScrolling: setDoScrolling,
    getDoScrolling: getDoScrolling,
    setModalNavigation: setModalNavigation,
    getModalNavigation: getModalNavigation,
    navigate: navigate,
    launchErrorAlert: launchErrorAlert
  };
}();
"use strict";

var Acr = Acr || {};

Acr.ModelSlider = function () {
  function setSlick(slider) {
    var showDots = slider.children().length > 1;
    slider.slick({
      autoplay: false,
      dots: showDots,
      speed: 1200,
      useTransform: true,
      nextArrow: '<svg class="acr-icon slick-next slick-arrow" ' + 'viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xlink:href="#arrow-right">' + '</use></svg>',
      prevArrow: '<svg class="acr-icon slick-prev slick-arrow" ' + 'viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xlink:href="#arrow-left">' + '</use></svg>'
    });
  }

  function init(element) {
    setSlick($(element));
  }

  return {
    init: init
  };
};
"use strict";

var MultiCol = function () {
  var Utility = window.Utility || {};
  Utility.log('MultiCol.js loaded');
  var colWrapper = $('.col-wrapper');
  var article = $('.col-wrapper article');
  var articleHeader = $('.col-wrapper article h6');
  var articleSubCopy = $('.col-wrapper article .sub-copy');
  var articleFirst = $('.col-wrapper article:first-child');
  var articleLast = $('.col-wrapper article:last-child');
  var multiColTitle01 = $('.multi-col-tile-01');

  function multiColWidth() {
    if (colWrapper.hasClass('cols-2')) {
      article.addClass('col-md-18');
    } else if (colWrapper.hasClass('cols-2-25-75')) {
      articleFirst.addClass('col-md-9');
      articleLast.addClass('col-md-27');
    } else if (colWrapper.hasClass('cols-2-75-25')) {
      articleFirst.addClass('col-md-27');
      articleLast.addClass('col-md-9');
    } else if (colWrapper.hasClass('cols-2-33-66')) {
      articleFirst.addClass('col-md-12');
      articleLast.addClass('col-md-24');
    } else if (colWrapper.hasClass('cols-2-66-33')) {
      articleFirst.addClass('col-md-24');
      articleLast.addClass('col-md-12');
    } else if (colWrapper.hasClass('cols-3')) {
      article.addClass('col-md-12');
    } else if (colWrapper.hasClass('cols-4')) {
      article.addClass('col-md-9');
    }
  }

  function emptyContent() {
    $('.col-wrapper article header').each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).hide();
      }
    });
    $(articleHeader).each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).next('div').hide();
      }
    });
    $(articleSubCopy).each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).remove();
      }
    });
    $('.multi-col .acr-cta-text').each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).remove();
      }
    });
    $('.multi-col .col-wrapper img').error(function () {
      $(this).hide();
      $(this).parent().closest(multiColTitle01).css('min-height', '17rem');
    });
  }

  function init() {
    multiColWidth();
    emptyContent();
  }

  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};

Acr.MultiFeatures = function () {
  var Utility = window.Utility || {};
  var DeepLink;
  var $element;
  var $slider;
  var $slides;
  var $tabs;
  var $featuresContainer;
  var $featuresHeading;
  var $leftArrowSvg;
  var $rightArrowSvg;
  var debounceResize;
  var api;
  var defaultTab = 0;
  var leftArrowHtml;
  var rightArrowHtml;
  var slider = '.acr-multi-features-slick';
  var slides = '.acr-mlp-slide';
  var tabs = '.acr-mlp-tab';
  var featuresContainer = '.acr-mlp-features-container';
  var featuresHeading = '.acr-mlp-features-heading';
  var activeClass = 'acr-mlp-active';
  var tabLink = '.js-tab-link';
  var leftArrowSvgClass = '.acr-icon.arrow-left-icon';
  var rightArrowSvgClass = '.acr-icon.arrow-right-icon';

  function slickAfterChange(e, slick, currentSlide) {
    var hash = location.hash.replace('#', '');

    if (hash && !isCurrentSlideHash(hash, currentSlide)) {
      history.pushState('', document.title, window.location.pathname);
    }

    if ($(slick.$slides[currentSlide]).hasClass('acr-mlp-all-features')) {
      // reinit scrollPane if slide is all features
      resize();
    }
  }

  function slickBeforeChange(e, slick, currentSlide, nextSlide) {
    var $dots = $element.find('.slick-dots');
    $tabs.removeClass(activeClass);
    $tabs.eq(nextSlide).addClass(activeClass);

    if ($(slick.$slides[nextSlide]).hasClass('acr-mlp-all-features')) {
      $dots.hide();
    } else {
      $dots.show();
    }
  }

  function setSlick() {
    $slider.slick({
      arrows: false,
      useTransform: true,
      infinite: false,
      centerPadding: '10px',
      initialSlide: defaultTab,
      responsive: [{
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: true,
          infinite: true,
          centerPadding: '0px',
          prevArrow: '<button type="button" data-role="none" ' + 'class="slick-prev" aria-label="Previous" ' + 'tabindex="0" role="button">' + leftArrowHtml + '</button>',
          nextArrow: '<button type="button" data-role="none" ' + 'class="slick-next" aria-label="Next" ' + 'tabindex="0" role="button">' + rightArrowHtml + '</button>'
        }
      }]
    });
    $slider.on('afterChange', slickAfterChange);
    $slider.on('beforeChange', slickBeforeChange);
  }

  function changeSlide(e) {
    if (location.hash) {
      history.pushState('', document.title, window.location.pathname);
    }

    var currentTarget = $(e.target).closest(tabLink);
    var position = $tabs.index(currentTarget);
    $slider.slick('slickGoTo', position);
  }

  function selectTab(selectedTab, setSlick) {
    var position = $tabs.index(selectedTab);
    $tabs.removeClass(activeClass);
    $(selectedTab).addClass(activeClass);

    if (setSlick) {
      $slider.slick('slickGoTo', position, true);
    }
  }

  function maxHeightMobileCalculation() {
    if (window.innerWidth < Constants.breakpoints.md) {
      var maxHeight = 0;
      $slides.each(function (index, slide) {
        var slideHeight = $(slide).find('.acr-mlp-bg').outerHeight() + $(slide).find('.acr-mlp-content').outerHeight();
        maxHeight = slideHeight > maxHeight ? slideHeight : maxHeight;
      });
      $element.find(slides).height(maxHeight);
    } else {
      $element.find(slides).height('auto');
    }

    setFeaturesHeight();
  }

  function setFeaturesHeight() {
    var heightParent = $slides.innerHeight();
    var heightSibling = $featuresHeading.outerHeight();
    $featuresContainer.height(heightParent - heightSibling);
  }

  function getTabSettings() {
    defaultTab = parseInt($element.data('defaultTab'), 10) - 1;

    if (defaultTab) {
      var selectedTab = $tabs[defaultTab];
      selectTab(selectedTab, false);
    } else {
      defaultTab = 0;
    }
  }

  function resize() {
    maxHeightMobileCalculation();

    if (api) {
      api.reinitialise();
    }
  }

  function resizeCallback() {
    clearTimeout(debounceResize);
    debounceResize = setTimeout(resize, 250);
  }

  function imagesReady() {
    resize();
  }

  function deepLinking() {
    if ($element.length) {
      var hashTab = DeepLink.getTabIdHashElement($element[0]);

      if (hashTab) {
        selectTab($(hashTab), true);
      }
    }
  }

  function isCurrentSlideHash(hash, currentIndex) {
    var isSlideIndex = false;

    if ($element.length) {
      var hashSelector = !Utility.isIE11() ? '.js-tab-link[tab-id="' + hash + '" i]' : '.js-tab-link[tab-id="' + hash + '"]';
      var tabHash = $element[0].querySelector(hashSelector);

      if (tabHash) {
        var tabHashIndex = $tabs.index(tabHash);
        isSlideIndex = tabHashIndex === currentIndex;
      }
    }

    return isSlideIndex;
  }

  function bindEvents() {
    $tabs.on('click', changeSlide);
    $(window).on('resize', resizeCallback);
    $(window).on('load', deepLinking);
    $(window).on('hashchange', deepLinking);
  }

  function getSvgsHTML() {
    if ($leftArrowSvg.length > 0) {
      Utility.removeClassFromSvg($leftArrowSvg, 'hide');
      leftArrowHtml = $leftArrowSvg[0].outerHTML;
      $leftArrowSvg[0].parentNode.removeChild($leftArrowSvg[0]);
    }

    if ($rightArrowSvg.length > 0) {
      Utility.removeClassFromSvg($rightArrowSvg, 'hide');
      rightArrowHtml = $rightArrowSvg[0].outerHTML;
      $rightArrowSvg[0].parentNode.removeChild($rightArrowSvg[0]);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $slider = $element.find(slider);
    $slides = $element.find(slides);
    $tabs = $element.find(tabs);
    $featuresContainer = $element.find(featuresContainer);
    $featuresHeading = $element.find(featuresHeading);
    $leftArrowSvg = $element.find(leftArrowSvgClass);
    $rightArrowSvg = $element.find(rightArrowSvgClass);
  }

  function init(element) {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    initSelectors(element);
    bindEvents();
    getTabSettings();
    getSvgsHTML();
    setSlick();
    maxHeightMobileCalculation();
    Utility.imagesReady($slider, imagesReady);
  }

  return {
    init: init
  };
};
"use strict";

var Acr = Acr || {};

Acr.MultiTabNavigation = function () {
  var DeepLink;
  var $element;
  var $slideElement;
  var $tabbedMenu;
  var $tabList;
  var $button;
  var $leftArrowSvg;
  var $rightArrowSvg;
  var $swiperPagination;
  var debounce;
  var maxTabs;
  var defaultTab;
  var $multiTabNavigationSwiper;
  var slideElement = '[data-navigation-label]';
  var tabbedMenu = '.tabbed-menu';
  var tabList = '.acr-multi-tab-list';
  var leftArrowSvgClass = '.js-arrow-left';
  var rightArrowSvgClass = '.js-arrow-right';
  var swiperPaginationClass = '.js-swiper-pagination';
  var singleSlideClass = 'acr-multi-tab-single-slide';

  function getComponentData() {
    maxTabs = parseInt($element.data('maxTabs'), 10) - 1;
    defaultTab = parseInt($element.data('defaultTab'), 10) - 1;

    if (!defaultTab || !$slideElement.length || defaultTab >= $slideElement.length || defaultTab >= maxTabs) {
      defaultTab = 0;
    }
  }

  function initSwiper() {
    var $firstMultiTab;
    var $cta;
    var $theme;
    var numbOfSlides = $element.find('.swiper-slide').length;

    if (numbOfSlides < 2) {
      $element.addClass(singleSlideClass);
      $firstMultiTab = $('.swiper-slide').find('.acr-multi-tab-content');
      $cta = $('.acr-cta-text', $firstMultiTab);

      if ($firstMultiTab.length > 0) {
        $theme = $firstMultiTab.data('theme');
        changeTheme($theme, $cta, $element);
      }
    } else {
      $multiTabNavigationSwiper = new Swiper($element.find('.swiper-container'), {
        speed: 400,
        slidesPerView: 1,
        loop: true,
        initialSlide: defaultTab,
        pagination: {
          el: $swiperPagination,
          clickable: true,
          bulletClass: 'acr-multi-tab-pagination-bullet',
          bulletActiveClass: 'acr-multi-tab-pagination-bullet-active'
        },
        navigation: {
          nextEl: $rightArrowSvg,
          prevEl: $leftArrowSvg
        }
      });
      $multiTabNavigationSwiper.on('slideChange', function () {
        if (Acr.TrackingManager) {
          Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
        }

        afterChange($multiTabNavigationSwiper);
      });
      $firstMultiTab = $($multiTabNavigationSwiper.slides[$multiTabNavigationSwiper.activeIndex]).find('.acr-multi-tab-content');
      $cta = $('.acr-cta-text', $firstMultiTab);

      if ($firstMultiTab.length > 0) {
        $theme = $firstMultiTab.data('theme');
        changeTheme($theme, $cta, $element);
      }

      executeLazyLoading();
    }
  }

  function afterChange($swiper) {
    var $currentSlide = $($swiper.slides[$swiper.activeIndex]);
    var $cta = $currentSlide.find('.acr-cta-text');
    var theme = $currentSlide.find('.acr-multi-tab-content').data('theme');
    changeTheme(theme, $cta);
    evaluateSelectedTab($swiper.realIndex);
  }

  function changeTheme(theme, $cta) {
    $element.removeClass('dark-theme light-theme');
    $element.addClass(theme);
    $cta.removeClass('is-black is-white');

    if (theme === 'dark-theme') {
      $cta.addClass('is-white');
    } else {
      $cta.addClass('is-black');
    }
  }

  function createNavigation() {
    if ($slideElement.length > 1) {
      var $navList = $('<ul class="acr-multi-tab-list"></ul>');
      $slideElement.each(function (index, el) {
        if (index > maxTabs) {
          return false;
        }

        var activeClass = index === defaultTab ? 'active' : '';
        var buttonLabel = el.dataset.navigationLabel;
        var buttonId = el.id;
        var $listItem = $('<li class="' + activeClass + '"></li>');
        $button = $('<button class="acr-multi-tab-button acr-label-2 js-tab-link" data-toggle="tab" tab-id="' + stripHtmlTags(buttonId) + '">' + buttonLabel + '</button>');
        var trackingData = $(el).data('trackingNoClick');

        if (trackingData) {
          $button.attr('data-tracking', trackingData);
        }

        $listItem.append($button);
        $navList.append($listItem);
      });

      if ($navList) {
        $tabbedMenu.append($navList);
        $tabbedMenu.css({
          display: 'block'
        });
        $tabList = $tabbedMenu.find(tabList);
      }
    }
  }

  function stripHtmlTags(str) {
    if (!str) {
      return false;
    }

    str = $('<p>' + str + '</p>').text();
    str = str.replace(/(™|®|©|&trade;|&reg;|&copy;|&#8482;|&#174;|&#169;)/g, '');
    return str.replace(/ /g, '-');
  }

  function changeSlide(e) {
    var position = $tabbedMenu.find('button').index(e.target);
    $multiTabNavigationSwiper.slideToLoop(position);
  }

  function selectTab(selectedTab) {
    var position = $tabbedMenu.find('button').index(selectedTab);
    $multiTabNavigationSwiper.slideToLoop(position);
  }

  function deepLinking() {
    if ($element.length) {
      var hashTab = DeepLink.getTabIdHashElement($element[0]);

      if (hashTab) {
        selectTab($(hashTab));
      }
    }
  }

  function evaluateSelectedTab(index) {
    $tabList.find('li').removeClass('active');
    $tabList.find('li').eq(index).addClass('active');
  }

  function onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(resize, 250);
  }

  function resize() {
    var $header = $element.find('.acr-multi-tab-header');
    var height = $header.outerHeight(true);
    height -= 20;
    $('.acr-multi-tab-arrows, .acr-multi-tab-xs-header', $element).css({
      top: height + 'px'
    });
  }

  function executeLazyLoading() {
    var imagesToLoad = [].slice.call(document.querySelectorAll('.swiper-slide img[loading="lazy"]'));
    Utility.initLazyLoadingIO(imagesToLoad, Acr.LazyLoadingHelper.loadImage);
  }

  function initSelectors(element) {
    $element = $(element);
    $slideElement = $element.find(slideElement);
    $tabbedMenu = $element.find(tabbedMenu);
    $leftArrowSvg = $element.find(leftArrowSvgClass);
    $rightArrowSvg = $element.find(rightArrowSvgClass);
    $swiperPagination = $element.find(swiperPaginationClass);
  }

  function bindEvents() {
    $(window).on('resize', onResize);
    $(window).on('load', deepLinking);
    $(window).on('hashchange', deepLinking);
    $element.find('.acr-multi-tab-button').on('click', changeSlide);
  }

  function init(element) {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    initSelectors(element);
    getComponentData();
    createNavigation();
    bindEvents();
    initSwiper();
    resize();
  }

  return {
    init: init
  };
};
"use strict";

// [AR-10101] NVP subnav based on MLPNav
var NVPNav = function ($el) {
  Utility.log('NVPNav.js loaded');
  var nvpNav = {};
  var $window = $(window);
  var swipeStartY;
  var swipeEndY;
  var translate = 0;
  var maxTranslate = 0;
  var debounce;
  var navSwitchWidth = null;
  var navLargePadding = 70; // 35px on each side @ large BP
  // NVP Nav Basic Constructor

  function NVPNav($el) {
    this.$el = $el;
    this.$section = this.$el.children('section');
    this.$button = this.$section.children('button');
    this.$buttonSVG = this.$button.children('svg');
    this.$hamburger = this.$el.children('aside[role=menu]');
    this.$navContainer = this.$el.children('section');
    this.$desktopNav = this.$navContainer.children('ul');
    return this;
  }

  function _toggleHamburger() {
    nvpNav.$hamburger.slideToggle({
      start: function start() {
        $(this).css('display', 'flex');
      },
      complete: function complete() {
        _setMaxTranslate();

        if ($(this).is(':visible')) {
          $(this).css('display', 'flex');
        }
      }
    }); // Flip flop the arrow icon

    nvpNav.$buttonSVG.each(function () {
      if ($(this).attr('class').indexOf('hidden') !== -1) {
        $(this).attr('class', 'acr-icon');
      } else {
        $(this).attr('class', 'acr-icon hidden');
      }
    });
  }

  function init() {
    // Bail if this element DNE
    if ($el.length === 0) {
      return null;
    } // Otherwise initialize the constructor


    nvpNav = new NVPNav($el); // Set Overview button up arrow to hidden on mobile

    $('.nvp-nav > section > button > svg:nth-child(2)').attr('class', 'acr-icon hidden');
    $('.acr-header > div').css('position', 'relative');
    nvpNav.$button.on('click.nvpNav', _toggleHamburger);
    $window.on('resize', _attachResize);

    _attachTouch(); // throwing this inside a timeOut to prevent incorrect
    // element widths being returned
    // causing navStyle to change at the wrong times


    setTimeout(function () {
      // set navSwitchWidth
      navSwitchWidth = nvpNav.$desktopNav.width(); // kick off the first resize event

      _onResize();
    }, 50);
    return this;
  }

  function _attachTouch() {
    nvpNav.$hamburger.off('touchstart', _touchStartHandler).on('touchstart', _touchStartHandler);
    nvpNav.$hamburger.off('touchmove', _touchMoveHandler).on('touchmove', _touchMoveHandler);
    nvpNav.$hamburger.off('touchend', _touchEndHandler).on('touchend', _touchEndHandler);
  }

  function _touchStartHandler(e) {
    swipeStartY = e.originalEvent.touches[0].clientY;
    translate = parseInt(mlpNav.$hamburger.css('top'), 10);
    nvpNav.$hamburger.removeClass('acr-animation');
  }

  function _touchMoveHandler(e) {
    var dY;
    var top;
    swipeEndY = e.originalEvent.touches[0].clientY;
    dY = swipeStartY - swipeEndY;
    dY *= -1;
    top = translate + dY;

    if (top > 0) {
      top = 0;
    } else if (top * -1 > maxTranslate) {
      top = maxTranslate * -1;
    }

    nvpNav.$hamburger.css('top', top.toString() + 'px');
    nvpNav.$hamburger.addClass('acr-animation');
  }

  function _touchEndHandler() {
    swipeStartY = null;
    swipeEndY = null;
  }

  function _setMaxTranslate() {
    var menuBarHeight = nvpNav.$section.height();
    var viewPortHeight = window.innerHeight;
    var hamburgerViewPortH = viewPortHeight - menuBarHeight;
    maxTranslate = Math.abs(nvpNav.$hamburger.height() - hamburgerViewPortH);
  }

  function _attachResize() {
    clearTimeout(debounce);
    debounce = setTimeout(_onResize, 250);
  }

  function _onResize() {
    setNavStyle();
  }

  function setNavStyle() {
    var hamburgerView = nvpNav.$navContainer.innerWidth() < navSwitchWidth + navLargePadding;

    if (window.innerWidth > Constants.breakpoints.lg - 1 && hamburgerView === false) {
      activateDesktopNav();
    } else {
      activateHamburgerNav();
    }
  }

  function activateHamburgerNav() {
    nvpNav.$el.removeClass('desktop-nav').addClass('hamburger-nav');
  }

  function activateDesktopNav() {
    nvpNav.$el.removeClass('hamburger-nav').addClass('desktop-nav');
  }

  return {
    init: init
  };
}($('.nvp-nav'));
"use strict";

var OffersTool = function () {
  Utility.log('OffersTool loaded');
  var offersUi;
  var stockPhotoTimeout = null;
  var legacyRaq = !!(window.tools && window.tools.legacyRaq);

  var formatOfferDetailsModalDates = function formatOfferDetailsModalDates(data) {
    // converts Offer-Details modal's Available-dates format,
    // from 'yyyy-mm-dd' to 'mmm dd, YYYY'.
    if (data.url.indexOf('/offer-details?') !== -1) {
      var startDateStrArr = data.event.item.offer.StartDate.split('-'); // [yyyy, mm, dd]

      var endDateStrArr = data.event.item.offer.EndDate.split('-'); // [yyyy, mm, dd]

      var dateStrsFormatted = {
        start: Utility.getMonthNameFromNumber(parseInt(startDateStrArr[1], 10)) + ' ' + startDateStrArr[2].replace(/^0/, '') + ', ' + startDateStrArr[0],
        end: Utility.getMonthNameFromNumber(parseInt(endDateStrArr[1], 10)) + ' ' + endDateStrArr[2].replace(/^0/, '') + ', ' + endDateStrArr[0]
      };
      $('.ui-modal-content .offer-detail-modal-dates-copy').text(dateStrsFormatted.start + ' - ' + dateStrsFormatted.end);
    }
  };

  var formatOfferDetailsModalPrice = function formatOfferDetailsModalPrice(data) {
    if (data.url.indexOf('/offer-details?') !== -1) {
      var $modalPrice = $('.ui-modal-content .offer-detail-modal-price');
      var priceStr = $modalPrice.text().trim();
      $modalPrice.text(priceStr.replace(/\.\d\d$/, ''));
    }
  };

  var handleStockPhotos = function handleStockPhotos() {
    // Adds classhooks to image containers to handle offer-specific, stock
    // images from API, when window.offer.stockPhoto var specifies this for a
    // tab.
    var stockPhoto;
    var $stockPhotoOffersContainer;
    var $stockPhotoImgContainers;

    if (window.offers.stockPhoto) {
      stockPhoto = window.offers.stockPhoto;

      if (stockPhotoTimeout) {
        clearTimeout(stockPhotoTimeout);
        stockPhotoTimeout = null;
      }

      if (stockPhoto.showStockPhoto) {
        $stockPhotoOffersContainer = $('.offers-container[offer-type=' + stockPhoto.stockPhotoTab + ']');
        $stockPhotoImgContainers = $stockPhotoOffersContainer.find('.offers-group-model-container');

        if ($stockPhotoImgContainers.length > 0) {
          $stockPhotoImgContainers.addClass('stock-photo');
        } else {
          console.warn('No image containers found!');
        }
      }
    } else {
      stockPhotoTimeout = setTimeout(function () {
        handleStockPhotos();
      }, 250);
    }
  };

  var reevalPicturefills = function reevalPicturefills() {
    // ie11 workaround:
    // re-evaluates images (with srcset attr) inside picture elements,
    // using picturefill.min.js.
    var $srcsetImages = $('.ui-modal-content picture img[srcset]:not(.interpolated)');

    if ($srcsetImages.length > 0) {
      picturefill({
        reevaluate: true,
        elements: $srcsetImages
      });
    }
  };

  var prefixV2Images = function prefixV2Images(images) {
    // All images with the string "acura2" in their path
    // are V2.0 images that need to be prefixed with "assets/"
    // This should be checked when the endpoint data is loaded
    // and when a model is selected and the feature offer image changes.
    for (var i = 0; i < images.length; i++) {
      var acura2Pos = images[i].src.indexOf('acura2');
      var assetsPos = images[i].src.indexOf('assets/');

      if (acura2Pos !== -1 && assetsPos === -1) {
        images[i].src = images[i].src.slice(0, acura2Pos) + 'assets/' + images[i].src.slice(acura2Pos);
      }
    }
  };

  var checkV2Images = function checkV2Images() {
    var vehicleImages = document.querySelectorAll('.offers-vehicle-image');
    prefixV2Images(vehicleImages);
  };

  var getText = function getText(url, offer) {
    // NOTE: Tokens should be part of the base url on CMS
    var replacements = url.match(/\[%%[\d\D]*?%%]/g);

    if (replacements) {
      replacements.forEach(function (match) {
        url = url.replace(match, offer[match.slice(3, -3).toLowerCase()]);
      });
    }

    return url;
  };

  var setListeners = function setListeners() {
    // once data is loaded initialize everything
    offersUi.bus.on(offersUi.bus.EVENTS.DATA.DATA_LOADED, function () {
      SelectBox.createSelect('.vehicle-dropdown-select');
      SelectBox.createSelect('.offers-filter-select');
      setTimeout(function () {
        handleStockPhotos();
      }, 500);
      checkV2Images();
    });
    offersUi.bus.on(offersUi.bus.EVENTS.MODAL.MODAL_LOADED, function (data) {
      // must be RAQ
      if (data.event === undefined) {
        // Deleting sessionStorage bapAccessories
        if (!window.BaP) {
          sessionStorage.removeItem('bapAccessories');
        }

        RaqTool.initRaq('.ui-modal-content');
        $('body').addClass('modal-open');
        $('offers-modal-wrapper').addClass('modal-raq');
      }

      if (data.url.indexOf('/offer-details?') !== -1) {
        formatOfferDetailsModalDates(data);
        formatOfferDetailsModalPrice(data);

        if (Utility.isIE11()) {
          reevalPicturefills();
        }
      }
    });
    offersUi.bus.on(offersUi.bus.EVENTS.MODAL.MODAL_IS_CLOSING, function () {
      $('body').removeClass('modal-open');
      $('offers-modal-wrapper').removeClass('modal-raq');
    });
    offersUi.bus.on(offersUi.bus.EVENTS.MODEL.CHANGE, function (data) {
      // trigger an update to the dropdown when the model is changed
      //  (could be changed via dropdown or the "All ILX Offers" CTA)
      try {
        // This initialization sometimes throws an exception that
        // prevents the riot event (model.change) from working from that point on
        // and checkV2Images from being called when the model changes.
        SelectBox.setInitialValue('input-vehicle-clone', data.newValue);
      } catch (err) {
        console.error(err);
      }

      checkV2Images();
    }); // handle special offers modal RAQ CTA click

    $(document).on('click', '.offer-detail-modal-cta.raq-cta', function (e) {
      e.preventDefault();

      if (legacyRaq) {
        window.open(e.target.href, 'acura');
      } else {
        offersUi.bus.trigger(offersUi.bus.EVENTS.MODAL.MODAL_OPEN, {
          url: e.target.href
        });
      }
    }); // handle "all [model] offers" cta when filtering "all vehicles" on the featured tab

    $(document).on('click', '.offers-group-model-filter', function () {
      window.scrollTo(0, 0);
    });
  };

  var init = function init() {
    // sitecoreExpEditor is used to avoid init the app
    // when on Sitecore experience editor
    var sitecoreExpEditor = !!(window.Sitecore && window.Sitecore.WebEditSettings && window.Sitecore.WebEditSettings.editing);

    if ($('offers-wrapper').length > 0 && !sitecoreExpEditor) {
      offersUi = window.platform.offers.default.init();
      setListeners();
    }
  }; // Listen for DOM changes and check the images prefixes when they happen


  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  if (MutationObserver) {
    var target = document.querySelector('offers-wrapper');

    if (target) {
      var observer = new MutationObserver(function () {
        checkV2Images();
      });
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe(target, config);
    }
  }

  return {
    init: init
  };
}();
"use strict";

var PackagesSlider = function (window) {
  var $sliders;

  function isEditingMode() {
    return $sliders && $sliders.parent('.acr-packages-slider') && $sliders.parent('.acr-packages-slider').hasClass('editing-mode');
  }

  function setEditingModeScreenWidth() {
    var width = 0;
    var packages = $('.acr-packages-slick .package');
    packages.each(function () {
      width += this.offsetWidth;
    });
    $('.acr-packages-slick').width(width);
  }

  function getNumberOfDots(el, slick) {
    var slidesToShow = slick.options.slidesToShow;

    if (slidesToShow < slick.$slides.length) {
      return slick.$slides.length - slidesToShow + 1;
    }

    return 0;
  }

  function setSlick() {
    $sliders = $('.acr-packages-slick');

    if (isEditingMode()) {
      return;
    }

    if ($sliders) {
      $sliders.slick({
        infinite: false,
        dots: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: '<button type="button" data-role="none"' + ' class="slick-prev acr-icon-arrow-large-left acr-f4 acr-mid-grey"' + ' aria-label="Previous" tabindex="0" role="button"></button>',
        nextArrow: '<button type="button" data-role="none"' + ' class="slick-next acr-icon-arrow-large-right acr-f4 acr-mid-grey"' + ' aria-label="Next" tabindex="0" role="button"></button>',
        useTransform: true,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
      $sliders.on('afterChange', function (event, slick, currentSlide) {
        var $this = $(this);

        if (currentSlide >= getNumberOfDots(this, slick)) {
          setTimeout(function () {
            $this.slick('slickGoTo', getNumberOfDots(this, slick) - 1, true);
          }, 10);
        }
      });
      $sliders.on('setPosition', function (event, slick) {
        var i;
        var dots = slick.$dots ? slick.$dots.find('li') : [];
        var numberOfDots = getNumberOfDots(this, slick);

        if (dots.length > numberOfDots) {
          for (i = numberOfDots; i < dots.length; i++) {
            dots[i].remove();
          }
        }
      });
    }
  }

  $(window).on('resize', $.throttle(250, function () {
    setTimeout(function () {
      if (isEditingMode()) {
        setEditingModeScreenWidth();
      }
    }, 200);

    if (window.innerWidth >= Constants.breakpoints.md) {
      if ($sliders && $sliders.hasClass('slick-initialized')) {
        $sliders.slick('unslick');
      }
    } else if ($sliders && !$sliders.hasClass('slick-initialized')) {
      setSlick();
    }
  }));

  function init() {
    $('.acr-packages').addClass('acr-total-packages-' + $('.acr-packages-slick .package').length);
    setSlick();

    if (window.innerWidth >= Constants.breakpoints.md) {
      $sliders.slick('unslick');
    }
  }

  return {
    init: init
  };
}(window);
"use strict";

var PeTool = function () {
  Utility.log('PeTool loaded');
  var peUI;
  var $peWrapper;
  var selects = [];
  var currentSelectOptions = {};
  var selectsLoaded = 0;
  var offerDetailsLinksSelector = '.offer-card-link, [text="Offer Details"] a';
  var offerDetailsUrl = null;
  var $notificationPanel;
  var debounce;

  var initPe = function initPe() {
    $peWrapper = $('pe-wrapper');
    var sitecoreExpEditor = !!(window.Sitecore && window.Sitecore.WebEditSettings && window.Sitecore.WebEditSettings.editing);

    if ($peWrapper.length >= 1 && !sitecoreExpEditor) {
      peUI = window.platform.pe.default.init()[0];
      $notificationPanel = $('.notification-panel', $peWrapper); // give each <select> an ID (required for SelectBox.createSelect())

      giveSelectsIDs(); // wait for <select> to be populated before creating the custom select box

      waitForSelectLoad();
      setListeners(); // Adding Offers zipcode palceholder

      var placeholder = window.pe && window.pe.labels && window.pe.labels.changeZip && window.pe.labels.changeZip.updateButton ? window.pe.labels.changeZip.updateButton : 'ZIP Code';
      $('pe-wrapper input.change-zip-input').attr('placeholder', placeholder); // console.log('PeTool initialized.');
      // console.log('peUI object below.');
      // console.log(peUI);
    }
  }; // setInterval to check each <select> to see if its content is populated (it comes from an API)
  // if the select has loaded then run the custom select box code on it


  var waitForSelectLoad = function waitForSelectLoad() {
    var checkSelectOptionsInterval = setInterval(function () {
      checkForSelectLoad();
    }, 500);

    function checkForSelectLoad() {
      for (var i = 0; i < selects.length; i++) {
        // only check the selects that haven't loaded yet
        if (selects[i] !== false) {
          var thisSelector = '#' + selects[i]; // if the select has options populated then create the custom select
          // then set the select to false so we don't keep checking it
          // then increment selectsLoaded variable so we can know when all selects have loaded and stop the interval

          if ($('option', thisSelector).length > 0) {
            selects[i] = false;
            selectsLoaded++; // make sure there isn't an existing SelectBox before creating a new one

            if ($('[data-id="' + thisSelector.substr(1) + '"]').length === 0) {
              SelectBox.createSelect(thisSelector);
            }
          }
        } // if all selects have loaded stop the interval


        if (selectsLoaded === selects.length) {
          stopInterval();
          currentSelectOptions = getSelectOptions();
        }
      }
    }

    function stopInterval() {
      clearInterval(checkSelectOptionsInterval);
    }
  }; // SelectBox.js requires IDs on select elements
  // if the select doesn't have an ID give it one


  var giveSelectsIDs = function giveSelectsIDs() {
    $('select').each(function (i) {
      if (!$(this).attr('id')) {
        // use the index to make the ID unique
        var newID = 'pe-select-' + i;
        $(this).attr('id', newID);
      }

      selects[i] = $(this).attr('id');
    });
  }; // creates an object for each <select> identified by its ID attribute
  //  and assigns the array of options to the object's option property


  var getSelectOptions = function getSelectOptions() {
    var selectOptions = {};
    $('select:not(#model)').each(function (i, el) {
      var options = [];
      $(el).find('option').each(function (j, ele) {
        options[j] = $(ele).attr('value');
      });
      selectOptions[$(this).attr('id')] = {};
      selectOptions[$(this).attr('id')].options = options;
    });
    return selectOptions;
  };

  var handleOfferDetailsClick = function handleOfferDetailsClick(e) {
    e.stopPropagation();
    e.preventDefault(); // Get root-relative content-URL (delete protocol & hostname).
    // Handle offer-card offer-details cta click

    var $link = $(e.currentTarget);
    var $modal = $('#acr-modal'); // console.log('Offer Details link clicked! e object:');
    // console.log(e);
    // console.log('offerDetailsUrl: ' + offerDetailsUrl);
    // Slight delay to allow OPEN_OFFER_DETAILS bus-event-handler to populate offerDetailsUrl.

    setTimeout(function () {
      $link.attr({
        href: offerDetailsUrl,
        'data-raq': 'false',
        'data-modal-type': 'large'
      });
      $modal.addClass('modal-offer-details').find('.acr-modal-close').one('click', function () {
        $modal.removeClass('modal-offer-details modal-large');
      });
      Modals.addCallback(function checkModalImage() {
        var $modalHeader = $('.modal-offer-details .offer-detail-modal-header');

        if ($modalHeader.length === 1) {
          if ($modalHeader.hasClass('no-image')) {
            $modal.addClass('no-image');
          } else {
            $modal.removeClass('no-image');
          }
        }
      });
      $(document).trigger('activateModal', e); // remove the attribute so we don't trigger the modal twice on the next click

      $link.removeAttr('data-modal-type');
      offerDetailsUrl = null;
    }, 100);
  };

  var openNotificationPanel = function openNotificationPanel(contentStr) {
    var $contentSpan = $notificationPanel.find('span');
    var defaultContent = $contentSpan.text();
    var $titleH3 = $notificationPanel.find('h3.vehicle-disclaimer-title');
    var $containerDiv = $notificationPanel.find('div');
    var titleContent = window.pe && window.pe.labels && window.pe.labels.selectModel && window.pe.labels.selectModel.total ? '*' + window.pe.labels.selectModel.total : '';
    $notificationPanel.find('h3').hide();

    if ($titleH3.length) {
      $titleH3.text(titleContent);
      $titleH3.show();
    } else {
      var h3 = $('<h3/>');
      h3.addClass('vehicle-disclaimer-title');
      h3.text(titleContent);
      $containerDiv.prepend(h3);
    }

    $contentSpan.text(contentStr);
    $notificationPanel.addClass('is-open');
    $notificationPanel.find('button').one('click', function () {
      $contentSpan.text(defaultContent);
      $notificationPanel.removeClass('is-open');
    });
  };

  var removeVehicleNotificationInfo = function removeVehicleNotificationInfo() {
    $notificationPanel.find('h3').show();
    $notificationPanel.find('h3.vehicle-disclaimer-title').remove();
  }; // sets height of all offer cards equal to height of the tallest card
  // this prevents a jumpy behavior when the user scrolls through the carousel
  // to a card that is taller than the previous


  var setOfferCardHeight = function setOfferCardHeight() {
    var $offerCards = $('.ui-slide');
    $offerCards.css('height', 'auto');
    var tallestCard = 0;
    $offerCards.each(function () {
      tallestCard = $(this).height() > tallestCard ? $(this).height() : tallestCard;
    });
    $offerCards.css('height', tallestCard);
  };

  function onResize() {
    clearTimeout(debounce);
    debounce = setTimeout(setOfferCardHeight, 250);
  }

  function onPaymentUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(updateDropdowns(), 500);
  }

  var setAppliedOfferCardSize = function setAppliedOfferCardSize($applyOfferBtn) {
    var $origCard = $applyOfferBtn.closest('.offer-card-container');
    var $appliedCard = $origCard.closest('.pe-offer-card').next('.pe-selected-offer');
    var origCardWidth = $origCard.outerWidth();
    var origCardHeight = $origCard.outerHeight();
    $appliedCard.outerWidth(origCardWidth).outerHeight(origCardHeight);
  }; // check if the list of options for the <select> matches previous list of options for the select
  // only if things have changed will we recreate our selectboxes


  var updateDropdowns = function updateDropdowns() {
    var newSelectOptions = getSelectOptions();
    $('select:not(#model)').each(function () {
      var id = $(this).attr('id'); // <select> options don't match - create a new selectBox and update currentOptions

      var $customSelect = $(this).next('.acr-select-box-cloned');
      $customSelect.remove();
      SelectBox.createSelect('#' + id);
      currentSelectOptions = newSelectOptions;
    });
  };

  function checkArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (var i = arr1.length; i--;) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  var setListeners = function setListeners() {
    $(window).resize(onResize);
    peUI.bus.on(peUI.bus.EVENTS.VEHICLE.OPEN_DISCLAIMER, function (e) {
      openNotificationPanel(e.disclaimer);
    });
    peUI.bus.on(peUI.bus.EVENTS.DISCLAIMER.OPEN, function () {
      removeVehicleNotificationInfo();
    });
    $(document).on('mousedown', '.offer-card-button', function (e) {
      setAppliedOfferCardSize($(e.originalEvent.target));
    }); // trigger RAQ

    $(document).on('click', '.pe-whats-next-ctas .raq-cta, .offer-detail-modal-box .raq-cta', function (e) {
      $(e.currentTarget).attr('data-raq', 'true').attr('data-modal-type', 'large');
      $(document).trigger('activateModal', e); // remove the attribute so we don't trigger the modal twice on the next click

      $(e.currentTarget).removeAttr('data-modal-type');
      e.preventDefault();
    });
    peUI.bus.on(peUI.bus.EVENTS.OFFER.OPEN_OFFER_DETAILS, function (data) {
      offerDetailsUrl = data.url;
    });
    peUI.bus.on(peUI.bus.EVENTS.OFFERS_CONTAINER.UPDATE_OFFERS + ' ' + peUI.bus.EVENTS.OFFERS_CONTAINER.UPDATE_SPECIAL_OFFERS, function (data) {
      $(offerDetailsLinksSelector).off('click', handleOfferDetailsClick).on('click', handleOfferDetailsClick); // set height of offer cards

      setOfferCardHeight();
    });
    peUI.bus.on(peUI.bus.EVENTS.FORM.UPDATE_DROPDOWNS, function () {
      var numOfDropdowns = $('select').length;

      if (selectsLoaded === numOfDropdowns) {
        onPaymentUpdate();
      }
    });
  };

  return {
    initPe: initPe
  };
}();
"use strict";

var PressReleases = function () {
  Utility.log('PressReleases.js loaded');
  var pressReleaseClass = 'article.press-releases-page';
  var $pressReleases = $(pressReleaseClass);
  var debounce;

  function init() {
    $pressReleases.each(function (i, el) {
      // Set up Listeners.
      $(el).on('selectBoxOptionChanged', submitFEFDebounce); // Init classes on select options.

      $('.acr-select-box-options li', $(el)).removeClass('selected');
      $('.acr-select-box-options', $(el)).each(function (idx, elem) {
        $('li', $(elem)).first().addClass('selected');
      }); // Set min height so that custom select boxes won't get cut off

      setMinHeight(el);
      $(el).on('selectBoxOptionShown', setMinHeightEvent);
      $(el).on('selectBoxOptionHidden', setMinHeightEvent);

      _attachResize();
    });
  }

  function submitFEFDebounce(e, inputElem) {
    e.stopPropagation();
    clearTimeout(debounce);
    debounce = setTimeout(submitFormElectionFilter.bind(this, e, inputElem), 250);
  }

  function submitFormElectionFilter(e, inputElem, selectBoxName, selectBoxValue) {
    e.stopPropagation(); // update correct form element with new value.

    $('form[name="formElectionFilter"] input[name="' + selectBoxName + '"]', $(this)).val(selectBoxValue); // get all values from form and submit.

    var year = $('form[name="formElectionFilter"] input[name="year"]', $(this)).val();
    var keywords = $('form[name="formElectionFilter"] input[name="keywords"]', $(this)).val();
    var rssFeedCategory = $('form[name="formElectionFilter"] #select-list-category > ul > li.selected > span', $(this)).data('rssfeedcategory');
    var pageNum = $('form[name="formElectionFilter"] input[name="pageNum"]', $(this)).val();

    if (window.location.hostname === 'localhost') {
      console.log('Localhost: simulate call to getViewData(' + year + ', ' + keywords + ', ' + rssFeedCategory + ', ' + pageNum + ')');
    } else {
      try {
        // this function should already exist in C# template.
        getViewData(year, keywords, rssFeedCategory, pageNum);
      } catch (e) {
        console.log(e);
      }
    }
  }

  function setMinHeightEvent(evt) {
    setMinHeight(evt.currentTarget);
  }

  function setMinHeight(el) {
    var $el = $(el);
    var prHeight = $el.height();
    var maxSelectBoxHeight = 0;
    $('.acr-select-box', $el).each(function (i, el) {
      if ($(el).height() > maxSelectBoxHeight) {
        maxSelectBoxHeight = $(el).height();
      }
    });
    var maxSelectOptionsHeight = 0;
    var optionExpanded = false;
    $('.acr-select-box-options', $el).each(function (i, el) {
      if ($(el).height() > maxSelectOptionsHeight) {
        maxSelectOptionsHeight = $(el).height();
      }

      if ($(el).attr('aria-expanded') === 'true') {
        optionExpanded = true;
      }
    });
    var prMinHeight = 0;

    if (optionExpanded) {
      prMinHeight = prHeight - maxSelectBoxHeight + maxSelectOptionsHeight;
    }

    $el.css('min-height', prMinHeight + 'px');
  }

  function _attachResize() {
    $(window).on('resize', _onResize);
  }

  function _onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(_resize, 250);
  }

  function _resize() {
    $pressReleases.each(function (i, el) {
      setMinHeight(el);
    });
  }

  return {
    init: init
  };
}();
"use strict";

var RaqTool = function () {
  Utility.log('RaqTool loaded');
  var disclaimerTimeout = null;

  var initDealerInfo = function initDealerInfo() {
    var $prefDlrInput = $('input#isPreferredInput');

    var handlePrefDlrStatus = function handlePrefDlrStatus($input) {
      var $prefDlrLabel = $input.closest('label[for=isPreferredInput]');

      if ($input.prop('checked')) {
        $prefDlrLabel.addClass('is-preferred');
        $input.addClass('is-preferred');
      } else {
        $prefDlrLabel.removeClass('is-preferred');
        $input.removeClass('is-preferred');
      }
    };

    var wrapPhoneNbr = function wrapPhoneNbr() {
      // wraps phone number in <span> tag to support brand-styling
      var $phoneLink = $('.raq-dealer-info .raq-dealer-info-detail.phone > a');

      if ($phoneLink.length > 0) {
        var $icon = $phoneLink.find('i').clone();
        var phoneStr = $phoneLink.text().trim();
        var $phoneSpan;

        if (phoneStr) {
          $phoneSpan = $('<span>' + phoneStr + '</span>');
          $phoneLink.empty('').append($icon);
          $phoneLink.append($phoneSpan);
        }
      }
    }; // Call function on initial page-load.


    handlePrefDlrStatus($prefDlrInput); // Listen to ALL preferred-dealer checkbox clicks.
    // Some pages will have this checkbox not only on the page, but
    // also in RAQ modal (opened via on-page CTAs).

    $(document.body).on('change', 'input#isPreferredInput', function (e) {
      // console.log('Preferred-Dealer input changed!  event object:...');
      // console.log(e);
      handlePrefDlrStatus($(e.originalEvent.target));
    });
    setTimeout(function () {
      wrapPhoneNbr();
    }, 1500);
  }; // Convert RAQ disclaimers to ACR ready (For standalone version)


  var buildDisclaimers = function buildDisclaimers() {
    var disclaimers = document.querySelectorAll('raq-wrapper sup.disclaimer');
    var currDisclaimer;

    for (var i = 0; i < disclaimers.length; i++) {
      currDisclaimer = disclaimers[i];
      var copy = currDisclaimer.getAttribute('description');
      var title = currDisclaimer.getAttribute('title');
      currDisclaimer.setAttribute('data-copy', copy);
      currDisclaimer.setAttribute('data-title', title);
      currDisclaimer.setAttribute('data-number', currDisclaimer.innerText);
      currDisclaimer.setAttribute('data-target', '#acura-disclaimer');
      currDisclaimer.classList.add('acr-sup');
    }
  };

  var initDisclaimers = function initDisclaimers() {
    clearTimeout(disclaimerTimeout);
    disclaimerTimeout = setTimeout(buildDisclaimers, 1000);
  }; // BEGIN initForms functions


  var initForms = function initForms(scope) {
    var queryScope = scope && typeof scope === 'string' ? scope + ' ' : '';
    var raqForm = $(queryScope + '.raq-form');
    customizeSelects(raqForm);
    attachFormListeners(raqForm);

    if ($('html').hasClass('ie11')) {
      // IE11 doesn't support pseudo-element with svg background-image.
      // Need add a label after checkboxes to support custom-styling.
      insertLabel(raqForm.find('input[type="checkbox"][name="terms"]'));
    }
  };

  var handleCustomDropdownPrompt = function handleCustomDropdownPrompt($nativeSelect) {
    // console.log('[RaqTool.js] handleCustomDropdownPrompt() called!');
    // handle any required custom-dropdown's .select-box-prompt (add/remove red asterisk)
    var regexKey = $nativeSelect.data('regexkey');

    if (regexKey) {
      if (regexKey === 'simplyRequired') {
        var $parent = $nativeSelect.parent();
        var $clone = $nativeSelect.next('.acr-select-box-cloned');
        var $clonePrompt = $clone.find('.select-box-prompt');
        $clonePrompt.addClass('required');
        $clonePrompt.addClass('acr-paragraph-8');
        $parent.on('selectBoxOptionHidden', function () {
          // console.log('[RaqTool.js] handleCustomDropdownPrompt(): selectBoxOptionHidden evt fired!');
          if ($nativeSelect.val() !== '') {
            $clonePrompt.removeClass('required');
          } else {
            $clonePrompt.addClass('required');
          }
        });
      }
    }
  };

  var customizeSelects = function customizeSelects($form) {
    $form.find('select').each(function () {
      var $currSelect = $(this);
      var currSelectId = $currSelect.attr('id');
      var currSelector = '#' + $form.attr('id') + ' #' + currSelectId;

      if (currSelectId !== 'state') {
        SelectBox.createSelect(currSelector, undefined, 'raq-form-class');
      } else {
        SelectBox.createSelect(currSelector, function () {
          // console.log('[RaqTool.js] customizeSelects(): selectBox callback called!');
          setTimeout(function () {
            handleCustomDropdownPrompt($currSelect);
          }, 500);
        }, 'raq-form-class');
      }
    });
  };

  var insertLabel = function insertLabel($field, labelText) {
    // inserts label after field element passed in.
    // get/set field ID
    var fieldId = $field.attr('id');
    var $label;

    if (!fieldId) {
      $field.attr('id', $field.attr('name'));
      fieldId = $field.attr('id');
    } // insert <label> if none exists before/after $field.


    if ($field.prev('label').length === 0 && $field.next('label').length === 0) {
      $label = $('<label for="' + fieldId + '"></label>');

      if (labelText) {
        $label.text(labelText);
      } else {
        // without label-text, add classhook to enable css vertical-alignment.
        $label.addClass('no-text');
      }

      $field.after($label);
    }
  };

  var stateCheckInterval = null;
  var statePrevValue = '';

  var checkStateChange = function checkStateChange($stateSelect) {
    // Runs on setInterval (stateCheckInterval above).
    // If State gets changed, change custom-dropdown selection.
    // Clear/reset interval when User makes selection -- this method should only update
    // custom-dropdown for dynamic selection by Gray-tool code.
    var stateCurrValue = $stateSelect.val();

    if (stateCurrValue !== statePrevValue) {
      // console.log('[RaqTool.js] checkStateChange(): State value changed to ' + stateCurrValue);
      var $clone = $stateSelect.next('.acr-select-box-cloned');
      var $cloneOptions = $clone.find('.acr-select-box-options');
      var $cloneOptionSpan = $cloneOptions.find('ul li span[data-value="' + stateCurrValue + '"]');
      var $clonePrompt = $clone.find('.acr-select-box-top-wrapper .select-box-prompt');
      SelectBox.selectOption($clone, $cloneOptions, $cloneOptionSpan, false);
      statePrevValue = stateCurrValue; // handle $clonePrompt required classhook (red asterisk)

      if (stateCurrValue === '') {
        $clonePrompt.addClass('required');
      } else {
        $clonePrompt.removeClass('required');
      } // console.log('[RaqTool.js] checkStateChange(): State custom-dropdown selection updated to ' +
      //   stateCurrValue);

    }
  };

  var handleUserStateSelection = function handleUserStateSelection($nativeSelectParent) {
    // Clears/resets stateCheckInterval above when User (not Gray-tool code) makes State selection.
    var $stateSelect = $nativeSelectParent.find('select#state');
    $nativeSelectParent.on('selectBoxOptionShown', function (e) {
      // console.log('[RaqTool.js] handleUserStateSelection(): selectBoxOptionShown event fired!');
      if (stateCheckInterval !== null) {
        clearInterval(stateCheckInterval);
        stateCheckInterval = null;
      }
    });
    $nativeSelectParent.on('selectBoxOptionHidden', function () {
      // console.log('[RaqTool.js] handleUserStateSelection(): selectBoxOptionHidden event fired!');
      setTimeout(function () {
        if (stateCheckInterval === null) {
          statePrevValue = $stateSelect.val();
          stateCheckInterval = setInterval(function () {
            checkStateChange($stateSelect);
          }, 250);
        }
      }, 500);
    });
  };

  var attachFormListeners = function attachFormListeners($form) {
    $('input', '.raq-form').on('focus', onFocus);
    $('input', '.raq-form').on('blur', onBlur); // Listen indirectly for dynamic State selection by gray-tool script.

    stateCheckInterval = setInterval(function () {
      checkStateChange($('select#state', $form));
    }, 250); // Handle stateCheckInterval clear/reset when User makes State selection.

    handleUserStateSelection($('.raq-form-box.state', $form));
  };

  var onFocus = function onFocus(e) {
    $(this).addClass('acr-not-empty');
  };

  var showHidePlaceholder = function showHidePlaceholder($input) {
    if ($input.val()) {
      $input.addClass('acr-not-empty');
    } else {
      $input.removeClass('acr-not-empty');
    }
  };

  var onBlur = function onBlur(e) {
    showHidePlaceholder($(e.target));
  }; // END initForms functions
  // BEGIN initRaq functions


  var stubScriptsFound = false;
  var stubScriptsRAQFound = false;

  var initRaq = function initRaq(modalSelector) {
    stubScriptsFound = false;
    stubScriptsRAQFound = false;
    var stubScripts = ' stubScriptsSection ';
    var stubScriptsRAQ = ' stubScriptsSectionRAQ ';
    var contents = document.querySelector(modalSelector);
    var nodes = contents.childNodes; // console.log('contents: ', contents);
    // console.log('nodes: ', nodes);

    for (var i = 0; i <= nodes.length; ++i) {
      if (nodes[i] && nodes[i].nodeType === 8 && nodes[i].nodeValue.toString() === stubScripts && !stubScriptsFound) {
        stubScriptsFound = true;
        getScript(nodes[i].nextSibling, i, nodes);
      } else if (nodes[i] && nodes[i].nodeType === 8 && nodes[i].nodeValue.toString() === stubScriptsRAQ && !stubScriptsRAQFound) {
        stubScriptsRAQFound = true;
        getScript(nodes[i].nextSibling, i, nodes);
      }
    }
  };

  var getScript = function getScript(node, position, nodes) {
    var i = 0;

    if (node.attributes && node.attributes[0] && node.attributes[0].nodeValue === 'text/javascript') {
      appendScript(node);
    } else {
      for (i = position; i <= nodes.length; ++i) {
        if (nodes[i].attributes && nodes[i].attributes[0] && nodes[i].attributes[0].nodeValue === 'text/javascript') {
          appendScript(nodes[i]);
          break;
        }
      }
    }
  };

  var appendScript = function appendScript(script) {
    var domBody = null;
    var domScript = null;
    domBody = document.querySelector('body');
    domScript = document.createElement('script');
    domScript.setAttribute('type', 'text/javascript');
    domScript.innerHTML = script.innerHTML;
    domBody.appendChild(domScript);
    domBody.removeChild(domScript); // console.log('domScript.innerHTML: ', domScript);

    if (stubScriptsFound && stubScriptsRAQFound) {
      // Init RAQ-UI app after scripts were injected on host page
      startRaq();
    }
  };

  function addresCompleted() {
    showHidePlaceholder($('.raq-form input[name=city]'));
  }

  var startRaq = function startRaq() {
    var sitecoreExpEditor = !!(window.Sitecore && window.Sitecore.WebEditSettings && window.Sitecore.WebEditSettings.editing);

    if (!window.BaP) {
      sessionStorage.removeItem('bapAccessories');
    }

    if (window['raq-ui'] && window['raq-ui'].init && !sitecoreExpEditor) {
      var raqUI = window['raq-ui'].init();
      hideUntilFetched();
      initForms();
      initDisclaimers();
      raqUI.bus.on(raqUI.bus.EVENTS.FORM.ADDRESS_AUTOCOMPLETED, addresCompleted);
    }
  };

  var hideUntilFetched = function hideUntilFetched() {
    $('body').addClass('is-loading'); // we have no event to know when RAQ is loaded so using a timeout to prevent
    //  the flashing issue on load

    setTimeout(function () {
      $('.modal-raq .modal-content, offers-modal-wrapper.modal-raq .ui-modal-container ').css('display', 'block');
      $('body').removeClass('is-loading');
      $('body').addClass('modal-open');
    }, 500);
  }; // END initRaq functions


  $(window).on('ar.closemodal', function () {
    $('.modal-raq .modal-content').removeAttr('style');
  });
  return {
    initDealerInfo: initDealerInfo,
    initForms: initForms,
    initRaq: initRaq,
    initDisclaimers: initDisclaimers
  };
}();
"use strict";

var RequestBrochure = function () {
  var $requestBrochureSelector;
  var $formPanelSelector;
  var $successPanelSelector;
  var $errorMessageSelector;
  var $spinnerOverlaySelector;
  var configurationItem;
  var brochureTrackingObject;
  Utility.log('RequestBrochure.js loaded');

  function serviceHandler(serviceData) {
    var data = JSON.parse(serviceData);

    if (data.Status) {
      $formPanelSelector.addClass('hidden');
      $successPanelSelector.removeClass('hidden');
    } else {
      $errorMessageSelector.removeClass('hidden');
    }

    $spinnerOverlaySelector.addClass('hidden');
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = {
      firstName: form.elements.firstName.value,
      lastName: form.elements.lastName.value,
      addressLineOne: form.elements.addressFirstLine.value,
      addressLineTwo: form.elements.addressSecondLine.value,
      city: form.elements.city.value,
      state: form.elements.state.value,
      zipcode: form.elements.zipCode.value,
      email: form.elements.email.value,
      model: form.dataset.model,
      terms: form.elements.terms.checked,
      brochureCode: form.dataset.brochurecd,
      interestId: form.dataset.interestid,
      configurationItem: configurationItem
    };
    $.ajax({
      data: JSON.stringify(data),
      method: 'POST',
      async: true,
      contentType: 'application/json; charset=utf-8',
      error: function error(data) {
        serviceHandler(data);
      },
      success: function success(data) {
        serviceHandler(data);
        submitSuccessTrackingPageload();
        Acr.TrackingManager.restorePageLoadObject();
      },
      url: action
    });
  }

  function submitHandler(event) {
    var success = Validation.validateForm(event);

    if (success) {
      $spinnerOverlaySelector.removeClass('hidden');
      sendData(event.target);
    }

    event.preventDefault();
    return false;
  } // submit Tracking pageload on brochure form success


  function submitSuccessTrackingPageload() {
    Acr.trackingObject.Page.page_name += ' success';

    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad();
    }
  }

  function selectEvent(event) {
    if (event.target.value !== '') {
      $(event.target).addClass('rab-form__select--selected');
    } else {
      $(event.target).removeClass('rab-form__select--selected');
    }
  }

  function attachEvents() {
    // Call events when new email input changes
    $requestBrochureSelector.find('input').on('focus', Validation.onFocus).on('blur', Validation.onBlur); // Call the Submit Form Method

    $requestBrochureSelector.submit(function (event) {
      $errorMessageSelector.addClass('hidden');
      submitHandler(event);
      event.preventDefault();
      event.stopImmediatePropagation();
    });
    $requestBrochureSelector.find('select').change(function (event) {
      selectEvent(event);
    });
  }

  function getQuerySelectors() {
    $requestBrochureSelector = $('.js-request-brochure');
    $formPanelSelector = $('.js-form-panel');
    $successPanelSelector = $('.js-success-panel');
    $errorMessageSelector = $('.js-server-message');
    $spinnerOverlaySelector = $('.js-spinner-overlay');
    brochureTrackingObject = $('[data-tracking-script]');
  }

  function getData() {
    configurationItem = $formPanelSelector.find('.js-configuration-item').text();
  }

  function init() {
    getQuerySelectors();

    if ($requestBrochureSelector.length > 0) {
      getData();
      attachEvents();
    }
  }

  return {
    init: init
  };
}();
"use strict";

var ResponsiveTable = function ($) {
  var flag = false;
  var delay = 400;
  var $wrapper = $('.wrapper');
  var $tableRow = $('.responsive-table tbody tr');
  var $tableMobileHeader = $('.responsive-table-header-mobile ul li');
  var $tableCol = $('.responsive-table tbody > ' + 'tr.responsive-table-body:nth-child(2) td');
  var widhtFirstColumnBody = $('.responsive-table-static tbody > ' + '.responsive-table-body:visible .responsive-table-fixed-column').width() - 8;

  function init(stickyHeader) {
    var initStickyHeader = stickyHeader !== undefined ? stickyHeader : true;
    flag = false;
    delay = 400;
    $tableRow = $('.responsive-table tbody tr');
    $tableMobileHeader = $('.responsive-table-header-mobile ul li');
    $tableCol = $('.responsive-table tbody > ' + 'tr.responsive-table-body:nth-child(2) td');
    widhtFirstColumnBody = $('.responsive-table-static tbody > ' + '.responsive-table-body:visible .responsive-table-fixed-column').width() - 8;
    $('.responsive-table-info').each(function () {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
        var spanToChange = $(this).find('span');
        $(spanToChange).css('display', 'block');
      }

      $(this).on('click', function (e) {
        var anchor = this;
        e.preventDefault();
        $(this).attr('href', '#');
        $.get($(this).data('href') + '?stub=1', function (data) {
          var $collapseContent = $('#' + $(anchor).attr('aria-controls') + ' .collapse-content').get(0);
          $collapseContent.innerHTML = data;
          setTimeout(function () {
            $('#' + $(anchor).attr('aria-controls')).collapse('toggle');

            if ($('html').hasClass('ie')) {
              setTimeout(waitImage, 400, $($collapseContent));
            } else {
              Acr.Disclaimer.init();
            }
          }, 200);
        });
      });
      $(this).on('mousedown', function (e) {
        var href = $(this).data('href');

        if (e.which === 3) {
          $(this).attr('href', href);
        }
      });
    });
    $tableRow.find('td.col-1').show().addClass('active');
    $tableMobileHeader.eq(0).addClass('active');
    $tableMobileHeader.on('click', function (event) {
      if (!flag && !$(this).hasClass('active')) {
        $('li').removeClass('active');
        $(this).addClass('active');
        toggleColumn($(this).index());
        flag = true;
      }

      if ($('.responsive-table-detail .collapse.in')) {
        $('.responsive-table-detail .collapse').collapse('hide');
      }
    });
    var resizeFunc = Utility.debounce(function () {
      widhtFirstColumnBody = $('.responsive-table-static tbody > ' + '.responsive-table-body:visible .responsive-table-fixed-column').width() - 8;
      removeAttrStyle(); // scrollTitleSticky();

      widthFirstColumnSubcategory();
    }, 10);
    $(window).resize(resizeFunc);

    if (initStickyHeader === true) {
      $(window).scroll({
        elementLabel: 'window'
      }, $.throttle(100, scrollHandler));
      $('.modal-body').scroll({
        elementLabel: 'modal-body'
      }, $.throttle(100, scrollHandler));
    }

    countCol();
    closeDetails();
    toggleAccordion();

    if (!window.ActiveXObject && 'ActiveXObject' in window) {
      waitImage($('.table.responsive-table-static thead'), false);
    }
  } // init END


  function scrollHandler(event) {
    Utility.log('SCROLLING: throttle(250) from ResponsiveTable (' + event.data.elementLabel + ')');
    scrollHeaderSticky(); // scrollTitleSticky();
  }

  function scrollDestroy() {
    $(window).off('scroll', scrollHandler);
    $('.modal-body').off('scroll', scrollHandler);
  }

  function countCol() {
    var colCount = 0;
    $tableCol.each(function () {
      colCount++;
    });
    $('.responsive-table-colspan').attr('colspan', colCount);
  }

  function closeDetails() {
    $tableRow.find('.responsive-table-detail-close').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $collapse = $this.closest('.collapse');
      $collapse.collapse('toggle');
    });
  }

  function hideCol(target) {
    $(target).removeClass('active');
    $(target).fadeOut(delay);
  }

  function removeAttrStyle() {
    if ($(window).width() > 550) {
      $tableRow.find('td').removeAttr('style');
    }
  }

  function scrollHeaderSticky() {
    var itIsPresent = $(document).find('.responsive-table-static thead');

    if (itIsPresent.length > 0) {
      var headerHeight = $('.responsive-table-static thead').height();
      var headerPosition = $('.responsive-table-static thead').position().top;
      var scrollWindowTop = $(window).scrollTop();
      var tablePositionTop = $('.responsive-table-static').position().top;
      var tableHeight = $('.responsive-table-static').height();
      var headerPositionWithoutModal = $('.responsive-table-static thead').offset().top - scrollWindowTop;
      var mlpNavHeight = $(document).find('.mlp-nav').outerHeight() - 1 || 0;
      var wraperHeight = $(document).find('.acr-nav__wrapper').outerHeight() - 1 || 0;
      var modalHeaderHeight = $('.modal-header').outerHeight();
      var negativeValueHeight = modalHeaderHeight ? -headerHeight : -(headerPositionWithoutModal + mlpNavHeight);
      var iOS = /iPad|iPhone|iPod|Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !window.MSStream;

      if ($('.responsive-table-static tbody > ' + '.responsive-table-body:visible').length > 0) {
        if ($('.modal-body .responsive-table').length > 0) {
          if (headerPosition < negativeValueHeight) {
            if (iOS) {
              var stickyHeader = $('.responsive-table-header-sticky-container');
              $('.modal-content').append(stickyHeader);
              $('.responsive-table-header-sticky-container').css({
                display: 'block',
                position: 'fixed',
                left: 0,
                'max-height': '100px',
                top: modalHeaderHeight
              });
              $('.acr-trim-header').css({
                opacity: 0
              });
            } else {
              $('.responsive-table-header-sticky-container').css({
                display: 'block',
                left: 0,
                top: modalHeaderHeight
              });
              $('.acr-trim-header').css({
                opacity: 0
              });
            }

            widthFirstColumnSubcategory();
          } else {
            $('.responsive-table-header-sticky-container').css('display', 'none');
            $('.acr-trim-header').css({
              opacity: 1
            });
          }
        } else if (headerPositionWithoutModal <= negativeValueHeight) {
          if ($wrapper.hasClass('expanded-nav')) {
            $('.responsive-table-header-sticky-container').css({
              display: 'block',
              top: mlpNavHeight + wraperHeight
            });
          } else {
            $('.responsive-table-header-sticky-container').css({
              display: 'block',
              top: mlpNavHeight
            });
          }

          if (scrollWindowTop >= tablePositionTop + tableHeight) {
            $('.responsive-table-header-sticky-container').css('display', 'none');
          }

          $('.acr-trim-header').css({
            opacity: 0
          });
          widthFirstColumnSubcategory();
        } else {
          $('.responsive-table-header-sticky-container').css('display', 'none');
          $('.acr-trim-header').css({
            opacity: 1
          });
        }
      } else {
        $('.responsive-table-header-sticky-container').css('display', 'none');
        $('.acr-trim-header').css({
          opacity: 1
        });
      }
    } else {
      scrollDestroy();
    }
  }

  function scrollTitleSticky() {
    var scrollWindowTop = $(window).scrollTop();
    var buttonData = $('.responsive-table-title-accordion h4.active');
    var elementPosition = 0;
    var subtraction = 0;
    var $grandparentElement = '';
    var stickyHeaderHeight = $('.responsive-table-header-sticky-container').outerHeight();
    var headerHeight = $('.responsive-table-static thead').height();
    var negativeValueHeight = -headerHeight;
    $.each(buttonData, function (k, v) {
      elementPosition = $(v).position().top;
      subtraction = elementPosition - scrollWindowTop;
      $grandparentElement = $(v).parents('.responsive-table-title-accordion');

      if (subtraction <= 0 && !$grandparentElement.hasClass('fixed')) {
        $('.responsive-table-title-accordion').removeClass('fixed');
        $grandparentElement.addClass('fixed').css('top', stickyHeaderHeight);
      } else if (subtraction >= negativeValueHeight && $grandparentElement.hasClass('fixed')) {
        $grandparentElement.removeClass('fixed');
      }
    });
  }

  function showCol(target) {
    $(target).addClass('active');
    $(target).css({
      opacity: 0,
      display: 'table-cell'
    });
    $(target).animate({
      opacity: 1
    }, delay);
    setTimeout(function () {
      flag = false;
    }, delay + 1);
  }

  function toggleAccordion() {
    var $button = $('.responsive-table-title-accordion-link');
    var buttonData = '';
    var $firstAnchor = $('.responsive-table-title-accordion').eq(0).find('h4');
    $('.responsive-table-body, .responsive-table-detail').hide();

    if ($firstAnchor.hasClass('expanded')) {
      $firstAnchor.addClass('active');
      buttonData = $firstAnchor.data('section');
      $('.' + buttonData).removeAttr('style');
    }

    $button.off('click').on('click', function (e) {
      buttonData = $(this).find('h4').data('section');

      if ($(e.target).closest('.disclaimer-callout').length === 0) {
        if ($('tr.' + buttonData).is(':visible')) {
          $('tr.' + buttonData).hide();
          $(this).find('h4').removeClass('active');
        } else {
          $(this).find('h4').addClass('active');
          $('.' + buttonData).removeAttr('style');
        }
      }
    });
    $button.eq(0).trigger('click');
  }

  function toggleColumn(index) {
    var indexCol = index + 1;
    var targetCol = $tableRow.find('td.active');
    var target = $tableRow.find('td.col-' + indexCol);
    hideCol(targetCol);
    setTimeout(function () {
      showCol(target);
    }, delay);
  }

  function widthFirstColumnSubcategory() {
    var widhtFirstColumnBody = $('.responsive-table-static tbody > ' + '.responsive-table-body:visible .responsive-table-fixed-column').width();
    var widthTable = $('.responsive-table-static').width();
    $('.responsive-table-header-sticky').width(widthTable);
    $('.responsive-table-header-sticky thead tr ' + 'th.responsive-table-fixed-column').width(widhtFirstColumnBody);
  }

  function waitImage($collapseContent, useBP) {
    if ($collapseContent.find('img').length) {
      var src;
      var srcset;
      var newSrc;
      var breakPImages;
      var image = new Image();
      var bpCurrent = getCurrentBreakpoint();
      useBP = useBP !== undefined ? useBP : true;

      if (useBP) {
        switch (bpCurrent) {
          case 'sm':
            breakPImages = $collapseContent.find('source[media|="(min-width: 550px)"]');
            break;

          case 'lg':
            breakPImages = $collapseContent.find('source[media|="(min-width: 1024px)"]');
            break;

          case 'xl':
            breakPImages = $collapseContent.find('source[media|="(min-width: 1400px)"]');
            break;

          default:
            breakPImages = $collapseContent.find('img');
            break;
        }
      } else {
        breakPImages = $collapseContent.find('img');
      }

      srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');
      src = breakPImages.attr('src') || breakPImages.attr('data-src');
      newSrc = srcset ? srcset.split(',') : src.split(',');
      newSrc = newSrc[0];
      $collapseContent.find('img').attr('src', newSrc);

      image.onload = function () {
        Acr.Disclaimer.init();
      };

      image.src = newSrc;
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  return {
    init: init,
    destroy: scrollDestroy
  };
}(jQuery);
"use strict";

var SearchCTA = function () {
  var $context = $('.acr-search-cta');

  function init() {
    checkInitialValue();
    attachEvents();
  }

  function checkInitialValue() {
    $('input', $context).each(function (i, el) {
      var $inputElem = $(el);

      if ($inputElem.val().length > 0) {
        $inputElem.addClass('acr-not-empty');
        $inputElem.parents('.acr-search-cta').addClass('active');
      }
    });
  }

  function attachEvents() {
    $('input', $context).on('focus', function () {
      setActive(this);
    });
    $('input', $context).on('blur', function () {
      setActive(this);
    }); // Don't submit if form is empty.

    $('button[type="submit"]', $context).on('click', function (e) {
      var $matchingInput = $(e.currentTarget).parent().find('input[id="cta-search-term"]');

      if ($matchingInput.val().length === 0) {
        e.preventDefault();
      }
    });
  }

  function setActive(elem) {
    var $parentContext = $(elem).parents('.acr-search-cta');

    if ($(elem).hasClass('acr-not-empty')) {
      $parentContext.addClass('active');
    } else {
      $parentContext.removeClass('active');
    }
  }

  return {
    init: init
  };
}();
"use strict";

var SelectBox = function () {
  var Utility = window.Utility;
  Utility.log('SelectBox.js loaded');
  var selectBoxClass = '.acr-select-box';
  var $selectBoxes = $(selectBoxClass);
  var selectOptionsClass = '.acr-select-box-options';
  var maxOptions = 10; // Default maximum number of options for non-scrollable dropdown.
  // @param scrollable: boolean - controls if we add the jquery scrollbar
  // @param callback (optional): function

  function init(nativeSelectId, scrollable, callback) {
    setUpListeners(); // AR-12539. When we go to an article and return to the page, we want the
    // select options to return to previous values.

    setTimeout(function () {
      checkForInitialValue();

      if (scrollable) {
        makeScrollable(nativeSelectId, callback);
      } else if (typeof callback === 'function') {
        callback();
      }
    }, 500);
  }

  function setUpListeners() {
    $('html').on('click', function (e) {
      $(selectBoxClass).trigger('htmlClick', e);
    });
    $(selectBoxClass).each(function (i, el) {
      $(el).on('htmlClick', htmlClick);
      $('.acr-select-box-options ul li', $(el)).on('click', selectListOptionEvent);
      $('.acr-select-box-options svg', $(el)).on('click', clickCloseSVG);

      if (Utility.isIOS()) {
        // Workaround for Boostrap's own listener not working in IOS.
        $('.acr-select-box-button.collapsed', $(el)).on('click', function (e) {
          var $this = $(e.originalEvent.target);
          $this.removeClass('collapsed');
          $this.closest('.acr-select-box-wrapper').find('.acr-select-box-options').addClass('in');
        });
      }

      $('.acr-select-box-options').on('shown.bs.collapse', optionsShownEvent);
      $('.acr-select-box-options').on('hidden.bs.collapse', optionsHiddenEvent);
    });
  }

  function checkForInitialValue() {
    $(selectBoxClass).each(function (i, el) {
      var id = $(selectOptionsClass, $(el)).attr('id');

      if (id && Utility.getCookie(id)) {
        setInitialValue(id, Utility.getCookie(id));
      }
    });
  }

  function setInitialValue(id, value) {
    var $optionsElem = $('#' + id);
    var $options = $('li', $optionsElem);
    $options.removeClass('selected'); // Find the span with the saved value and add class 'selected' to parent li.

    var $targetSpan = $('span[data-value="' + value + '"]', $options);
    $targetSpan.closest('li').addClass('selected'); // Set the prompt to match the selected option

    var optionName = $targetSpan.html();
    var $selectBox = $targetSpan.closest(selectBoxClass);
    $('.select-box-prompt', $selectBox).html(optionName);
  }

  function htmlClick(evt, sourceEvt) {
    evt.stopPropagation();

    if (!thisOrChild(evt.target, sourceEvt.target)) {
      handleClickOutside(evt.target);
    }
  }

  function thisOrChild(elem, compElem) {
    if (compElem === elem || $(compElem).parentsUntil(elem).parent()[0] === $(elem)[0]) {
      return true;
    }

    return false;
  }

  function handleClickOutside(selectBox) {
    collapseSelectOptions(selectBox);
  }

  function collapseSelectOptions(selectBox) {
    $(selectOptionsClass, $(selectBox)).collapse('hide');
  }

  function makeScrollable(nativeSelectId, callback
  /* optional */
  ) {
    var $nativeSelect = $('select#' + nativeSelectId);
    var $parent = $nativeSelect.parent();
    var $cloneOptions = $nativeSelect.next('.acr-select-box-cloned').find('.acr-select-box-options');
    $parent.one('selectBoxOptionShown', function () {
      $cloneOptions.addClass('scrollable');
    });

    if (typeof callback === 'function') {
      callback();
    }
  }

  function selectListOptionEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    var parentSelectBoxOptions = $(e.target).closest(selectOptionsClass);
    var target = $('span', $(e.currentTarget));
    selectOption(parentSelectBox, parentSelectBoxOptions, target, true);
  }

  function selectOption(parentSelectBox, parentSelectBoxOptions, target, isUserClick) {
    var newVal = $(target).data('value'); // Set input value

    $('input', $(parentSelectBox)).val(newVal); // Change selected option

    $('li', $(parentSelectBox)).removeClass('selected');
    $(target).parent().addClass('selected');
    $('.select-box-prompt', $(parentSelectBox)).html($(target).html()); // Close select options

    collapseSelectOptions(parentSelectBox);

    if ($('input', $(parentSelectBox)).length > 0) {
      // save current select value state for return to page
      Utility.setCookie(parentSelectBoxOptions.attr('id'), newVal); // Notify parent that select change happened (so it can submit form / handle)

      notifyParentOfChange(parentSelectBox);
    } // If this is a clone of a native dropdown, and
    // custom-dropdown selection is by User-click (not by custom-code), then
    // Update native dropdown value with new selected value


    var $clone = target.closest('.acr-select-box-cloned');

    if ($clone.length > 0 && isUserClick) {
      updateNativeDropdown($clone, newVal);
    }
  } // only runs if there's an <input> in the parent container


  function notifyParentOfChange(parentSelectBox) {
    // Let the parent element know that a select option has changed
    // and pass it the input element with the new value.
    var inputElem = $('input', $(parentSelectBox))[0];
    var selectBoxName = inputElem.name;
    var selectBoxValue = inputElem.value;
    $(parentSelectBox).parent().trigger('selectBoxOptionChanged', inputElem, selectBoxName, selectBoxValue);
  }

  function clickCloseSVG(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).parentsUntil(selectBoxClass).parent();
    collapseSelectOptions(parentSelectBox);
  }

  function optionsShownEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    $(parentSelectBox).parent().trigger('selectBoxOptionShown', e);
  }

  function optionsHiddenEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    $(parentSelectBox).parent().trigger('selectBoxOptionHidden', e);
  } // @param $clone: DOM element (the dropdown container)
  // @param newVal: string (the new dropdown value)


  var updateNativeDropdown = function updateNativeDropdown($clone, newVal) {
    var id = $clone.attr('data-id');
    var $nativeDropdown = $('#' + id);
    var onChangeEvent = null; // "new Event" throws error on IE

    try {
      onChangeEvent = new Event('change');
    } catch (error) {
      onChangeEvent = document.createEvent('Event');
      onChangeEvent.initEvent('change', false, false);
    } // update the native dropdown's value then trigger a change event


    $nativeDropdown.val(newVal);
    $nativeDropdown[0].dispatchEvent(onChangeEvent);
  }; // this function is for replacing existing dropdowns with the non-native style
  // @param selector: css selector (the dropdown to be replaced)
  // @param maxOptionsOverride (optional): maximum nbr of options for a non-scrollable dropdown, if not 10
  // @param callback (optional): function to run after this method completes.
  // @param fontClass (optional): function to replace default font (acr-tab-small)


  var createSelect = function createSelect(selector, callback, fontClass) {
    // we'll need the ID to setup the bootstrap dropdowns
    var id = $(selector).attr('id');
    var defaultFontClass = 'acr-label-3';

    if (fontClass) {
      defaultFontClass = fontClass;
    }

    if (id) {
      var $dropdown = $(selector); // create a list of all the <option>s inside the select

      var itemList = returnList($dropdown); // find which <option> is selected

      var activeItem = $.grep(itemList, function (e) {
        return e.selected === 'selected';
      }); // if no <option> is selected default to first

      activeItem = activeItem.length > 0 ? activeItem[0] : itemList[0];
      var template = '<div class="acr-select-box acr-select-box-cloned" data-id="' + id + '">' + '<div class="acr-select-box-top-wrapper">' + '<div class="acr-select-box-button collapsed" data-target="#' + id + '-clone" data-toggle="collapse" aria-expanded="false" aria-controls="' + id + '-clone">' + '<span class="select-box-prompt ' + defaultFontClass + '">' + activeItem.text + '</span>' + '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-down"></use></svg>' + '</div>' + '</div>' + '<div id="' + id + '-clone" aria-expanded="false" class="acr-select-box-options collapse">' + '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-down"></use></svg>' + '<ul>' + returnListAsString(itemList) + '</ul>' + '</div>' + '</div>';
      var newContainer = document.createElement('div');
      $dropdown.hide(); // add our HTML to our placeholder div then inject into the page

      $(newContainer).html(template);
      $dropdown.after(template); // reinit so the asynchronously added dropdowns start working

      var scrollable = itemList.length - 1 > maxOptions;
      init(id, scrollable, callback);
    }
  }; // @param list: array of objects (list of value/text pairings for the <option> elements)


  var returnListAsString = function returnListAsString(list) {
    var string = '';

    for (var i = 0; i < list.length; i++) {
      string += '<li class="' + list[i].selected + '">';
      string += '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#checkmark"></use></svg>';
      string += '<span class="acr-paragraph-6" data-value="' + list[i].value + '">' + list[i].text + '</span></li>';
    }

    return string;
  }; // @param element: DOM element (the native <select> being replaced)


  var returnList = function returnList(element) {
    var items = [];
    $('option', element).each(function () {
      var thisItem = {
        value: $(this)[0].value,
        text: $(this).text(),
        selected: $(this)[0].getAttribute('is-selected') === 'selected' ? 'selected' : ''
      };
      items.push(thisItem);
    });
    return items;
  };

  return {
    init: init,
    createSelect: createSelect,
    setInitialValue: setInitialValue,
    selectOption: selectOption
  };
}();
"use strict";

Acr = window.Acr || {};

Acr.SignUpForEmails = function (window, $) {
  var DeepLink;
  var $context = $('.acr-sign-up-form-emails');
  var contextId = $context.attr('id');
  var sectionPadding = -40;
  var trackingSubmitObject = {
    'Event Metadata': {
      action_category: 'mlp newsletter',
      action_type: 'cta'
    },
    dynamic_variables: [{
      key_name: 'action_label',
      parent: 'Event Metadata',
      search: '[page_name]:newsletter:submit',
      type: 'dynamicName'
    }, {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle'
    }]
  };
  var $form = $('form', $context);

  var attachEvents = function attachEvents() {
    var regExp = /[a-z]/i;
    $form.on('submit', onSubmit);
    $('input', $form).on('keypress', Validation.onKeypress).on('keyup', Validation.onKeyup).on('focus', Validation.onFocus).on('blur', Validation.onBlur);
    $('[name="PhoneNumber"]', $form).on('keyup', function () {
      // Phone number key up (format phone number)
      var $this = $(this);
      $this.val(Utility.formatPhone($this.val()));
    }).on('keydown', function (e) {
      // Phone number key down (no alpha characters allowed)
      var value = String.fromCharCode(e.which) || e.key; // No letters

      if (regExp.test(value)) {
        e.preventDefault();
        return false;
      }
    });
    $('.acr-show-form', $context).on('click', showForm);
  };

  var onSubmit = function onSubmit(e) {
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e);

    if (success) {
      sendSuccessTrackingObject(false);
      send(e.target);
    }

    e.preventDefault();
    return false;
  };

  var send = function send(form) {
    var data = Acr.CampaignManager.appendCampaignName($(form).serialize());
    var method = form.getAttribute('method');
    var action = form.getAttribute('action');
    $.ajax({
      beforeSend: function beforeSend() {
        $('.acr-sign-up-form-emails-content', $context).addClass('acr-hidden');
        $('.acr-sign-up-form-emails-processing', $context).css('display', 'block');
        DeepLink.inPageDeepLink(contextId, sectionPadding);
      },
      data: data,
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
      },
      method: method,
      success: function success(data) {
        if (data.Status === 'success') {
          sendSuccessTrackingObject(true);
        }

        var message = $('<div>').html(data.Message).text();
        $('.acr-sign-up-form-emails-processing', $context).css('display', 'none');
        $('.acr-sign-up-form-emails-message', $context).html(message);
        $('.acr-sign-up-form-emails-response', $context).css('display', 'block');
        DeepLink.inPageDeepLink(contextId, sectionPadding);
      },
      url: action
    });
  };

  var sendSuccessTrackingObject = function sendSuccessTrackingObject(isSuccess) {
    var object = JSON.parse(JSON.stringify(trackingSubmitObject));

    if (isSuccess) {
      object.dynamic_variables[0].search += ' success';
    }

    if (Acr.TrackingManager) {
      Acr.TrackingManager.clickActivity(object);
    }
  };

  var showForm = function showForm() {
    $('.acr-sign-up-form-emails-messges', $context).css('display', 'none');
    $('.acr-sign-up-form-emails-content', $context).removeClass('acr-hidden');
    $('input', $form).removeClass('acr-not-empty');
    $('form', $context)[0].reset();
    DeepLink.inPageDeepLink(contextId, sectionPadding);
  };

  var init = function init() {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    attachEvents();
  };

  return {
    init: init
  };
}(window, window.$);
"use strict";

var SlickOverride = function () {
  $.fn.slick.stopAuto = function () {
    var _ = this;

    $(this).on('click', '.slick-arrow, .slick-dots button', function (e) {
      var $slider = $(this).parents('.slick-initialized');
      $slider.slick('slickSetOption', 'autoplay', false, false);
    });
  };

  function init() {
    $.fn.slick.stopAuto();
  }

  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};

Acr.StayInformedForm = function () {
  var $element;
  var $input;
  var $form;
  var $processing;
  var $body;
  var $response;
  var $copy;
  var $messages;
  var $submitButton;
  var $contactDealerCheck;
  var $zipInput;
  var processingClass = '.acr-stay-informed__processing';
  var bodyClass = '.acr-stay-informed__body';
  var copyClass = '.acr-stay-informed__copy';
  var responseClass = '.acr-stay-informed__response';
  var messagesClass = '.acr-stay-informed__messages';
  var showFormBtn = '.js-show-form';
  var submBtn = '.acr-stay-informed__btn';
  var contactDealerCheck = '.acr-stay-informed__contact-dealer-checkbox';
  var zipInput = '.acr-stay-informed__input[name="ZipCode"]';
  var requiredClass = 'acr-required';
  var requiredAttr = 'required';
  var errorTextClass = '.acr-stay-informed__error';
  var errorStateClass = 'acr-form-element-error';

  function showForm() {
    $messages.hide();
    $body.show();
    $form.reset();
  }

  var sendSuccessTrackingObject = function sendSuccessTrackingObject(isSuccess) {
    var stringObject = $submitButton.attr('data-form-submit-tracking') ? $submitButton.attr('data-form-submit-tracking') : '';

    if (Acr.TrackingManager && stringObject) {
      try {
        var object = JSON.parse(stringObject.split("'").join('"'));

        if (isSuccess && object) {
          object.dynamic_variables[0].search += ' success';
        }

        Acr.TrackingManager.clickActivity(object);
      } catch (err) {
        console.warn('ERROR AT TRACKING OBJECT: ' + err);
      }
    }
  };

  function send(form) {
    var data;
    var method;
    var action;
    data = Acr.CampaignManager.appendCampaignName($(form).serialize());
    method = form.getAttribute('method');
    action = form.getAttribute('action');
    $.ajax({
      beforeSend: function beforeSend() {
        $processing.show();
        $body.hide();
      },
      data: data,
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
      },
      method: method,
      success: function success(data) {
        var message;

        if (data.Status === 'success') {
          sendSuccessTrackingObject(true);
        }

        message = $('<div>').html(data.Message).text();
        $processing.hide();
        $copy.html(message);
        $response.show();

        if ($response.length !== 0) {
          var $window = $(window);
          var elementTop = $response.offset().top;
          var elementHeight = $response.height();
          var viewportHeight = $window.height();
          var scrollIt = elementTop - (viewportHeight - elementHeight) / 2;
          $window.scrollTop(scrollIt);
        }
      },
      url: action
    });
  }

  function onSubmit(e) {
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e);

    if (success) {
      sendSuccessTrackingObject(false);
      send(e.target);
    }

    e.preventDefault();
    return false;
  }

  function toogleZipCodeRequired(e) {
    var checkbox = e.target;

    if (checkbox.checked && $zipInput && !$zipInput.hasClass(requiredClass)) {
      $zipInput.addClass(requiredClass);
      $zipInput.attr(requiredAttr, requiredAttr);
    } else if ($zipInput) {
      $zipInput.removeClass(requiredClass);
      $zipInput.removeAttr(requiredAttr);
      $zipInput.siblings(errorTextClass).html('');
      $zipInput.parent().removeClass(errorStateClass);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $input = $element.find('input');
    $form = $element.find('form');
    $processing = $element.find(processingClass);
    $body = $element.find(bodyClass);
    $copy = $element.find(copyClass);
    $response = $element.find(responseClass);
    $messages = $element.find(messagesClass);
    $submitButton = $(element).find(submBtn);
    $contactDealerCheck = $(element).find(contactDealerCheck);
    $zipInput = $(element).find(zipInput);
  }

  function bindEvents(element) {
    initSelectors(element);
    $($input, $form).on('keypress', Validation.onKeypress).on('keyup', Validation.onKeyup).on('focus', Validation.onFocus).on('blur', Validation.onBlur);
    $form.on('submit', onSubmit);
    $contactDealerCheck.change(toogleZipCodeRequired);
  }

  function init(element) {
    bindEvents(element);
  }

  return {
    init: init
  };
};
"use strict";

var StyleGuide = function () {
  Utility.log('styleGuideSlider js loaded');
  var $styleguideSlick = $.noop;

  function init() {
    setSlick();
    hideGhostUnderHeading();
  }

  function setSlick() {
    $styleguideSlick = $('.styleguide-slider').slick({
      autoplay: true,
      cssEase: 'linear',
      dots: true,
      infinite: true,
      nextArrow: '<svg class="acr-icon slick-prev slick-arrow"' + ' viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink"' + ' xlink:href="#arrow-left">' + ' </use></svg>',
      prevArrow: '<svg class="acr-icon slick-next slick-arrow"' + ' viewBox="0 0 26 26">' + '<use xmlns:xlink="http://www.w3.org/1999/xlink"' + ' xlink:href="#arrow-right">' + '</use></svg>',
      speed: 200,
      useTransform: true,
      variableWidth: true
    });
  }

  function hideGhostUnderHeading() {
    // if there is no text in .acr-heading > h6, hide .acr-heading so we don't get the red underline (.acr-underheading, child of .acr-heading) when there is no text to be underlined.
    var $acrHeading = $('.acr-heading');
    var $acrUnderheading = null;
    $acrHeading.each(function (index, element) {
      var $headingText = $('h6', $(element));

      if ($headingText && $headingText.html() !== undefined && $headingText.html().length === 0) {
        $acrUnderheading = $('.acr-underheading', $(element));

        if ($acrUnderheading !== undefined) {
          $acrUnderheading.css('display', 'none'); // if it's under a parent div of class "mlp-shopping-tools-title"
          // hide that parent as well.

          var $parentElement = $(element).parents('.mlp-shopping-tools-title');

          if ($parentElement) {
            $parentElement.css('display', 'none');
          }
        }
      }
    });
  }

  return {
    init: init
  };
}();
"use strict";

var SubHeroPage = function () {
  var $stackedHeroes;

  function init() {
    $stackedHeroes = $('.acr-sub-page-hero-stacked');
    $(document).off('SubHeroPage/imageLoad', imageLoad).on('SubHeroPage/imageLoad', imageLoad); // Unfortunately, the image sometimes don't get the resize instruction
    // so we need to call this every so often

    setInterval(imageLoad, 1000);
  }

  function imageLoad() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      $stackedHeroes.each(function (i, hero) {
        $(hero).css({
          zoom: '1',
          'background-image': '',
          height: 'auto'
        });
      });
    }
  }

  return {
    init: init
  };
}();
"use strict";

var TextSVGTiles = function () {
  var Utility = window.Utility || {};
  Utility.log('TextSVGTiles.js loaded');

  function numDivs() {
    var myDivs = $('.svg-tiles .acr-tools');
    var myDivsLast = $('.svg-tiles .acr-tools:last-child');
    var myDivsNth3 = $('.svg-tiles .acr-tools:nth-child(3n)');
    var countDivs = $(myDivs).length;

    if (countDivs === 2) {
      myDivs.addClass('col-xs-12 col-xs-push-6');
    } else if (countDivs === 3) {
      myDivs.addClass('col-xs-12');
    } else if (countDivs === 4) {
      myDivs.addClass('col-xs-12 col-xs-push-6');
      myDivsNth3.css('clear', 'both');
    } else if (countDivs === 5) {
      myDivs.addClass('col-xs-12');
      $(myDivsLast).prev('.acr-tools').andSelf().addClass('col-xs-push-6');
    } else if (countDivs === 6) {
      myDivs.addClass('col-xs-12');
    }
  }

  function init() {
    numDivs();
  }

  return {
    init: init
  };
}();
"use strict";

(function (window, $) {
  var Utility = window.Utility || {};
  var Acr = window.Acr || {};
  Utility.log('ThreeSixty.js loaded');

  Acr.threeSixty = function () {
    var mainContainer = $('.acr-threesixty-small');
    var galleriesContainer = mainContainer.find('.galleries-container');
    var buttonsTabContainer = mainContainer.find('.color-selector .row.buttons');
    var buttonsColorsContainer = mainContainer.find('.color-selector');
    var buildCTAs = mainContainer.find('.build-n-price .acr-cta-btn');
    var activeGallery = true;
    var btnClass = 'btn-color-select';
    var colorName = 'color-name';
    var pClass = 'previous-image';
    var currentClass = 'current-image';
    var ext = '.jpg';
    var aspectW = 16;
    var aspectH = 9;
    var defaultTotalFrames = 72;
    var isActive = 'is-active';
    var prevCur = 'acr-threesixty-small-prev-current';
    var dButtons = '.btn-display-selector';
    var lazyClass360 = 'lazy-360';
    var lazyClassPano = 'lazy-pano';
    var observerOptions = {
      root: null,
      rootMargin: window.innerHeight / 2 + 'px'
    };

    function Gallery(gallery) {
      this.id = gallery.name.replace(/\s/g, '_');
      this.colorId = 0;
      this.name = gallery.name;
      this.type = gallery.type;
      this.framePerGallery = gallery.frames ? parseInt(gallery.frames, 10) : defaultTotalFrames;
      this.vehicles = gallery.vehicles;
      this.disclaimer = gallery.disclaimer;
      this.activeGallery = '';
      this.ldImages = 0;
      this.frames = [];
      this.galleryContainer = '';
      this.imagesContainer = '';
      this.colorsContainer = '';
      this.spinner = '';
      this.threesixtyIcon = '';
      this.selectedFrame = 0;
      this.lWinW = 0;
      this.pointerStartPosX = 0;
      this.pointerEndPosX = 0;
      this.dragging = false;
      this.ready = false;
      this.monitorStartTime = 0;
      this.monitorInt = 10;
      this.pDist = 0;
      this.sPd = 10; // Speed

      this.cFrame = 0;
      this.eFrame = 0;
      this.ticker = 0;
      this.isLoaded = false;
      var oThis = this;

      if (activeGallery) {
        activeGallery = false;
        this.activeGallery = 'is-active';
      }

      this.initialize = function () {
        this.addTabBtnChangeGallery();
        this.addColorBtnsAndDisclaimer();

        if (this.type === 'iframe') {
          this.initIframe();
        } else if (this.type === 'pano') {
          this.initPano();
        } else {
          this.initThreesixty();
        }
      };

      this.initThreesixty = function () {
        this.addThreesixtyDom();
        this.loadImage(0);
        this.attachListeners();
        this.selectGalleryListener();
      };

      this.initIframe = function () {
        this.addIframeDom();
        this.imagesContainer.attr({
          src: this.vehicles[0].baseUrl
        });
        this.setSizes();
        this.setColorName(0);
        this.attachIntListeners();
        this.selectGalleryListener();
      };

      this.initPano = function () {
        this.addPanoDom();
        var panoUrl = galleriesContainer.data('panohtml');
        this.setSizes();
        this.setColorName(0);
        this.attachPanoListeners();
        this.selectGalleryListener();
      };

      this.attachIntListeners = function () {
        var that = this;
        this.colorsContainer.on('click', '.btn-color-select', function (e) {
          var selected = $(this).data('item');
          e.preventDefault(); // This function doesn't exist anywhere! Commenting for now,
          // probably can be removed next time this file needs an update
          // that.updateInterior(selected);

          that.setColorName(selected);
        });
        $(window).on('resize', that.resizeHandler);
      };

      this.attachPanoListeners = function () {
        var that = this;
        this.colorsContainer.on('click', '.btn-color-select', function (e) {
          var selected = $(this).data('item');
          e.preventDefault();

          if (that.colorId !== selected) {
            window.pano.readConfigUrlAsync(that.vehicles[selected].baseUrl);
            that.setColorName(selected);
          }
        });
        $(window).on('resize', that.resizeHandler);
      };

      this.addIframeDom = function () {
        var templateIframe = '<div class="iframe360 ' + this.id + ' item ' + this.activeGallery + ' "><iframe id="iframeSpin-' + this.id + '" /></div>';
        galleriesContainer.append(templateIframe);
        this.galleryContainer = galleriesContainer.find('.iframe360.' + this.id);
        this.imagesContainer = galleriesContainer.find('#iframeSpin-' + this.id);
        this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
      };

      this.addPanoDom = function () {
        var that = this;
        var templateIframe = '<div class="pano360 ' + this.id + ' item ' + lazyClassPano + ' ' + this.activeGallery + ' "></div>';
        galleriesContainer.append(templateIframe);
        this.galleryContainer = galleriesContainer.find('.pano360.' + this.id);
        $.ajax({
          url: galleriesContainer.data('panohtml'),
          type: 'GET',
          dataType: 'html',
          xhrFields: {
            withCredentials: true
          },
          success: function success(resp) {
            that.galleryContainer.html(resp);
            window.pano.setBasePath(galleriesContainer.data('absolute-url'));
            that.initLazyLoadingPano();
          },
          error: function error(xhr, ajaxOptions, thrownError) {
            console.log(xhr.status);
            console.log(xhr.responseText);
          }
        });
        this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
      };

      this.selectGalleryListener = function () {
        var toggleTimeout;
        var that = this;
        buttonsTabContainer.on('click', '[data-target="' + this.id + '"]', function (event) {
          event.preventDefault();

          if (!$(this).hasClass(isActive)) {
            var target = $(this).data('target');
            clearTimeout(toggleTimeout);
            $(dButtons).removeClass(isActive);
            $(this).addClass(isActive);
            galleriesContainer.find('.item').removeClass(isActive);
            buttonsColorsContainer.find('.item').removeClass(isActive);
            galleriesContainer.find('.' + target).addClass(isActive);
            buttonsColorsContainer.find('.' + target).addClass(isActive); // If the pano wasn't loaded on component load is reloaded with the current selected color

            if (target.toLowerCase() === 'interior' && !that.isLoaded) {
              that.isLoaded = true;
            }

            toggleTimeout = setTimeout(function () {
              that.resizeHandler();
            }, 500);
          }
        });
      };

      this.attachListeners = function () {
        var that = this;
        this.galleryContainer.mousedown(function (event) {
          event.preventDefault();
          that.pointerStartPosX = that.getPointerEvent(event).pageX;
          that.dragging = true;
        });
        this.galleryContainer.mouseup(function (event) {
          event.preventDefault();
          that.dragging = false;
        });
        this.galleryContainer.mousemove(function (event) {
          event.preventDefault();
          that.trackPointer(event);
        });
        this.galleryContainer.on('touchstart', function (event) {
          that.pointerStartPosX = that.getPointerEvent(event).pageX;
          that.dragging = true;
        });
        this.galleryContainer.on('touchmove', function (event) {
          that.trackPointer(event);
        });
        this.galleryContainer.on('touchend', function (event) {
          event.preventDefault();
          that.dragging = false;
        });
        this.colorsContainer.on('click', '.btn-color-select', function (e) {
          var selected = $(this).data('item');
          e.preventDefault();
          that.frames = [];
          that.eFrame = 0;
          that.ldImages = 0;
          that.clearContainer();
          that.loadImage(selected);
          that.setColorName(selected);
        });
        $(window).on('resize', that.resizeHandler);
      }; // Handling window resize event


      this.resizeHandler = function () {
        oThis.setSizes();
      }; // Cleaning DOM elements when changing colors


      this.clearContainer = function () {
        var $current;
        this.spinner.fadeIn();
        $current = this.imagesContainer.find('li .current-image').parent('li');
        $current.addClass(prevCur);
        this.imagesContainer.find('li:not(.' + prevCur + ')').remove();
      };

      this.trackPointer = function (event) {
        var cLc;

        if (this.ready && this.dragging) {
          this.pointerEndPosX = this.getPointerEvent(event).pageX;

          if (this.monitorStartTime < new Date().getTime() - this.monitorInt) {
            this.pDist = this.pointerEndPosX - this.pointerStartPosX;
            cLc = Math.ceil((this.framePerGallery - 1) * this.sPd * (this.pDist / this.galleryContainer.width()));
            this.eFrame = this.cFrame + cLc;
            this.refresh();
            this.monitorStartTime = new Date().getTime();
            this.pointerStartPosX = this.getPointerEvent(event).pageX;
          }
        }
      };

      this.refresh = function () {
        this.renderFrame();
      };

      this.renderFrame = function () {
        var deft;
        var ease;

        if (this.cFrame !== this.eFrame) {
          deft = Math.ceil((this.eFrame - this.cFrame) * 0.1);
          ease = this.eFrame < this.cFrame ? Math.floor((this.eFrame - this.cFrame) * 0.1) : deft;
          this.hidePreviousFrame();
          this.cFrame += ease;
          this.showCFrame();
          this.selectedFrame = this.getCurrFrame();
        }
      };

      this.hidePreviousFrame = function () {
        this.frames[this.getCurrFrame()].removeClass(currentClass).addClass(pClass);
      };

      this.showCFrame = function () {
        this.frames[this.getCurrFrame()].removeClass(pClass).addClass(currentClass);
      };

      this.getCurrFrame = function () {
        var c = -Math.ceil(this.cFrame % this.framePerGallery);

        if (c < 0) {
          c += this.framePerGallery - 1;
        }

        return c;
      };

      this.getPointerEvent = function (event) {
        var e = event;
        var oE = e.originalEvent;
        return oE.targetTouches ? oE.targetTouches[0] : e;
      };

      this.addThreesixtyDom = function () {
        var templateThreeixty = '<div class="threesixty ' + this.id + ' item ' + this.activeGallery + ' "><ol class="threesixty-images ' + lazyClass360 + ' " ' + 'id="threesixty_images"></ol><div class="spinner"><div ' + 'class="animated-spinner"></div></div><div ' + 'class="threesixty-icon"><svg ' + 'viewBox="0 0 45 20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#360-arrows"></use></svg></div></div>';
        galleriesContainer.append(templateThreeixty);
        this.galleryContainer = galleriesContainer.find('.threesixty.' + this.id);
        this.imagesContainer = this.galleryContainer.find('.threesixty-images');
        this.spinner = this.galleryContainer.find('.spinner');
        this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
        this.threesixtyIcon = this.galleryContainer.find('.threesixty-icon');
      }; // Adding + Loading images based on provided DATA


      this.loadImage = function (index) {
        var that;
        var li;
        var imageN;
        var image;

        if (this.vehicles[index]) {
          that = this;
          li = document.createElement('li');
          imageN = this.vehicles[index].baseUrl + ('0' + (this.ldImages + 1)).slice(-2) + ext;
          image = $('<img>').attr({
            'data-src': imageN,
            'data-index': that.ldImages,
            alt: this.vehicles[index].colorName
          }).addClass(pClass).appendTo(li);
          this.frames.push(image);
          this.imagesContainer.append(li);
          that.imageLoaded(index);
          $(image).load(function () {
            if ($(this).attr('data-index') === that.selectedFrame) {
              that.spinner.fadeOut(500);
            }
          });
        }
      };

      this.setSizes = function () {
        var containerWidth;
        var newHeight;

        if (window.innerWidth !== this.lWinW) {
          this.lWinW = window.innerWidth;
          containerWidth = galleriesContainer.width();
          newHeight = aspectH / aspectW * containerWidth;
          this.galleryContainer.height(newHeight);
        }
      }; // Checking loaded images against total images to start 360


      this.imageLoaded = function (index) {
        var that = this;
        this.ldImages += 1;

        if (this.ldImages === this.framePerGallery) {
          this.frames[this.selectedFrame].removeClass(pClass).addClass(currentClass);
          this.setColorName(index);
          that.initLazyLoading360();
          that.setSizes();
          that.showThreeSixty();
        } else {
          this.loadImage(index);
        }
      }; // Updating color name text based on selection


      this.setColorName = function (i) {
        var selectedColorConfig = this.vehicles[i];
        var configurationType = this.name.toLowerCase();
        this.colorId = i;
        this.colorsContainer.find('.' + this.id + '.' + colorName + ' .text').text(selectedColorConfig.colorName);
        this.setActiveButton(i); // Updates the URL for the Build CTA

        if (selectedColorConfig.colorCode) {
          buildCTAs.each(function (index, item) {
            var url = $(item).attr('href');
            $(item).attr('href', Utility.updateQueryStringParameter(url, configurationType, selectedColorConfig.colorCode));
          });
        }
      }; // Updating active color button based on selection


      this.setActiveButton = function (i) {
        this.colorsContainer.find('.' + btnClass).removeClass(isActive);
        this.colorsContainer.find('[data-item="' + i + '"]').addClass(isActive);
      }; // Showing 360 when all is ready


      this.showThreeSixty = function () {
        var that = this;
        this.imagesContainer.fadeIn('slow', function () {
          that.imagesContainer.find('.' + prevCur).remove();
        });
        this.ready = true;
      };

      this.addTabBtnChangeGallery = function () {
        var trackingData = $('.color-selector .threesixty-tabs').attr('data-tab-tracking');
        var trackingAttribute = '';

        if (trackingData) {
          trackingAttribute = 'data-tracking="' + trackingData + '"';
        }

        var btn = '<a href="#" ' + trackingAttribute + ' class="acr-label-3 tab-button ' + 'btn-display-selector ' + this.activeGallery + '" data-target="' + this.id + '">' + this.name + '</a>';
        buttonsTabContainer.append(btn);
      };

      this.addColorBtnsAndDisclaimer = function () {
        var buttons = '<div class="' + this.id + ' item color-swatches ' + this.activeGallery + ' ">';
        buttons += '<div class="text-container">' + '<div class="' + this.id + ' ' + colorName + '">' + '<strong class="text"></strong>' + '</div>';

        if (this.disclaimer) {
          buttons += '<div class="gallery-disclaimer">' + this.disclaimer + '</div>';
        }

        buttons += '</div><div class="color-buttons">';
        $.each(this.vehicles, function (index) {
          buttons += '<a href="#" class="' + btnClass;
          buttons += '" title="' + this.colorName;
          buttons += '" data-name="' + this.colorName;
          buttons += '" data-item="' + index;
          buttons += '" style="' + (this.colorSwatch.indexOf('/') >= 0 ? 'background-image: url(' + this.colorSwatch + ')' : 'background-color: ' + this.colorSwatch + '') + '">';
          buttons += '<svg viewBox="0 0 200 200">';
          buttons += '<use xmlns:xlink="http://www.w3.org/1999/xlink"';
          buttons += ' xlink:href="#checkmark"></use></svg></a>';
        });
        buttons += '</div></div>';
        buttonsColorsContainer.append(buttons);
      };

      this.addLazy360 = function (element) {
        var elementChildren = [].slice.call(element.querySelectorAll('img'));
        elementChildren.forEach(function (elementChild) {
          elementChild.src = elementChild.dataset.src;
        });
      };

      this.addLazyPano = function () {
        var galleries;
        var baseUrl;
        galleries = [].slice.call(document.querySelectorAll('.acr-threesixty-small'));
        baseUrl = JSON.parse(galleries[0].dataset.galleries.replace(/[']/g, '"'))[1].vehicles[0].baseUrl;
        window.pano.readConfigUrlAsync(baseUrl);
      };

      this.initLazyLoading360 = function () {
        var that = this;
        var lazyElements360 = [].slice.call(document.querySelectorAll('.threesixty-images.' + lazyClass360));
        Utility.initLazyLoadingIO(lazyElements360, this.addLazy360);
      };

      this.initLazyLoadingPano = function () {
        var that = this;
        var lazyElementsPano = [].slice.call(document.querySelectorAll('.pano360.' + lazyClassPano));
        Utility.initLazyLoadingIO(lazyElementsPano, this.addLazyPano);
      };

      this.initialize();
    }

    function init() {
      var galleries;

      if (mainContainer.length) {
        galleries = mainContainer.data('galleries');

        if (galleries && galleries.length) {
          galleries = $.parseJSON(galleries.replace(/[']/g, '"'));
          galleries.forEach(function (gallery) {
            new Gallery(gallery);
          });
        }
      }
    }

    return {
      init: init
    };
  }();
})(window, $);
"use strict";

var Validation = function () {
  Utility.log('Validation.js loaded');
  var invalidValueText = 'Please enter a valid ';
  var errorsCount = 0;
  var numberPattern = '[0-9]';
  var a = [];
  var valueMissingMessage = 'Please fill out this field';

  function init() {
    validateForms();
    ios();
    checkEmpty();
  }

  function validateForms() {
    var formValidate = $('.acr-form-validate');
    var formValidateInput = formValidate.find('input');
    formValidate.on('submit', validateForm);
    formValidateInput.on('keypress', onKeypress);
    formValidateInput.on('keyup', onKeyup);
    formValidateInput.on('focus', onFocus);
    formValidateInput.on('blur', onBlur);
  }

  function validateForm(e) {
    errorsCount = 0;
    $('input, select, checkbox', e.target).each(validateField);

    if (errorsCount > 0) {
      $(this).addClass('acr-form-error');
      e.preventDefault();
      return false;
    }

    $(this).removeClass('acr-form-error');
    return true;
  }

  function validateField(index, element) {
    if (element.id === 'cta-search-term' || element.id === 'nav-search') {
      if (element.value.indexOf('<') > -1) {
        element.value = element.value.replace(/</g, '');
      }
    }

    var pattern = element.getAttribute('pattern');
    var modifier = element.dataset.patternModifier;
    var regExp = new RegExp(pattern, modifier);

    if (element.required || element.value.replace(/\s+/g, '').length > 0) {
      if (pattern && regExp.test(element.value) === false) {
        setError(element);
      } else if (!pattern && !element.validity.valid) {
        setError(element);
      } else {
        $(element).parents('.acr-form-element').removeClass('acr-form-element-error').children('.acr-error').text('');
      }
    }
  }

  function setError(element) {
    var errorText;

    if (element.validity.valueMissing) {
      errorText = element.dataset.missingText ? element.dataset.missingText : valueMissingMessage;
    }

    if (!errorText) {
      errorText = element.dataset.errorText;
    }

    if (!errorText) {
      errorText = invalidValueText;
      errorText += $(element).parents('.acr-form-element').children('label').text();
    }

    $(element).parents('.acr-form-element').addClass('acr-form-element-error').children('.acr-error').text('*' + errorText);
    errorsCount++;
  }

  function onKeypress(e) {
    var type = this.getAttribute('type');
    var maxlength = this.getAttribute('maxlength');
    var keyCode = e.keyCode ? e.keyCode : e.which;
    var char = String.fromCharCode(keyCode);
    var regExp;

    if (keyCode !== 8 && keyCode !== 13) {
      if (type === 'number') {
        regExp = new RegExp(numberPattern);

        if (maxlength && this.value.length > maxlength - 1 || e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) {
          e.preventDefault();
        }
      }

      if (regExp && !regExp.test(char)) {
        e.stopPropagation();
        e.preventDefault();

        if ($('html').hasClass('ie')) {
          var _this = this;

          setTimeout(function () {
            $(_this).val('');
          }, 300);
        }
      }
    }
  }

  function onKeyup(e) {
    var type = this.getAttribute('type');
    var maxlength = this.getAttribute('maxlength');
    var char = String.fromCharCode(e.keyCode);
    var regExp;

    if (e.keyCode !== 8 && e.keyCode !== 13) {
      if (type === 'number') {
        regExp = new RegExp(numberPattern);

        if ($('html').hasClass('appleios') && this.value === '') {
          this.value = '';
        }
      }
    }
  }

  function onFocus(e) {
    $(this).addClass('acr-not-empty');
  }

  function onBlur(e) {
    if (this.value.length === 0) {
      $(this).removeClass('acr-not-empty');
    }
  }

  function ios() {
    if ($('html').hasClass('appleios')) {
      $('input[type=number]').attr('pattern', '[0-9]*');
    }
  }

  function checkEmpty() {
    var $inputElements = $('.acr-error~input');
    $inputElements.each(function (index, element) {
      var $input = $(element);

      if ($input.val()) {
        $input.addClass('acr-not-empty');
      }
    });
  }

  function isValidEmail(email) {
    var regExp = new RegExp(/^[0-9a-zA-Z~!$%^&*_=+}{'?]+(\.[0-9a-zA-Z~!$%^&*_=+}{'?]+)*@([0-9a-zA-Z_][0-9a-zA-Z_]*(\.[0-9a-zA-Z_]+)*\.(AERO|aero|ARPA|arpa|BIZ|biz|COM|com|COOP|coop|EDU|edu|GOV|gov|INFO|info|INT|int|MIL|mil|MUSEUM|museum|NAME|name|NET|net|ORG|org|PRO|pro|TRAVEL|travel|Mobi|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/);
    return regExp.test(email);
  }

  return {
    init: init,
    invalidValueText: invalidValueText,
    validateForm: validateForm,
    onKeypress: onKeypress,
    onKeyup: onKeyup,
    onFocus: onFocus,
    onBlur: onBlur,
    isValidEmail: isValidEmail
  };
}();
"use strict";

(function (window, $) {
  window.Acr = window.Acr || {};
  var Acr = window.Acr;
  var Ut = window.Utility;

  Acr.boxParallax = function ($) {
    var parallaxSelector = '[data-box-parallax]';
    var pElSel = '[data-box-content]';
    var pElDOMRefI = {};
    var parallaxElements = [];
    var registeredAnimationFrames = [];
    var goParallax = !(Ut.isMobile() || Ut.isIE() || Ut.isTablet());
    var initialWidth;

    var init = function init() {
      initialWidth = window.innerWidth || document.documentElement.clientWidth;
      var cssSelector = parallaxSelector;
      clearAnimationFrames();
      $(window).off('scroll', addAnimationFrame);

      if ($(cssSelector).length) {
        var wProps = getwProps();
        pElDOMRefI = {};
        $(cssSelector).each(function (index, el) {
          var parallaxElement = {};
          parallaxElement.element = $(el);
          parallaxElements.push(parallaxElement);
          var $pEl = parallaxElement.element;
          $pEl.addClass('acr-box-parallax').children(pElSel).addClass('acr-box-parallax-element');
          pElDOMRefI[index] = $pEl.find(pElSel);

          if (goParallax) {
            moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
          }
        });
        $(window).resize(function (event) {
          var cW = window.innerWidth || document.documentElement.clientWidth;

          if (initialWidth !== cW) {
            initialWidth = cW;
            goParallax = true;
            var wProps = getwProps();
            $.each(parallaxElements, function (index, parallaxElement) {
              if (goParallax) {
                var $pEl = parallaxElement.element;
                moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
              }
            });
          }
        });

        if (goParallax) {
          $(window).scroll(addAnimationFrame);
        }
      }
    };

    var getElementBoundingRect = function getElementBoundingRect(Ele) {
      var rect = Ele[0].getBoundingClientRect();
      var win = window;
      var doc = document;
      var results = {
        rect: rect,
        inViewport: false
      };

      if (rect.bottom >= 0 && rect.top <= (win.innerHeight || doc.documentElement.clientHeight)) {
        results.inViewport = true;
      }

      return results;
    };

    var moveElement = function moveElement($pEl, wTop, wHeight) {
      var elementRect = getElementBoundingRect($pEl);

      if (elementRect.inViewport) {
        var bgBladeTopPos = $pEl.offset().top;
        var slashHeight = elementRect.rect.height;
        var bghHeight = slashHeight * 1.2;
        var maxOffset = slashHeight - bghHeight + 2;
        var bgSpeed = $pEl.data('box-speed') ? $pEl.data('box-speed') : 30;
        var doReverse = !!$pEl.data('box-reverse');
        bgSpeed = -Math.abs(bgSpeed);
        var offset = (wTop - bgBladeTopPos) / slashHeight * bgSpeed;
        offset = Math.max(offset, maxOffset);

        if (doReverse) {
          offset *= -1;
        }

        $pEl.css({
          transform: 'translate3d(0px,' + offset + 'px, 0px)'
        });
      }
    };

    var sHandler = function sHandler() {
      var wProps = getwProps();
      $.each(parallaxElements, function (index, parallaxElement) {
        if (goParallax) {
          moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
        }
      });
    };

    var addAnimationFrame = function addAnimationFrame() {
      registeredAnimationFrames.push(window.requestAnimationFrame(sHandler));
    };

    var getwProps = function getwProps() {
      return {
        wTop: $(window).scrollTop(),
        wHeight: $(window).height()
      };
    };

    var clearAnimationFrames = function clearAnimationFrames() {
      $.each(registeredAnimationFrames, function (index, requestID) {
        window.cancelAnimationFrame(requestID);
      });
      registeredAnimationFrames = [];
    };

    var destroy = function destroy() {
      parallaxElements = [];
      $(window).off('scroll', addAnimationFrame);
      clearAnimationFrames();

      if (pElDOMRefI) {
        $.each(pElDOMRefI, function (k, v) {
          pElDOMRefI[k] = null;
        });
        pElDOMRefI = null;
      }
    };

    return {
      init: init
    };
  }($);
})(window, jQuery);
"use strict";

Modernizr.addTest('ipad', function () {
  return !!navigator.userAgent.match(/iPad/i);
});
Modernizr.addTest('iphone', function () {
  return !!navigator.userAgent.match(/iPhone/i);
});
Modernizr.addTest('ipod', function () {
  return !!navigator.userAgent.match(/iPod/i);
});
Modernizr.addTest('android', function () {
  return !!navigator.userAgent.match(/android/i);
});
Modernizr.addTest('mac', function () {
  return !!navigator.userAgent.match(/Mac/i);
});
Modernizr.addTest('appleios', function () {
  return Modernizr.ipad || Modernizr.ipod || Modernizr.iphone;
});

var ie = function () {
  var rv = null; // Return value assumes failure.

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var trident = ua.indexOf('Trident/');

  if (msie > 0) {
    // IE 10 or older => return version number
    rv = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  } else if (trident > 0) {
    // IE 11 (or newer) => return version number
    var rvNum = ua.indexOf('rv:');
    rv = parseInt(ua.substring(rvNum + 3, ua.indexOf('.', rvNum)), 10);
  }

  return rv;
}();

Modernizr.addTest('ie', function () {
  return !!ie;
});
Modernizr.addTest('ie8', function () {
  return Modernizr.ie && ie === 8;
});
Modernizr.addTest('ie9', function () {
  return Modernizr.ie && ie === 9;
});
Modernizr.addTest('ie10', function () {
  return Modernizr.ie && ie === 10;
});
Modernizr.addTest('ie11', function () {
  return Modernizr.ie && ie === 11;
});

var isObjectFitSupported = function () {
  var isSupported = true;

  if ('objectFit' in document.documentElement.style === false) {
    isSupported = false;
  }

  return isSupported;
}();

Modernizr.addTest('objectfit', function () {
  return !!isObjectFitSupported;
});
Modernizr.addTest('chrome', function () {
  return !!navigator.userAgent.match(/chrome/i);
});
Modernizr.addTest('firefox', function () {
  return !!navigator.userAgent.match(/Firefox/i);
});

(function (Modernizr) {
  // Here are all the values we will test. If you want to use just one or two,
  // comment out the lines of test you don't need.
  var tests = [// False positive in IE, supports
  // SVG clip-path, but not on HTML element
  {
    name: 'svg',
    value: 'url(#test)'
  }, {
    name: 'inset',
    value: 'inset(10px 20px 30px 40px)'
  }, {
    name: 'circle',
    value: 'circle(60px at center)'
  }, {
    name: 'ellipse',
    value: 'ellipse(50% 50% at 50% 50%)'
  }, {
    name: 'polygon',
    value: 'polygon(50% 0%, 0% 100%, 100% 100%)'
  }];
  var t = 0;
  var name;
  var value;
  var prop;

  for (; t < tests.length; t++) {
    name = tests[t].name;
    value = tests[t].value;
    Modernizr.addTest('cssclippath' + name, function () {
      // Try using window.CSS.supports
      if ('CSS' in window && 'supports' in window.CSS) {
        for (var i = 0; i < Modernizr._prefixes.length; i++) {
          prop = Modernizr._prefixes[i] + 'clip-path';

          if (window.CSS.supports(prop, value)) {
            return true;
          }
        }

        return false;
      } // Otherwise, use Modernizr.testStyles and examine the property manually


      return Modernizr.testStyles('#modernizr { ' + Modernizr._prefixes.join('clip-path:' + value + '; ') + ' }', function (elem) {
        var style = getComputedStyle(elem);
        var clip = style.clipPath;

        if (!clip || clip === 'none') {
          clip = false;

          for (var j = 0; j < Modernizr._domPrefixes.length; j++) {
            var test = Modernizr._domPrefixes[j] + 'ClipPath';

            if (style[test] && style[test] !== 'none') {
              clip = true;
              break;
            }
          }
        }

        return Modernizr.testProp('clipPath') && clip;
      });
    });
  }
})(Modernizr);
"use strict";

var RichTextTableResponsive = function () {
  function init() {
    var $richTextTables = $('.rzf-gry-rich-text table');

    if ($richTextTables.length > 0) {
      $richTextTables.each(function () {
        var headerLabels = []; // gather headers and store them in the array

        $(this).find('thead tr th').each(function (index, value) {
          headerLabels.push(value.innerHTML);
        }); // gather rows

        var tableRows = $(this).find('tbody > tr'); // loop through each row

        tableRows.each(function () {
          var tableCells = $(this).children('td'); // assign data-label to each table cell in the current row

          tableCells.each(function (index) {
            $(this).attr('data-label', headerLabels[index]);
          });
        });
        /* $(this).find('tbody > tr > td').each(function(index, value) {
          console.log('this: ', $(this));
          console.log('index: ', index);
           $(this).attr('data-label', headerLabels[index]);
        }); */
      });
    }
  }

  return {
    init: init
  };
}();
"use strict";

var ToutThree = function () {
  // context argument added to allow function to be called with a scope on touts loaded asynchronously inside modals
  function init(context) {
    // only tier 3 touts are not children of an article.rzf-gry-tout
    var $tierThreeTouts = $('.rzf-gry-multi-column-container', context).find('.rzf-gry-tout-tile').parent(':not(.rzf-gry-tout)');
    $tierThreeTouts.each(function () {
      $(this).closest('.rzf-gry-multi-column-container').addClass('rzf-gry-tout-tier-3');
    });
  }

  return {
    init: init
  };
}();
"use strict";

var Acr = Acr || {};

Acr.Tooltip = function () {
  var utility = window.Utility;
  var $element;
  var $closeButton;
  var closeButton = '.js-close';

  function showTooltip() {
    $element.removeAttr('style');
  }

  function hideTooltip() {
    $element.hide();
  } // TODO: Remove jquery from this function


  function initZipcode() {
    var zipcode = utility.getUrlParameterValue('zipcode') || utility.getCookie('zipcode');

    if (!zipcode) {
      showTooltip();
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $closeButton = $element.find(closeButton);
  }

  function bindEvents() {
    $closeButton.click(hideTooltip);
    window.addEventListener('zipcodeUpdate', hideTooltip);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    initZipcode();
  }

  return {
    init: init
  };
};
"use strict";

/**
 * Looks for modules in the page and initialize them if they are ready.
 * @param {HTMLElement} $root [optional] Parent root to look for modules. If not given, uses the document.
 */
function initializeModules($root) {
  var jsModuleClass = 'js-module';
  var $parentNode = $root || document;
  var $modules = $parentNode.getElementsByClassName(jsModuleClass);
  var Acr = window.Acr || {};
  Acr.Modules = {};

  for (var modulesIndex = 0; modulesIndex < $modules.length; modulesIndex++) {
    var $module = $modules[modulesIndex];

    if ($module.dataset.moduleStarted !== 'true') {
      var loadModule = $module.dataset.moduleLoad;

      if (loadModule !== 'false') {
        var moduleName = $module.dataset.module;
        var moduleId = (modulesIndex + 1).toString();
        $module.dataset.moduleStarted = 'true';
        $module.dataset.moduleId = moduleId;

        if (moduleName) {
          var newModule = new Acr[moduleName]($module);

          if (newModule.init) {
            newModule.init($module);
            Acr.Modules[moduleId] = newModule;
          }
        }
      }
    }
  }
}
"use strict";function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}(window.webpackJsonp=window.webpackJsonp||[]).push([[0],{319:function _(e,t,i){e.exports=function(){"use strict";var e="undefined"==typeof document?{body:{},addEventListener:function addEventListener(){},removeEventListener:function removeEventListener(){},activeElement:{blur:function blur(){},nodeName:""},querySelector:function querySelector(){return null;},querySelectorAll:function querySelectorAll(){return[];},getElementById:function getElementById(){return null;},createEvent:function createEvent(){return{initEvent:function initEvent(){}};},createElement:function createElement(){return{children:[],childNodes:[],style:{},setAttribute:function setAttribute(){},getElementsByTagName:function getElementsByTagName(){return[];}};},location:{hash:""}}:document,t="undefined"==typeof window?{document:e,navigator:{userAgent:""},location:{},history:{},CustomEvent:function CustomEvent(){return this;},addEventListener:function addEventListener(){},removeEventListener:function removeEventListener(){},getComputedStyle:function getComputedStyle(){return{getPropertyValue:function getPropertyValue(){return"";}};},Image:function Image(){},Date:function Date(){},screen:{},setTimeout:function setTimeout(){},clearTimeout:function clearTimeout(){}}:window,i=function i(e){for(var t=0;t<e.length;t+=1){this[t]=e[t];}return this.length=e.length,this;};function s(s,a){var r=[],n=0;if(s&&!a&&s instanceof i)return s;if(s)if("string"==typeof s){var o,l,d=s.trim();if(d.indexOf("<")>=0&&d.indexOf(">")>=0){var h="div";for(0===d.indexOf("<li")&&(h="ul"),0===d.indexOf("<tr")&&(h="tbody"),0!==d.indexOf("<td")&&0!==d.indexOf("<th")||(h="tr"),0===d.indexOf("<tbody")&&(h="table"),0===d.indexOf("<option")&&(h="select"),(l=e.createElement(h)).innerHTML=d,n=0;n<l.childNodes.length;n+=1){r.push(l.childNodes[n]);}}else for(o=a||"#"!==s[0]||s.match(/[ .<>:~]/)?(a||e).querySelectorAll(s.trim()):[e.getElementById(s.trim().split("#")[1])],n=0;n<o.length;n+=1){o[n]&&r.push(o[n]);}}else if(s.nodeType||s===t||s===e)r.push(s);else if(s.length>0&&s[0].nodeType)for(n=0;n<s.length;n+=1){r.push(s[n]);}return new i(r);}function a(e){for(var t=[],i=0;i<e.length;i+=1){-1===t.indexOf(e[i])&&t.push(e[i]);}return t;}s.fn=i.prototype,s.Class=i,s.Dom7=i;var r={addClass:function addClass(e){if(void 0===e)return this;for(var t=e.split(" "),i=0;i<t.length;i+=1){for(var s=0;s<this.length;s+=1){void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.add(t[i]);}}return this;},removeClass:function removeClass(e){for(var t=e.split(" "),i=0;i<t.length;i+=1){for(var s=0;s<this.length;s+=1){void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.remove(t[i]);}}return this;},hasClass:function hasClass(e){return!!this[0]&&this[0].classList.contains(e);},toggleClass:function toggleClass(e){for(var t=e.split(" "),i=0;i<t.length;i+=1){for(var s=0;s<this.length;s+=1){void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.toggle(t[i]);}}return this;},attr:function attr(e,t){var i=arguments;if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var s=0;s<this.length;s+=1){if(2===i.length)this[s].setAttribute(e,t);else for(var a in e){this[s][a]=e[a],this[s].setAttribute(a,e[a]);}}return this;},removeAttr:function removeAttr(e){for(var t=0;t<this.length;t+=1){this[t].removeAttribute(e);}return this;},data:function data(e,t){var i;if(void 0!==t){for(var s=0;s<this.length;s+=1){(i=this[s]).dom7ElementDataStorage||(i.dom7ElementDataStorage={}),i.dom7ElementDataStorage[e]=t;}return this;}if(i=this[0])return i.dom7ElementDataStorage&&e in i.dom7ElementDataStorage?i.dom7ElementDataStorage[e]:i.getAttribute("data-"+e)||void 0;},transform:function transform(e){for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransform=e,i.transform=e;}return this;},transition:function transition(e){"string"!=typeof e&&(e+="ms");for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransitionDuration=e,i.transitionDuration=e;}return this;},on:function on(){for(var e,t=[],i=arguments.length;i--;){t[i]=arguments[i];}var a=t[0],r=t[1],n=t[2],o=t[3];function l(e){var t=e.target;if(t){var i=e.target.dom7EventData||[];if(i.indexOf(e)<0&&i.unshift(e),s(t).is(r))n.apply(t,i);else for(var a=s(t).parents(),o=0;o<a.length;o+=1){s(a[o]).is(r)&&n.apply(a[o],i);}}}function d(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),n.apply(this,t);}"function"==typeof t[1]&&(a=(e=t)[0],n=e[1],o=e[2],r=void 0),o||(o=!1);for(var h,p=a.split(" "),c=0;c<this.length;c+=1){var u=this[c];if(r)for(h=0;h<p.length;h+=1){var v=p[h];u.dom7LiveListeners||(u.dom7LiveListeners={}),u.dom7LiveListeners[v]||(u.dom7LiveListeners[v]=[]),u.dom7LiveListeners[v].push({listener:n,proxyListener:l}),u.addEventListener(v,l,o);}else for(h=0;h<p.length;h+=1){var f=p[h];u.dom7Listeners||(u.dom7Listeners={}),u.dom7Listeners[f]||(u.dom7Listeners[f]=[]),u.dom7Listeners[f].push({listener:n,proxyListener:d}),u.addEventListener(f,d,o);}}return this;},off:function off(){for(var e,t=[],i=arguments.length;i--;){t[i]=arguments[i];}var s=t[0],a=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(s=(e=t)[0],r=e[1],n=e[2],a=void 0),n||(n=!1);for(var o=s.split(" "),l=0;l<o.length;l+=1){for(var d=o[l],h=0;h<this.length;h+=1){var p=this[h],c=void 0;if(!a&&p.dom7Listeners?c=p.dom7Listeners[d]:a&&p.dom7LiveListeners&&(c=p.dom7LiveListeners[d]),c&&c.length)for(var u=c.length-1;u>=0;u-=1){var v=c[u];r&&v.listener===r||r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1)):r||(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1));}}}return this;},trigger:function trigger(){for(var i=[],s=arguments.length;s--;){i[s]=arguments[s];}for(var a=i[0].split(" "),r=i[1],n=0;n<a.length;n+=1){for(var o=a[n],l=0;l<this.length;l+=1){var d=this[l],h=void 0;try{h=new t.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0});}catch(t){(h=e.createEvent("Event")).initEvent(o,!0,!0),h.detail=r;}d.dom7EventData=i.filter(function(e,t){return t>0;}),d.dispatchEvent(h),d.dom7EventData=[],delete d.dom7EventData;}}return this;},transitionEnd:function transitionEnd(e){var t,i=["webkitTransitionEnd","transitionend"],s=this;function a(r){if(r.target===this)for(e.call(this,r),t=0;t<i.length;t+=1){s.off(i[t],a);}}if(e)for(t=0;t<i.length;t+=1){s.on(i[t],a);}return this;},outerWidth:function outerWidth(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"));}return this[0].offsetWidth;}return null;},outerHeight:function outerHeight(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"));}return this[0].offsetHeight;}return null;},offset:function offset(){if(this.length>0){var i=this[0],s=i.getBoundingClientRect(),a=e.body,r=i.clientTop||a.clientTop||0,n=i.clientLeft||a.clientLeft||0,o=i===t?t.scrollY:i.scrollTop,l=i===t?t.scrollX:i.scrollLeft;return{top:s.top+o-r,left:s.left+l-n};}return null;},css:function css(e,i){var s;if(1===arguments.length){if("string"!=typeof e){for(s=0;s<this.length;s+=1){for(var a in e){this[s].style[a]=e[a];}}return this;}if(this[0])return t.getComputedStyle(this[0],null).getPropertyValue(e);}if(2===arguments.length&&"string"==typeof e){for(s=0;s<this.length;s+=1){this[s].style[e]=i;}return this;}return this;},each:function each(e){if(!e)return this;for(var t=0;t<this.length;t+=1){if(!1===e.call(this[t],t,this[t]))return this;}return this;},html:function html(e){if(void 0===e)return this[0]?this[0].innerHTML:void 0;for(var t=0;t<this.length;t+=1){this[t].innerHTML=e;}return this;},text:function text(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1){this[t].textContent=e;}return this;},is:function is(a){var r,n,o=this[0];if(!o||void 0===a)return!1;if("string"==typeof a){if(o.matches)return o.matches(a);if(o.webkitMatchesSelector)return o.webkitMatchesSelector(a);if(o.msMatchesSelector)return o.msMatchesSelector(a);for(r=s(a),n=0;n<r.length;n+=1){if(r[n]===o)return!0;}return!1;}if(a===e)return o===e;if(a===t)return o===t;if(a.nodeType||a instanceof i){for(r=a.nodeType?[a]:a,n=0;n<r.length;n+=1){if(r[n]===o)return!0;}return!1;}return!1;},index:function index(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);){1===t.nodeType&&(e+=1);}return e;}},eq:function eq(e){if(void 0===e)return this;var t,s=this.length;return new i(e>s-1?[]:e<0?(t=s+e)<0?[]:[this[t]]:[this[e]]);},append:function append(){for(var t,s=[],a=arguments.length;a--;){s[a]=arguments[a];}for(var r=0;r<s.length;r+=1){t=s[r];for(var n=0;n<this.length;n+=1){if("string"==typeof t){var o=e.createElement("div");for(o.innerHTML=t;o.firstChild;){this[n].appendChild(o.firstChild);}}else if(t instanceof i)for(var l=0;l<t.length;l+=1){this[n].appendChild(t[l]);}else this[n].appendChild(t);}}return this;},prepend:function prepend(t){var s,a;for(s=0;s<this.length;s+=1){if("string"==typeof t){var r=e.createElement("div");for(r.innerHTML=t,a=r.childNodes.length-1;a>=0;a-=1){this[s].insertBefore(r.childNodes[a],this[s].childNodes[0]);}}else if(t instanceof i)for(a=0;a<t.length;a+=1){this[s].insertBefore(t[a],this[s].childNodes[0]);}else this[s].insertBefore(t,this[s].childNodes[0]);}return this;},next:function next(e){return this.length>0?e?this[0].nextElementSibling&&s(this[0].nextElementSibling).is(e)?new i([this[0].nextElementSibling]):new i([]):this[0].nextElementSibling?new i([this[0].nextElementSibling]):new i([]):new i([]);},nextAll:function nextAll(e){var t=[],a=this[0];if(!a)return new i([]);for(;a.nextElementSibling;){var r=a.nextElementSibling;e?s(r).is(e)&&t.push(r):t.push(r),a=r;}return new i(t);},prev:function prev(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&s(t.previousElementSibling).is(e)?new i([t.previousElementSibling]):new i([]):t.previousElementSibling?new i([t.previousElementSibling]):new i([]);}return new i([]);},prevAll:function prevAll(e){var t=[],a=this[0];if(!a)return new i([]);for(;a.previousElementSibling;){var r=a.previousElementSibling;e?s(r).is(e)&&t.push(r):t.push(r),a=r;}return new i(t);},parent:function parent(e){for(var t=[],i=0;i<this.length;i+=1){null!==this[i].parentNode&&(e?s(this[i].parentNode).is(e)&&t.push(this[i].parentNode):t.push(this[i].parentNode));}return s(a(t));},parents:function parents(e){for(var t=[],i=0;i<this.length;i+=1){for(var r=this[i].parentNode;r;){e?s(r).is(e)&&t.push(r):t.push(r),r=r.parentNode;}}return s(a(t));},closest:function closest(e){var t=this;return void 0===e?new i([]):(t.is(e)||(t=t.parents(e).eq(0)),t);},find:function find(e){for(var t=[],s=0;s<this.length;s+=1){for(var a=this[s].querySelectorAll(e),r=0;r<a.length;r+=1){t.push(a[r]);}}return new i(t);},children:function children(e){for(var t=[],r=0;r<this.length;r+=1){for(var n=this[r].childNodes,o=0;o<n.length;o+=1){e?1===n[o].nodeType&&s(n[o]).is(e)&&t.push(n[o]):1===n[o].nodeType&&t.push(n[o]);}}return new i(a(t));},filter:function filter(e){for(var t=[],s=0;s<this.length;s+=1){e.call(this[s],s,this[s])&&t.push(this[s]);}return new i(t);},remove:function remove(){for(var e=0;e<this.length;e+=1){this[e].parentNode&&this[e].parentNode.removeChild(this[e]);}return this;},add:function add(){for(var e=[],t=arguments.length;t--;){e[t]=arguments[t];}var i,a,r=this;for(i=0;i<e.length;i+=1){var n=s(e[i]);for(a=0;a<n.length;a+=1){r[r.length]=n[a],r.length+=1;}}return r;},styles:function styles(){return this[0]?t.getComputedStyle(this[0],null):{};}};Object.keys(r).forEach(function(e){s.fn[e]=s.fn[e]||r[e];});var n={deleteProps:function deleteProps(e){var t=e;Object.keys(t).forEach(function(e){try{t[e]=null;}catch(e){}try{delete t[e];}catch(e){}});},nextTick:function nextTick(e,t){return void 0===t&&(t=0),setTimeout(e,t);},now:function now(){return Date.now();},getTranslate:function getTranslate(e,i){var s,a,r;void 0===i&&(i="x");var n=t.getComputedStyle(e,null);return t.WebKitCSSMatrix?((a=n.transform||n.webkitTransform).split(",").length>6&&(a=a.split(", ").map(function(e){return e.replace(",",".");}).join(", ")),r=new t.WebKitCSSMatrix("none"===a?"":a)):s=(r=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===i&&(a=t.WebKitCSSMatrix?r.m41:16===s.length?parseFloat(s[12]):parseFloat(s[4])),"y"===i&&(a=t.WebKitCSSMatrix?r.m42:16===s.length?parseFloat(s[13]):parseFloat(s[5])),a||0;},parseUrlQuery:function parseUrlQuery(e){var i,s,a,r,n={},o=e||t.location.href;if("string"==typeof o&&o.length)for(r=(s=(o=o.indexOf("?")>-1?o.replace(/\S*\?/,""):"").split("&").filter(function(e){return""!==e;})).length,i=0;i<r;i+=1){a=s[i].replace(/#\S+/g,"").split("="),n[decodeURIComponent(a[0])]=void 0===a[1]?void 0:decodeURIComponent(a[1])||"";}return n;},isObject:function isObject(e){return"object"==_typeof(e)&&null!==e&&e.constructor&&e.constructor===Object;},extend:function extend(){for(var e=[],t=arguments.length;t--;){e[t]=arguments[t];}for(var i=Object(e[0]),s=1;s<e.length;s+=1){var a=e[s];if(null!=a)for(var r=Object.keys(Object(a)),o=0,l=r.length;o<l;o+=1){var d=r[o],h=Object.getOwnPropertyDescriptor(a,d);void 0!==h&&h.enumerable&&(n.isObject(i[d])&&n.isObject(a[d])?n.extend(i[d],a[d]):!n.isObject(i[d])&&n.isObject(a[d])?(i[d]={},n.extend(i[d],a[d])):i[d]=a[d]);}}return i;}},o={touch:t.Modernizr&&!0===t.Modernizr.touch||!!(t.navigator.maxTouchPoints>0||"ontouchstart"in t||t.DocumentTouch&&e instanceof t.DocumentTouch),pointerEvents:!!t.PointerEvent&&"maxTouchPoints"in t.navigator&&t.navigator.maxTouchPoints>0,observer:"MutationObserver"in t||"WebkitMutationObserver"in t,passiveListener:function(){var e=!1;try{var i=Object.defineProperty({},"passive",{get:function get(){e=!0;}});t.addEventListener("testPassiveListener",null,i);}catch(e){}return e;}(),gestures:"ongesturestart"in t},l=function l(e){void 0===e&&(e={});var t=this;t.params=e,t.eventsListeners={},t.params&&t.params.on&&Object.keys(t.params.on).forEach(function(e){t.on(e,t.params.on[e]);});},d={components:{configurable:!0}};l.prototype.on=function(e,t,i){var s=this;if("function"!=typeof t)return s;var a=i?"unshift":"push";return e.split(" ").forEach(function(e){s.eventsListeners[e]||(s.eventsListeners[e]=[]),s.eventsListeners[e][a](t);}),s;},l.prototype.once=function(e,t,i){var s=this;if("function"!=typeof t)return s;function a(){for(var i=[],r=arguments.length;r--;){i[r]=arguments[r];}s.off(e,a),a.f7proxy&&delete a.f7proxy,t.apply(s,i);}return a.f7proxy=t,s.on(e,a,i);},l.prototype.off=function(e,t){var i=this;return i.eventsListeners?(e.split(" ").forEach(function(e){void 0===t?i.eventsListeners[e]=[]:i.eventsListeners[e]&&i.eventsListeners[e].length&&i.eventsListeners[e].forEach(function(s,a){(s===t||s.f7proxy&&s.f7proxy===t)&&i.eventsListeners[e].splice(a,1);});}),i):i;},l.prototype.emit=function(){for(var e=[],t=arguments.length;t--;){e[t]=arguments[t];}var i,s,a,r=this;if(!r.eventsListeners)return r;"string"==typeof e[0]||Array.isArray(e[0])?(i=e[0],s=e.slice(1,e.length),a=r):(i=e[0].events,s=e[0].data,a=e[0].context||r);var n=Array.isArray(i)?i:i.split(" ");return n.forEach(function(e){if(r.eventsListeners&&r.eventsListeners[e]){var t=[];r.eventsListeners[e].forEach(function(e){t.push(e);}),t.forEach(function(e){e.apply(a,s);});}}),r;},l.prototype.useModulesParams=function(e){var t=this;t.modules&&Object.keys(t.modules).forEach(function(i){var s=t.modules[i];s.params&&n.extend(e,s.params);});},l.prototype.useModules=function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach(function(i){var s=t.modules[i],a=e[i]||{};s.instance&&Object.keys(s.instance).forEach(function(e){var i=s.instance[e];t[e]="function"==typeof i?i.bind(t):i;}),s.on&&t.on&&Object.keys(s.on).forEach(function(e){t.on(e,s.on[e]);}),s.create&&s.create.bind(t)(a);});},d.components.set=function(e){this.use&&this.use(e);},l.installModule=function(e){for(var t=[],i=arguments.length-1;i-->0;){t[i]=arguments[i+1];}var s=this;s.prototype.modules||(s.prototype.modules={});var a=e.name||Object.keys(s.prototype.modules).length+"_"+n.now();return s.prototype.modules[a]=e,e.proto&&Object.keys(e.proto).forEach(function(t){s.prototype[t]=e.proto[t];}),e.static&&Object.keys(e.static).forEach(function(t){s[t]=e.static[t];}),e.install&&e.install.apply(s,t),s;},l.use=function(e){for(var t=[],i=arguments.length-1;i-->0;){t[i]=arguments[i+1];}var s=this;return Array.isArray(e)?(e.forEach(function(e){return s.installModule(e);}),s):s.installModule.apply(s,[e].concat(t));},Object.defineProperties(l,d);var h,p,c,u,v,f,m,g,b,w,y,x,T,E,S,C={updateSize:function updateSize(){var e,t,i=this.$el;e=void 0!==this.params.width?this.params.width:i[0].clientWidth,t=void 0!==this.params.height?this.params.height:i[0].clientHeight,0===e&&this.isHorizontal()||0===t&&this.isVertical()||(e=e-parseInt(i.css("padding-left"),10)-parseInt(i.css("padding-right"),10),t=t-parseInt(i.css("padding-top"),10)-parseInt(i.css("padding-bottom"),10),n.extend(this,{width:e,height:t,size:this.isHorizontal()?e:t}));},updateSlides:function updateSlides(){var e=this.params,i=this.$wrapperEl,s=this.size,a=this.rtlTranslate,r=this.wrongRTL,o=this.virtual&&e.virtual.enabled,l=o?this.virtual.slides.length:this.slides.length,d=i.children("."+this.params.slideClass),h=o?this.virtual.slides.length:d.length,p=[],c=[],u=[];function v(t){return!e.cssMode||t!==d.length-1;}var f=e.slidesOffsetBefore;"function"==typeof f&&(f=e.slidesOffsetBefore.call(this));var m=e.slidesOffsetAfter;"function"==typeof m&&(m=e.slidesOffsetAfter.call(this));var g=this.snapGrid.length,b=this.snapGrid.length,w=e.spaceBetween,y=-f,x=0,T=0;if(void 0!==s){var E,S;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*s),this.virtualSize=-w,a?d.css({marginLeft:"",marginTop:""}):d.css({marginRight:"",marginBottom:""}),e.slidesPerColumn>1&&(E=Math.floor(h/e.slidesPerColumn)===h/this.params.slidesPerColumn?h:Math.ceil(h/e.slidesPerColumn)*e.slidesPerColumn,"auto"!==e.slidesPerView&&"row"===e.slidesPerColumnFill&&(E=Math.max(E,e.slidesPerView*e.slidesPerColumn)));for(var C,M=e.slidesPerColumn,P=E/M,z=Math.floor(h/e.slidesPerColumn),k=0;k<h;k+=1){S=0;var $=d.eq(k);if(e.slidesPerColumn>1){var L=void 0,I=void 0,D=void 0;if("row"===e.slidesPerColumnFill&&e.slidesPerGroup>1){var O=Math.floor(k/(e.slidesPerGroup*e.slidesPerColumn)),A=k-e.slidesPerColumn*e.slidesPerGroup*O,G=0===O?e.slidesPerGroup:Math.min(Math.ceil((h-O*M*e.slidesPerGroup)/M),e.slidesPerGroup);L=(I=A-(D=Math.floor(A/G))*G+O*e.slidesPerGroup)+D*E/M,$.css({"-webkit-box-ordinal-group":L,"-moz-box-ordinal-group":L,"-ms-flex-order":L,"-webkit-order":L,order:L});}else"column"===e.slidesPerColumnFill?(D=k-(I=Math.floor(k/M))*M,(I>z||I===z&&D===M-1)&&(D+=1)>=M&&(D=0,I+=1)):I=k-(D=Math.floor(k/P))*P;$.css("margin-"+(this.isHorizontal()?"top":"left"),0!==D&&e.spaceBetween&&e.spaceBetween+"px");}if("none"!==$.css("display")){if("auto"===e.slidesPerView){var H=t.getComputedStyle($[0],null),B=$[0].style.transform,N=$[0].style.webkitTransform;if(B&&($[0].style.transform="none"),N&&($[0].style.webkitTransform="none"),e.roundLengths)S=this.isHorizontal()?$.outerWidth(!0):$.outerHeight(!0);else if(this.isHorizontal()){var X=parseFloat(H.getPropertyValue("width")),V=parseFloat(H.getPropertyValue("padding-left")),Y=parseFloat(H.getPropertyValue("padding-right")),F=parseFloat(H.getPropertyValue("margin-left")),W=parseFloat(H.getPropertyValue("margin-right")),R=H.getPropertyValue("box-sizing");S=R&&"border-box"===R?X+F+W:X+V+Y+F+W;}else{var q=parseFloat(H.getPropertyValue("height")),j=parseFloat(H.getPropertyValue("padding-top")),K=parseFloat(H.getPropertyValue("padding-bottom")),U=parseFloat(H.getPropertyValue("margin-top")),_=parseFloat(H.getPropertyValue("margin-bottom")),J=H.getPropertyValue("box-sizing");S=J&&"border-box"===J?q+U+_:q+j+K+U+_;}B&&($[0].style.transform=B),N&&($[0].style.webkitTransform=N),e.roundLengths&&(S=Math.floor(S));}else S=(s-(e.slidesPerView-1)*w)/e.slidesPerView,e.roundLengths&&(S=Math.floor(S)),d[k]&&(this.isHorizontal()?d[k].style.width=S+"px":d[k].style.height=S+"px");d[k]&&(d[k].swiperSlideSize=S),u.push(S),e.centeredSlides?(y=y+S/2+x/2+w,0===x&&0!==k&&(y=y-s/2-w),0===k&&(y=y-s/2-w),Math.abs(y)<.001&&(y=0),e.roundLengths&&(y=Math.floor(y)),T%e.slidesPerGroup==0&&p.push(y),c.push(y)):(e.roundLengths&&(y=Math.floor(y)),(T-Math.min(this.params.slidesPerGroupSkip,T))%this.params.slidesPerGroup==0&&p.push(y),c.push(y),y=y+S+w),this.virtualSize+=S+w,x=S,T+=1;}}if(this.virtualSize=Math.max(this.virtualSize,s)+m,a&&r&&("slide"===e.effect||"coverflow"===e.effect)&&i.css({width:this.virtualSize+e.spaceBetween+"px"}),e.setWrapperSize&&(this.isHorizontal()?i.css({width:this.virtualSize+e.spaceBetween+"px"}):i.css({height:this.virtualSize+e.spaceBetween+"px"})),e.slidesPerColumn>1&&(this.virtualSize=(S+e.spaceBetween)*E,this.virtualSize=Math.ceil(this.virtualSize/e.slidesPerColumn)-e.spaceBetween,this.isHorizontal()?i.css({width:this.virtualSize+e.spaceBetween+"px"}):i.css({height:this.virtualSize+e.spaceBetween+"px"}),e.centeredSlides)){C=[];for(var Z=0;Z<p.length;Z+=1){var Q=p[Z];e.roundLengths&&(Q=Math.floor(Q)),p[Z]<this.virtualSize+p[0]&&C.push(Q);}p=C;}if(!e.centeredSlides){C=[];for(var ee=0;ee<p.length;ee+=1){var te=p[ee];e.roundLengths&&(te=Math.floor(te)),p[ee]<=this.virtualSize-s&&C.push(te);}p=C,Math.floor(this.virtualSize-s)-Math.floor(p[p.length-1])>1&&p.push(this.virtualSize-s);}if(0===p.length&&(p=[0]),0!==e.spaceBetween&&(this.isHorizontal()?a?d.filter(v).css({marginLeft:w+"px"}):d.filter(v).css({marginRight:w+"px"}):d.filter(v).css({marginBottom:w+"px"})),e.centeredSlides&&e.centeredSlidesBounds){var ie=0;u.forEach(function(t){ie+=t+(e.spaceBetween?e.spaceBetween:0);});var se=(ie-=e.spaceBetween)-s;p=p.map(function(e){return e<0?-f:e>se?se+m:e;});}if(e.centerInsufficientSlides){var ae=0;if(u.forEach(function(t){ae+=t+(e.spaceBetween?e.spaceBetween:0);}),(ae-=e.spaceBetween)<s){var re=(s-ae)/2;p.forEach(function(e,t){p[t]=e-re;}),c.forEach(function(e,t){c[t]=e+re;});}}n.extend(this,{slides:d,snapGrid:p,slidesGrid:c,slidesSizesGrid:u}),h!==l&&this.emit("slidesLengthChange"),p.length!==g&&(this.params.watchOverflow&&this.checkOverflow(),this.emit("snapGridLengthChange")),c.length!==b&&this.emit("slidesGridLengthChange"),(e.watchSlidesProgress||e.watchSlidesVisibility)&&this.updateSlidesOffset();}},updateAutoHeight:function updateAutoHeight(e){var t,i=[],s=0;if("number"==typeof e?this.setTransition(e):!0===e&&this.setTransition(this.params.speed),"auto"!==this.params.slidesPerView&&this.params.slidesPerView>1){if(this.params.centeredSlides)this.visibleSlides.each(function(e,t){i.push(t);});else for(t=0;t<Math.ceil(this.params.slidesPerView);t+=1){var a=this.activeIndex+t;if(a>this.slides.length)break;i.push(this.slides.eq(a)[0]);}}else i.push(this.slides.eq(this.activeIndex)[0]);for(t=0;t<i.length;t+=1){if(void 0!==i[t]){var r=i[t].offsetHeight;s=r>s?r:s;}}s&&this.$wrapperEl.css("height",s+"px");},updateSlidesOffset:function updateSlidesOffset(){for(var e=this.slides,t=0;t<e.length;t+=1){e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop;}},updateSlidesProgress:function updateSlidesProgress(e){void 0===e&&(e=this&&this.translate||0);var t=this.params,i=this.slides,a=this.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&this.updateSlidesOffset();var r=-e;a&&(r=e),i.removeClass(t.slideVisibleClass),this.visibleSlidesIndexes=[],this.visibleSlides=[];for(var n=0;n<i.length;n+=1){var o=i[n],l=(r+(t.centeredSlides?this.minTranslate():0)-o.swiperSlideOffset)/(o.swiperSlideSize+t.spaceBetween);if(t.watchSlidesVisibility||t.centeredSlides&&t.autoHeight){var d=-(r-o.swiperSlideOffset),h=d+this.slidesSizesGrid[n];(d>=0&&d<this.size-1||h>1&&h<=this.size||d<=0&&h>=this.size)&&(this.visibleSlides.push(o),this.visibleSlidesIndexes.push(n),i.eq(n).addClass(t.slideVisibleClass));}o.progress=a?-l:l;}this.visibleSlides=s(this.visibleSlides);}},updateProgress:function updateProgress(e){if(void 0===e){var t=this.rtlTranslate?-1:1;e=this&&this.translate&&this.translate*t||0;}var i=this.params,s=this.maxTranslate()-this.minTranslate(),a=this.progress,r=this.isBeginning,o=this.isEnd,l=r,d=o;0===s?(a=0,r=!0,o=!0):(r=(a=(e-this.minTranslate())/s)<=0,o=a>=1),n.extend(this,{progress:a,isBeginning:r,isEnd:o}),(i.watchSlidesProgress||i.watchSlidesVisibility||i.centeredSlides&&i.autoHeight)&&this.updateSlidesProgress(e),r&&!l&&this.emit("reachBeginning toEdge"),o&&!d&&this.emit("reachEnd toEdge"),(l&&!r||d&&!o)&&this.emit("fromEdge"),this.emit("progress",a);},updateSlidesClasses:function updateSlidesClasses(){var e,t=this.slides,i=this.params,s=this.$wrapperEl,a=this.activeIndex,r=this.realIndex,n=this.virtual&&i.virtual.enabled;t.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=n?this.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+a+'"]'):t.eq(a)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=t.eq(0)).addClass(i.slideNextClass);var l=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===l.length&&(l=t.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),l.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass));},updateActiveIndex:function updateActiveIndex(e){var t,i=this.rtlTranslate?this.translate:-this.translate,s=this.slidesGrid,a=this.snapGrid,r=this.params,o=this.activeIndex,l=this.realIndex,d=this.snapIndex,h=e;if(void 0===h){for(var p=0;p<s.length;p+=1){void 0!==s[p+1]?i>=s[p]&&i<s[p+1]-(s[p+1]-s[p])/2?h=p:i>=s[p]&&i<s[p+1]&&(h=p+1):i>=s[p]&&(h=p);}r.normalizeSlideIndex&&(h<0||void 0===h)&&(h=0);}if(a.indexOf(i)>=0)t=a.indexOf(i);else{var c=Math.min(r.slidesPerGroupSkip,h);t=c+Math.floor((h-c)/r.slidesPerGroup);}if(t>=a.length&&(t=a.length-1),h!==o){var u=parseInt(this.slides.eq(h).attr("data-swiper-slide-index")||h,10);n.extend(this,{snapIndex:t,realIndex:u,previousIndex:o,activeIndex:h}),this.emit("activeIndexChange"),this.emit("snapIndexChange"),l!==u&&this.emit("realIndexChange"),(this.initialized||this.params.runCallbacksOnInit)&&this.emit("slideChange");}else t!==d&&(this.snapIndex=t,this.emit("snapIndexChange"));},updateClickedSlide:function updateClickedSlide(e){var t=this.params,i=s(e.target).closest("."+t.slideClass)[0],a=!1;if(i)for(var r=0;r<this.slides.length;r+=1){this.slides[r]===i&&(a=!0);}if(!i||!a)return this.clickedSlide=void 0,void(this.clickedIndex=void 0);this.clickedSlide=i,this.virtual&&this.params.virtual.enabled?this.clickedIndex=parseInt(s(i).attr("data-swiper-slide-index"),10):this.clickedIndex=s(i).index(),t.slideToClickedSlide&&void 0!==this.clickedIndex&&this.clickedIndex!==this.activeIndex&&this.slideToClickedSlide();}},M={getTranslate:function getTranslate(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this.params,i=this.rtlTranslate,s=this.translate,a=this.$wrapperEl;if(t.virtualTranslate)return i?-s:s;if(t.cssMode)return s;var r=n.getTranslate(a[0],e);return i&&(r=-r),r||0;},setTranslate:function setTranslate(e,t){var i=this.rtlTranslate,s=this.params,a=this.$wrapperEl,r=this.wrapperEl,n=this.progress,o=0,l=0;this.isHorizontal()?o=i?-e:e:l=e,s.roundLengths&&(o=Math.floor(o),l=Math.floor(l)),s.cssMode?r[this.isHorizontal()?"scrollLeft":"scrollTop"]=this.isHorizontal()?-o:-l:s.virtualTranslate||a.transform("translate3d("+o+"px, "+l+"px, 0px)"),this.previousTranslate=this.translate,this.translate=this.isHorizontal()?o:l;var d=this.maxTranslate()-this.minTranslate();(0===d?0:(e-this.minTranslate())/d)!==n&&this.updateProgress(e),this.emit("setTranslate",this.translate,t);},minTranslate:function minTranslate(){return-this.snapGrid[0];},maxTranslate:function maxTranslate(){return-this.snapGrid[this.snapGrid.length-1];},translateTo:function translateTo(e,t,i,s,a){var r;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0),void 0===s&&(s=!0);var n=this,o=n.params,l=n.wrapperEl;if(n.animating&&o.preventInteractionOnTransition)return!1;var d,h=n.minTranslate(),p=n.maxTranslate();if(d=s&&e>h?h:s&&e<p?p:e,n.updateProgress(d),o.cssMode){var c=n.isHorizontal();return 0===t?l[c?"scrollLeft":"scrollTop"]=-d:l.scrollTo?l.scrollTo(((r={})[c?"left":"top"]=-d,r.behavior="smooth",r)):l[c?"scrollLeft":"scrollTop"]=-d,!0;}return 0===t?(n.setTransition(0),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionEnd"))):(n.setTransition(t),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionStart")),n.animating||(n.animating=!0,n.onTranslateToWrapperTransitionEnd||(n.onTranslateToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd),n.onTranslateToWrapperTransitionEnd=null,delete n.onTranslateToWrapperTransitionEnd,i&&n.emit("transitionEnd"));}),n.$wrapperEl[0].addEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd))),!0;}},P={slideTo:function slideTo(e,t,i,s){var a;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var r=this,n=e;n<0&&(n=0);var o=r.params,l=r.snapGrid,d=r.slidesGrid,h=r.previousIndex,p=r.activeIndex,c=r.rtlTranslate,u=r.wrapperEl;if(r.animating&&o.preventInteractionOnTransition)return!1;var v=Math.min(r.params.slidesPerGroupSkip,n),f=v+Math.floor((n-v)/r.params.slidesPerGroup);f>=l.length&&(f=l.length-1),(p||o.initialSlide||0)===(h||0)&&i&&r.emit("beforeSlideChangeStart");var m,g=-l[f];if(r.updateProgress(g),o.normalizeSlideIndex)for(var b=0;b<d.length;b+=1){-Math.floor(100*g)>=Math.floor(100*d[b])&&(n=b);}if(r.initialized&&n!==p){if(!r.allowSlideNext&&g<r.translate&&g<r.minTranslate())return!1;if(!r.allowSlidePrev&&g>r.translate&&g>r.maxTranslate()&&(p||0)!==n)return!1;}if(m=n>p?"next":n<p?"prev":"reset",c&&-g===r.translate||!c&&g===r.translate)return r.updateActiveIndex(n),o.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==o.effect&&r.setTranslate(g),"reset"!==m&&(r.transitionStart(i,m),r.transitionEnd(i,m)),!1;if(o.cssMode){var w=r.isHorizontal(),y=-g;return c&&(y=u.scrollWidth-u.offsetWidth-y),0===t?u[w?"scrollLeft":"scrollTop"]=y:u.scrollTo?u.scrollTo(((a={})[w?"left":"top"]=y,a.behavior="smooth",a)):u[w?"scrollLeft":"scrollTop"]=y,!0;}return 0===t?(r.setTransition(0),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.transitionEnd(i,m)):(r.setTransition(t),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(i,m));}),r.$wrapperEl[0].addEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd))),!0;},slideToLoop:function slideToLoop(e,t,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var a=e;return this.params.loop&&(a+=this.loopedSlides),this.slideTo(a,t,i,s);},slideNext:function slideNext(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft;}return this.slideTo(this.activeIndex+r,e,t,i);},slidePrev:function slidePrev(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.snapGrid,n=this.slidesGrid,o=this.rtlTranslate;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft;}function l(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e);}var d,h=l(o?this.translate:-this.translate),p=r.map(function(e){return l(e);}),c=(n.map(function(e){return l(e);}),r[p.indexOf(h)],r[p.indexOf(h)-1]);return void 0===c&&s.cssMode&&r.forEach(function(e){!c&&h>=e&&(c=e);}),void 0!==c&&(d=n.indexOf(c))<0&&(d=this.activeIndex-1),this.slideTo(d,e,t,i);},slideReset:function slideReset(e,t,i){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,i);},slideToClosest:function slideToClosest(e,t,i,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===s&&(s=.5);var a=this.activeIndex,r=Math.min(this.params.slidesPerGroupSkip,a),n=r+Math.floor((a-r)/this.params.slidesPerGroup),o=this.rtlTranslate?this.translate:-this.translate;if(o>=this.snapGrid[n]){var l=this.snapGrid[n];o-l>(this.snapGrid[n+1]-l)*s&&(a+=this.params.slidesPerGroup);}else{var d=this.snapGrid[n-1];o-d<=(this.snapGrid[n]-d)*s&&(a-=this.params.slidesPerGroup);}return a=Math.max(a,0),a=Math.min(a,this.slidesGrid.length-1),this.slideTo(a,e,t,i);},slideToClickedSlide:function slideToClickedSlide(){var e,t=this,i=t.params,a=t.$wrapperEl,r="auto"===i.slidesPerView?t.slidesPerViewDynamic():i.slidesPerView,o=t.clickedIndex;if(i.loop){if(t.animating)return;e=parseInt(s(t.clickedSlide).attr("data-swiper-slide-index"),10),i.centeredSlides?o<t.loopedSlides-r/2||o>t.slides.length-t.loopedSlides+r/2?(t.loopFix(),o=a.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),n.nextTick(function(){t.slideTo(o);})):t.slideTo(o):o>t.slides.length-r?(t.loopFix(),o=a.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),n.nextTick(function(){t.slideTo(o);})):t.slideTo(o);}else t.slideTo(o);}},z={loopCreate:function loopCreate(){var t=this,i=t.params,a=t.$wrapperEl;a.children("."+i.slideClass+"."+i.slideDuplicateClass).remove();var r=a.children("."+i.slideClass);if(i.loopFillGroupWithBlank){var n=i.slidesPerGroup-r.length%i.slidesPerGroup;if(n!==i.slidesPerGroup){for(var o=0;o<n;o+=1){var l=s(e.createElement("div")).addClass(i.slideClass+" "+i.slideBlankClass);a.append(l);}r=a.children("."+i.slideClass);}}"auto"!==i.slidesPerView||i.loopedSlides||(i.loopedSlides=r.length),t.loopedSlides=Math.ceil(parseFloat(i.loopedSlides||i.slidesPerView,10)),t.loopedSlides+=i.loopAdditionalSlides,t.loopedSlides>r.length&&(t.loopedSlides=r.length);var d=[],h=[];r.each(function(e,i){var a=s(i);e<t.loopedSlides&&h.push(i),e<r.length&&e>=r.length-t.loopedSlides&&d.push(i),a.attr("data-swiper-slide-index",e);});for(var p=0;p<h.length;p+=1){a.append(s(h[p].cloneNode(!0)).addClass(i.slideDuplicateClass));}for(var c=d.length-1;c>=0;c-=1){a.prepend(s(d[c].cloneNode(!0)).addClass(i.slideDuplicateClass));}},loopFix:function loopFix(){this.emit("beforeLoopFix");var e,t=this.activeIndex,i=this.slides,s=this.loopedSlides,a=this.allowSlidePrev,r=this.allowSlideNext,n=this.snapGrid,o=this.rtlTranslate;this.allowSlidePrev=!0,this.allowSlideNext=!0;var l=-n[t]-this.getTranslate();t<s?(e=i.length-3*s+t,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l)):t>=i.length-s&&(e=-i.length+t+s,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l)),this.allowSlidePrev=a,this.allowSlideNext=r,this.emit("loopFix");},loopDestroy:function loopDestroy(){var e=this.$wrapperEl,t=this.params,i=this.slides;e.children("."+t.slideClass+"."+t.slideDuplicateClass+",."+t.slideClass+"."+t.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index");}},k={setGrabCursor:function setGrabCursor(e){if(!(o.touch||!this.params.simulateTouch||this.params.watchOverflow&&this.isLocked||this.params.cssMode)){var t=this.el;t.style.cursor="move",t.style.cursor=e?"-webkit-grabbing":"-webkit-grab",t.style.cursor=e?"-moz-grabbin":"-moz-grab",t.style.cursor=e?"grabbing":"grab";}},unsetGrabCursor:function unsetGrabCursor(){o.touch||this.params.watchOverflow&&this.isLocked||this.params.cssMode||(this.el.style.cursor="");}},$={appendSlide:function appendSlide(e){var t=this.$wrapperEl,i=this.params;if(i.loop&&this.loopDestroy(),"object"==_typeof(e)&&"length"in e)for(var s=0;s<e.length;s+=1){e[s]&&t.append(e[s]);}else t.append(e);i.loop&&this.loopCreate(),i.observer&&o.observer||this.update();},prependSlide:function prependSlide(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&this.loopDestroy();var a=s+1;if("object"==_typeof(e)&&"length"in e){for(var r=0;r<e.length;r+=1){e[r]&&i.prepend(e[r]);}a=s+e.length;}else i.prepend(e);t.loop&&this.loopCreate(),t.observer&&o.observer||this.update(),this.slideTo(a,0,!1);},addSlide:function addSlide(e,t){var i=this.$wrapperEl,s=this.params,a=this.activeIndex;s.loop&&(a-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+s.slideClass));var r=this.slides.length;if(e<=0)this.prependSlide(t);else if(e>=r)this.appendSlide(t);else{for(var n=a>e?a+1:a,l=[],d=r-1;d>=e;d-=1){var h=this.slides.eq(d);h.remove(),l.unshift(h);}if("object"==_typeof(t)&&"length"in t){for(var p=0;p<t.length;p+=1){t[p]&&i.append(t[p]);}n=a>e?a+t.length:a;}else i.append(t);for(var c=0;c<l.length;c+=1){i.append(l[c]);}s.loop&&this.loopCreate(),s.observer&&o.observer||this.update(),s.loop?this.slideTo(n+this.loopedSlides,0,!1):this.slideTo(n,0,!1);}},removeSlide:function removeSlide(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&(s-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+t.slideClass));var a,r=s;if("object"==_typeof(e)&&"length"in e){for(var n=0;n<e.length;n+=1){a=e[n],this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1);}r=Math.max(r,0);}else a=e,this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1),r=Math.max(r,0);t.loop&&this.loopCreate(),t.observer&&o.observer||this.update(),t.loop?this.slideTo(r+this.loopedSlides,0,!1):this.slideTo(r,0,!1);},removeAllSlides:function removeAllSlides(){for(var e=[],t=0;t<this.slides.length;t+=1){e.push(t);}this.removeSlide(e);}},L=(h=t.navigator.platform,p=t.navigator.userAgent,c={ios:!1,android:!1,androidChrome:!1,desktop:!1,iphone:!1,ipod:!1,ipad:!1,edge:!1,ie:!1,firefox:!1,macos:!1,windows:!1,cordova:!(!t.cordova&&!t.phonegap),phonegap:!(!t.cordova&&!t.phonegap),electron:!1},u=t.screen.width,v=t.screen.height,f=p.match(/(Android);?[\s\/]+([\d.]+)?/),m=p.match(/(iPad).*OS\s([\d_]+)/),g=p.match(/(iPod)(.*OS\s([\d_]+))?/),b=!m&&p.match(/(iPhone\sOS|iOS)\s([\d_]+)/),w=p.indexOf("MSIE ")>=0||p.indexOf("Trident/")>=0,y=p.indexOf("Edge/")>=0,x=p.indexOf("Gecko/")>=0&&p.indexOf("Firefox/")>=0,T="Win32"===h,E=p.toLowerCase().indexOf("electron")>=0,S="MacIntel"===h,!m&&S&&o.touch&&(1024===u&&1366===v||834===u&&1194===v||834===u&&1112===v||768===u&&1024===v)&&(m=p.match(/(Version)\/([\d.]+)/),S=!1),c.ie=w,c.edge=y,c.firefox=x,f&&!T&&(c.os="android",c.osVersion=f[2],c.android=!0,c.androidChrome=p.toLowerCase().indexOf("chrome")>=0),(m||b||g)&&(c.os="ios",c.ios=!0),b&&!g&&(c.osVersion=b[2].replace(/_/g,"."),c.iphone=!0),m&&(c.osVersion=m[2].replace(/_/g,"."),c.ipad=!0),g&&(c.osVersion=g[3]?g[3].replace(/_/g,"."):null,c.ipod=!0),c.ios&&c.osVersion&&p.indexOf("Version/")>=0&&"10"===c.osVersion.split(".")[0]&&(c.osVersion=p.toLowerCase().split("version/")[1].split(" ")[0]),c.webView=!(!(b||m||g)||!p.match(/.*AppleWebKit(?!.*Safari)/i)&&!t.navigator.standalone)||t.matchMedia&&t.matchMedia("(display-mode: standalone)").matches,c.webview=c.webView,c.standalone=c.webView,c.desktop=!(c.ios||c.android)||E,c.desktop&&(c.electron=E,c.macos=S,c.windows=T,c.macos&&(c.os="macos"),c.windows&&(c.os="windows")),c.pixelRatio=t.devicePixelRatio||1,c);function I(i){var a=this.touchEventsData,r=this.params,o=this.touches;if(!this.animating||!r.preventInteractionOnTransition){var l=i;l.originalEvent&&(l=l.originalEvent);var d=s(l.target);if(("wrapper"!==r.touchEventsTarget||d.closest(this.wrapperEl).length)&&(a.isTouchEvent="touchstart"===l.type,(a.isTouchEvent||!("which"in l)||3!==l.which)&&!(!a.isTouchEvent&&"button"in l&&l.button>0||a.isTouched&&a.isMoved)))if(r.noSwiping&&d.closest(r.noSwipingSelector?r.noSwipingSelector:"."+r.noSwipingClass)[0])this.allowClick=!0;else if(!r.swipeHandler||d.closest(r.swipeHandler)[0]){o.currentX="touchstart"===l.type?l.targetTouches[0].pageX:l.pageX,o.currentY="touchstart"===l.type?l.targetTouches[0].pageY:l.pageY;var h=o.currentX,p=o.currentY,c=r.edgeSwipeDetection||r.iOSEdgeSwipeDetection,u=r.edgeSwipeThreshold||r.iOSEdgeSwipeThreshold;if(!c||!(h<=u||h>=t.screen.width-u)){if(n.extend(a,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=h,o.startY=p,a.touchStartTime=n.now(),this.allowClick=!0,this.updateSize(),this.swipeDirection=void 0,r.threshold>0&&(a.allowThresholdMove=!1),"touchstart"!==l.type){var v=!0;d.is(a.formElements)&&(v=!1),e.activeElement&&s(e.activeElement).is(a.formElements)&&e.activeElement!==d[0]&&e.activeElement.blur();var f=v&&this.allowTouchMove&&r.touchStartPreventDefault;(r.touchStartForcePreventDefault||f)&&l.preventDefault();}this.emit("touchStart",l);}}}}function D(t){var i=this.touchEventsData,a=this.params,r=this.touches,o=this.rtlTranslate,l=t;if(l.originalEvent&&(l=l.originalEvent),i.isTouched){if(!i.isTouchEvent||"mousemove"!==l.type){var d="touchmove"===l.type&&l.targetTouches&&(l.targetTouches[0]||l.changedTouches[0]),h="touchmove"===l.type?d.pageX:l.pageX,p="touchmove"===l.type?d.pageY:l.pageY;if(l.preventedByNestedSwiper)return r.startX=h,void(r.startY=p);if(!this.allowTouchMove)return this.allowClick=!1,void(i.isTouched&&(n.extend(r,{startX:h,startY:p,currentX:h,currentY:p}),i.touchStartTime=n.now()));if(i.isTouchEvent&&a.touchReleaseOnEdges&&!a.loop)if(this.isVertical()){if(p<r.startY&&this.translate<=this.maxTranslate()||p>r.startY&&this.translate>=this.minTranslate())return i.isTouched=!1,void(i.isMoved=!1);}else if(h<r.startX&&this.translate<=this.maxTranslate()||h>r.startX&&this.translate>=this.minTranslate())return;if(i.isTouchEvent&&e.activeElement&&l.target===e.activeElement&&s(l.target).is(i.formElements))return i.isMoved=!0,void(this.allowClick=!1);if(i.allowTouchCallbacks&&this.emit("touchMove",l),!(l.targetTouches&&l.targetTouches.length>1)){r.currentX=h,r.currentY=p;var c,u=r.currentX-r.startX,v=r.currentY-r.startY;if(!(this.params.threshold&&Math.sqrt(Math.pow(u,2)+Math.pow(v,2))<this.params.threshold))if(void 0===i.isScrolling&&(this.isHorizontal()&&r.currentY===r.startY||this.isVertical()&&r.currentX===r.startX?i.isScrolling=!1:u*u+v*v>=25&&(c=180*Math.atan2(Math.abs(v),Math.abs(u))/Math.PI,i.isScrolling=this.isHorizontal()?c>a.touchAngle:90-c>a.touchAngle)),i.isScrolling&&this.emit("touchMoveOpposite",l),void 0===i.startMoving&&(r.currentX===r.startX&&r.currentY===r.startY||(i.startMoving=!0)),i.isScrolling)i.isTouched=!1;else if(i.startMoving){this.allowClick=!1,a.cssMode||l.preventDefault(),a.touchMoveStopPropagation&&!a.nested&&l.stopPropagation(),i.isMoved||(a.loop&&this.loopFix(),i.startTranslate=this.getTranslate(),this.setTransition(0),this.animating&&this.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!a.grabCursor||!0!==this.allowSlideNext&&!0!==this.allowSlidePrev||this.setGrabCursor(!0),this.emit("sliderFirstMove",l)),this.emit("sliderMove",l),i.isMoved=!0;var f=this.isHorizontal()?u:v;r.diff=f,f*=a.touchRatio,o&&(f=-f),this.swipeDirection=f>0?"prev":"next",i.currentTranslate=f+i.startTranslate;var m=!0,g=a.resistanceRatio;if(a.touchReleaseOnEdges&&(g=0),f>0&&i.currentTranslate>this.minTranslate()?(m=!1,a.resistance&&(i.currentTranslate=this.minTranslate()-1+Math.pow(-this.minTranslate()+i.startTranslate+f,g))):f<0&&i.currentTranslate<this.maxTranslate()&&(m=!1,a.resistance&&(i.currentTranslate=this.maxTranslate()+1-Math.pow(this.maxTranslate()-i.startTranslate-f,g))),m&&(l.preventedByNestedSwiper=!0),!this.allowSlideNext&&"next"===this.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!this.allowSlidePrev&&"prev"===this.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),a.threshold>0){if(!(Math.abs(f)>a.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,r.startX=r.currentX,r.startY=r.currentY,i.currentTranslate=i.startTranslate,void(r.diff=this.isHorizontal()?r.currentX-r.startX:r.currentY-r.startY);}a.followFinger&&!a.cssMode&&((a.freeMode||a.watchSlidesProgress||a.watchSlidesVisibility)&&(this.updateActiveIndex(),this.updateSlidesClasses()),a.freeMode&&(0===i.velocities.length&&i.velocities.push({position:r[this.isHorizontal()?"startX":"startY"],time:i.touchStartTime}),i.velocities.push({position:r[this.isHorizontal()?"currentX":"currentY"],time:n.now()})),this.updateProgress(i.currentTranslate),this.setTranslate(i.currentTranslate));}}}}else i.startMoving&&i.isScrolling&&this.emit("touchMoveOpposite",l);}function O(e){var t=this,i=t.touchEventsData,s=t.params,a=t.touches,r=t.rtlTranslate,o=t.$wrapperEl,l=t.slidesGrid,d=t.snapGrid,h=e;if(h.originalEvent&&(h=h.originalEvent),i.allowTouchCallbacks&&t.emit("touchEnd",h),i.allowTouchCallbacks=!1,!i.isTouched)return i.isMoved&&s.grabCursor&&t.setGrabCursor(!1),i.isMoved=!1,void(i.startMoving=!1);s.grabCursor&&i.isMoved&&i.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,c=n.now(),u=c-i.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(h),t.emit("tap click",h),u<300&&c-i.lastClickTime<300&&t.emit("doubleTap doubleClick",h)),i.lastClickTime=n.now(),n.nextTick(function(){t.destroyed||(t.allowClick=!0);}),!i.isTouched||!i.isMoved||!t.swipeDirection||0===a.diff||i.currentTranslate===i.startTranslate)return i.isTouched=!1,i.isMoved=!1,void(i.startMoving=!1);if(i.isTouched=!1,i.isMoved=!1,i.startMoving=!1,p=s.followFinger?r?t.translate:-t.translate:-i.currentTranslate,!s.cssMode)if(s.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1));if(s.freeModeMomentum){if(i.velocities.length>1){var v=i.velocities.pop(),f=i.velocities.pop(),m=v.position-f.position,g=v.time-f.time;t.velocity=m/g,t.velocity/=2,Math.abs(t.velocity)<s.freeModeMinimumVelocity&&(t.velocity=0),(g>150||n.now()-v.time>300)&&(t.velocity=0);}else t.velocity=0;t.velocity*=s.freeModeMomentumVelocityRatio,i.velocities.length=0;var b=1e3*s.freeModeMomentumRatio,w=t.velocity*b,y=t.translate+w;r&&(y=-y);var x,T,E=!1,S=20*Math.abs(t.velocity)*s.freeModeMomentumBounceRatio;if(y<t.maxTranslate())s.freeModeMomentumBounce?(y+t.maxTranslate()<-S&&(y=t.maxTranslate()-S),x=t.maxTranslate(),E=!0,i.allowMomentumBounce=!0):y=t.maxTranslate(),s.loop&&s.centeredSlides&&(T=!0);else if(y>t.minTranslate())s.freeModeMomentumBounce?(y-t.minTranslate()>S&&(y=t.minTranslate()+S),x=t.minTranslate(),E=!0,i.allowMomentumBounce=!0):y=t.minTranslate(),s.loop&&s.centeredSlides&&(T=!0);else if(s.freeModeSticky){for(var C,M=0;M<d.length;M+=1){if(d[M]>-y){C=M;break;}}y=-(y=Math.abs(d[C]-y)<Math.abs(d[C-1]-y)||"next"===t.swipeDirection?d[C]:d[C-1]);}if(T&&t.once("transitionEnd",function(){t.loopFix();}),0!==t.velocity){if(b=r?Math.abs((-y-t.translate)/t.velocity):Math.abs((y-t.translate)/t.velocity),s.freeModeSticky){var P=Math.abs((r?-y:y)-t.translate),z=t.slidesSizesGrid[t.activeIndex];b=P<z?s.speed:P<2*z?1.5*s.speed:2.5*s.speed;}}else if(s.freeModeSticky)return void t.slideToClosest();s.freeModeMomentumBounce&&E?(t.updateProgress(x),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating=!0,o.transitionEnd(function(){t&&!t.destroyed&&i.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(s.speed),setTimeout(function(){t.setTranslate(x),o.transitionEnd(function(){t&&!t.destroyed&&t.transitionEnd();});},0));})):t.velocity?(t.updateProgress(y),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,o.transitionEnd(function(){t&&!t.destroyed&&t.transitionEnd();}))):t.updateProgress(y),t.updateActiveIndex(),t.updateSlidesClasses();}else if(s.freeModeSticky)return void t.slideToClosest();(!s.freeModeMomentum||u>=s.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses());}else{for(var k=0,$=t.slidesSizesGrid[0],L=0;L<l.length;L+=L<s.slidesPerGroupSkip?1:s.slidesPerGroup){var I=L<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;void 0!==l[L+I]?p>=l[L]&&p<l[L+I]&&(k=L,$=l[L+I]-l[L]):p>=l[L]&&(k=L,$=l[l.length-1]-l[l.length-2]);}var D=(p-l[k])/$,O=k<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;if(u>s.longSwipesMs){if(!s.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(D>=s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k)),"prev"===t.swipeDirection&&(D>1-s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k));}else{if(!s.shortSwipes)return void t.slideTo(t.activeIndex);!t.navigation||h.target!==t.navigation.nextEl&&h.target!==t.navigation.prevEl?("next"===t.swipeDirection&&t.slideTo(k+O),"prev"===t.swipeDirection&&t.slideTo(k)):h.target===t.navigation.nextEl?t.slideTo(k+O):t.slideTo(k);}}}function A(){var e=this.params,t=this.el;if(!t||0!==t.offsetWidth){e.breakpoints&&this.setBreakpoint();var i=this.allowSlideNext,s=this.allowSlidePrev,a=this.snapGrid;this.allowSlideNext=!0,this.allowSlidePrev=!0,this.updateSize(),this.updateSlides(),this.updateSlidesClasses(),("auto"===e.slidesPerView||e.slidesPerView>1)&&this.isEnd&&!this.params.centeredSlides?this.slideTo(this.slides.length-1,0,!1,!0):this.slideTo(this.activeIndex,0,!1,!0),this.autoplay&&this.autoplay.running&&this.autoplay.paused&&this.autoplay.run(),this.allowSlidePrev=s,this.allowSlideNext=i,this.params.watchOverflow&&a!==this.snapGrid&&this.checkOverflow();}}function G(e){this.allowClick||(this.params.preventClicks&&e.preventDefault(),this.params.preventClicksPropagation&&this.animating&&(e.stopPropagation(),e.stopImmediatePropagation()));}function H(){var e=this.wrapperEl,t=this.rtlTranslate;this.previousTranslate=this.translate,this.isHorizontal()?this.translate=t?e.scrollWidth-e.offsetWidth-e.scrollLeft:-e.scrollLeft:this.translate=-e.scrollTop,-0===this.translate&&(this.translate=0),this.updateActiveIndex(),this.updateSlidesClasses();var i=this.maxTranslate()-this.minTranslate();(0===i?0:(this.translate-this.minTranslate())/i)!==this.progress&&this.updateProgress(t?-this.translate:this.translate),this.emit("setTranslate",this.translate,!1);}var B=!1;function N(){}var X={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,preventInteractionOnTransition:!1,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0},V={update:C,translate:M,transition:{setTransition:function setTransition(e,t){this.params.cssMode||this.$wrapperEl.transition(e),this.emit("setTransition",e,t);},transitionStart:function transitionStart(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.params,a=this.previousIndex;if(!s.cssMode){s.autoHeight&&this.updateAutoHeight();var r=t;if(r||(r=i>a?"next":i<a?"prev":"reset"),this.emit("transitionStart"),e&&i!==a){if("reset"===r)return void this.emit("slideResetTransitionStart");this.emit("slideChangeTransitionStart"),"next"===r?this.emit("slideNextTransitionStart"):this.emit("slidePrevTransitionStart");}}},transitionEnd:function transitionEnd(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.previousIndex,a=this.params;if(this.animating=!1,!a.cssMode){this.setTransition(0);var r=t;if(r||(r=i>s?"next":i<s?"prev":"reset"),this.emit("transitionEnd"),e&&i!==s){if("reset"===r)return void this.emit("slideResetTransitionEnd");this.emit("slideChangeTransitionEnd"),"next"===r?this.emit("slideNextTransitionEnd"):this.emit("slidePrevTransitionEnd");}}}},slide:P,loop:z,grabCursor:k,manipulation:$,events:{attachEvents:function attachEvents(){var t=this.params,i=this.touchEvents,s=this.el,a=this.wrapperEl;this.onTouchStart=I.bind(this),this.onTouchMove=D.bind(this),this.onTouchEnd=O.bind(this),t.cssMode&&(this.onScroll=H.bind(this)),this.onClick=G.bind(this);var r=!!t.nested;if(!o.touch&&o.pointerEvents)s.addEventListener(i.start,this.onTouchStart,!1),e.addEventListener(i.move,this.onTouchMove,r),e.addEventListener(i.end,this.onTouchEnd,!1);else{if(o.touch){var n=!("touchstart"!==i.start||!o.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(i.start,this.onTouchStart,n),s.addEventListener(i.move,this.onTouchMove,o.passiveListener?{passive:!1,capture:r}:r),s.addEventListener(i.end,this.onTouchEnd,n),i.cancel&&s.addEventListener(i.cancel,this.onTouchEnd,n),B||(e.addEventListener("touchstart",N),B=!0);}(t.simulateTouch&&!L.ios&&!L.android||t.simulateTouch&&!o.touch&&L.ios)&&(s.addEventListener("mousedown",this.onTouchStart,!1),e.addEventListener("mousemove",this.onTouchMove,r),e.addEventListener("mouseup",this.onTouchEnd,!1));}(t.preventClicks||t.preventClicksPropagation)&&s.addEventListener("click",this.onClick,!0),t.cssMode&&a.addEventListener("scroll",this.onScroll),t.updateOnWindowResize?this.on(L.ios||L.android?"resize orientationchange observerUpdate":"resize observerUpdate",A,!0):this.on("observerUpdate",A,!0);},detachEvents:function detachEvents(){var t=this.params,i=this.touchEvents,s=this.el,a=this.wrapperEl,r=!!t.nested;if(!o.touch&&o.pointerEvents)s.removeEventListener(i.start,this.onTouchStart,!1),e.removeEventListener(i.move,this.onTouchMove,r),e.removeEventListener(i.end,this.onTouchEnd,!1);else{if(o.touch){var n=!("onTouchStart"!==i.start||!o.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(i.start,this.onTouchStart,n),s.removeEventListener(i.move,this.onTouchMove,r),s.removeEventListener(i.end,this.onTouchEnd,n),i.cancel&&s.removeEventListener(i.cancel,this.onTouchEnd,n);}(t.simulateTouch&&!L.ios&&!L.android||t.simulateTouch&&!o.touch&&L.ios)&&(s.removeEventListener("mousedown",this.onTouchStart,!1),e.removeEventListener("mousemove",this.onTouchMove,r),e.removeEventListener("mouseup",this.onTouchEnd,!1));}(t.preventClicks||t.preventClicksPropagation)&&s.removeEventListener("click",this.onClick,!0),t.cssMode&&a.removeEventListener("scroll",this.onScroll),this.off(L.ios||L.android?"resize orientationchange observerUpdate":"resize observerUpdate",A);}},breakpoints:{setBreakpoint:function setBreakpoint(){var e=this.activeIndex,t=this.initialized,i=this.loopedSlides;void 0===i&&(i=0);var s=this.params,a=this.$el,r=s.breakpoints;if(r&&(!r||0!==Object.keys(r).length)){var o=this.getBreakpoint(r);if(o&&this.currentBreakpoint!==o){var l=o in r?r[o]:void 0;l&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach(function(e){var t=l[e];void 0!==t&&(l[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto");});var d=l||this.originalParams,h=s.slidesPerColumn>1,p=d.slidesPerColumn>1;h&&!p?a.removeClass(s.containerModifierClass+"multirow "+s.containerModifierClass+"multirow-column"):!h&&p&&(a.addClass(s.containerModifierClass+"multirow"),"column"===d.slidesPerColumnFill&&a.addClass(s.containerModifierClass+"multirow-column"));var c=d.direction&&d.direction!==s.direction,u=s.loop&&(d.slidesPerView!==s.slidesPerView||c);c&&t&&this.changeDirection(),n.extend(this.params,d),n.extend(this,{allowTouchMove:this.params.allowTouchMove,allowSlideNext:this.params.allowSlideNext,allowSlidePrev:this.params.allowSlidePrev}),this.currentBreakpoint=o,u&&t&&(this.loopDestroy(),this.loopCreate(),this.updateSlides(),this.slideTo(e-i+this.loopedSlides,0,!1)),this.emit("breakpoint",d);}}},getBreakpoint:function getBreakpoint(e){if(e){var i=!1,s=Object.keys(e).map(function(e){if("string"==typeof e&&0===e.indexOf("@")){var i=parseFloat(e.substr(1));return{value:t.innerHeight*i,point:e};}return{value:e,point:e};});s.sort(function(e,t){return parseInt(e.value,10)-parseInt(t.value,10);});for(var a=0;a<s.length;a+=1){var r=s[a],n=r.point;r.value<=t.innerWidth&&(i=n);}return i||"max";}}},checkOverflow:{checkOverflow:function checkOverflow(){var e=this.params,t=this.isLocked,i=this.slides.length>0&&e.slidesOffsetBefore+e.spaceBetween*(this.slides.length-1)+this.slides[0].offsetWidth*this.slides.length;e.slidesOffsetBefore&&e.slidesOffsetAfter&&i?this.isLocked=i<=this.size:this.isLocked=1===this.snapGrid.length,this.allowSlideNext=!this.isLocked,this.allowSlidePrev=!this.isLocked,t!==this.isLocked&&this.emit(this.isLocked?"lock":"unlock"),t&&t!==this.isLocked&&(this.isEnd=!1,this.navigation.update());}},classes:{addClasses:function addClasses(){var e=this.classNames,t=this.params,i=this.rtl,s=this.$el,a=[];a.push("initialized"),a.push(t.direction),t.freeMode&&a.push("free-mode"),t.autoHeight&&a.push("autoheight"),i&&a.push("rtl"),t.slidesPerColumn>1&&(a.push("multirow"),"column"===t.slidesPerColumnFill&&a.push("multirow-column")),L.android&&a.push("android"),L.ios&&a.push("ios"),t.cssMode&&a.push("css-mode"),a.forEach(function(i){e.push(t.containerModifierClass+i);}),s.addClass(e.join(" "));},removeClasses:function removeClasses(){var e=this.$el,t=this.classNames;e.removeClass(t.join(" "));}},images:{loadImage:function loadImage(e,i,s,a,r,n){var o;function l(){n&&n();}e.complete&&r?l():i?((o=new t.Image()).onload=l,o.onerror=l,a&&(o.sizes=a),s&&(o.srcset=s),i&&(o.src=i)):l();},preloadImages:function preloadImages(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")));}e.imagesToLoad=e.$el.find("img");for(var i=0;i<e.imagesToLoad.length;i+=1){var s=e.imagesToLoad[i];e.loadImage(s,s.currentSrc||s.getAttribute("src"),s.srcset||s.getAttribute("srcset"),s.sizes||s.getAttribute("sizes"),!0,t);}}}},Y={},F=function(e){function t(){for(var i,a,r,l=[],d=arguments.length;d--;){l[d]=arguments[d];}1===l.length&&l[0].constructor&&l[0].constructor===Object?r=l[0]:(a=(i=l)[0],r=i[1]),r||(r={}),r=n.extend({},r),a&&!r.el&&(r.el=a),e.call(this,r),Object.keys(V).forEach(function(e){Object.keys(V[e]).forEach(function(i){t.prototype[i]||(t.prototype[i]=V[e][i]);});});var h=this;void 0===h.modules&&(h.modules={}),Object.keys(h.modules).forEach(function(e){var t=h.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=_typeof(s)||null===s)return;if(!(i in r)||!("enabled"in s))return;!0===r[i]&&(r[i]={enabled:!0}),"object"!=_typeof(r[i])||"enabled"in r[i]||(r[i].enabled=!0),r[i]||(r[i]={enabled:!1});}});var p=n.extend({},X);h.useModulesParams(p),h.params=n.extend({},p,Y,r),h.originalParams=n.extend({},h.params),h.passedParams=n.extend({},r),h.$=s;var c=s(h.params.el);if(a=c[0]){if(c.length>1){var u=[];return c.each(function(e,i){var s=n.extend({},r,{el:i});u.push(new t(s));}),u;}var v,f,m;return a.swiper=h,c.data("swiper",h),a&&a.shadowRoot&&a.shadowRoot.querySelector?(v=s(a.shadowRoot.querySelector("."+h.params.wrapperClass))).children=function(e){return c.children(e);}:v=c.children("."+h.params.wrapperClass),n.extend(h,{$el:c,el:a,$wrapperEl:v,wrapperEl:v[0],classNames:[],slides:s(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function isHorizontal(){return"horizontal"===h.params.direction;},isVertical:function isVertical(){return"vertical"===h.params.direction;},rtl:"rtl"===a.dir.toLowerCase()||"rtl"===c.css("direction"),rtlTranslate:"horizontal"===h.params.direction&&("rtl"===a.dir.toLowerCase()||"rtl"===c.css("direction")),wrongRTL:"-webkit-box"===v.css("display"),activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:h.params.allowSlideNext,allowSlidePrev:h.params.allowSlidePrev,touchEvents:(f=["touchstart","touchmove","touchend","touchcancel"],m=["mousedown","mousemove","mouseup"],o.pointerEvents&&(m=["pointerdown","pointermove","pointerup"]),h.touchEventsTouch={start:f[0],move:f[1],end:f[2],cancel:f[3]},h.touchEventsDesktop={start:m[0],move:m[1],end:m[2]},o.touch||!h.params.simulateTouch?h.touchEventsTouch:h.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,formElements:"input, select, option, textarea, button, video, label",lastClickTime:n.now(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:h.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),h.useModules(),h.params.init&&h.init(),h;}}e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t;var i={extendedDefaults:{configurable:!0},defaults:{configurable:!0},Class:{configurable:!0},$:{configurable:!0}};return t.prototype.slidesPerViewDynamic=function(){var e=this.params,t=this.slides,i=this.slidesGrid,s=this.size,a=this.activeIndex,r=1;if(e.centeredSlides){for(var n,o=t[a].swiperSlideSize,l=a+1;l<t.length;l+=1){t[l]&&!n&&(r+=1,(o+=t[l].swiperSlideSize)>s&&(n=!0));}for(var d=a-1;d>=0;d-=1){t[d]&&!n&&(r+=1,(o+=t[d].swiperSlideSize)>s&&(n=!0));}}else for(var h=a+1;h<t.length;h+=1){i[h]-i[a]<s&&(r+=1);}return r;},t.prototype.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,i=e.params;i.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(s(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||s(),i.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update");}function s(){var t=e.rtlTranslate?-1*e.translate:e.translate,i=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(i),e.updateActiveIndex(),e.updateSlidesClasses();}},t.prototype.changeDirection=function(e,t){void 0===t&&(t=!0);var i=this.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(this.$el.removeClass(""+this.params.containerModifierClass+i).addClass(""+this.params.containerModifierClass+e),this.params.direction=e,this.slides.each(function(t,i){"vertical"===e?i.style.width="":i.style.height="";}),this.emit("changeDirection"),t&&this.update()),this;},t.prototype.init=function(){this.initialized||(this.emit("beforeInit"),this.params.breakpoints&&this.setBreakpoint(),this.addClasses(),this.params.loop&&this.loopCreate(),this.updateSize(),this.updateSlides(),this.params.watchOverflow&&this.checkOverflow(),this.params.grabCursor&&this.setGrabCursor(),this.params.preloadImages&&this.preloadImages(),this.params.loop?this.slideTo(this.params.initialSlide+this.loopedSlides,0,this.params.runCallbacksOnInit):this.slideTo(this.params.initialSlide,0,this.params.runCallbacksOnInit),this.attachEvents(),this.initialized=!0,this.emit("init"));},t.prototype.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var i=this,s=i.params,a=i.$el,r=i.$wrapperEl,o=i.slides;return void 0===i.params||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),a.removeAttr("style"),r.removeAttr("style"),o&&o.length&&o.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach(function(e){i.off(e);}),!1!==e&&(i.$el[0].swiper=null,i.$el.data("swiper",null),n.deleteProps(i)),i.destroyed=!0),null;},t.extendDefaults=function(e){n.extend(Y,e);},i.extendedDefaults.get=function(){return Y;},i.defaults.get=function(){return X;},i.Class.get=function(){return e;},i.$.get=function(){return s;},Object.defineProperties(t,i),t;}(l),W={name:"device",proto:{device:L},static:{device:L}},R={name:"support",proto:{support:o},static:{support:o}},q={isEdge:!!t.navigator.userAgent.match(/Edge/g),isSafari:function(){var e=t.navigator.userAgent.toLowerCase();return e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0;}(),isUiWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)},j={name:"browser",proto:{browser:q},static:{browser:q}},K={name:"resize",create:function create(){var e=this;n.extend(e,{resize:{resizeHandler:function resizeHandler(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"));},orientationChangeHandler:function orientationChangeHandler(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange");}}});},on:{init:function init(){t.addEventListener("resize",this.resize.resizeHandler),t.addEventListener("orientationchange",this.resize.orientationChangeHandler);},destroy:function destroy(){t.removeEventListener("resize",this.resize.resizeHandler),t.removeEventListener("orientationchange",this.resize.orientationChangeHandler);}}},U={func:t.MutationObserver||t.WebkitMutationObserver,attach:function attach(e,i){void 0===i&&(i={});var s=this,a=new(0,U.func)(function(e){if(1!==e.length){var i=function i(){s.emit("observerUpdate",e[0]);};t.requestAnimationFrame?t.requestAnimationFrame(i):t.setTimeout(i,0);}else s.emit("observerUpdate",e[0]);});a.observe(e,{attributes:void 0===i.attributes||i.attributes,childList:void 0===i.childList||i.childList,characterData:void 0===i.characterData||i.characterData}),s.observer.observers.push(a);},init:function init(){if(o.observer&&this.params.observer){if(this.params.observeParents)for(var e=this.$el.parents(),t=0;t<e.length;t+=1){this.observer.attach(e[t]);}this.observer.attach(this.$el[0],{childList:this.params.observeSlideChildren}),this.observer.attach(this.$wrapperEl[0],{attributes:!1});}},destroy:function destroy(){this.observer.observers.forEach(function(e){e.disconnect();}),this.observer.observers=[];}},_={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function create(){n.extend(this,{observer:{init:U.init.bind(this),attach:U.attach.bind(this),destroy:U.destroy.bind(this),observers:[]}});},on:{init:function init(){this.observer.init();},destroy:function destroy(){this.observer.destroy();}}},J={update:function update(e){var t=this,i=t.params,s=i.slidesPerView,a=i.slidesPerGroup,r=i.centeredSlides,o=t.params.virtual,l=o.addSlidesBefore,d=o.addSlidesAfter,h=t.virtual,p=h.from,c=h.to,u=h.slides,v=h.slidesGrid,f=h.renderSlide,m=h.offset;t.updateActiveIndex();var g,b,w,y=t.activeIndex||0;g=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(b=Math.floor(s/2)+a+l,w=Math.floor(s/2)+a+d):(b=s+(a-1)+l,w=a+d);var x=Math.max((y||0)-w,0),T=Math.min((y||0)+b,u.length-1),E=(t.slidesGrid[x]||0)-(t.slidesGrid[0]||0);function S(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load();}if(n.extend(t.virtual,{from:x,to:T,offset:E,slidesGrid:t.slidesGrid}),p===x&&c===T&&!e)return t.slidesGrid!==v&&E!==m&&t.slides.css(g,E+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:E,from:x,to:T,slides:function(){for(var e=[],t=x;t<=T;t+=1){e.push(u[t]);}return e;}()}),void S();var C=[],M=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var P=p;P<=c;P+=1){(P<x||P>T)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+P+'"]').remove();}for(var z=0;z<u.length;z+=1){z>=x&&z<=T&&(void 0===c||e?M.push(z):(z>c&&M.push(z),z<p&&C.push(z)));}M.forEach(function(e){t.$wrapperEl.append(f(u[e],e));}),C.sort(function(e,t){return t-e;}).forEach(function(e){t.$wrapperEl.prepend(f(u[e],e));}),t.$wrapperEl.children(".swiper-slide").css(g,E+"px"),S();},renderSlide:function renderSlide(e,t){var i=this.params.virtual;if(i.cache&&this.virtual.cache[t])return this.virtual.cache[t];var a=i.renderSlide?s(i.renderSlide.call(this,e,t)):s('<div class="'+this.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return a.attr("data-swiper-slide-index")||a.attr("data-swiper-slide-index",t),i.cache&&(this.virtual.cache[t]=a),a;},appendSlide:function appendSlide(e){if("object"==_typeof(e)&&"length"in e)for(var t=0;t<e.length;t+=1){e[t]&&this.virtual.slides.push(e[t]);}else this.virtual.slides.push(e);this.virtual.update(!0);},prependSlide:function prependSlide(e){var t=this.activeIndex,i=t+1,s=1;if(Array.isArray(e)){for(var a=0;a<e.length;a+=1){e[a]&&this.virtual.slides.unshift(e[a]);}i=t+e.length,s=e.length;}else this.virtual.slides.unshift(e);if(this.params.virtual.cache){var r=this.virtual.cache,n={};Object.keys(r).forEach(function(e){var t=r[e],i=t.attr("data-swiper-slide-index");i&&t.attr("data-swiper-slide-index",parseInt(i,10)+1),n[parseInt(e,10)+s]=t;}),this.virtual.cache=n;}this.virtual.update(!0),this.slideTo(i,0);},removeSlide:function removeSlide(e){if(null!=e){var t=this.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1){this.virtual.slides.splice(e[i],1),this.params.virtual.cache&&delete this.virtual.cache[e[i]],e[i]<t&&(t-=1),t=Math.max(t,0);}else this.virtual.slides.splice(e,1),this.params.virtual.cache&&delete this.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);this.virtual.update(!0),this.slideTo(t,0);}},removeAllSlides:function removeAllSlides(){this.virtual.slides=[],this.params.virtual.cache&&(this.virtual.cache={}),this.virtual.update(!0),this.slideTo(0,0);}},Z={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,addSlidesBefore:0,addSlidesAfter:0}},create:function create(){n.extend(this,{virtual:{update:J.update.bind(this),appendSlide:J.appendSlide.bind(this),prependSlide:J.prependSlide.bind(this),removeSlide:J.removeSlide.bind(this),removeAllSlides:J.removeAllSlides.bind(this),renderSlide:J.renderSlide.bind(this),slides:this.params.virtual.slides,cache:{}}});},on:{beforeInit:function beforeInit(){if(this.params.virtual.enabled){this.classNames.push(this.params.containerModifierClass+"virtual");var e={watchSlidesProgress:!0};n.extend(this.params,e),n.extend(this.originalParams,e),this.params.initialSlide||this.virtual.update();}},setTranslate:function setTranslate(){this.params.virtual.enabled&&this.virtual.update();}}},Q={handle:function handle(i){var s=this.rtlTranslate,a=i;a.originalEvent&&(a=a.originalEvent);var r=a.keyCode||a.charCode;if(!this.allowSlideNext&&(this.isHorizontal()&&39===r||this.isVertical()&&40===r||34===r))return!1;if(!this.allowSlidePrev&&(this.isHorizontal()&&37===r||this.isVertical()&&38===r||33===r))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||e.activeElement&&e.activeElement.nodeName&&("input"===e.activeElement.nodeName.toLowerCase()||"textarea"===e.activeElement.nodeName.toLowerCase()))){if(this.params.keyboard.onlyInViewport&&(33===r||34===r||37===r||39===r||38===r||40===r)){var n=!1;if(this.$el.parents("."+this.params.slideClass).length>0&&0===this.$el.parents("."+this.params.slideActiveClass).length)return;var o=t.innerWidth,l=t.innerHeight,d=this.$el.offset();s&&(d.left-=this.$el[0].scrollLeft);for(var h=[[d.left,d.top],[d.left+this.width,d.top],[d.left,d.top+this.height],[d.left+this.width,d.top+this.height]],p=0;p<h.length;p+=1){var c=h[p];c[0]>=0&&c[0]<=o&&c[1]>=0&&c[1]<=l&&(n=!0);}if(!n)return;}this.isHorizontal()?(33!==r&&34!==r&&37!==r&&39!==r||(a.preventDefault?a.preventDefault():a.returnValue=!1),(34!==r&&39!==r||s)&&(33!==r&&37!==r||!s)||this.slideNext(),(33!==r&&37!==r||s)&&(34!==r&&39!==r||!s)||this.slidePrev()):(33!==r&&34!==r&&38!==r&&40!==r||(a.preventDefault?a.preventDefault():a.returnValue=!1),34!==r&&40!==r||this.slideNext(),33!==r&&38!==r||this.slidePrev()),this.emit("keyPress",r);}},enable:function enable(){this.keyboard.enabled||(s(e).on("keydown",this.keyboard.handle),this.keyboard.enabled=!0);},disable:function disable(){this.keyboard.enabled&&(s(e).off("keydown",this.keyboard.handle),this.keyboard.enabled=!1);}},ee={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0}},create:function create(){n.extend(this,{keyboard:{enabled:!1,enable:Q.enable.bind(this),disable:Q.disable.bind(this),handle:Q.handle.bind(this)}});},on:{init:function init(){this.params.keyboard.enabled&&this.keyboard.enable();},destroy:function destroy(){this.keyboard.enabled&&this.keyboard.disable();}}},te={lastScrollTime:n.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function event(){return t.navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var t=("onwheel"in e);if(!t){var i=e.createElement("div");i.setAttribute("onwheel","return;"),t="function"==typeof i.onwheel;}return!t&&e.implementation&&e.implementation.hasFeature&&!0!==e.implementation.hasFeature("","")&&(t=e.implementation.hasFeature("Events.wheel","3.0")),t;}()?"wheel":"mousewheel";},normalize:function normalize(e){var t=0,i=0,s=0,a=0;return"detail"in e&&(i=e.detail),"wheelDelta"in e&&(i=-e.wheelDelta/120),"wheelDeltaY"in e&&(i=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=i,i=0),s=10*t,a=10*i,"deltaY"in e&&(a=e.deltaY),"deltaX"in e&&(s=e.deltaX),e.shiftKey&&!s&&(s=a,a=0),(s||a)&&e.deltaMode&&(1===e.deltaMode?(s*=40,a*=40):(s*=800,a*=800)),s&&!t&&(t=s<1?-1:1),a&&!i&&(i=a<1?-1:1),{spinX:t,spinY:i,pixelX:s,pixelY:a};},handleMouseEnter:function handleMouseEnter(){this.mouseEntered=!0;},handleMouseLeave:function handleMouseLeave(){this.mouseEntered=!1;},handle:function handle(e){var t=e,i=this,a=i.params.mousewheel;i.params.cssMode&&t.preventDefault();var r=i.$el;if("container"!==i.params.mousewheel.eventsTarged&&(r=s(i.params.mousewheel.eventsTarged)),!i.mouseEntered&&!r[0].contains(t.target)&&!a.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var o=0,l=i.rtlTranslate?-1:1,d=te.normalize(t);if(a.forceToAxis){if(i.isHorizontal()){if(!(Math.abs(d.pixelX)>Math.abs(d.pixelY)))return!0;o=d.pixelX*l;}else{if(!(Math.abs(d.pixelY)>Math.abs(d.pixelX)))return!0;o=d.pixelY;}}else o=Math.abs(d.pixelX)>Math.abs(d.pixelY)?-d.pixelX*l:-d.pixelY;if(0===o)return!0;if(a.invert&&(o=-o),i.params.freeMode){var h={time:n.now(),delta:Math.abs(o),direction:Math.sign(o)},p=i.mousewheel.lastEventBeforeSnap,c=p&&h.time<p.time+500&&h.delta<=p.delta&&h.direction===p.direction;if(!c){i.mousewheel.lastEventBeforeSnap=void 0,i.params.loop&&i.loopFix();var u=i.getTranslate()+o*a.sensitivity,v=i.isBeginning,f=i.isEnd;if(u>=i.minTranslate()&&(u=i.minTranslate()),u<=i.maxTranslate()&&(u=i.maxTranslate()),i.setTransition(0),i.setTranslate(u),i.updateProgress(),i.updateActiveIndex(),i.updateSlidesClasses(),(!v&&i.isBeginning||!f&&i.isEnd)&&i.updateSlidesClasses(),i.params.freeModeSticky){clearTimeout(i.mousewheel.timeout),i.mousewheel.timeout=void 0;var m=i.mousewheel.recentWheelEvents;m.length>=15&&m.shift();var g=m.length?m[m.length-1]:void 0,b=m[0];if(m.push(h),g&&(h.delta>g.delta||h.direction!==g.direction))m.splice(0);else if(m.length>=15&&h.time-b.time<500&&b.delta-h.delta>=1&&h.delta<=6){var w=o>0?.8:.2;i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.mousewheel.timeout=n.nextTick(function(){i.slideToClosest(i.params.speed,!0,void 0,w);},0);}i.mousewheel.timeout||(i.mousewheel.timeout=n.nextTick(function(){i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.slideToClosest(i.params.speed,!0,void 0,.5);},500));}if(c||i.emit("scroll",t),i.params.autoplay&&i.params.autoplayDisableOnInteraction&&i.autoplay.stop(),u===i.minTranslate()||u===i.maxTranslate())return!0;}}else{var y={time:n.now(),delta:Math.abs(o),direction:Math.sign(o),raw:e},x=i.mousewheel.recentWheelEvents;x.length>=2&&x.shift();var T=x.length?x[x.length-1]:void 0;if(x.push(y),T?(y.direction!==T.direction||y.delta>T.delta)&&i.mousewheel.animateSlider(y):i.mousewheel.animateSlider(y),i.mousewheel.releaseScroll(y))return!0;}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1;},animateSlider:function animateSlider(e){return e.delta>=6&&n.now()-this.mousewheel.lastScrollTime<60||(e.direction<0?this.isEnd&&!this.params.loop||this.animating||(this.slideNext(),this.emit("scroll",e.raw)):this.isBeginning&&!this.params.loop||this.animating||(this.slidePrev(),this.emit("scroll",e.raw)),this.mousewheel.lastScrollTime=new t.Date().getTime(),!1);},releaseScroll:function releaseScroll(e){var t=this.params.mousewheel;if(e.direction<0){if(this.isEnd&&!this.params.loop&&t.releaseOnEdges)return!0;}else if(this.isBeginning&&!this.params.loop&&t.releaseOnEdges)return!0;return!1;},enable:function enable(){var e=te.event();if(this.params.cssMode)return this.wrapperEl.removeEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=s(this.params.mousewheel.eventsTarged)),t.on("mouseenter",this.mousewheel.handleMouseEnter),t.on("mouseleave",this.mousewheel.handleMouseLeave),t.on(e,this.mousewheel.handle),this.mousewheel.enabled=!0,!0;},disable:function disable(){var e=te.event();if(this.params.cssMode)return this.wrapperEl.addEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(!this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=s(this.params.mousewheel.eventsTarged)),t.off(e,this.mousewheel.handle),this.mousewheel.enabled=!1,!0;}},ie={update:function update(){var e=this.params.navigation;if(!this.params.loop){var t=this.navigation,i=t.$nextEl,s=t.$prevEl;s&&s.length>0&&(this.isBeginning?s.addClass(e.disabledClass):s.removeClass(e.disabledClass),s[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass)),i&&i.length>0&&(this.isEnd?i.addClass(e.disabledClass):i.removeClass(e.disabledClass),i[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass));}},onPrevClick:function onPrevClick(e){e.preventDefault(),this.isBeginning&&!this.params.loop||this.slidePrev();},onNextClick:function onNextClick(e){e.preventDefault(),this.isEnd&&!this.params.loop||this.slideNext();},init:function init(){var e,t,i=this.params.navigation;(i.nextEl||i.prevEl)&&(i.nextEl&&(e=s(i.nextEl),this.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===this.$el.find(i.nextEl).length&&(e=this.$el.find(i.nextEl))),i.prevEl&&(t=s(i.prevEl),this.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===this.$el.find(i.prevEl).length&&(t=this.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",this.navigation.onNextClick),t&&t.length>0&&t.on("click",this.navigation.onPrevClick),n.extend(this.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}));},destroy:function destroy(){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;t&&t.length&&(t.off("click",this.navigation.onNextClick),t.removeClass(this.params.navigation.disabledClass)),i&&i.length&&(i.off("click",this.navigation.onPrevClick),i.removeClass(this.params.navigation.disabledClass));}},se={update:function update(){var e=this.rtl,t=this.params.pagination;if(t.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var i,a=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,r=this.pagination.$el,n=this.params.loop?Math.ceil((a-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length;if(this.params.loop?((i=Math.ceil((this.activeIndex-this.loopedSlides)/this.params.slidesPerGroup))>a-1-2*this.loopedSlides&&(i-=a-2*this.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==this.params.paginationType&&(i=n+i)):i=void 0!==this.snapIndex?this.snapIndex:this.activeIndex||0,"bullets"===t.type&&this.pagination.bullets&&this.pagination.bullets.length>0){var o,l,d,h=this.pagination.bullets;if(t.dynamicBullets&&(this.pagination.bulletSize=h.eq(0)[this.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(this.isHorizontal()?"width":"height",this.pagination.bulletSize*(t.dynamicMainBullets+4)+"px"),t.dynamicMainBullets>1&&void 0!==this.previousIndex&&(this.pagination.dynamicBulletIndex+=i-this.previousIndex,this.pagination.dynamicBulletIndex>t.dynamicMainBullets-1?this.pagination.dynamicBulletIndex=t.dynamicMainBullets-1:this.pagination.dynamicBulletIndex<0&&(this.pagination.dynamicBulletIndex=0)),o=i-this.pagination.dynamicBulletIndex,d=((l=o+(Math.min(h.length,t.dynamicMainBullets)-1))+o)/2),h.removeClass(t.bulletActiveClass+" "+t.bulletActiveClass+"-next "+t.bulletActiveClass+"-next-next "+t.bulletActiveClass+"-prev "+t.bulletActiveClass+"-prev-prev "+t.bulletActiveClass+"-main"),r.length>1)h.each(function(e,a){var r=s(a),n=r.index();n===i&&r.addClass(t.bulletActiveClass),t.dynamicBullets&&(n>=o&&n<=l&&r.addClass(t.bulletActiveClass+"-main"),n===o&&r.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),n===l&&r.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next"));});else{var p=h.eq(i),c=p.index();if(p.addClass(t.bulletActiveClass),t.dynamicBullets){for(var u=h.eq(o),v=h.eq(l),f=o;f<=l;f+=1){h.eq(f).addClass(t.bulletActiveClass+"-main");}if(this.params.loop){if(c>=h.length-t.dynamicMainBullets){for(var m=t.dynamicMainBullets;m>=0;m-=1){h.eq(h.length-m).addClass(t.bulletActiveClass+"-main");}h.eq(h.length-t.dynamicMainBullets-1).addClass(t.bulletActiveClass+"-prev");}else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next");}else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next");}}if(t.dynamicBullets){var g=Math.min(h.length,t.dynamicMainBullets+4),b=(this.pagination.bulletSize*g-this.pagination.bulletSize)/2-d*this.pagination.bulletSize,w=e?"right":"left";h.css(this.isHorizontal()?w:"top",b+"px");}}if("fraction"===t.type&&(r.find("."+t.currentClass).text(t.formatFractionCurrent(i+1)),r.find("."+t.totalClass).text(t.formatFractionTotal(n))),"progressbar"===t.type){var y;y=t.progressbarOpposite?this.isHorizontal()?"vertical":"horizontal":this.isHorizontal()?"horizontal":"vertical";var x=(i+1)/n,T=1,E=1;"horizontal"===y?T=x:E=x,r.find("."+t.progressbarFillClass).transform("translate3d(0,0,0) scaleX("+T+") scaleY("+E+")").transition(this.params.speed);}"custom"===t.type&&t.renderCustom?(r.html(t.renderCustom(this,i+1,n)),this.emit("paginationRender",this,r[0])):this.emit("paginationUpdate",this,r[0]),r[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](t.lockClass);}},render:function render(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,i=this.pagination.$el,s="";if("bullets"===e.type){for(var a=this.params.loop?Math.ceil((t-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length,r=0;r<a;r+=1){e.renderBullet?s+=e.renderBullet.call(this,r,e.bulletClass):s+="<"+e.bulletElement+' class="'+e.bulletClass+'"></'+e.bulletElement+">";}i.html(s),this.pagination.bullets=i.find("."+e.bulletClass);}"fraction"===e.type&&(s=e.renderFraction?e.renderFraction.call(this,e.currentClass,e.totalClass):'<span class="'+e.currentClass+'"></span> / <span class="'+e.totalClass+'"></span>',i.html(s)),"progressbar"===e.type&&(s=e.renderProgressbar?e.renderProgressbar.call(this,e.progressbarFillClass):'<span class="'+e.progressbarFillClass+'"></span>',i.html(s)),"custom"!==e.type&&this.emit("paginationRender",this.pagination.$el[0]);}},init:function init(){var e=this,t=e.params.pagination;if(t.el){var i=s(t.el);0!==i.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&i.length>1&&1===e.$el.find(t.el).length&&(i=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&i.addClass(t.clickableClass),i.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(i.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&i.addClass(t.progressbarOppositeClass),t.clickable&&i.on("click","."+t.bulletClass,function(t){t.preventDefault();var i=s(this).index()*e.params.slidesPerGroup;e.params.loop&&(i+=e.loopedSlides),e.slideTo(i);}),n.extend(e.pagination,{$el:i,el:i[0]}));}},destroy:function destroy(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.pagination.$el;t.removeClass(e.hiddenClass),t.removeClass(e.modifierClass+e.type),this.pagination.bullets&&this.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&t.off("click","."+e.bulletClass);}}},ae={setTranslate:function setTranslate(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=this.rtlTranslate,i=this.progress,s=e.dragSize,a=e.trackSize,r=e.$dragEl,n=e.$el,o=this.params.scrollbar,l=s,d=(a-s)*i;t?(d=-d)>0?(l=s-d,d=0):-d+s>a&&(l=a+d):d<0?(l=s+d,d=0):d+s>a&&(l=a-d),this.isHorizontal()?(r.transform("translate3d("+d+"px, 0, 0)"),r[0].style.width=l+"px"):(r.transform("translate3d(0px, "+d+"px, 0)"),r[0].style.height=l+"px"),o.hide&&(clearTimeout(this.scrollbar.timeout),n[0].style.opacity=1,this.scrollbar.timeout=setTimeout(function(){n[0].style.opacity=0,n.transition(400);},1e3));}},setTransition:function setTransition(e){this.params.scrollbar.el&&this.scrollbar.el&&this.scrollbar.$dragEl.transition(e);},updateSize:function updateSize(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=e.$dragEl,i=e.$el;t[0].style.width="",t[0].style.height="";var s,a=this.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,r=this.size/this.virtualSize,o=r*(a/this.size);s="auto"===this.params.scrollbar.dragSize?a*r:parseInt(this.params.scrollbar.dragSize,10),this.isHorizontal()?t[0].style.width=s+"px":t[0].style.height=s+"px",i[0].style.display=r>=1?"none":"",this.params.scrollbar.hide&&(i[0].style.opacity=0),n.extend(e,{trackSize:a,divider:r,moveDivider:o,dragSize:s}),e.$el[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](this.params.scrollbar.lockClass);}},getPointerPosition:function getPointerPosition(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY;},setDragPosition:function setDragPosition(e){var t,i=this.scrollbar,s=this.rtlTranslate,a=i.$el,r=i.dragSize,n=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-a.offset()[this.isHorizontal()?"left":"top"]-(null!==o?o:r/2))/(n-r),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var l=this.minTranslate()+(this.maxTranslate()-this.minTranslate())*t;this.updateProgress(l),this.setTranslate(l),this.updateActiveIndex(),this.updateSlidesClasses();},onDragStart:function onDragStart(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el,r=i.$dragEl;this.scrollbar.isTouched=!0,this.scrollbar.dragStartPos=e.target===r[0]||e.target===r?i.getPointerPosition(e)-e.target.getBoundingClientRect()[this.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),r.transition(100),i.setDragPosition(e),clearTimeout(this.scrollbar.dragTimeout),a.transition(0),t.hide&&a.css("opacity",1),this.params.cssMode&&this.$wrapperEl.css("scroll-snap-type","none"),this.emit("scrollbarDragStart",e);},onDragMove:function onDragMove(e){var t=this.scrollbar,i=this.$wrapperEl,s=t.$el,a=t.$dragEl;this.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,t.setDragPosition(e),i.transition(0),s.transition(0),a.transition(0),this.emit("scrollbarDragMove",e));},onDragEnd:function onDragEnd(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el;this.scrollbar.isTouched&&(this.scrollbar.isTouched=!1,this.params.cssMode&&(this.$wrapperEl.css("scroll-snap-type",""),s.transition("")),t.hide&&(clearTimeout(this.scrollbar.dragTimeout),this.scrollbar.dragTimeout=n.nextTick(function(){a.css("opacity",0),a.transition(400);},1e3)),this.emit("scrollbarDragEnd",e),t.snapOnRelease&&this.slideToClosest());},enableDraggable:function enableDraggable(){if(this.params.scrollbar.el){var t=this.scrollbar,i=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=t.$el[0],n=!(!o.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},l=!(!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};o.touch?(r.addEventListener(i.start,this.scrollbar.onDragStart,n),r.addEventListener(i.move,this.scrollbar.onDragMove,n),r.addEventListener(i.end,this.scrollbar.onDragEnd,l)):(r.addEventListener(s.start,this.scrollbar.onDragStart,n),e.addEventListener(s.move,this.scrollbar.onDragMove,n),e.addEventListener(s.end,this.scrollbar.onDragEnd,l));}},disableDraggable:function disableDraggable(){if(this.params.scrollbar.el){var t=this.scrollbar,i=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=t.$el[0],n=!(!o.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},l=!(!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};o.touch?(r.removeEventListener(i.start,this.scrollbar.onDragStart,n),r.removeEventListener(i.move,this.scrollbar.onDragMove,n),r.removeEventListener(i.end,this.scrollbar.onDragEnd,l)):(r.removeEventListener(s.start,this.scrollbar.onDragStart,n),e.removeEventListener(s.move,this.scrollbar.onDragMove,n),e.removeEventListener(s.end,this.scrollbar.onDragEnd,l));}},init:function init(){if(this.params.scrollbar.el){var e=this.scrollbar,t=this.$el,i=this.params.scrollbar,a=s(i.el);this.params.uniqueNavElements&&"string"==typeof i.el&&a.length>1&&1===t.find(i.el).length&&(a=t.find(i.el));var r=a.find("."+this.params.scrollbar.dragClass);0===r.length&&(r=s('<div class="'+this.params.scrollbar.dragClass+'"></div>'),a.append(r)),n.extend(e,{$el:a,el:a[0],$dragEl:r,dragEl:r[0]}),i.draggable&&e.enableDraggable();}},destroy:function destroy(){this.scrollbar.disableDraggable();}},re={setTransform:function setTransform(e,t){var i=this.rtl,a=s(e),r=i?-1:1,n=a.attr("data-swiper-parallax")||"0",o=a.attr("data-swiper-parallax-x"),l=a.attr("data-swiper-parallax-y"),d=a.attr("data-swiper-parallax-scale"),h=a.attr("data-swiper-parallax-opacity");if(o||l?(o=o||"0",l=l||"0"):this.isHorizontal()?(o=n,l="0"):(l=n,o="0"),o=o.indexOf("%")>=0?parseInt(o,10)*t*r+"%":o*t*r+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=h){var p=h-(h-1)*(1-Math.abs(t));a[0].style.opacity=p;}if(null==d)a.transform("translate3d("+o+", "+l+", 0px)");else{var c=d-(d-1)*(1-Math.abs(t));a.transform("translate3d("+o+", "+l+", 0px) scale("+c+")");}},setTranslate:function setTranslate(){var e=this,t=e.$el,i=e.slides,a=e.progress,r=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(t,i){e.parallax.setTransform(i,a);}),i.each(function(t,i){var n=i.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(n+=Math.ceil(t/2)-a*(r.length-1)),n=Math.min(Math.max(n,-1),1),s(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(t,i){e.parallax.setTransform(i,n);});});},setTransition:function setTransition(e){void 0===e&&(e=this.params.speed),this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(t,i){var a=s(i),r=parseInt(a.attr("data-swiper-parallax-duration"),10)||e;0===e&&(r=0),a.transition(r);});}},ne={getDistanceBetweenTouches:function getDistanceBetweenTouches(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,i=e.targetTouches[0].pageY,s=e.targetTouches[1].pageX,a=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s-t,2)+Math.pow(a-i,2));},onGestureStart:function onGestureStart(e){var t=this.params.zoom,i=this.zoom,a=i.gesture;if(i.fakeGestureTouched=!1,i.fakeGestureMoved=!1,!o.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;i.fakeGestureTouched=!0,a.scaleStart=ne.getDistanceBetweenTouches(e);}a.$slideEl&&a.$slideEl.length||(a.$slideEl=s(e.target).closest("."+this.params.slideClass),0===a.$slideEl.length&&(a.$slideEl=this.slides.eq(this.activeIndex)),a.$imageEl=a.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),a.$imageWrapEl=a.$imageEl.parent("."+t.containerClass),a.maxRatio=a.$imageWrapEl.attr("data-swiper-zoom")||t.maxRatio,0!==a.$imageWrapEl.length)?(a.$imageEl&&a.$imageEl.transition(0),this.zoom.isScaling=!0):a.$imageEl=void 0;},onGestureChange:function onGestureChange(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!o.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;i.fakeGestureMoved=!0,s.scaleMove=ne.getDistanceBetweenTouches(e);}s.$imageEl&&0!==s.$imageEl.length&&(i.scale=o.gestures?e.scale*i.currentScale:s.scaleMove/s.scaleStart*i.currentScale,i.scale>s.maxRatio&&(i.scale=s.maxRatio-1+Math.pow(i.scale-s.maxRatio+1,.5)),i.scale<t.minRatio&&(i.scale=t.minRatio+1-Math.pow(t.minRatio-i.scale+1,.5)),s.$imageEl.transform("translate3d(0,0,0) scale("+i.scale+")"));},onGestureEnd:function onGestureEnd(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!o.gestures){if(!i.fakeGestureTouched||!i.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!L.android)return;i.fakeGestureTouched=!1,i.fakeGestureMoved=!1;}s.$imageEl&&0!==s.$imageEl.length&&(i.scale=Math.max(Math.min(i.scale,s.maxRatio),t.minRatio),s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale("+i.scale+")"),i.currentScale=i.scale,i.isScaling=!1,1===i.scale&&(s.$slideEl=void 0));},onTouchStart:function onTouchStart(e){var t=this.zoom,i=t.gesture,s=t.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(L.android&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY));},onTouchMove:function onTouchMove(e){var t=this.zoom,i=t.gesture,s=t.image,a=t.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(this.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=n.getTranslate(i.$imageWrapEl[0],"x")||0,s.startY=n.getTranslate(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0),this.rtl&&(s.startX=-s.startX,s.startY=-s.startY));var r=s.width*t.scale,o=s.height*t.scale;if(!(r<i.slideWidth&&o<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-r/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-o/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!t.isScaling){if(this.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!this.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1);}e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),a.prevPositionX||(a.prevPositionX=s.touchesCurrent.x),a.prevPositionY||(a.prevPositionY=s.touchesCurrent.y),a.prevTime||(a.prevTime=Date.now()),a.x=(s.touchesCurrent.x-a.prevPositionX)/(Date.now()-a.prevTime)/2,a.y=(s.touchesCurrent.y-a.prevPositionY)/(Date.now()-a.prevTime)/2,Math.abs(s.touchesCurrent.x-a.prevPositionX)<2&&(a.x=0),Math.abs(s.touchesCurrent.y-a.prevPositionY)<2&&(a.y=0),a.prevPositionX=s.touchesCurrent.x,a.prevPositionY=s.touchesCurrent.y,a.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)");}}},onTouchEnd:function onTouchEnd(){var e=this.zoom,t=e.gesture,i=e.image,s=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!i.isTouched||!i.isMoved)return i.isTouched=!1,void(i.isMoved=!1);i.isTouched=!1,i.isMoved=!1;var a=300,r=300,n=s.x*a,o=i.currentX+n,l=s.y*r,d=i.currentY+l;0!==s.x&&(a=Math.abs((o-i.currentX)/s.x)),0!==s.y&&(r=Math.abs((d-i.currentY)/s.y));var h=Math.max(a,r);i.currentX=o,i.currentY=d;var p=i.width*e.scale,c=i.height*e.scale;i.minX=Math.min(t.slideWidth/2-p/2,0),i.maxX=-i.minX,i.minY=Math.min(t.slideHeight/2-c/2,0),i.maxY=-i.minY,i.currentX=Math.max(Math.min(i.currentX,i.maxX),i.minX),i.currentY=Math.max(Math.min(i.currentY,i.maxY),i.minY),t.$imageWrapEl.transition(h).transform("translate3d("+i.currentX+"px, "+i.currentY+"px,0)");}},onTransitionEnd:function onTransitionEnd(){var e=this.zoom,t=e.gesture;t.$slideEl&&this.previousIndex!==this.activeIndex&&(t.$imageEl&&t.$imageEl.transform("translate3d(0,0,0) scale(1)"),t.$imageWrapEl&&t.$imageWrapEl.transform("translate3d(0,0,0)"),e.scale=1,e.currentScale=1,t.$slideEl=void 0,t.$imageEl=void 0,t.$imageWrapEl=void 0);},toggle:function toggle(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e);},in:function _in(e){var t,i,s,a,r,n,o,l,d,h,p,c,u,v,f,m,g=this.zoom,b=this.params.zoom,w=g.gesture,y=g.image;w.$slideEl||(this.params.virtual&&this.params.virtual.enabled&&this.virtual?w.$slideEl=this.$wrapperEl.children("."+this.params.slideActiveClass):w.$slideEl=this.slides.eq(this.activeIndex),w.$imageEl=w.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),w.$imageWrapEl=w.$imageEl.parent("."+b.containerClass)),w.$imageEl&&0!==w.$imageEl.length&&(w.$slideEl.addClass(""+b.zoomedSlideClass),void 0===y.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,i="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=y.touchesStart.x,i=y.touchesStart.y),g.scale=w.$imageWrapEl.attr("data-swiper-zoom")||b.maxRatio,g.currentScale=w.$imageWrapEl.attr("data-swiper-zoom")||b.maxRatio,e?(f=w.$slideEl[0].offsetWidth,m=w.$slideEl[0].offsetHeight,s=w.$slideEl.offset().left+f/2-t,a=w.$slideEl.offset().top+m/2-i,o=w.$imageEl[0].offsetWidth,l=w.$imageEl[0].offsetHeight,d=o*g.scale,h=l*g.scale,u=-(p=Math.min(f/2-d/2,0)),v=-(c=Math.min(m/2-h/2,0)),(r=s*g.scale)<p&&(r=p),r>u&&(r=u),(n=a*g.scale)<c&&(n=c),n>v&&(n=v)):(r=0,n=0),w.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),w.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+g.scale+")"));},out:function out(){var e=this.zoom,t=this.params.zoom,i=e.gesture;i.$slideEl||(this.params.virtual&&this.params.virtual.enabled&&this.virtual?i.$slideEl=this.$wrapperEl.children("."+this.params.slideActiveClass):i.$slideEl=this.slides.eq(this.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),i.$imageWrapEl=i.$imageEl.parent("."+t.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&(e.scale=1,e.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+t.zoomedSlideClass),i.$slideEl=void 0);},enable:function enable(){var e=this.zoom;if(!e.enabled){e.enabled=!0;var t=!("touchstart"!==this.touchEvents.start||!o.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!o.passiveListener||{passive:!1,capture:!0},s="."+this.params.slideClass;o.gestures?(this.$wrapperEl.on("gesturestart",s,e.onGestureStart,t),this.$wrapperEl.on("gesturechange",s,e.onGestureChange,t),this.$wrapperEl.on("gestureend",s,e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.on(this.touchEvents.start,s,e.onGestureStart,t),this.$wrapperEl.on(this.touchEvents.move,s,e.onGestureChange,i),this.$wrapperEl.on(this.touchEvents.end,s,e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.on(this.touchEvents.cancel,s,e.onGestureEnd,t)),this.$wrapperEl.on(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i);}},disable:function disable(){var e=this.zoom;if(e.enabled){this.zoom.enabled=!1;var t=!("touchstart"!==this.touchEvents.start||!o.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!o.passiveListener||{passive:!1,capture:!0},s="."+this.params.slideClass;o.gestures?(this.$wrapperEl.off("gesturestart",s,e.onGestureStart,t),this.$wrapperEl.off("gesturechange",s,e.onGestureChange,t),this.$wrapperEl.off("gestureend",s,e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.off(this.touchEvents.start,s,e.onGestureStart,t),this.$wrapperEl.off(this.touchEvents.move,s,e.onGestureChange,i),this.$wrapperEl.off(this.touchEvents.end,s,e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.off(this.touchEvents.cancel,s,e.onGestureEnd,t)),this.$wrapperEl.off(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i);}}},oe={loadInSlide:function loadInSlide(e,t){void 0===t&&(t=!0);var i=this,a=i.params.lazy;if(void 0!==e&&0!==i.slides.length){var r=i.virtual&&i.params.virtual.enabled?i.$wrapperEl.children("."+i.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):i.slides.eq(e),n=r.find("."+a.elementClass+":not(."+a.loadedClass+"):not(."+a.loadingClass+")");!r.hasClass(a.elementClass)||r.hasClass(a.loadedClass)||r.hasClass(a.loadingClass)||(n=n.add(r[0])),0!==n.length&&n.each(function(e,n){var o=s(n);o.addClass(a.loadingClass);var l=o.attr("data-background"),d=o.attr("data-src"),h=o.attr("data-srcset"),p=o.attr("data-sizes");i.loadImage(o[0],d||l,h,p,!1,function(){if(null!=i&&i&&(!i||i.params)&&!i.destroyed){if(l?(o.css("background-image",'url("'+l+'")'),o.removeAttr("data-background")):(h&&(o.attr("srcset",h),o.removeAttr("data-srcset")),p&&(o.attr("sizes",p),o.removeAttr("data-sizes")),d&&(o.attr("src",d),o.removeAttr("data-src"))),o.addClass(a.loadedClass).removeClass(a.loadingClass),r.find("."+a.preloaderClass).remove(),i.params.loop&&t){var e=r.attr("data-swiper-slide-index");if(r.hasClass(i.params.slideDuplicateClass)){var s=i.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+i.params.slideDuplicateClass+")");i.lazy.loadInSlide(s.index(),!1);}else{var n=i.$wrapperEl.children("."+i.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');i.lazy.loadInSlide(n.index(),!1);}}i.emit("lazyImageReady",r[0],o[0]),i.params.autoHeight&&i.updateAutoHeight();}}),i.emit("lazyImageLoad",r[0],o[0]);});}},load:function load(){var e=this,t=e.$wrapperEl,i=e.params,a=e.slides,r=e.activeIndex,n=e.virtual&&i.virtual.enabled,o=i.lazy,l=i.slidesPerView;function d(e){if(n){if(t.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0;}else if(a[e])return!0;return!1;}function h(e){return n?s(e).attr("data-swiper-slide-index"):s(e).index();}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+i.slideVisibleClass).each(function(t,i){var a=n?s(i).attr("data-swiper-slide-index"):s(i).index();e.lazy.loadInSlide(a);});else if(l>1)for(var p=r;p<r+l;p+=1){d(p)&&e.lazy.loadInSlide(p);}else e.lazy.loadInSlide(r);if(o.loadPrevNext)if(l>1||o.loadPrevNextAmount&&o.loadPrevNextAmount>1){for(var c=o.loadPrevNextAmount,u=l,v=Math.min(r+u+Math.max(c,u),a.length),f=Math.max(r-Math.max(u,c),0),m=r+l;m<v;m+=1){d(m)&&e.lazy.loadInSlide(m);}for(var g=f;g<r;g+=1){d(g)&&e.lazy.loadInSlide(g);}}else{var b=t.children("."+i.slideNextClass);b.length>0&&e.lazy.loadInSlide(h(b));var w=t.children("."+i.slidePrevClass);w.length>0&&e.lazy.loadInSlide(h(w));}}},le={LinearSpline:function LinearSpline(e,t){var i,s,a,r,n;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=function(e,t){for(s=-1,i=e.length;i-s>1;){e[a=i+s>>1]<=t?s=a:i=a;}return i;}(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0;},this;},getInterpolateFunction:function getInterpolateFunction(e){this.controller.spline||(this.controller.spline=this.params.loop?new le.LinearSpline(this.slidesGrid,e.slidesGrid):new le.LinearSpline(this.snapGrid,e.snapGrid));},setTranslate:function setTranslate(e,t){var i,s,a=this,r=a.controller.control;function n(e){var t=a.rtlTranslate?-a.translate:a.translate;"slide"===a.params.controller.by&&(a.controller.getInterpolateFunction(e),s=-a.controller.spline.interpolate(-t)),s&&"container"!==a.params.controller.by||(i=(e.maxTranslate()-e.minTranslate())/(a.maxTranslate()-a.minTranslate()),s=(t-a.minTranslate())*i+e.minTranslate()),a.params.controller.inverse&&(s=e.maxTranslate()-s),e.updateProgress(s),e.setTranslate(s,a),e.updateActiveIndex(),e.updateSlidesClasses();}if(Array.isArray(r))for(var o=0;o<r.length;o+=1){r[o]!==t&&r[o]instanceof F&&n(r[o]);}else r instanceof F&&t!==r&&n(r);},setTransition:function setTransition(e,t){var i,s=this,a=s.controller.control;function r(t){t.setTransition(e,s),0!==e&&(t.transitionStart(),t.params.autoHeight&&n.nextTick(function(){t.updateAutoHeight();}),t.$wrapperEl.transitionEnd(function(){a&&(t.params.loop&&"slide"===s.params.controller.by&&t.loopFix(),t.transitionEnd());}));}if(Array.isArray(a))for(i=0;i<a.length;i+=1){a[i]!==t&&a[i]instanceof F&&r(a[i]);}else a instanceof F&&t!==a&&r(a);}},de={makeElFocusable:function makeElFocusable(e){return e.attr("tabIndex","0"),e;},addElRole:function addElRole(e,t){return e.attr("role",t),e;},addElLabel:function addElLabel(e,t){return e.attr("aria-label",t),e;},disableEl:function disableEl(e){return e.attr("aria-disabled",!0),e;},enableEl:function enableEl(e){return e.attr("aria-disabled",!1),e;},onEnterKey:function onEnterKey(e){var t=this.params.a11y;if(13===e.keyCode){var i=s(e.target);this.navigation&&this.navigation.$nextEl&&i.is(this.navigation.$nextEl)&&(this.isEnd&&!this.params.loop||this.slideNext(),this.isEnd?this.a11y.notify(t.lastSlideMessage):this.a11y.notify(t.nextSlideMessage)),this.navigation&&this.navigation.$prevEl&&i.is(this.navigation.$prevEl)&&(this.isBeginning&&!this.params.loop||this.slidePrev(),this.isBeginning?this.a11y.notify(t.firstSlideMessage):this.a11y.notify(t.prevSlideMessage)),this.pagination&&i.is("."+this.params.pagination.bulletClass)&&i[0].click();}},notify:function notify(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e));},updateNavigation:function updateNavigation(){if(!this.params.loop&&this.navigation){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;i&&i.length>0&&(this.isBeginning?this.a11y.disableEl(i):this.a11y.enableEl(i)),t&&t.length>0&&(this.isEnd?this.a11y.disableEl(t):this.a11y.enableEl(t));}},updatePagination:function updatePagination(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each(function(i,a){var r=s(a);e.a11y.makeElFocusable(r),e.a11y.addElRole(r,"button"),e.a11y.addElLabel(r,t.paginationBulletMessage.replace(/\{\{index\}\}/,r.index()+1));});},init:function init(){this.$el.append(this.a11y.liveRegion);var e,t,i=this.params.a11y;this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&(this.a11y.makeElFocusable(e),this.a11y.addElRole(e,"button"),this.a11y.addElLabel(e,i.nextSlideMessage),e.on("keydown",this.a11y.onEnterKey)),t&&(this.a11y.makeElFocusable(t),this.a11y.addElRole(t,"button"),this.a11y.addElLabel(t,i.prevSlideMessage),t.on("keydown",this.a11y.onEnterKey)),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.on("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey);},destroy:function destroy(){var e,t;this.a11y.liveRegion&&this.a11y.liveRegion.length>0&&this.a11y.liveRegion.remove(),this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&e.off("keydown",this.a11y.onEnterKey),t&&t.off("keydown",this.a11y.onEnterKey),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.off("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey);}},he={init:function init(){if(this.params.history){if(!t.history||!t.history.pushState)return this.params.history.enabled=!1,void(this.params.hashNavigation.enabled=!0);var e=this.history;e.initialized=!0,e.paths=he.getPathValues(),(e.paths.key||e.paths.value)&&(e.scrollToSlide(0,e.paths.value,this.params.runCallbacksOnInit),this.params.history.replaceState||t.addEventListener("popstate",this.history.setHistoryPopState));}},destroy:function destroy(){this.params.history.replaceState||t.removeEventListener("popstate",this.history.setHistoryPopState);},setHistoryPopState:function setHistoryPopState(){this.history.paths=he.getPathValues(),this.history.scrollToSlide(this.params.speed,this.history.paths.value,!1);},getPathValues:function getPathValues(){var e=t.location.pathname.slice(1).split("/").filter(function(e){return""!==e;}),i=e.length;return{key:e[i-2],value:e[i-1]};},setHistory:function setHistory(e,i){if(this.history.initialized&&this.params.history.enabled){var s=this.slides.eq(i),a=he.slugify(s.attr("data-history"));t.location.pathname.includes(e)||(a=e+"/"+a);var r=t.history.state;r&&r.value===a||(this.params.history.replaceState?t.history.replaceState({value:a},null,a):t.history.pushState({value:a},null,a));}},slugify:function slugify(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"");},scrollToSlide:function scrollToSlide(e,t,i){if(t)for(var s=0,a=this.slides.length;s<a;s+=1){var r=this.slides.eq(s);if(he.slugify(r.attr("data-history"))===t&&!r.hasClass(this.params.slideDuplicateClass)){var n=r.index();this.slideTo(n,e,i);}}else this.slideTo(0,e,i);}},pe={onHashCange:function onHashCange(){var t=e.location.hash.replace("#","");if(t!==this.slides.eq(this.activeIndex).attr("data-hash")){var i=this.$wrapperEl.children("."+this.params.slideClass+'[data-hash="'+t+'"]').index();if(void 0===i)return;this.slideTo(i);}},setHash:function setHash(){if(this.hashNavigation.initialized&&this.params.hashNavigation.enabled)if(this.params.hashNavigation.replaceState&&t.history&&t.history.replaceState)t.history.replaceState(null,null,"#"+this.slides.eq(this.activeIndex).attr("data-hash")||!1);else{var i=this.slides.eq(this.activeIndex),s=i.attr("data-hash")||i.attr("data-history");e.location.hash=s||"";}},init:function init(){if(!(!this.params.hashNavigation.enabled||this.params.history&&this.params.history.enabled)){this.hashNavigation.initialized=!0;var i=e.location.hash.replace("#","");if(i)for(var a=0,r=this.slides.length;a<r;a+=1){var n=this.slides.eq(a);if((n.attr("data-hash")||n.attr("data-history"))===i&&!n.hasClass(this.params.slideDuplicateClass)){var o=n.index();this.slideTo(o,0,this.params.runCallbacksOnInit,!0);}}this.params.hashNavigation.watchState&&s(t).on("hashchange",this.hashNavigation.onHashCange);}},destroy:function destroy(){this.params.hashNavigation.watchState&&s(t).off("hashchange",this.hashNavigation.onHashCange);}},ce={run:function run(){var e=this,t=e.slides.eq(e.activeIndex),i=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(i=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=n.nextTick(function(){e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),e.params.cssMode&&e.autoplay.running&&e.autoplay.run();},i);},start:function start(){return void 0===this.autoplay.timeout&&!this.autoplay.running&&(this.autoplay.running=!0,this.emit("autoplayStart"),this.autoplay.run(),!0);},stop:function stop(){return!!this.autoplay.running&&void 0!==this.autoplay.timeout&&(this.autoplay.timeout&&(clearTimeout(this.autoplay.timeout),this.autoplay.timeout=void 0),this.autoplay.running=!1,this.emit("autoplayStop"),!0);},pause:function pause(e){this.autoplay.running&&(this.autoplay.paused||(this.autoplay.timeout&&clearTimeout(this.autoplay.timeout),this.autoplay.paused=!0,0!==e&&this.params.autoplay.waitForTransition?(this.$wrapperEl[0].addEventListener("transitionend",this.autoplay.onTransitionEnd),this.$wrapperEl[0].addEventListener("webkitTransitionEnd",this.autoplay.onTransitionEnd)):(this.autoplay.paused=!1,this.autoplay.run())));}},ue={setTranslate:function setTranslate(){for(var e=this.slides,t=0;t<e.length;t+=1){var i=this.slides.eq(t),s=-i[0].swiperSlideOffset;this.params.virtualTranslate||(s-=this.translate);var a=0;this.isHorizontal()||(a=s,s=0);var r=this.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:r}).transform("translate3d("+s+"px, "+a+"px, 0px)");}},setTransition:function setTransition(e){var t=this,i=t.slides,s=t.$wrapperEl;if(i.transition(e),t.params.virtualTranslate&&0!==e){var a=!1;i.transitionEnd(function(){if(!a&&t&&!t.destroyed){a=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1){s.trigger(e[i]);}}});}}},ve={setTranslate:function setTranslate(){var e,t=this.$el,i=this.$wrapperEl,a=this.slides,r=this.width,n=this.height,o=this.rtlTranslate,l=this.size,d=this.params.cubeEffect,h=this.isHorizontal(),p=this.virtual&&this.params.virtual.enabled,c=0;d.shadow&&(h?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=s('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=t.find(".swiper-cube-shadow")).length&&(e=s('<div class="swiper-cube-shadow"></div>'),t.append(e)));for(var u=0;u<a.length;u+=1){var v=a.eq(u),f=u;p&&(f=parseInt(v.attr("data-swiper-slide-index"),10));var m=90*f,g=Math.floor(m/360);o&&(m=-m,g=Math.floor(-m/360));var b=Math.max(Math.min(v[0].progress,1),-1),w=0,y=0,x=0;f%4==0?(w=4*-g*l,x=0):(f-1)%4==0?(w=0,x=4*-g*l):(f-2)%4==0?(w=l+4*g*l,x=l):(f-3)%4==0&&(w=-l,x=3*l+4*l*g),o&&(w=-w),h||(y=w,w=0);var T="rotateX("+(h?0:-m)+"deg) rotateY("+(h?m:0)+"deg) translate3d("+w+"px, "+y+"px, "+x+"px)";if(b<=1&&b>-1&&(c=90*f+90*b,o&&(c=90*-f-90*b)),v.transform(T),d.slideShadows){var E=h?v.find(".swiper-slide-shadow-left"):v.find(".swiper-slide-shadow-top"),S=h?v.find(".swiper-slide-shadow-right"):v.find(".swiper-slide-shadow-bottom");0===E.length&&(E=s('<div class="swiper-slide-shadow-'+(h?"left":"top")+'"></div>'),v.append(E)),0===S.length&&(S=s('<div class="swiper-slide-shadow-'+(h?"right":"bottom")+'"></div>'),v.append(S)),E.length&&(E[0].style.opacity=Math.max(-b,0)),S.length&&(S[0].style.opacity=Math.max(b,0));}}if(i.css({"-webkit-transform-origin":"50% 50% -"+l/2+"px","-moz-transform-origin":"50% 50% -"+l/2+"px","-ms-transform-origin":"50% 50% -"+l/2+"px","transform-origin":"50% 50% -"+l/2+"px"}),d.shadow)if(h)e.transform("translate3d(0px, "+(r/2+d.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+d.shadowScale+")");else{var C=Math.abs(c)-90*Math.floor(Math.abs(c)/90),M=1.5-(Math.sin(2*C*Math.PI/360)/2+Math.cos(2*C*Math.PI/360)/2),P=d.shadowScale,z=d.shadowScale/M,k=d.shadowOffset;e.transform("scale3d("+P+", 1, "+z+") translate3d(0px, "+(n/2+k)+"px, "+-n/2/z+"px) rotateX(-90deg)");}var $=q.isSafari||q.isUiWebView?-l/2:0;i.transform("translate3d(0px,0,"+$+"px) rotateX("+(this.isHorizontal()?0:c)+"deg) rotateY("+(this.isHorizontal()?-c:0)+"deg)");},setTransition:function setTransition(e){var t=this.$el;this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),this.params.cubeEffect.shadow&&!this.isHorizontal()&&t.find(".swiper-cube-shadow").transition(e);}},fe={setTranslate:function setTranslate(){for(var e=this.slides,t=this.rtlTranslate,i=0;i<e.length;i+=1){var a=e.eq(i),r=a[0].progress;this.params.flipEffect.limitRotation&&(r=Math.max(Math.min(a[0].progress,1),-1));var n=-180*r,o=0,l=-a[0].swiperSlideOffset,d=0;if(this.isHorizontal()?t&&(n=-n):(d=l,l=0,o=-n,n=0),a[0].style.zIndex=-Math.abs(Math.round(r))+e.length,this.params.flipEffect.slideShadows){var h=this.isHorizontal()?a.find(".swiper-slide-shadow-left"):a.find(".swiper-slide-shadow-top"),p=this.isHorizontal()?a.find(".swiper-slide-shadow-right"):a.find(".swiper-slide-shadow-bottom");0===h.length&&(h=s('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"left":"top")+'"></div>'),a.append(h)),0===p.length&&(p=s('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"right":"bottom")+'"></div>'),a.append(p)),h.length&&(h[0].style.opacity=Math.max(-r,0)),p.length&&(p[0].style.opacity=Math.max(r,0));}a.transform("translate3d("+l+"px, "+d+"px, 0px) rotateX("+o+"deg) rotateY("+n+"deg)");}},setTransition:function setTransition(e){var t=this,i=t.slides,s=t.activeIndex,a=t.$wrapperEl;if(i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;i.eq(s).transitionEnd(function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1){a.trigger(e[i]);}}});}}},me={setTranslate:function setTranslate(){for(var e=this.width,t=this.height,i=this.slides,a=this.$wrapperEl,r=this.slidesSizesGrid,n=this.params.coverflowEffect,l=this.isHorizontal(),d=this.translate,h=l?e/2-d:t/2-d,p=l?n.rotate:-n.rotate,c=n.depth,u=0,v=i.length;u<v;u+=1){var f=i.eq(u),m=r[u],g=(h-f[0].swiperSlideOffset-m/2)/m*n.modifier,b=l?p*g:0,w=l?0:p*g,y=-c*Math.abs(g),x=n.stretch;"string"==typeof x&&-1!==x.indexOf("%")&&(x=parseFloat(n.stretch)/100*m);var T=l?0:x*g,E=l?x*g:0;Math.abs(E)<.001&&(E=0),Math.abs(T)<.001&&(T=0),Math.abs(y)<.001&&(y=0),Math.abs(b)<.001&&(b=0),Math.abs(w)<.001&&(w=0);var S="translate3d("+E+"px,"+T+"px,"+y+"px)  rotateX("+w+"deg) rotateY("+b+"deg)";if(f.transform(S),f[0].style.zIndex=1-Math.abs(Math.round(g)),n.slideShadows){var C=l?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),M=l?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===C.length&&(C=s('<div class="swiper-slide-shadow-'+(l?"left":"top")+'"></div>'),f.append(C)),0===M.length&&(M=s('<div class="swiper-slide-shadow-'+(l?"right":"bottom")+'"></div>'),f.append(M)),C.length&&(C[0].style.opacity=g>0?g:0),M.length&&(M[0].style.opacity=-g>0?-g:0);}}(o.pointerEvents||o.prefixedPointerEvents)&&(a[0].style.perspectiveOrigin=h+"px 50%");},setTransition:function setTransition(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);}},ge={init:function init(){var e=this.params.thumbs,t=this.constructor;e.swiper instanceof t?(this.thumbs.swiper=e.swiper,n.extend(this.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),n.extend(this.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):n.isObject(e.swiper)&&(this.thumbs.swiper=new t(n.extend({},e.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),this.thumbs.swiperCreated=!0),this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass),this.thumbs.swiper.on("tap",this.thumbs.onThumbClick);},onThumbClick:function onThumbClick(){var e=this.thumbs.swiper;if(e){var t=e.clickedIndex,i=e.clickedSlide;if(!(i&&s(i).hasClass(this.params.thumbs.slideThumbActiveClass)||null==t)){var a;if(a=e.params.loop?parseInt(s(e.clickedSlide).attr("data-swiper-slide-index"),10):t,this.params.loop){var r=this.activeIndex;this.slides.eq(r).hasClass(this.params.slideDuplicateClass)&&(this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft,r=this.activeIndex);var n=this.slides.eq(r).prevAll('[data-swiper-slide-index="'+a+'"]').eq(0).index(),o=this.slides.eq(r).nextAll('[data-swiper-slide-index="'+a+'"]').eq(0).index();a=void 0===n?o:void 0===o?n:o-r<r-n?o:n;}this.slideTo(a);}}},update:function update(e){var t=this.thumbs.swiper;if(t){var i="auto"===t.params.slidesPerView?t.slidesPerViewDynamic():t.params.slidesPerView,s=this.params.thumbs.autoScrollOffset,a=s&&!t.params.loop;if(this.realIndex!==t.realIndex||a){var r,n,o=t.activeIndex;if(t.params.loop){t.slides.eq(o).hasClass(t.params.slideDuplicateClass)&&(t.loopFix(),t._clientLeft=t.$wrapperEl[0].clientLeft,o=t.activeIndex);var l=t.slides.eq(o).prevAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index(),d=t.slides.eq(o).nextAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index();r=void 0===l?d:void 0===d?l:d-o==o-l?o:d-o<o-l?d:l,n=this.activeIndex>this.previousIndex?"next":"prev";}else n=(r=this.realIndex)>this.previousIndex?"next":"prev";a&&(r+="next"===n?s:-1*s),t.visibleSlidesIndexes&&t.visibleSlidesIndexes.indexOf(r)<0&&(t.params.centeredSlides?r=r>o?r-Math.floor(i/2)+1:r+Math.floor(i/2)-1:r>o&&(r=r-i+1),t.slideTo(r,e?0:void 0));}var h=1,p=this.params.thumbs.slideThumbActiveClass;if(this.params.slidesPerView>1&&!this.params.centeredSlides&&(h=this.params.slidesPerView),this.params.thumbs.multipleActiveThumbs||(h=1),h=Math.floor(h),t.slides.removeClass(p),t.params.loop||t.params.virtual&&t.params.virtual.enabled)for(var c=0;c<h;c+=1){t.$wrapperEl.children('[data-swiper-slide-index="'+(this.realIndex+c)+'"]').addClass(p);}else for(var u=0;u<h;u+=1){t.slides.eq(this.realIndex+u).addClass(p);}}}},be=[W,R,j,K,_,Z,ee,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarged:"container"}},create:function create(){n.extend(this,{mousewheel:{enabled:!1,enable:te.enable.bind(this),disable:te.disable.bind(this),handle:te.handle.bind(this),handleMouseEnter:te.handleMouseEnter.bind(this),handleMouseLeave:te.handleMouseLeave.bind(this),animateSlider:te.animateSlider.bind(this),releaseScroll:te.releaseScroll.bind(this),lastScrollTime:n.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[]}});},on:{init:function init(){!this.params.mousewheel.enabled&&this.params.cssMode&&this.mousewheel.disable(),this.params.mousewheel.enabled&&this.mousewheel.enable();},destroy:function destroy(){this.params.cssMode&&this.mousewheel.enable(),this.mousewheel.enabled&&this.mousewheel.disable();}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function create(){n.extend(this,{navigation:{init:ie.init.bind(this),update:ie.update.bind(this),destroy:ie.destroy.bind(this),onNextClick:ie.onNextClick.bind(this),onPrevClick:ie.onPrevClick.bind(this)}});},on:{init:function init(){this.navigation.init(),this.navigation.update();},toEdge:function toEdge(){this.navigation.update();},fromEdge:function fromEdge(){this.navigation.update();},destroy:function destroy(){this.navigation.destroy();},click:function click(e){var t,i=this.navigation,a=i.$nextEl,r=i.$prevEl;!this.params.navigation.hideOnClick||s(e.target).is(r)||s(e.target).is(a)||(a?t=a.hasClass(this.params.navigation.hiddenClass):r&&(t=r.hasClass(this.params.navigation.hiddenClass)),!0===t?this.emit("navigationShow",this):this.emit("navigationHide",this),a&&a.toggleClass(this.params.navigation.hiddenClass),r&&r.toggleClass(this.params.navigation.hiddenClass));}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function formatFractionCurrent(e){return e;},formatFractionTotal:function formatFractionTotal(e){return e;},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function create(){n.extend(this,{pagination:{init:se.init.bind(this),render:se.render.bind(this),update:se.update.bind(this),destroy:se.destroy.bind(this),dynamicBulletIndex:0}});},on:{init:function init(){this.pagination.init(),this.pagination.render(),this.pagination.update();},activeIndexChange:function activeIndexChange(){(this.params.loop||void 0===this.snapIndex)&&this.pagination.update();},snapIndexChange:function snapIndexChange(){this.params.loop||this.pagination.update();},slidesLengthChange:function slidesLengthChange(){this.params.loop&&(this.pagination.render(),this.pagination.update());},snapGridLengthChange:function snapGridLengthChange(){this.params.loop||(this.pagination.render(),this.pagination.update());},destroy:function destroy(){this.pagination.destroy();},click:function click(e){this.params.pagination.el&&this.params.pagination.hideOnClick&&this.pagination.$el.length>0&&!s(e.target).hasClass(this.params.pagination.bulletClass)&&(!0===this.pagination.$el.hasClass(this.params.pagination.hiddenClass)?this.emit("paginationShow",this):this.emit("paginationHide",this),this.pagination.$el.toggleClass(this.params.pagination.hiddenClass));}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function create(){n.extend(this,{scrollbar:{init:ae.init.bind(this),destroy:ae.destroy.bind(this),updateSize:ae.updateSize.bind(this),setTranslate:ae.setTranslate.bind(this),setTransition:ae.setTransition.bind(this),enableDraggable:ae.enableDraggable.bind(this),disableDraggable:ae.disableDraggable.bind(this),setDragPosition:ae.setDragPosition.bind(this),getPointerPosition:ae.getPointerPosition.bind(this),onDragStart:ae.onDragStart.bind(this),onDragMove:ae.onDragMove.bind(this),onDragEnd:ae.onDragEnd.bind(this),isTouched:!1,timeout:null,dragTimeout:null}});},on:{init:function init(){this.scrollbar.init(),this.scrollbar.updateSize(),this.scrollbar.setTranslate();},update:function update(){this.scrollbar.updateSize();},resize:function resize(){this.scrollbar.updateSize();},observerUpdate:function observerUpdate(){this.scrollbar.updateSize();},setTranslate:function setTranslate(){this.scrollbar.setTranslate();},setTransition:function setTransition(e){this.scrollbar.setTransition(e);},destroy:function destroy(){this.scrollbar.destroy();}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function create(){n.extend(this,{parallax:{setTransform:re.setTransform.bind(this),setTranslate:re.setTranslate.bind(this),setTransition:re.setTransition.bind(this)}});},on:{beforeInit:function beforeInit(){this.params.parallax.enabled&&(this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0);},init:function init(){this.params.parallax.enabled&&this.parallax.setTranslate();},setTranslate:function setTranslate(){this.params.parallax.enabled&&this.parallax.setTranslate();},setTransition:function setTransition(e){this.params.parallax.enabled&&this.parallax.setTransition(e);}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function create(){var e=this,t={enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}};"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(i){t[i]=ne[i].bind(e);}),n.extend(e,{zoom:t});var i=1;Object.defineProperty(e.zoom,"scale",{get:function get(){return i;},set:function set(t){if(i!==t){var s=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,a=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,s,a);}i=t;}});},on:{init:function init(){this.params.zoom.enabled&&this.zoom.enable();},destroy:function destroy(){this.zoom.disable();},touchStart:function touchStart(e){this.zoom.enabled&&this.zoom.onTouchStart(e);},touchEnd:function touchEnd(e){this.zoom.enabled&&this.zoom.onTouchEnd(e);},doubleTap:function doubleTap(e){this.params.zoom.enabled&&this.zoom.enabled&&this.params.zoom.toggle&&this.zoom.toggle(e);},transitionEnd:function transitionEnd(){this.zoom.enabled&&this.params.zoom.enabled&&this.zoom.onTransitionEnd();},slideChange:function slideChange(){this.zoom.enabled&&this.params.zoom.enabled&&this.params.cssMode&&this.zoom.onTransitionEnd();}}},{name:"lazy",params:{lazy:{enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function create(){n.extend(this,{lazy:{initialImageLoaded:!1,load:oe.load.bind(this),loadInSlide:oe.loadInSlide.bind(this)}});},on:{beforeInit:function beforeInit(){this.params.lazy.enabled&&this.params.preloadImages&&(this.params.preloadImages=!1);},init:function init(){this.params.lazy.enabled&&!this.params.loop&&0===this.params.initialSlide&&this.lazy.load();},scroll:function scroll(){this.params.freeMode&&!this.params.freeModeSticky&&this.lazy.load();},resize:function resize(){this.params.lazy.enabled&&this.lazy.load();},scrollbarDragMove:function scrollbarDragMove(){this.params.lazy.enabled&&this.lazy.load();},transitionStart:function transitionStart(){this.params.lazy.enabled&&(this.params.lazy.loadOnTransitionStart||!this.params.lazy.loadOnTransitionStart&&!this.lazy.initialImageLoaded)&&this.lazy.load();},transitionEnd:function transitionEnd(){this.params.lazy.enabled&&!this.params.lazy.loadOnTransitionStart&&this.lazy.load();},slideChange:function slideChange(){this.params.lazy.enabled&&this.params.cssMode&&this.lazy.load();}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function create(){n.extend(this,{controller:{control:this.params.controller.control,getInterpolateFunction:le.getInterpolateFunction.bind(this),setTranslate:le.setTranslate.bind(this),setTransition:le.setTransition.bind(this)}});},on:{update:function update(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline);},resize:function resize(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline);},observerUpdate:function observerUpdate(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline);},setTranslate:function setTranslate(e,t){this.controller.control&&this.controller.setTranslate(e,t);},setTransition:function setTransition(e,t){this.controller.control&&this.controller.setTransition(e,t);}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}"}},create:function create(){var e=this;n.extend(e,{a11y:{liveRegion:s('<span class="'+e.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')}}),Object.keys(de).forEach(function(t){e.a11y[t]=de[t].bind(e);});},on:{init:function init(){this.params.a11y.enabled&&(this.a11y.init(),this.a11y.updateNavigation());},toEdge:function toEdge(){this.params.a11y.enabled&&this.a11y.updateNavigation();},fromEdge:function fromEdge(){this.params.a11y.enabled&&this.a11y.updateNavigation();},paginationUpdate:function paginationUpdate(){this.params.a11y.enabled&&this.a11y.updatePagination();},destroy:function destroy(){this.params.a11y.enabled&&this.a11y.destroy();}}},{name:"history",params:{history:{enabled:!1,replaceState:!1,key:"slides"}},create:function create(){n.extend(this,{history:{init:he.init.bind(this),setHistory:he.setHistory.bind(this),setHistoryPopState:he.setHistoryPopState.bind(this),scrollToSlide:he.scrollToSlide.bind(this),destroy:he.destroy.bind(this)}});},on:{init:function init(){this.params.history.enabled&&this.history.init();},destroy:function destroy(){this.params.history.enabled&&this.history.destroy();},transitionEnd:function transitionEnd(){this.history.initialized&&this.history.setHistory(this.params.history.key,this.activeIndex);},slideChange:function slideChange(){this.history.initialized&&this.params.cssMode&&this.history.setHistory(this.params.history.key,this.activeIndex);}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function create(){n.extend(this,{hashNavigation:{initialized:!1,init:pe.init.bind(this),destroy:pe.destroy.bind(this),setHash:pe.setHash.bind(this),onHashCange:pe.onHashCange.bind(this)}});},on:{init:function init(){this.params.hashNavigation.enabled&&this.hashNavigation.init();},destroy:function destroy(){this.params.hashNavigation.enabled&&this.hashNavigation.destroy();},transitionEnd:function transitionEnd(){this.hashNavigation.initialized&&this.hashNavigation.setHash();},slideChange:function slideChange(){this.hashNavigation.initialized&&this.params.cssMode&&this.hashNavigation.setHash();}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1}},create:function create(){var e=this;n.extend(e,{autoplay:{running:!1,paused:!1,run:ce.run.bind(e),start:ce.start.bind(e),stop:ce.stop.bind(e),pause:ce.pause.bind(e),onVisibilityChange:function onVisibilityChange(){"hidden"===document.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===document.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1);},onTransitionEnd:function onTransitionEnd(t){e&&!e.destroyed&&e.$wrapperEl&&t.target===this&&(e.$wrapperEl[0].removeEventListener("transitionend",e.autoplay.onTransitionEnd),e.$wrapperEl[0].removeEventListener("webkitTransitionEnd",e.autoplay.onTransitionEnd),e.autoplay.paused=!1,e.autoplay.running?e.autoplay.run():e.autoplay.stop());}}});},on:{init:function init(){this.params.autoplay.enabled&&(this.autoplay.start(),document.addEventListener("visibilitychange",this.autoplay.onVisibilityChange));},beforeTransitionStart:function beforeTransitionStart(e,t){this.autoplay.running&&(t||!this.params.autoplay.disableOnInteraction?this.autoplay.pause(e):this.autoplay.stop());},sliderFirstMove:function sliderFirstMove(){this.autoplay.running&&(this.params.autoplay.disableOnInteraction?this.autoplay.stop():this.autoplay.pause());},touchEnd:function touchEnd(){this.params.cssMode&&this.autoplay.paused&&!this.params.autoplay.disableOnInteraction&&this.autoplay.run();},destroy:function destroy(){this.autoplay.running&&this.autoplay.stop(),document.removeEventListener("visibilitychange",this.autoplay.onVisibilityChange);}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function create(){n.extend(this,{fadeEffect:{setTranslate:ue.setTranslate.bind(this),setTransition:ue.setTransition.bind(this)}});},on:{beforeInit:function beforeInit(){if("fade"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"fade");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e);}},setTranslate:function setTranslate(){"fade"===this.params.effect&&this.fadeEffect.setTranslate();},setTransition:function setTransition(e){"fade"===this.params.effect&&this.fadeEffect.setTransition(e);}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function create(){n.extend(this,{cubeEffect:{setTranslate:ve.setTranslate.bind(this),setTransition:ve.setTransition.bind(this)}});},on:{beforeInit:function beforeInit(){if("cube"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"cube"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e);}},setTranslate:function setTranslate(){"cube"===this.params.effect&&this.cubeEffect.setTranslate();},setTransition:function setTransition(e){"cube"===this.params.effect&&this.cubeEffect.setTransition(e);}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function create(){n.extend(this,{flipEffect:{setTranslate:fe.setTranslate.bind(this),setTransition:fe.setTransition.bind(this)}});},on:{beforeInit:function beforeInit(){if("flip"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"flip"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e);}},setTranslate:function setTranslate(){"flip"===this.params.effect&&this.flipEffect.setTranslate();},setTransition:function setTransition(e){"flip"===this.params.effect&&this.flipEffect.setTransition(e);}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:!0}},create:function create(){n.extend(this,{coverflowEffect:{setTranslate:me.setTranslate.bind(this),setTransition:me.setTransition.bind(this)}});},on:{beforeInit:function beforeInit(){"coverflow"===this.params.effect&&(this.classNames.push(this.params.containerModifierClass+"coverflow"),this.classNames.push(this.params.containerModifierClass+"3d"),this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0);},setTranslate:function setTranslate(){"coverflow"===this.params.effect&&this.coverflowEffect.setTranslate();},setTransition:function setTransition(e){"coverflow"===this.params.effect&&this.coverflowEffect.setTransition(e);}}},{name:"thumbs",params:{thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function create(){n.extend(this,{thumbs:{swiper:null,init:ge.init.bind(this),update:ge.update.bind(this),onThumbClick:ge.onThumbClick.bind(this)}});},on:{beforeInit:function beforeInit(){var e=this.params.thumbs;e&&e.swiper&&(this.thumbs.init(),this.thumbs.update(!0));},slideChange:function slideChange(){this.thumbs.swiper&&this.thumbs.update();},update:function update(){this.thumbs.swiper&&this.thumbs.update();},resize:function resize(){this.thumbs.swiper&&this.thumbs.update();},observerUpdate:function observerUpdate(){this.thumbs.swiper&&this.thumbs.update();},setTransition:function setTransition(e){var t=this.thumbs.swiper;t&&t.setTransition(e);},beforeDestroy:function beforeDestroy(){var e=this.thumbs.swiper;e&&this.thumbs.swiperCreated&&e&&e.destroy();}}}];return void 0===F.use&&(F.use=F.Class.use,F.installModule=F.Class.installModule),F.use(be),F;}();}}]);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(window.webpackJsonp = window.webpackJsonp || []).push([[1], {
  320: function _(t, i, e) {
    var n, s;
    /*!
     * getSize v2.0.3
     * measure size of elements
     * MIT license
     */

    window, void 0 === (s = "function" == typeof (n = function n() {
      "use strict";

      function t(t) {
        var i = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(i) && i;
      }

      var i = "undefined" == typeof console ? function () {} : function (t) {
        console.error(t);
      },
          e = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
          n = e.length;

      function s(t) {
        var e = getComputedStyle(t);
        return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
      }

      var o,
          r = !1;

      function a(i) {
        if (function () {
          if (!r) {
            r = !0;
            var i = document.createElement("div");
            i.style.width = "200px", i.style.padding = "1px 2px 3px 4px", i.style.borderStyle = "solid", i.style.borderWidth = "1px 2px 3px 4px", i.style.boxSizing = "border-box";
            var e = document.body || document.documentElement;
            e.appendChild(i);
            var n = s(i);
            o = 200 == Math.round(t(n.width)), a.isBoxSizeOuter = o, e.removeChild(i);
          }
        }(), "string" == typeof i && (i = document.querySelector(i)), i && "object" == _typeof(i) && i.nodeType) {
          var h = s(i);
          if ("none" == h.display) return function () {
            for (var t = {
              width: 0,
              height: 0,
              innerWidth: 0,
              innerHeight: 0,
              outerWidth: 0,
              outerHeight: 0
            }, i = 0; i < n; i++) {
              t[e[i]] = 0;
            }

            return t;
          }();
          var u = {};
          u.width = i.offsetWidth, u.height = i.offsetHeight;

          for (var c = u.isBorderBox = "border-box" == h.boxSizing, d = 0; d < n; d++) {
            var l = e[d],
                f = h[l],
                p = parseFloat(f);
            u[l] = isNaN(p) ? 0 : p;
          }

          var g = u.paddingLeft + u.paddingRight,
              m = u.paddingTop + u.paddingBottom,
              y = u.marginLeft + u.marginRight,
              v = u.marginTop + u.marginBottom,
              _ = u.borderLeftWidth + u.borderRightWidth,
              x = u.borderTopWidth + u.borderBottomWidth,
              b = c && o,
              w = t(h.width);

          !1 !== w && (u.width = w + (b ? 0 : g + _));
          var E = t(h.height);
          return !1 !== E && (u.height = E + (b ? 0 : m + x)), u.innerWidth = u.width - (g + _), u.innerHeight = u.height - (m + x), u.outerWidth = u.width + y, u.outerHeight = u.height + v, u;
        }
      }

      return a;
    }) ? n.call(i, e, i, t) : n) || (t.exports = s);
  },
  321: function _(t, i, e) {
    var n, s;
    window, void 0 === (s = "function" == typeof (n = function n() {
      "use strict";

      function t(i) {
        for (var e in t.defaults) {
          this[e] = t.defaults[e];
        }

        for (e in i) {
          this[e] = i[e];
        }
      }

      t.defaults = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
      var i = t.prototype;
      return i.contains = function (t) {
        var i = t.width || 0,
            e = t.height || 0;
        return this.x <= t.x && this.y <= t.y && this.x + this.width >= t.x + i && this.y + this.height >= t.y + e;
      }, i.overlaps = function (t) {
        var i = this.x + this.width,
            e = this.y + this.height,
            n = t.x + t.width,
            s = t.y + t.height;
        return this.x < n && i > t.x && this.y < s && e > t.y;
      }, i.getMaximalFreeRects = function (i) {
        if (!this.overlaps(i)) return !1;
        var e,
            n = [],
            s = this.x + this.width,
            o = this.y + this.height,
            r = i.x + i.width,
            a = i.y + i.height;
        return this.y < i.y && (e = new t({
          x: this.x,
          y: this.y,
          width: this.width,
          height: i.y - this.y
        }), n.push(e)), s > r && (e = new t({
          x: r,
          y: this.y,
          width: s - r,
          height: this.height
        }), n.push(e)), o > a && (e = new t({
          x: this.x,
          y: a,
          width: this.width,
          height: o - a
        }), n.push(e)), this.x < i.x && (e = new t({
          x: this.x,
          y: this.y,
          width: i.x - this.x,
          height: this.height
        }), n.push(e)), n;
      }, i.canFit = function (t) {
        return this.width >= t.width && this.height >= t.height;
      }, t;
    }) ? n.call(i, e, i, t) : n) || (t.exports = s);
  },
  322: function _(t, i, e) {
    var n, s;
    /*!
     * Outlayer v2.1.1
     * the brains and guts of a layout library
     * MIT license
     */

    !function (o, r) {
      "use strict";

      n = [e(323), e(320), e(325), e(327)], void 0 === (s = function (t, i, e, n) {
        return function (t, i, e, n, s) {
          var o = t.console,
              r = t.jQuery,
              a = function a() {},
              h = 0,
              u = {};

          function c(t, i) {
            var e = n.getQueryElement(t);

            if (e) {
              this.element = e, r && (this.$element = r(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(i);
              var s = ++h;
              this.element.outlayerGUID = s, u[s] = this, this._create(), this._getOption("initLayout") && this.layout();
            } else o && o.error("Bad element for " + this.constructor.namespace + ": " + (e || t));
          }

          c.namespace = "outlayer", c.Item = s, c.defaults = {
            containerStyle: {
              position: "relative"
            },
            initLayout: !0,
            originLeft: !0,
            originTop: !0,
            resize: !0,
            resizeContainer: !0,
            transitionDuration: "0.4s",
            hiddenStyle: {
              opacity: 0,
              transform: "scale(0.001)"
            },
            visibleStyle: {
              opacity: 1,
              transform: "scale(1)"
            }
          };
          var d = c.prototype;

          function l(t) {
            function i() {
              t.apply(this, arguments);
            }

            return i.prototype = Object.create(t.prototype), i.prototype.constructor = i, i;
          }

          n.extend(d, i.prototype), d.option = function (t) {
            n.extend(this.options, t);
          }, d._getOption = function (t) {
            var i = this.constructor.compatOptions[t];
            return i && void 0 !== this.options[i] ? this.options[i] : this.options[t];
          }, c.compatOptions = {
            initLayout: "isInitLayout",
            horizontal: "isHorizontal",
            layoutInstant: "isLayoutInstant",
            originLeft: "isOriginLeft",
            originTop: "isOriginTop",
            resize: "isResizeBound",
            resizeContainer: "isResizingContainer"
          }, d._create = function () {
            this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize();
          }, d.reloadItems = function () {
            this.items = this._itemize(this.element.children);
          }, d._itemize = function (t) {
            for (var i = this._filterFindItemElements(t), e = this.constructor.Item, n = [], s = 0; s < i.length; s++) {
              var o = new e(i[s], this);
              n.push(o);
            }

            return n;
          }, d._filterFindItemElements = function (t) {
            return n.filterFindElements(t, this.options.itemSelector);
          }, d.getItemElements = function () {
            return this.items.map(function (t) {
              return t.element;
            });
          }, d.layout = function () {
            this._resetLayout(), this._manageStamps();

            var t = this._getOption("layoutInstant"),
                i = void 0 !== t ? t : !this._isLayoutInited;

            this.layoutItems(this.items, i), this._isLayoutInited = !0;
          }, d._init = d.layout, d._resetLayout = function () {
            this.getSize();
          }, d.getSize = function () {
            this.size = e(this.element);
          }, d._getMeasurement = function (t, i) {
            var n,
                s = this.options[t];
            s ? ("string" == typeof s ? n = this.element.querySelector(s) : s instanceof HTMLElement && (n = s), this[t] = n ? e(n)[i] : s) : this[t] = 0;
          }, d.layoutItems = function (t, i) {
            t = this._getItemsForLayout(t), this._layoutItems(t, i), this._postLayout();
          }, d._getItemsForLayout = function (t) {
            return t.filter(function (t) {
              return !t.isIgnored;
            });
          }, d._layoutItems = function (t, i) {
            if (this._emitCompleteOnItems("layout", t), t && t.length) {
              var e = [];
              t.forEach(function (t) {
                var n = this._getItemLayoutPosition(t);

                n.item = t, n.isInstant = i || t.isLayoutInstant, e.push(n);
              }, this), this._processLayoutQueue(e);
            }
          }, d._getItemLayoutPosition = function () {
            return {
              x: 0,
              y: 0
            };
          }, d._processLayoutQueue = function (t) {
            this.updateStagger(), t.forEach(function (t, i) {
              this._positionItem(t.item, t.x, t.y, t.isInstant, i);
            }, this);
          }, d.updateStagger = function () {
            var t = this.options.stagger;
            if (null != t) return this.stagger = function (t) {
              if ("number" == typeof t) return t;
              var i = t.match(/(^\d*\.?\d*)(\w*)/),
                  e = i && i[1],
                  n = i && i[2];
              if (!e.length) return 0;
              return (e = parseFloat(e)) * (f[n] || 1);
            }(t), this.stagger;
            this.stagger = 0;
          }, d._positionItem = function (t, i, e, n, s) {
            n ? t.goTo(i, e) : (t.stagger(s * this.stagger), t.moveTo(i, e));
          }, d._postLayout = function () {
            this.resizeContainer();
          }, d.resizeContainer = function () {
            if (this._getOption("resizeContainer")) {
              var t = this._getContainerSize();

              t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1));
            }
          }, d._getContainerSize = a, d._setContainerMeasure = function (t, i) {
            if (void 0 !== t) {
              var e = this.size;
              e.isBorderBox && (t += i ? e.paddingLeft + e.paddingRight + e.borderLeftWidth + e.borderRightWidth : e.paddingBottom + e.paddingTop + e.borderTopWidth + e.borderBottomWidth), t = Math.max(t, 0), this.element.style[i ? "width" : "height"] = t + "px";
            }
          }, d._emitCompleteOnItems = function (t, i) {
            var e = this;

            function n() {
              e.dispatchEvent(t + "Complete", null, [i]);
            }

            var s = i.length;

            if (i && s) {
              var o = 0;
              i.forEach(function (i) {
                i.once(t, r);
              });
            } else n();

            function r() {
              ++o == s && n();
            }
          }, d.dispatchEvent = function (t, i, e) {
            var n = i ? [i].concat(e) : e;
            if (this.emitEvent(t, n), r) if (this.$element = this.$element || r(this.element), i) {
              var s = r.Event(i);
              s.type = t, this.$element.trigger(s, e);
            } else this.$element.trigger(t, e);
          }, d.ignore = function (t) {
            var i = this.getItem(t);
            i && (i.isIgnored = !0);
          }, d.unignore = function (t) {
            var i = this.getItem(t);
            i && delete i.isIgnored;
          }, d.stamp = function (t) {
            (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this));
          }, d.unstamp = function (t) {
            (t = this._find(t)) && t.forEach(function (t) {
              n.removeFrom(this.stamps, t), this.unignore(t);
            }, this);
          }, d._find = function (t) {
            if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t);
          }, d._manageStamps = function () {
            this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
          }, d._getBoundingRect = function () {
            var t = this.element.getBoundingClientRect(),
                i = this.size;
            this._boundingRect = {
              left: t.left + i.paddingLeft + i.borderLeftWidth,
              top: t.top + i.paddingTop + i.borderTopWidth,
              right: t.right - (i.paddingRight + i.borderRightWidth),
              bottom: t.bottom - (i.paddingBottom + i.borderBottomWidth)
            };
          }, d._manageStamp = a, d._getElementOffset = function (t) {
            var i = t.getBoundingClientRect(),
                n = this._boundingRect,
                s = e(t);
            return {
              left: i.left - n.left - s.marginLeft,
              top: i.top - n.top - s.marginTop,
              right: n.right - i.right - s.marginRight,
              bottom: n.bottom - i.bottom - s.marginBottom
            };
          }, d.handleEvent = n.handleEvent, d.bindResize = function () {
            t.addEventListener("resize", this), this.isResizeBound = !0;
          }, d.unbindResize = function () {
            t.removeEventListener("resize", this), this.isResizeBound = !1;
          }, d.onresize = function () {
            this.resize();
          }, n.debounceMethod(c, "onresize", 100), d.resize = function () {
            this.isResizeBound && this.needsResizeLayout() && this.layout();
          }, d.needsResizeLayout = function () {
            var t = e(this.element);
            return this.size && t && t.innerWidth !== this.size.innerWidth;
          }, d.addItems = function (t) {
            var i = this._itemize(t);

            return i.length && (this.items = this.items.concat(i)), i;
          }, d.appended = function (t) {
            var i = this.addItems(t);
            i.length && (this.layoutItems(i, !0), this.reveal(i));
          }, d.prepended = function (t) {
            var i = this._itemize(t);

            if (i.length) {
              var e = this.items.slice(0);
              this.items = i.concat(e), this._resetLayout(), this._manageStamps(), this.layoutItems(i, !0), this.reveal(i), this.layoutItems(e);
            }
          }, d.reveal = function (t) {
            if (this._emitCompleteOnItems("reveal", t), t && t.length) {
              var i = this.updateStagger();
              t.forEach(function (t, e) {
                t.stagger(e * i), t.reveal();
              });
            }
          }, d.hide = function (t) {
            if (this._emitCompleteOnItems("hide", t), t && t.length) {
              var i = this.updateStagger();
              t.forEach(function (t, e) {
                t.stagger(e * i), t.hide();
              });
            }
          }, d.revealItemElements = function (t) {
            var i = this.getItems(t);
            this.reveal(i);
          }, d.hideItemElements = function (t) {
            var i = this.getItems(t);
            this.hide(i);
          }, d.getItem = function (t) {
            for (var i = 0; i < this.items.length; i++) {
              var e = this.items[i];
              if (e.element == t) return e;
            }
          }, d.getItems = function (t) {
            t = n.makeArray(t);
            var i = [];
            return t.forEach(function (t) {
              var e = this.getItem(t);
              e && i.push(e);
            }, this), i;
          }, d.remove = function (t) {
            var i = this.getItems(t);
            this._emitCompleteOnItems("remove", i), i && i.length && i.forEach(function (t) {
              t.remove(), n.removeFrom(this.items, t);
            }, this);
          }, d.destroy = function () {
            var t = this.element.style;
            t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
              t.destroy();
            }), this.unbindResize();
            var i = this.element.outlayerGUID;
            delete u[i], delete this.element.outlayerGUID, r && r.removeData(this.element, this.constructor.namespace);
          }, c.data = function (t) {
            var i = (t = n.getQueryElement(t)) && t.outlayerGUID;
            return i && u[i];
          }, c.create = function (t, i) {
            var e = l(c);
            return e.defaults = n.extend({}, c.defaults), n.extend(e.defaults, i), e.compatOptions = n.extend({}, c.compatOptions), e.namespace = t, e.data = c.data, e.Item = l(s), n.htmlInit(e, t), r && r.bridget && r.bridget(t, e), e;
          };
          var f = {
            ms: 1,
            s: 1e3
          };
          return c.Item = s, c;
        }(o, t, i, e, n);
      }.apply(i, n)) || (t.exports = s);
    }(window);
  },
  323: function _(t, i, e) {
    var n, s;
    "undefined" != typeof window && window, void 0 === (s = "function" == typeof (n = function n() {
      "use strict";

      function t() {}

      var i = t.prototype;
      return i.on = function (t, i) {
        if (t && i) {
          var e = this._events = this._events || {},
              n = e[t] = e[t] || [];
          return -1 == n.indexOf(i) && n.push(i), this;
        }
      }, i.once = function (t, i) {
        if (t && i) {
          this.on(t, i);
          var e = this._onceEvents = this._onceEvents || {};
          return (e[t] = e[t] || {})[i] = !0, this;
        }
      }, i.off = function (t, i) {
        var e = this._events && this._events[t];

        if (e && e.length) {
          var n = e.indexOf(i);
          return -1 != n && e.splice(n, 1), this;
        }
      }, i.emitEvent = function (t, i) {
        var e = this._events && this._events[t];

        if (e && e.length) {
          e = e.slice(0), i = i || [];

          for (var n = this._onceEvents && this._onceEvents[t], s = 0; s < e.length; s++) {
            var o = e[s];
            n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, i);
          }

          return this;
        }
      }, i.allOff = function () {
        delete this._events, delete this._onceEvents;
      }, t;
    }) ? n.call(i, e, i, t) : n) || (t.exports = s);
  },
  324: function _(t, i, e) {
    var n, s, o;
    /*!
     * Packery v2.1.2
     * Gapless, draggable grid layouts
     *
     * Licensed GPLv3 for open source use
     * or Packery Commercial License for commercial use
     *
     * http://packery.metafizzy.co
     * Copyright 2013-2018 Metafizzy
     */

    window, s = [e(320), e(322), e(321), e(328), e(329)], void 0 === (o = "function" == typeof (n = function n(t, i, e, _n, s) {
      "use strict";

      e.prototype.canFit = function (t) {
        return this.width >= t.width - 1 && this.height >= t.height - 1;
      };

      var o = i.create("packery");
      o.Item = s;
      var r = o.prototype;

      function a(t, i) {
        return t.position.y - i.position.y || t.position.x - i.position.x;
      }

      function h(t, i) {
        return t.position.x - i.position.x || t.position.y - i.position.y;
      }

      r._create = function () {
        i.prototype._create.call(this), this.packer = new _n(), this.shiftPacker = new _n(), this.isEnabled = !0, this.dragItemCount = 0;
        var t = this;
        this.handleDraggabilly = {
          dragStart: function dragStart() {
            t.itemDragStart(this.element);
          },
          dragMove: function dragMove() {
            t.itemDragMove(this.element, this.position.x, this.position.y);
          },
          dragEnd: function dragEnd() {
            t.itemDragEnd(this.element);
          }
        }, this.handleUIDraggable = {
          start: function start(i, e) {
            e && t.itemDragStart(i.currentTarget);
          },
          drag: function drag(i, e) {
            e && t.itemDragMove(i.currentTarget, e.position.left, e.position.top);
          },
          stop: function stop(i, e) {
            e && t.itemDragEnd(i.currentTarget);
          }
        };
      }, r._resetLayout = function () {
        var t, i, e;
        this.getSize(), this._getMeasurements(), this._getOption("horizontal") ? (t = 1 / 0, i = this.size.innerHeight + this.gutter, e = "rightwardTopToBottom") : (t = this.size.innerWidth + this.gutter, i = 1 / 0, e = "downwardLeftToRight"), this.packer.width = this.shiftPacker.width = t, this.packer.height = this.shiftPacker.height = i, this.packer.sortDirection = this.shiftPacker.sortDirection = e, this.packer.reset(), this.maxY = 0, this.maxX = 0;
      }, r._getMeasurements = function () {
        this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width");
      }, r._getItemLayoutPosition = function (t) {
        if (this._setRectSize(t.element, t.rect), this.isShifting || this.dragItemCount > 0) {
          var i = this._getPackMethod();

          this.packer[i](t.rect);
        } else this.packer.pack(t.rect);

        return this._setMaxXY(t.rect), t.rect;
      }, r.shiftLayout = function () {
        this.isShifting = !0, this.layout(), delete this.isShifting;
      }, r._getPackMethod = function () {
        return this._getOption("horizontal") ? "rowPack" : "columnPack";
      }, r._setMaxXY = function (t) {
        this.maxX = Math.max(t.x + t.width, this.maxX), this.maxY = Math.max(t.y + t.height, this.maxY);
      }, r._setRectSize = function (i, e) {
        var n = t(i),
            s = n.outerWidth,
            o = n.outerHeight;
        (s || o) && (s = this._applyGridGutter(s, this.columnWidth), o = this._applyGridGutter(o, this.rowHeight)), e.width = Math.min(s, this.packer.width), e.height = Math.min(o, this.packer.height);
      }, r._applyGridGutter = function (t, i) {
        if (!i) return t + this.gutter;
        var e = t % (i += this.gutter);
        return t = Math[e && e < 1 ? "round" : "ceil"](t / i) * i;
      }, r._getContainerSize = function () {
        return this._getOption("horizontal") ? {
          width: this.maxX - this.gutter
        } : {
          height: this.maxY - this.gutter
        };
      }, r._manageStamp = function (t) {
        var i,
            n = this.getItem(t);
        if (n && n.isPlacing) i = n.rect;else {
          var s = this._getElementOffset(t);

          i = new e({
            x: this._getOption("originLeft") ? s.left : s.right,
            y: this._getOption("originTop") ? s.top : s.bottom
          });
        }
        this._setRectSize(t, i), this.packer.placed(i), this._setMaxXY(i);
      }, r.sortItemsByPosition = function () {
        var t = this._getOption("horizontal") ? h : a;
        this.items.sort(t);
      }, r.fit = function (t, i, e) {
        var n = this.getItem(t);
        n && (this.stamp(n.element), n.enablePlacing(), this.updateShiftTargets(n), i = void 0 === i ? n.rect.x : i, e = void 0 === e ? n.rect.y : e, this.shift(n, i, e), this._bindFitEvents(n), n.moveTo(n.rect.x, n.rect.y), this.shiftLayout(), this.unstamp(n.element), this.sortItemsByPosition(), n.disablePlacing());
      }, r._bindFitEvents = function (t) {
        var i = this,
            e = 0;

        function n() {
          2 == ++e && i.dispatchEvent("fitComplete", null, [t]);
        }

        t.once("layout", n), this.once("layoutComplete", n);
      }, r.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && (this.options.shiftPercentResize ? this.resizeShiftPercentLayout() : this.layout());
      }, r.needsResizeLayout = function () {
        var i = t(this.element),
            e = this._getOption("horizontal") ? "innerHeight" : "innerWidth";
        return i[e] != this.size[e];
      }, r.resizeShiftPercentLayout = function () {
        var i = this._getItemsForLayout(this.items),
            e = this._getOption("horizontal"),
            n = e ? "y" : "x",
            s = e ? "height" : "width",
            o = e ? "rowHeight" : "columnWidth",
            r = e ? "innerHeight" : "innerWidth",
            a = this[o];

        if (a = a && a + this.gutter) {
          this._getMeasurements();

          var h = this[o] + this.gutter;
          i.forEach(function (t) {
            var i = Math.round(t.rect[n] / a);
            t.rect[n] = i * h;
          });
        } else {
          var u = t(this.element)[r] + this.gutter,
              c = this.packer[s];
          i.forEach(function (t) {
            t.rect[n] = t.rect[n] / c * u;
          });
        }

        this.shiftLayout();
      }, r.itemDragStart = function (t) {
        if (this.isEnabled) {
          this.stamp(t);
          var i = this.getItem(t);
          i && (i.enablePlacing(), i.showDropPlaceholder(), this.dragItemCount++, this.updateShiftTargets(i));
        }
      }, r.updateShiftTargets = function (t) {
        this.shiftPacker.reset(), this._getBoundingRect();

        var i = this._getOption("originLeft"),
            n = this._getOption("originTop");

        this.stamps.forEach(function (t) {
          var s = this.getItem(t);

          if (!s || !s.isPlacing) {
            var o = this._getElementOffset(t),
                r = new e({
              x: i ? o.left : o.right,
              y: n ? o.top : o.bottom
            });

            this._setRectSize(t, r), this.shiftPacker.placed(r);
          }
        }, this);

        var s,
            o = this._getOption("horizontal"),
            r = o ? "rowHeight" : "columnWidth",
            a = o ? "height" : "width";

        this.shiftTargetKeys = [], this.shiftTargets = [];
        var h = this[r];

        if (h = h && h + this.gutter) {
          var u = Math.ceil(t.rect[a] / h),
              c = Math.floor((this.shiftPacker[a] + this.gutter) / h);
          s = (c - u) * h;

          for (var d = 0; d < c; d++) {
            var l = o ? 0 : d * h,
                f = o ? d * h : 0;

            this._addShiftTarget(l, f, s);
          }
        } else s = this.shiftPacker[a] + this.gutter - t.rect[a], this._addShiftTarget(0, 0, s);

        var p = this._getItemsForLayout(this.items),
            g = this._getPackMethod();

        p.forEach(function (t) {
          var i = t.rect;
          this._setRectSize(t.element, i), this.shiftPacker[g](i), this._addShiftTarget(i.x, i.y, s);
          var e = o ? i.x + i.width : i.x,
              n = o ? i.y : i.y + i.height;
          if (this._addShiftTarget(e, n, s), h) for (var r = Math.round(i[a] / h), u = 1; u < r; u++) {
            var c = o ? e : i.x + h * u,
                d = o ? i.y + h * u : n;

            this._addShiftTarget(c, d, s);
          }
        }, this);
      }, r._addShiftTarget = function (t, i, e) {
        var n = this._getOption("horizontal") ? i : t;

        if (!(0 !== n && n > e)) {
          var s = t + "," + i;
          -1 != this.shiftTargetKeys.indexOf(s) || (this.shiftTargetKeys.push(s), this.shiftTargets.push({
            x: t,
            y: i
          }));
        }
      }, r.shift = function (t, i, e) {
        var n,
            s = 1 / 0,
            o = {
          x: i,
          y: e
        };
        this.shiftTargets.forEach(function (t) {
          var i,
              e,
              r,
              a,
              h = (r = (e = o).x - (i = t).x, a = e.y - i.y, Math.sqrt(r * r + a * a));
          h < s && (n = t, s = h);
        }), t.rect.x = n.x, t.rect.y = n.y;
      }, r.itemDragMove = function (t, i, e) {
        var n = this.isEnabled && this.getItem(t);

        if (n) {
          i -= this.size.paddingLeft, e -= this.size.paddingTop;
          var s = this,
              o = new Date();
          this._itemDragTime && o - this._itemDragTime < 120 ? (clearTimeout(this.dragTimeout), this.dragTimeout = setTimeout(r, 120)) : (r(), this._itemDragTime = o);
        }

        function r() {
          s.shift(n, i, e), n.positionDropPlaceholder(), s.layout();
        }
      }, r.itemDragEnd = function (t) {
        var i = this.isEnabled && this.getItem(t);

        if (i) {
          clearTimeout(this.dragTimeout), i.element.classList.add("is-positioning-post-drag");
          var e = 0,
              n = this;
          i.once("layout", s), this.once("layoutComplete", s), i.moveTo(i.rect.x, i.rect.y), this.layout(), this.dragItemCount = Math.max(0, this.dragItemCount - 1), this.sortItemsByPosition(), i.disablePlacing(), this.unstamp(i.element);
        }

        function s() {
          2 == ++e && (i.element.classList.remove("is-positioning-post-drag"), i.hideDropPlaceholder(), n.dispatchEvent("dragItemPositioned", null, [i]));
        }
      }, r.bindDraggabillyEvents = function (t) {
        this._bindDraggabillyEvents(t, "on");
      }, r.unbindDraggabillyEvents = function (t) {
        this._bindDraggabillyEvents(t, "off");
      }, r._bindDraggabillyEvents = function (t, i) {
        var e = this.handleDraggabilly;
        t[i]("dragStart", e.dragStart), t[i]("dragMove", e.dragMove), t[i]("dragEnd", e.dragEnd);
      }, r.bindUIDraggableEvents = function (t) {
        this._bindUIDraggableEvents(t, "on");
      }, r.unbindUIDraggableEvents = function (t) {
        this._bindUIDraggableEvents(t, "off");
      }, r._bindUIDraggableEvents = function (t, i) {
        var e = this.handleUIDraggable;
        t[i]("dragstart", e.start)[i]("drag", e.drag)[i]("dragstop", e.stop);
      };
      var u = r.destroy;
      return r.destroy = function () {
        u.apply(this, arguments), this.isEnabled = !1;
      }, o.Rect = e, o.Packer = _n, o;
    }) ? n.apply(i, s) : n) || (t.exports = o);
  },
  325: function _(t, i, e) {
    var n, s;
    !function (o, r) {
      n = [e(326)], void 0 === (s = function (t) {
        return function (t, i) {
          "use strict";

          var e = {
            extend: function extend(t, i) {
              for (var e in i) {
                t[e] = i[e];
              }

              return t;
            },
            modulo: function modulo(t, i) {
              return (t % i + i) % i;
            }
          },
              n = Array.prototype.slice;
          e.makeArray = function (t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == _typeof(t) && "number" == typeof t.length ? n.call(t) : [t];
          }, e.removeFrom = function (t, i) {
            var e = t.indexOf(i);
            -1 != e && t.splice(e, 1);
          }, e.getParent = function (t, e) {
            for (; t.parentNode && t != document.body;) {
              if (t = t.parentNode, i(t, e)) return t;
            }
          }, e.getQueryElement = function (t) {
            return "string" == typeof t ? document.querySelector(t) : t;
          }, e.handleEvent = function (t) {
            var i = "on" + t.type;
            this[i] && this[i](t);
          }, e.filterFindElements = function (t, n) {
            t = e.makeArray(t);
            var s = [];
            return t.forEach(function (t) {
              if (t instanceof HTMLElement) if (n) {
                i(t, n) && s.push(t);

                for (var e = t.querySelectorAll(n), o = 0; o < e.length; o++) {
                  s.push(e[o]);
                }
              } else s.push(t);
            }), s;
          }, e.debounceMethod = function (t, i, e) {
            e = e || 100;
            var n = t.prototype[i],
                s = i + "Timeout";

            t.prototype[i] = function () {
              var t = this[s];
              clearTimeout(t);
              var i = arguments,
                  o = this;
              this[s] = setTimeout(function () {
                n.apply(o, i), delete o[s];
              }, e);
            };
          }, e.docReady = function (t) {
            var i = document.readyState;
            "complete" == i || "interactive" == i ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
          }, e.toDashed = function (t) {
            return t.replace(/(.)([A-Z])/g, function (t, i, e) {
              return i + "-" + e;
            }).toLowerCase();
          };
          var s = t.console;
          return e.htmlInit = function (i, n) {
            e.docReady(function () {
              var o = e.toDashed(n),
                  r = "data-" + o,
                  a = document.querySelectorAll("[" + r + "]"),
                  h = document.querySelectorAll(".js-" + o),
                  u = e.makeArray(a).concat(e.makeArray(h)),
                  c = r + "-options",
                  d = t.jQuery;
              u.forEach(function (t) {
                var e,
                    o = t.getAttribute(r) || t.getAttribute(c);

                try {
                  e = o && JSON.parse(o);
                } catch (i) {
                  return void (s && s.error("Error parsing " + r + " on " + t.className + ": " + i));
                }

                var a = new i(t, e);
                d && d.data(t, n, a);
              });
            });
          }, e;
        }(o, t);
      }.apply(i, n)) || (t.exports = s);
    }(window);
  },
  326: function _(t, i, e) {
    var n, s;
    !function (o, r) {
      "use strict";

      void 0 === (s = "function" == typeof (n = r) ? n.call(i, e, i, t) : n) || (t.exports = s);
    }(window, function () {
      "use strict";

      var t = function () {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";

        for (var i = ["webkit", "moz", "ms", "o"], e = 0; e < i.length; e++) {
          var n = i[e] + "MatchesSelector";
          if (t[n]) return n;
        }
      }();

      return function (i, e) {
        return i[t](e);
      };
    });
  },
  327: function _(t, i, e) {
    var n, s, o;
    window, s = [e(323), e(320)], void 0 === (o = "function" == typeof (n = function n(t, i) {
      "use strict";

      var e = document.documentElement.style,
          n = "string" == typeof e.transition ? "transition" : "WebkitTransition",
          s = "string" == typeof e.transform ? "transform" : "WebkitTransform",
          o = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
      }[n],
          r = {
        transform: s,
        transition: n,
        transitionDuration: n + "Duration",
        transitionProperty: n + "Property",
        transitionDelay: n + "Delay"
      };

      function a(t, i) {
        t && (this.element = t, this.layout = i, this.position = {
          x: 0,
          y: 0
        }, this._create());
      }

      var h = a.prototype = Object.create(t.prototype);
      h.constructor = a, h._create = function () {
        this._transn = {
          ingProperties: {},
          clean: {},
          onEnd: {}
        }, this.css({
          position: "absolute"
        });
      }, h.handleEvent = function (t) {
        var i = "on" + t.type;
        this[i] && this[i](t);
      }, h.getSize = function () {
        this.size = i(this.element);
      }, h.css = function (t) {
        var i = this.element.style;

        for (var e in t) {
          i[r[e] || e] = t[e];
        }
      }, h.getPosition = function () {
        var t = getComputedStyle(this.element),
            i = this.layout._getOption("originLeft"),
            e = this.layout._getOption("originTop"),
            n = t[i ? "left" : "right"],
            s = t[e ? "top" : "bottom"],
            o = parseFloat(n),
            r = parseFloat(s),
            a = this.layout.size;

        -1 != n.indexOf("%") && (o = o / 100 * a.width), -1 != s.indexOf("%") && (r = r / 100 * a.height), o = isNaN(o) ? 0 : o, r = isNaN(r) ? 0 : r, o -= i ? a.paddingLeft : a.paddingRight, r -= e ? a.paddingTop : a.paddingBottom, this.position.x = o, this.position.y = r;
      }, h.layoutPosition = function () {
        var t = this.layout.size,
            i = {},
            e = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            s = e ? "paddingLeft" : "paddingRight",
            o = e ? "left" : "right",
            r = e ? "right" : "left",
            a = this.position.x + t[s];

        i[o] = this.getXValue(a), i[r] = "";
        var h = n ? "paddingTop" : "paddingBottom",
            u = n ? "top" : "bottom",
            c = n ? "bottom" : "top",
            d = this.position.y + t[h];
        i[u] = this.getYValue(d), i[c] = "", this.css(i), this.emitEvent("layout", [this]);
      }, h.getXValue = function (t) {
        var i = this.layout._getOption("horizontal");

        return this.layout.options.percentPosition && !i ? t / this.layout.size.width * 100 + "%" : t + "px";
      }, h.getYValue = function (t) {
        var i = this.layout._getOption("horizontal");

        return this.layout.options.percentPosition && i ? t / this.layout.size.height * 100 + "%" : t + "px";
      }, h._transitionTo = function (t, i) {
        this.getPosition();
        var e = this.position.x,
            n = this.position.y,
            s = t == this.position.x && i == this.position.y;

        if (this.setPosition(t, i), !s || this.isTransitioning) {
          var o = t - e,
              r = i - n,
              a = {};
          a.transform = this.getTranslate(o, r), this.transition({
            to: a,
            onTransitionEnd: {
              transform: this.layoutPosition
            },
            isCleaning: !0
          });
        } else this.layoutPosition();
      }, h.getTranslate = function (t, i) {
        return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (i = this.layout._getOption("originTop") ? i : -i) + "px, 0)";
      }, h.goTo = function (t, i) {
        this.setPosition(t, i), this.layoutPosition();
      }, h.moveTo = h._transitionTo, h.setPosition = function (t, i) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(i);
      }, h._nonTransition = function (t) {
        for (var i in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) {
          t.onTransitionEnd[i].call(this);
        }
      }, h.transition = function (t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
          var i = this._transn;

          for (var e in t.onTransitionEnd) {
            i.onEnd[e] = t.onTransitionEnd[e];
          }

          for (e in t.to) {
            i.ingProperties[e] = !0, t.isCleaning && (i.clean[e] = !0);
          }

          t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0;
        } else this._nonTransition(t);
      };
      var u = "opacity," + s.replace(/([A-Z])/g, function (t) {
        return "-" + t.toLowerCase();
      });
      h.enableTransition = function () {
        if (!this.isTransitioning) {
          var t = this.layout.options.transitionDuration;
          t = "number" == typeof t ? t + "ms" : t, this.css({
            transitionProperty: u,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0
          }), this.element.addEventListener(o, this, !1);
        }
      }, h.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }, h.onotransitionend = function (t) {
        this.ontransitionend(t);
      };
      var c = {
        "-webkit-transform": "transform"
      };
      h.ontransitionend = function (t) {
        if (t.target === this.element) {
          var i = this._transn,
              e = c[t.propertyName] || t.propertyName;
          delete i.ingProperties[e], function (t) {
            for (var i in t) {
              return !1;
            }

            return !0;
          }(i.ingProperties) && this.disableTransition(), e in i.clean && (this.element.style[t.propertyName] = "", delete i.clean[e]), e in i.onEnd && (i.onEnd[e].call(this), delete i.onEnd[e]), this.emitEvent("transitionEnd", [this]);
        }
      }, h.disableTransition = function () {
        this.removeTransitionStyles(), this.element.removeEventListener(o, this, !1), this.isTransitioning = !1;
      }, h._removeStyles = function (t) {
        var i = {};

        for (var e in t) {
          i[e] = "";
        }

        this.css(i);
      };
      var d = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
      };
      return h.removeTransitionStyles = function () {
        this.css(d);
      }, h.stagger = function (t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms";
      }, h.removeElem = function () {
        this.element.parentNode.removeChild(this.element), this.css({
          display: ""
        }), this.emitEvent("remove", [this]);
      }, h.remove = function () {
        n && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
          this.removeElem();
        }), this.hide()) : this.removeElem();
      }, h.reveal = function () {
        delete this.isHidden, this.css({
          display: ""
        });
        var t = this.layout.options,
            i = {};
        i[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
          from: t.hiddenStyle,
          to: t.visibleStyle,
          isCleaning: !0,
          onTransitionEnd: i
        });
      }, h.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal");
      }, h.getHideRevealTransitionEndProperty = function (t) {
        var i = this.layout.options[t];
        if (i.opacity) return "opacity";

        for (var e in i) {
          return e;
        }
      }, h.hide = function () {
        this.isHidden = !0, this.css({
          display: ""
        });
        var t = this.layout.options,
            i = {};
        i[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
          from: t.visibleStyle,
          to: t.hiddenStyle,
          isCleaning: !0,
          onTransitionEnd: i
        });
      }, h.onHideTransitionEnd = function () {
        this.isHidden && (this.css({
          display: "none"
        }), this.emitEvent("hide"));
      }, h.destroy = function () {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: ""
        });
      }, a;
    }) ? n.apply(i, s) : n) || (t.exports = o);
  },
  328: function _(t, i, e) {
    var n, s, o;
    window, s = [e(321)], void 0 === (o = "function" == typeof (n = function n(t) {
      "use strict";

      function i(t, i, e) {
        this.width = t || 0, this.height = i || 0, this.sortDirection = e || "downwardLeftToRight", this.reset();
      }

      var e = i.prototype;
      e.reset = function () {
        this.spaces = [];
        var i = new t({
          x: 0,
          y: 0,
          width: this.width,
          height: this.height
        });
        this.spaces.push(i), this.sorter = n[this.sortDirection] || n.downwardLeftToRight;
      }, e.pack = function (t) {
        for (var i = 0; i < this.spaces.length; i++) {
          var e = this.spaces[i];

          if (e.canFit(t)) {
            this.placeInSpace(t, e);
            break;
          }
        }
      }, e.columnPack = function (t) {
        for (var i = 0; i < this.spaces.length; i++) {
          var e = this.spaces[i];

          if (e.x <= t.x && e.x + e.width >= t.x + t.width && e.height >= t.height - .01) {
            t.y = e.y, this.placed(t);
            break;
          }
        }
      }, e.rowPack = function (t) {
        for (var i = 0; i < this.spaces.length; i++) {
          var e = this.spaces[i];

          if (e.y <= t.y && e.y + e.height >= t.y + t.height && e.width >= t.width - .01) {
            t.x = e.x, this.placed(t);
            break;
          }
        }
      }, e.placeInSpace = function (t, i) {
        t.x = i.x, t.y = i.y, this.placed(t);
      }, e.placed = function (t) {
        for (var i = [], e = 0; e < this.spaces.length; e++) {
          var n = this.spaces[e],
              s = n.getMaximalFreeRects(t);
          s ? i.push.apply(i, s) : i.push(n);
        }

        this.spaces = i, this.mergeSortSpaces();
      }, e.mergeSortSpaces = function () {
        i.mergeRects(this.spaces), this.spaces.sort(this.sorter);
      }, e.addSpace = function (t) {
        this.spaces.push(t), this.mergeSortSpaces();
      }, i.mergeRects = function (t) {
        var i = 0,
            e = t[i];

        t: for (; e;) {
          for (var n = 0, s = t[i + n]; s;) {
            if (s == e) n++;else {
              if (s.contains(e)) {
                t.splice(i, 1), e = t[i];
                continue t;
              }

              e.contains(s) ? t.splice(i + n, 1) : n++;
            }
            s = t[i + n];
          }

          e = t[++i];
        }

        return t;
      };
      var n = {
        downwardLeftToRight: function downwardLeftToRight(t, i) {
          return t.y - i.y || t.x - i.x;
        },
        rightwardTopToBottom: function rightwardTopToBottom(t, i) {
          return t.x - i.x || t.y - i.y;
        }
      };
      return i;
    }) ? n.apply(i, s) : n) || (t.exports = o);
  },
  329: function _(t, i, e) {
    var n, s, o;
    window, s = [e(322), e(321)], void 0 === (o = "function" == typeof (n = function n(t, i) {
      "use strict";

      var e = "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform",
          n = function n() {
        t.Item.apply(this, arguments);
      },
          s = n.prototype = Object.create(t.Item.prototype),
          o = s._create;

      s._create = function () {
        o.call(this), this.rect = new i();
      };

      var r = s.moveTo;
      return s.moveTo = function (t, i) {
        var e = Math.abs(this.position.x - t),
            n = Math.abs(this.position.y - i),
            s = this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && e < 1 && n < 1;
        s ? this.goTo(t, i) : r.apply(this, arguments);
      }, s.enablePlacing = function () {
        this.removeTransitionStyles(), this.isTransitioning && e && (this.element.style[e] = "none"), this.isTransitioning = !1, this.getSize(), this.layout._setRectSize(this.element, this.rect), this.isPlacing = !0;
      }, s.disablePlacing = function () {
        this.isPlacing = !1;
      }, s.removeElem = function () {
        var t = this.element.parentNode;
        t && t.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this]);
      }, s.showDropPlaceholder = function () {
        var t = this.dropPlaceholder;
        t || ((t = this.dropPlaceholder = document.createElement("div")).className = "packery-drop-placeholder", t.style.position = "absolute"), t.style.width = this.size.width + "px", t.style.height = this.size.height + "px", this.positionDropPlaceholder(), this.layout.element.appendChild(t);
      }, s.positionDropPlaceholder = function () {
        this.dropPlaceholder.style[e] = "translate(" + this.rect.x + "px, " + this.rect.y + "px)";
      }, s.hideDropPlaceholder = function () {
        var t = this.dropPlaceholder.parentNode;
        t && t.removeChild(this.dropPlaceholder);
      }, n;
    }) ? n.apply(i, s) : n) || (t.exports = o);
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[10], {
  127: function _(e, n) {
    throw new Error("Module parse failed: Unexpected token (17:9)\nYou may need an appropriate loader to handle this file type, currently no loaders are configured to process this file. See https://webpack.js.org/concepts#loaders\n| \n| describe('AcrStepSlider', () => {\n>   let dom: JSDOM;\n|   let jsModule: HTMLElement;\n| ");
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[2], {
  121: function _(t, e, i) {
    "use strict";

    i.r(e), i.d(e, "AcrGallery", function () {
      return l;
    });
    var n = i(318),
        a = i(324),
        r = i.n(a);

    function l(t) {
      var e, i, a, l, o, s, c, d;

      var u = function u() {
        d.addEventListener("change", function () {
          setTimeout(function () {
            a.layout();
          }, 200);
        }), void 0 !== s && l.forEach(function (t) {
          t.addEventListener("click", function (t) {
            t.preventDefault();
            var e = t.target.closest(".js-gallery-item"),
                i = e.dataset.galleryDetailTarget,
                n = e.dataset.imageId,
                a = e.dataset.index;
            i && o[i].openDetailview(n, a, c);
          });
        });
      };

      return {
        init: function init(t) {
          (function (t) {
            e = t, i = e.querySelector(".js-gallery-grid"), l = e.querySelectorAll(".js-gallery-item"), c = e.classList.contains("acr-gallery--mini");
          })(t), function (t) {
            e = t, c = e.classList.contains("acr-gallery--mini"), o = [];
          }(t), s = e.dataset.galleryDetail ? e.dataset.galleryDetail.toString().split(",") : void 0, void 0 !== s && s.forEach(function (t) {
            var e = new window.Acr.GalleryDetail(),
                i = document.getElementById(t);
            e.init(i), o[t] = e;
          }), a = new r.a(i, {
            itemSelector: ".js-gallery-item",
            gutter: 3,
            percentPosition: !0
          }), d = window.matchMedia("(max-width:" + (n.a.md - 1) + "px)"), u();
        },
        reset: function reset() {
          a.options.transitionDuration = "0s", a.layout(), a.options.transitionDuration = "0.4s";
        }
      };
    }
  },
  318: function _(t, e, i) {
    "use strict";

    i.d(e, "a", function () {
      return n;
    });
    var n = {
      xs: 320,
      sm: 550,
      md: 768,
      lg: 1024,
      lgxl: 1200,
      xl: 1400,
      mega: 1920
    };
  }
}]);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(window.webpackJsonp = window.webpackJsonp || []).push([[3], {
  123: function _(e, t, s) {
    "use strict";

    s.r(t), s.d(t, "AcrMLPNav", function () {
      return c;
    });
    var i = s(318),
        n = window.Utility || {};

    function c() {
      var e,
          t,
          s,
          c,
          a,
          o,
          r,
          d,
          l,
          u,
          h = 0,
          v = 0;

      var L = function L() {
        n.slideToggle(r, 400, "flex"), w(), r.offsetWidth > 0 && r.offsetHeight > 0 && (r.style.display = "flex"), o.forEach(function (e) {
          e.classList.contains("hidden") ? e.classList.remove("hidden") : e.classList.add("hidden");
        });
      };

      function m() {
        this.classList.contains("expanded") ? this.classList.remove("expanded") : this.classList.add("expanded");
      }

      function p() {
        var e;
        this.classList.add("selected"), e = n.siblings(this, "a"), e.forEach(function (e) {
          e.classList.remove("selected");
        });
      }

      var f = function f(e) {
        d = e.originalEvent.touches[0].clientY, h = parseInt(r.style.top, 10), r.classList.remove("acr-animation");
      },
          g = function g(e) {
        var t, s;
        l = e.originalEvent.touches[0].clientY, t = d - l, t *= -1, s = h + t, s > 0 ? s = 0 : -1 * s > v && (s = -1 * v), r.style.top = s.toString() + "px", r.classList.add("acr-animation");
      },
          E = function E() {
        d = null, l = null;
      },
          w = function w() {
        var e = t.clientHeight,
            s = window.innerHeight - e;
        v = Math.abs(r.clientHeight - s);
      },
          y = function y() {
        clearTimeout(u), u = setTimeout(x, 250);
      },
          x = function x() {
        window.innerWidth < i.a.lg && s.classList.contains("expanded") && s.classList.remove("expanded");
      };

      return {
        init: function init(i) {
          e = i, t = e.querySelector("section"), s = e.querySelector("div[role=presentation]"), c = _toConsumableArray(s.querySelectorAll("a")), a = t.querySelector("button"), o = _toConsumableArray(a.querySelectorAll("svg")), r = e.querySelector("aside[role=menu]"), o[1].classList.add("acr-icon"), o[1].classList.add("hidden"), e.querySelector(".acr-header > div") && (e.querySelector(".acr-header > div").style.position = "relative"), a.addEventListener("click", L), s.addEventListener("click", m), c.forEach(function (e) {
            e.addEventListener("click", p);
          }), window.addEventListener("resize", y), r.removeEventListener("touchstart", f), r.addEventListener("touchstart", f), r.removeEventListener("touchmove", g), r.addEventListener("touchmove", g), r.removeEventListener("touchend", E), r.addEventListener("touchend", E);
        }
      };
    }
  },
  318: function _(e, t, s) {
    "use strict";

    s.d(t, "a", function () {
      return i;
    });
    var i = {
      xs: 320,
      sm: 550,
      md: 768,
      lg: 1024,
      lgxl: 1200,
      xl: 1400,
      mega: 1920
    };
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[4], {
  125: function _(e, t, i) {
    "use strict";

    i.r(t), i.d(t, "AcrMultiColumn", function () {
      return l;
    });
    var r = i(318),
        o = i(319),
        a = i.n(o);

    function l() {
      var e, t, i, o, l, n, c, s, u, d, p, w;

      var S = function S(t, i) {
        if (t && t.matches) {
          var _e = {
            slidesPerView: 1,
            loop: !1,
            effect: "fade",
            allowTouchMove: "1" == w.SettingSwiperDraggable,
            fadeEffect: {
              crossFade: !0
            },
            navigation: {
              nextEl: u,
              prevEl: s
            }
          };
          "1" == w.SettingSwiperDots && (_e.pagination = {
            el: c,
            clickable: !0
          }), d = new a.a(n, _e);
        } else p = e.querySelector(".swiper-slide-active"), p && d.destroy(!1, !0);
      },
          g = function g(e) {
        i = e.target.querySelector("video"), i.offsetWidth > 0 && i.offsetHeight > 0 && (e.target.querySelector("picture").style.opacity = "0", i.style.opacity = "1", i.play());
      },
          m = function m(e) {
        i = e.target.querySelector("video"), i.offsetWidth > 0 && i.offsetHeight > 0 && (i.pause(), i.currentTime = 0, i.style.opacity = "0", e.target.querySelector("picture").style.opacity = "1");
      };

      return {
        init: function init(a) {
          (function (t) {
            e = t, o = e.querySelector(".js-multi-column-container"), l = e.querySelector(".js-multi-column-list"), s = e.querySelector(".js-arrow-left"), u = e.querySelector(".js-arrow-right"), n = t.querySelector(".js-swiper-container"), c = t.querySelector(".js-swiper-pagination");
          })(a), function () {
            try {
              w = JSON.parse(e.getAttribute("data-module-settings"));
            } catch (e) {
              w = {};
            }
          }(), t = w.SettingMobileSwiper && w.SettingTabletSwiper ? window.matchMedia("(max-width:".concat(r.a.lg - 1, "px)")) : w.SettingMobileSwiper ? window.matchMedia("(max-width:".concat(r.a.md - 1, "px)")) : w.SettingTabletSwiper ? window.matchMedia("(min-width:".concat(r.a.md, "px) and (max-width:").concat(r.a.lg - 1, "px)")) : void 0, S(t), function (e) {
            w.SettingMobileSwiper && e.querySelector(".js-multi-column-container").classList.add("mobile-swiper"), w.SettingTabletSwiper && e.querySelector(".js-multi-column-container").classList.add("tablet-swiper");
          }(a), e.querySelectorAll(".tile").forEach(function (e) {
            i = e.querySelector("video"), i && (e.addEventListener("mouseenter", g), e.addEventListener("mouseleave", m));
          }), (w.SettingMobileSwiper || w.SettingTabletSwiper) && t.addListener(S);
        }
      };
    }
  },
  318: function _(e, t, i) {
    "use strict";

    i.d(t, "a", function () {
      return r;
    });
    var r = {
      xs: 320,
      sm: 550,
      md: 768,
      lg: 1024,
      lgxl: 1200,
      xl: 1400,
      mega: 1920
    };
  }
}]);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(window.webpackJsonp = window.webpackJsonp || []).push([[5], {
  129: function _(e, t, a) {
    "use strict";

    a.r(t), a.d(t, "AcrTab", function () {
      return s;
    });
    var r = a(318),
        i = a(319),
        n = a.n(i),
        c = window.Acr || {},
        l = window.Utility || {};

    function s() {
      var e, t, a, i, s, o, d, u, b, g, w, p, v, S, _, y;

      var k = function k(e) {
        var t, a;
        a = (t = e).getAttribute("tab-id"), function (e, t) {
          for (var _e = 0; _e < i.length; _e++) {
            i[_e].classList.remove("acr-tab__link--active"), i[_e].setAttribute("aria-selected", "false");
          }

          e.classList.add("acr-tab__link--active"), e.setAttribute("aria-selected", "true"), d.forEach(function (e) {
            e.classList.remove("acr-tab__section--active");
          }), y = s.querySelector('*[data-id="' + t + '"]'), y.classList.add("acr-tab__section--active");
        }(t, a), f(y);
      };

      var h = function h(e) {
        var t = o.getAttribute("data-tracking-no-click");

        if (t && c.TrackingManager) {
          var a = JSON.parse(t.split("'").join('"'));
          a.dynamic_variables[0].search += e, c.TrackingManager.clickActivity(a);
        }
      },
          f = function f(e) {
        var a;
        a = _toConsumableArray(e.querySelectorAll(".js-module"));

        for (var r = 0; r < a.length; r++) {
          var i = parseInt(a[r].dataset.moduleId, 10);

          if (i) {
            var n = c.Modules[i];
            n.reset && n.reset();
          }
        }

        t.querySelector(".acr-package-detail__swiper-container") && (S = l.createEvent("swiperUpdate"), window.dispatchEvent(S));
      };

      function m() {
        if (t) {
          var a = e.getTabIdHashElement(t[0]);
          a && k(a);
        }
      }

      var A = function A(e, r) {
        if (e && e.matches) {
          var _e2 = {
            speed: 400,
            slidesPerView: 1,
            loop: !1,
            initialSlide: t.querySelector(".acr-tab__link--active") ? l.index(t.querySelector(".acr-tab__link--active").parentElement) : 0,
            pagination: {
              el: w,
              clickable: !0,
              type: "custom",
              bulletClass: "acr-tab__bullet",
              renderCustom: T,
              bulletActiveClass: "acr-tab__bullet-active"
            },
            on: {
              slideChange: function slideChange() {
                if (t.querySelector(".swiper-container")) {
                  var e = w.querySelector(".js-tab-link") ? w.querySelector(".js-tab-link").getAttribute("tab-id") : void 0,
                      i = a.querySelector('[tab-id="' + e + '"]');
                  i && k(i);
                }

                if (c.TrackingManager) {
                  var n = w.querySelector(".js-tab-link") ? w.querySelector(".js-tab-link").getAttribute("aria-controls") : void 0;
                  q(n), r && c.TrackingManager.sendCarouselActivity(r.currentTarget, this);
                }
              }
            },
            navigation: {
              nextEl: u,
              prevEl: b,
              disabledClass: "acr-tab__arrow--disabled"
            }
          };
          _ = new n.a(g, _e2);
        } else void 0 !== _ && _.destroy(!0, !0);
      },
          q = function q(e) {
        if (e) {
          var _a;

          var _r = new RegExp(/packages:.*'/);

          t.getAttribute("data-arrow-tracking") && (_a = t.getAttribute("data-arrow-tracking").replace(_r, "packages:".concat(e, "'")), t.setAttribute("data-arrow-tracking", _a));
        }
      },
          T = function T(e, t, a) {
        return i[t - 1].outerHTML.replace("acr-tab__link--active", "");
      };

      return {
        init: function init(n) {
          e = window.Acr && window.Acr.DeepLinking || {}, function (e) {
            t = e, i = _toConsumableArray(t.querySelectorAll(".js-tab-link")), d = _toConsumableArray(t.querySelectorAll(".js-tab-section")), a = t.querySelector(".js-tab-list"), s = t.querySelector(".js-tab-body"), o = t.querySelector(".js-tab-head"), w = t.querySelector(".acr-tab__controls-container .js-swiper-pagination"), b = t.querySelector(".acr-tab__controls-container .js-arrow-left"), u = t.querySelector(".acr-tab__controls-container .js-arrow-right"), g = t.querySelector(".acr-tab__body.swiper-container");
          }(n), function () {
            try {
              var _e3;

              t.dataset.defaultTab && (_e3 = parseInt(t.dataset.defaultTab, 10) - 1), v = JSON.parse(t.getAttribute("data-module-settings")), _e3 >= 0 && i.length > 1 && k(i[_e3]);
            } catch (e) {
              v = {};
            }
          }(), v.SettingMobileSwiper && t.classList.add("acr-tab--mobile-carousel"), v.SettingTabletSwiper && t.classList.add("acr-tab--tablet-carousel"), p = v.SettingMobileSwiper && v.SettingTabletSwiper ? window.matchMedia("(max-width:" + (r.a.lg - 1) + "px)") : v.SettingMobileSwiper ? window.matchMedia("(max-width:" + (r.a.md - 1) + "px)") : v.SettingTabletSwiper ? window.matchMedia("(min-width:" + r.a.md + "px) and (max-width:" + (r.a.lg - 1) + "px)") : void 0, A(p), (v.SettingMobileSwiper || v.SettingTabletSwiper) && p.addEventListener("change", function () {}), window.addEventListener("hashchange", m), window.addEventListener("load", m), function () {
            for (var e = 0; e < i.length; e++) {
              i[e].addEventListener("click", function (e) {
                var t = e.currentTarget.getAttribute("aria-controls");
                h(t), e.preventDefault(), k(this);
              });
            }
          }();
        }
      };
    }
  },
  318: function _(e, t, a) {
    "use strict";

    a.d(t, "a", function () {
      return r;
    });
    var r = {
      xs: 320,
      sm: 550,
      md: 768,
      lg: 1024,
      lgxl: 1200,
      xl: 1400,
      mega: 1920
    };
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[6], {
  126: function _(e, t, a) {
    "use strict";

    a.r(t), a.d(t, "AcrPackageDetail", function () {
      return r;
    });
    var i = a(319),
        l = l || {},
        s = window.Utility || {};

    function r() {
      var e, t, a, r, c, o, n, d, u, p, y, g, v;

      var w = /\[%colorCode%]/g,
          f = /\[%interiorCode%]/g,
          b = /\[%modelId%]/g,
          k = function k() {
        y = new i(g, {
          speed: 400,
          slidesPerView: 1,
          loop: !0,
          pagination: {
            el: u,
            clickable: !0,
            bulletClass: "acr-package-detail__bullet",
            bulletActiveClass: "acr-package-detail__bullet-active"
          },
          navigation: {
            nextEl: n,
            prevEl: d
          }
        }), y.on("slideChangeTransitionStart", function () {
          h();
        }), y.on("slideChange", function () {
          l.TrackingManager && l.TrackingManager.sendCarouselActivity(event.currentTarget, this);
        }), window.addEventListener("swiperUpdate", function (e) {
          S();
        });
      },
          S = function S() {
        y.update();
      },
          q = function q(e) {
        var t = e.dataset.id,
            a = e.dataset.colorCode,
            i = e.dataset.interiorCode,
            l = e.dataset.modelids.split(",");
        r.forEach(function (e) {
          var a = e;
          a.dataset.id === t ? a.classList.add("is-active") : a.classList.remove("is-active");
        }), m(a, i), L(a, l[0]), j(l);
      },
          m = function m(e, t) {
        if (c) {
          var _a = c.dataset.href.replace(w, e);

          _a = _a.replace(f, t), c.setAttribute("href", _a);
        }
      },
          L = function L(a, i) {
        var l, s, r;
        l = y.realIndex || 0, p = t.querySelector("img.swiper-slide-active"), p || (p = t.querySelector("img.swiper-slide-duplicate-active")), p && !p.classList.contains("loaded") && (v.classList.add("avoid-clicking"), r = new Image(), e.style.display = "block", s = p.dataset.src.replace(w, a), s = s.replace(b, i), r.src = s, r.onload = function () {
          p.setAttribute("src", s), p.classList.add("loaded"), e.style.display = "none", v.classList.remove("avoid-clicking");
        });
      },
          j = function j(e) {
        o && (-1 !== e.indexOf(o.dataset.modelId) ? o.style.display = "block" : o.style.display = "none");
      },
          h = function h() {
        var e;
        a.forEach(function (t) {
          t.classList.contains("is-active") && (e = t);
        }), e && q(e);
      },
          A = function A() {
        h();
      },
          C = function C(e) {
        event.preventDefault(), a.forEach(function (e) {
          e.classList.remove("is-active");
        }), e.classList.add("is-active"), t.querySelectorAll(".js-img-src").forEach(function (e) {
          e.setAttribute("src", ""), e.classList.remove("loaded");
        }), q(e);
      };

      return {
        init: function init(i) {
          (function (i) {
            t = i, e = t.querySelector(".js-spinner-overlay"), a = t.querySelectorAll(".js-color-button"), r = t.querySelectorAll(".js-color-name-label"), c = t.querySelector(".js-build-link"), p = t.querySelector(".js-img-src"), o = t.querySelector(".js-available-build"), n = t.querySelector(".js-arrow-right"), d = t.querySelector(".js-arrow-left"), u = t.querySelector(".js-swiper-pagination"), g = t.querySelector(".js-swiper-container"), v = t.querySelector(".js-avoid-clicking");
          })(i), k(), a.forEach(function (e) {
            e.addEventListener("click", function () {
              C(e);
            });
          }), function () {
            var e = [].slice.call(document.querySelectorAll(".js-lazy-packages"));
            s.initLazyLoadingIO(e, A);
          }();
        }
      };
    }
  }
}]);
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(window.webpackJsonp = window.webpackJsonp || []).push([[7], {
  128: function _(e, n, r) {
    "use strict";

    r.r(n), r.d(n, "AcrStepSlider", function () {
      return o;
    });
    var i = r(319),
        t = r.n(i);

    function o() {
      var e, n, r, i, o;
      var s = {
        slidesPerView: 1,
        allowTouchMove: !0,
        breakpoints: {
          1023: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        }
      };
      return {
        init: function init(u) {
          !function (t) {
            e = t, i = e.querySelector(".swiper-container"), o = e.querySelector(".swiper-pagination"), n = e.querySelector(".swiper-button-prev"), r = e.querySelector(".swiper-button-next");
          }(u), new t.a(i, _objectSpread(_objectSpread({}, s), {}, {
            navigation: {
              nextEl: r,
              prevEl: n
            },
            pagination: {
              el: o
            }
          }));
        }
      };
    }
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[8], {
  122: function _(e, n) {
    throw new Error("Module parse failed: Unexpected token (13:11)\nYou may need an appropriate loader to handle this file type, currently no loaders are configured to process this file. See https://webpack.js.org/concepts#loaders\n| \n| describe('AcrMLPNav', () => {\n>     let dom: JSDOM;\n|     let jsModule: HTMLElement;\n|   ");
  }
}]);
"use strict";

(window.webpackJsonp = window.webpackJsonp || []).push([[9], {
  124: function _(e, n) {
    throw new Error("Module parse failed: Unexpected token (28:9)\nYou may need an appropriate loader to handle this file type, currently no loaders are configured to process this file. See https://webpack.js.org/concepts#loaders\n| \n| describe('AcrMultiColumn', () => {\n>   let dom: JSDOM;\n|   let jsModule: HTMLElement;\n| ");
  }
}]);
"use strict";function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}!function(t){function n(n){for(var r,i,o=n[0],u=n[1],c=0,f=[];c<o.length;c++){i=o[c],Object.prototype.hasOwnProperty.call(e,i)&&e[i]&&f.push(e[i][0]),e[i]=0;}for(r in u){Object.prototype.hasOwnProperty.call(u,r)&&(t[r]=u[r]);}for(a&&a(n);f.length;){f.shift()();}}var r={},e={11:0};function i(n){if(r[n])return r[n].exports;var e=r[n]={i:n,l:!1,exports:{}};return t[n].call(e.exports,e,e.exports,i),e.l=!0,e.exports;}i.e=function(t){var n=[],r=e[t];if(0!==r)if(r)n.push(r[2]);else{var o=new Promise(function(n,i){r=e[t]=[n,i];});n.push(r[2]=o);var u,c=document.createElement("script");c.charset="utf-8",c.timeout=120,i.nc&&c.setAttribute("nonce",i.nc),c.src=function(t){return i.p+""+t+".temp-scripts.js";}(t);var a=new Error();u=function u(n){c.onerror=c.onload=null,clearTimeout(f);var r=e[t];if(0!==r){if(r){var i=n&&("load"===n.type?"missing":n.type),o=n&&n.target&&n.target.src;a.message="Loading chunk "+t+" failed.\n("+i+": "+o+")",a.name="ChunkLoadError",a.type=i,a.request=o,r[1](a);}e[t]=void 0;}};var f=setTimeout(function(){u({type:"timeout",target:c});},12e4);c.onerror=c.onload=u,document.head.appendChild(c);}return Promise.all(n);},i.m=t,i.c=r,i.d=function(t,n,r){i.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r});},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},i.t=function(t,n){if(1&n&&(t=i(t)),8&n)return t;if(4&n&&"object"==_typeof(t)&&t&&t.__esModule)return t;var r=Object.create(null);if(i.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var e in t){i.d(r,e,function(n){return t[n];}.bind(null,e));}return r;},i.n=function(t){var n=t&&t.__esModule?function(){return t.default;}:function(){return t;};return i.d(n,"a",n),n;},i.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n);},i.p="",i.oe=function(t){throw console.error(t),t;};var o=window.webpackJsonp=window.webpackJsonp||[],u=o.push.bind(o);o.push=n,o=o.slice();for(var c=0;c<o.length;c++){n(o[c]);}var a=u;i(i.s=130);}([function(t,n,r){var e=r(1),i=r(7),o=r(14),u=r(11),c=r(17),a=function a(t,n,r){var f,s,l,h,p=t&a.F,v=t&a.G,d=t&a.S,y=t&a.P,g=t&a.B,m=v?e:d?e[n]||(e[n]={}):(e[n]||{}).prototype,b=v?i:i[n]||(i[n]={}),x=b.prototype||(b.prototype={});for(f in v&&(r=n),r){l=((s=!p&&m&&void 0!==m[f])?m:r)[f],h=g&&s?c(l,e):y&&"function"==typeof l?c(Function.call,l):l,m&&u(m,f,l,t&a.U),b[f]!=l&&o(b,f,h),y&&x[f]!=l&&(x[f]=l);}};e.core=i,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a;},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},function(t,n){t.exports=function(t){try{return!!t();}catch(t){return!0;}};},function(t,n,r){var e=r(4);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t;};},function(t,n){t.exports=function(t){return"object"==_typeof(t)?null!==t:"function"==typeof t;};},function(t,n,r){var e=r(48)("wks"),i=r(29),o=r(1).Symbol,u="function"==typeof o;(t.exports=function(t){return e[t]||(e[t]=u&&o[t]||(u?o:i)("Symbol."+t));}).store=e;},function(t,n,r){var e=r(19),i=Math.min;t.exports=function(t){return t>0?i(e(t),9007199254740991):0;};},function(t,n){var r=t.exports={version:"2.6.12"};"number"==typeof __e&&(__e=r);},function(t,n,r){t.exports=!r(2)(function(){return 7!=Object.defineProperty({},"a",{get:function get(){return 7;}}).a;});},function(t,n,r){var e=r(3),i=r(88),o=r(26),u=Object.defineProperty;n.f=r(8)?Object.defineProperty:function(t,n,r){if(e(t),n=o(n,!0),e(r),i)try{return u(t,n,r);}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t;};},function(t,n,r){var e=r(24);t.exports=function(t){return Object(e(t));};},function(t,n,r){var e=r(1),i=r(14),o=r(13),u=r(29)("src"),c=r(135),a=(""+c).split("toString");r(7).inspectSource=function(t){return c.call(t);},(t.exports=function(t,n,r,c){var f="function"==typeof r;f&&(o(r,"name")||i(r,"name",n)),t[n]!==r&&(f&&(o(r,u)||i(r,u,t[n]?""+t[n]:a.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:i(t,n,r):(delete t[n],i(t,n,r)));})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this);});},function(t,n,r){var e=r(0),i=r(2),o=r(24),u=/"/g,c=function c(t,n,r,e){var i=String(o(t)),c="<"+n;return""!==r&&(c+=" "+r+'="'+String(e).replace(u,"&quot;")+'"'),c+">"+i+"</"+n+">";};t.exports=function(t,n){var r={};r[t]=n(c),e(e.P+e.F*i(function(){var n=""[t]('"');return n!==n.toLowerCase()||n.split('"').length>3;}),"String",r);};},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n);};},function(t,n,r){var e=r(9),i=r(28);t.exports=r(8)?function(t,n,r){return e.f(t,n,i(1,r));}:function(t,n,r){return t[n]=r,t;};},function(t,n,r){var e=r(44),i=r(24);t.exports=function(t){return e(i(t));};},function(t,n,r){"use strict";var e=r(2);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null);});};},function(t,n,r){var e=r(18);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r);};case 2:return function(r,e){return t.call(n,r,e);};case 3:return function(r,e,i){return t.call(n,r,e,i);};}return function(){return t.apply(n,arguments);};};},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t;};},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t);};},function(t,n,r){var e=r(45),i=r(28),o=r(15),u=r(26),c=r(13),a=r(88),f=Object.getOwnPropertyDescriptor;n.f=r(8)?f:function(t,n){if(t=o(t),n=u(n,!0),a)try{return f(t,n);}catch(t){}if(c(t,n))return i(!e.f.call(t,n),t[n]);};},function(t,n,r){var e=r(0),i=r(7),o=r(2);t.exports=function(t,n){var r=(i.Object||{})[t]||Object[t],u={};u[t]=n(r),e(e.S+e.F*o(function(){r(1);}),"Object",u);};},function(t,n,r){var e=r(17),i=r(44),o=r(10),u=r(6),c=r(104);t.exports=function(t,n){var r=1==t,a=2==t,f=3==t,s=4==t,l=6==t,h=5==t||l,p=n||c;return function(n,c,v){for(var d,y,g=o(n),m=i(g),b=e(c,v,3),x=u(m.length),w=0,S=r?p(n,x):a?p(n,0):void 0;x>w;w++){if((h||w in m)&&(y=b(d=m[w],w,g),t))if(r)S[w]=y;else if(y)switch(t){case 3:return!0;case 5:return d;case 6:return w;case 2:S.push(d);}else if(s)return!1;}return l?-1:f||s?s:S;};};},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1);};},function(t,n){t.exports=function(t){if(null==t)throw TypeError("Can't call method on  "+t);return t;};},function(t,n,r){"use strict";if(r(8)){var e=r(30),i=r(1),o=r(2),u=r(0),c=r(59),a=r(84),f=r(17),s=r(42),l=r(28),h=r(14),p=r(43),v=r(19),d=r(6),y=r(115),g=r(32),m=r(26),b=r(13),x=r(46),w=r(4),S=r(10),_=r(76),E=r(33),O=r(35),A=r(34).f,P=r(78),M=r(29),F=r(5),j=r(22),I=r(49),N=r(47),T=r(80),L=r(40),R=r(52),k=r(41),C=r(79),D=r(106),W=r(9),G=r(20),U=W.f,B=G.f,V=i.RangeError,z=i.TypeError,Y=i.Uint8Array,$=Array.prototype,q=a.ArrayBuffer,J=a.DataView,K=j(0),X=j(2),H=j(3),Z=j(4),Q=j(5),tt=j(6),nt=I(!0),rt=I(!1),et=T.values,it=T.keys,ot=T.entries,ut=$.lastIndexOf,ct=$.reduce,at=$.reduceRight,ft=$.join,st=$.sort,lt=$.slice,ht=$.toString,pt=$.toLocaleString,vt=F("iterator"),dt=F("toStringTag"),yt=M("typed_constructor"),gt=M("def_constructor"),mt=c.CONSTR,bt=c.TYPED,xt=c.VIEW,wt=j(1,function(t,n){return At(N(t,t[gt]),n);}),St=o(function(){return 1===new Y(new Uint16Array([1]).buffer)[0];}),_t=!!Y&&!!Y.prototype.set&&o(function(){new Y(1).set({});}),Et=function Et(t,n){var r=v(t);if(r<0||r%n)throw V("Wrong offset!");return r;},Ot=function Ot(t){if(w(t)&&bt in t)return t;throw z(t+" is not a typed array!");},At=function At(t,n){if(!w(t)||!(yt in t))throw z("It is not a typed array constructor!");return new t(n);},Pt=function Pt(t,n){return Mt(N(t,t[gt]),n);},Mt=function Mt(t,n){for(var r=0,e=n.length,i=At(t,e);e>r;){i[r]=n[r++];}return i;},Ft=function Ft(t,n,r){U(t,n,{get:function get(){return this._d[r];}});},jt=function jt(t){var n,r,e,i,o,u,c=S(t),a=arguments.length,s=a>1?arguments[1]:void 0,l=void 0!==s,h=P(c);if(null!=h&&!_(h)){for(u=h.call(c),e=[],n=0;!(o=u.next()).done;n++){e.push(o.value);}c=e;}for(l&&a>2&&(s=f(s,arguments[2],2)),n=0,r=d(c.length),i=At(this,r);r>n;n++){i[n]=l?s(c[n],n):c[n];}return i;},It=function It(){for(var t=0,n=arguments.length,r=At(this,n);n>t;){r[t]=arguments[t++];}return r;},Nt=!!Y&&o(function(){pt.call(new Y(1));}),Tt=function Tt(){return pt.apply(Nt?lt.call(Ot(this)):Ot(this),arguments);},Lt={copyWithin:function copyWithin(t,n){return D.call(Ot(this),t,n,arguments.length>2?arguments[2]:void 0);},every:function every(t){return Z(Ot(this),t,arguments.length>1?arguments[1]:void 0);},fill:function fill(t){return C.apply(Ot(this),arguments);},filter:function filter(t){return Pt(this,X(Ot(this),t,arguments.length>1?arguments[1]:void 0));},find:function find(t){return Q(Ot(this),t,arguments.length>1?arguments[1]:void 0);},findIndex:function findIndex(t){return tt(Ot(this),t,arguments.length>1?arguments[1]:void 0);},forEach:function forEach(t){K(Ot(this),t,arguments.length>1?arguments[1]:void 0);},indexOf:function indexOf(t){return rt(Ot(this),t,arguments.length>1?arguments[1]:void 0);},includes:function includes(t){return nt(Ot(this),t,arguments.length>1?arguments[1]:void 0);},join:function join(t){return ft.apply(Ot(this),arguments);},lastIndexOf:function lastIndexOf(t){return ut.apply(Ot(this),arguments);},map:function map(t){return wt(Ot(this),t,arguments.length>1?arguments[1]:void 0);},reduce:function reduce(t){return ct.apply(Ot(this),arguments);},reduceRight:function reduceRight(t){return at.apply(Ot(this),arguments);},reverse:function reverse(){for(var t,n=Ot(this).length,r=Math.floor(n/2),e=0;e<r;){t=this[e],this[e++]=this[--n],this[n]=t;}return this;},some:function some(t){return H(Ot(this),t,arguments.length>1?arguments[1]:void 0);},sort:function sort(t){return st.call(Ot(this),t);},subarray:function subarray(t,n){var r=Ot(this),e=r.length,i=g(t,e);return new(N(r,r[gt]))(r.buffer,r.byteOffset+i*r.BYTES_PER_ELEMENT,d((void 0===n?e:g(n,e))-i));}},Rt=function Rt(t,n){return Pt(this,lt.call(Ot(this),t,n));},kt=function kt(t){Ot(this);var n=Et(arguments[1],1),r=this.length,e=S(t),i=d(e.length),o=0;if(i+n>r)throw V("Wrong length!");for(;o<i;){this[n+o]=e[o++];}},Ct={entries:function entries(){return ot.call(Ot(this));},keys:function keys(){return it.call(Ot(this));},values:function values(){return et.call(Ot(this));}},Dt=function Dt(t,n){return w(t)&&t[bt]&&"symbol"!=_typeof(n)&&n in t&&String(+n)==String(n);},Wt=function Wt(t,n){return Dt(t,n=m(n,!0))?l(2,t[n]):B(t,n);},Gt=function Gt(t,n,r){return!(Dt(t,n=m(n,!0))&&w(r)&&b(r,"value"))||b(r,"get")||b(r,"set")||r.configurable||b(r,"writable")&&!r.writable||b(r,"enumerable")&&!r.enumerable?U(t,n,r):(t[n]=r.value,t);};mt||(G.f=Wt,W.f=Gt),u(u.S+u.F*!mt,"Object",{getOwnPropertyDescriptor:Wt,defineProperty:Gt}),o(function(){ht.call({});})&&(ht=pt=function pt(){return ft.call(this);});var Ut=p({},Lt);p(Ut,Ct),h(Ut,vt,Ct.values),p(Ut,{slice:Rt,set:kt,constructor:function constructor(){},toString:ht,toLocaleString:Tt}),Ft(Ut,"buffer","b"),Ft(Ut,"byteOffset","o"),Ft(Ut,"byteLength","l"),Ft(Ut,"length","e"),U(Ut,dt,{get:function get(){return this[bt];}}),t.exports=function(t,n,r,a){var f=t+((a=!!a)?"Clamped":"")+"Array",l="get"+t,p="set"+t,v=i[f],g=v||{},m=v&&O(v),b=!v||!c.ABV,S={},_=v&&v.prototype,P=function P(t,r){U(t,r,{get:function get(){return function(t,r){var e=t._d;return e.v[l](r*n+e.o,St);}(this,r);},set:function set(t){return function(t,r,e){var i=t._d;a&&(e=(e=Math.round(e))<0?0:e>255?255:255&e),i.v[p](r*n+i.o,e,St);}(this,r,t);},enumerable:!0});};b?(v=r(function(t,r,e,i){s(t,v,f,"_d");var o,u,c,a,l=0,p=0;if(w(r)){if(!(r instanceof q||"ArrayBuffer"==(a=x(r))||"SharedArrayBuffer"==a))return bt in r?Mt(v,r):jt.call(v,r);o=r,p=Et(e,n);var g=r.byteLength;if(void 0===i){if(g%n)throw V("Wrong length!");if((u=g-p)<0)throw V("Wrong length!");}else if((u=d(i)*n)+p>g)throw V("Wrong length!");c=u/n;}else c=y(r),o=new q(u=c*n);for(h(t,"_d",{b:o,o:p,l:u,e:c,v:new J(o)});l<c;){P(t,l++);}}),_=v.prototype=E(Ut),h(_,"constructor",v)):o(function(){v(1);})&&o(function(){new v(-1);})&&R(function(t){new v(),new v(null),new v(1.5),new v(t);},!0)||(v=r(function(t,r,e,i){var o;return s(t,v,f),w(r)?r instanceof q||"ArrayBuffer"==(o=x(r))||"SharedArrayBuffer"==o?void 0!==i?new g(r,Et(e,n),i):void 0!==e?new g(r,Et(e,n)):new g(r):bt in r?Mt(v,r):jt.call(v,r):new g(y(r));}),K(m!==Function.prototype?A(g).concat(A(m)):A(g),function(t){t in v||h(v,t,g[t]);}),v.prototype=_,e||(_.constructor=v));var M=_[vt],F=!!M&&("values"==M.name||null==M.name),j=Ct.values;h(v,yt,!0),h(_,bt,f),h(_,xt,!0),h(_,gt,v),(a?new v(1)[dt]==f:dt in _)||U(_,dt,{get:function get(){return f;}}),S[f]=v,u(u.G+u.W+u.F*(v!=g),S),u(u.S,f,{BYTES_PER_ELEMENT:n}),u(u.S+u.F*o(function(){g.of.call(v,1);}),f,{from:jt,of:It}),"BYTES_PER_ELEMENT"in _||h(_,"BYTES_PER_ELEMENT",n),u(u.P,f,Lt),k(f),u(u.P+u.F*_t,f,{set:kt}),u(u.P+u.F*!F,f,Ct),e||_.toString==ht||(_.toString=ht),u(u.P+u.F*o(function(){new v(1).slice();}),f,{slice:Rt}),u(u.P+u.F*(o(function(){return[1,2].toLocaleString()!=new v([1,2]).toLocaleString();})||!o(function(){_.toLocaleString.call([1,2]);})),f,{toLocaleString:Tt}),L[f]=F?M:j,e||F||h(_,vt,j);};}else t.exports=function(){};},function(t,n,r){var e=r(4);t.exports=function(t,n){if(!e(t))return t;var r,i;if(n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;if("function"==typeof(r=t.valueOf)&&!e(i=r.call(t)))return i;if(!n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;throw TypeError("Can't convert object to primitive value");};},function(t,n,r){var e=r(29)("meta"),i=r(4),o=r(13),u=r(9).f,c=0,a=Object.isExtensible||function(){return!0;},f=!r(2)(function(){return a(Object.preventExtensions({}));}),s=function s(t){u(t,e,{value:{i:"O"+ ++c,w:{}}});},l=t.exports={KEY:e,NEED:!1,fastKey:function fastKey(t,n){if(!i(t))return"symbol"==_typeof(t)?t:("string"==typeof t?"S":"P")+t;if(!o(t,e)){if(!a(t))return"F";if(!n)return"E";s(t);}return t[e].i;},getWeak:function getWeak(t,n){if(!o(t,e)){if(!a(t))return!0;if(!n)return!1;s(t);}return t[e].w;},onFreeze:function onFreeze(t){return f&&l.NEED&&a(t)&&!o(t,e)&&s(t),t;}};},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n};};},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36));};},function(t,n){t.exports=!1;},function(t,n,r){var e=r(90),i=r(63);t.exports=Object.keys||function(t){return e(t,i);};},function(t,n,r){var e=r(19),i=Math.max,o=Math.min;t.exports=function(t,n){return(t=e(t))<0?i(t+n,0):o(t,n);};},function(t,n,r){var e=r(3),i=r(91),o=r(63),u=r(62)("IE_PROTO"),c=function c(){},_a=function a(){var t,n=r(60)("iframe"),e=o.length;for(n.style.display="none",r(64).appendChild(n),n.src="javascript:",(t=n.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),_a=t.F;e--;){delete _a.prototype[o[e]];}return _a();};t.exports=Object.create||function(t,n){var r;return null!==t?(c.prototype=e(t),r=new c(),c.prototype=null,r[u]=t):r=_a(),void 0===n?r:i(r,n);};},function(t,n,r){var e=r(90),i=r(63).concat("length","prototype");n.f=Object.getOwnPropertyNames||function(t){return e(t,i);};},function(t,n,r){var e=r(13),i=r(10),o=r(62)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),e(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null;};},function(t,n,r){var e=r(5)("unscopables"),i=Array.prototype;null==i[e]&&r(14)(i,e,{}),t.exports=function(t){i[e][t]=!0;};},function(t,n,r){var e=r(4);t.exports=function(t,n){if(!e(t)||t._t!==n)throw TypeError("Incompatible receiver, "+n+" required!");return t;};},function(t,n,r){var e=r(9).f,i=r(13),o=r(5)("toStringTag");t.exports=function(t,n,r){t&&!i(t=r?t:t.prototype,o)&&e(t,o,{configurable:!0,value:n});};},function(t,n,r){var e=r(0),i=r(24),o=r(2),u=r(66),c="["+u+"]",a=RegExp("^"+c+c+"*"),f=RegExp(c+c+"*$"),s=function s(t,n,r){var i={},c=o(function(){return!!u[t]()||"​"!="​"[t]();}),a=i[t]=c?n(l):u[t];r&&(i[r]=a),e(e.P+e.F*c,"String",i);},l=s.trim=function(t,n){return t=String(i(t)),1&n&&(t=t.replace(a,"")),2&n&&(t=t.replace(f,"")),t;};t.exports=s;},function(t,n){t.exports={};},function(t,n,r){"use strict";var e=r(1),i=r(9),o=r(8),u=r(5)("species");t.exports=function(t){var n=e[t];o&&n&&!n[u]&&i.f(n,u,{configurable:!0,get:function get(){return this;}});};},function(t,n){t.exports=function(t,n,r,e){if(!(t instanceof n)||void 0!==e&&e in t)throw TypeError(r+": incorrect invocation!");return t;};},function(t,n,r){var e=r(11);t.exports=function(t,n,r){for(var i in n){e(t,i,n[i],r);}return t;};},function(t,n,r){var e=r(23);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t);};},function(t,n){n.f={}.propertyIsEnumerable;},function(t,n,r){var e=r(23),i=r(5)("toStringTag"),o="Arguments"==e(function(){return arguments;}());t.exports=function(t){var n,r,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,n){try{return t[n];}catch(t){}}(n=Object(t),i))?r:o?e(n):"Object"==(u=e(n))&&"function"==typeof n.callee?"Arguments":u;};},function(t,n,r){var e=r(3),i=r(18),o=r(5)("species");t.exports=function(t,n){var r,u=e(t).constructor;return void 0===u||null==(r=e(u)[o])?n:i(r);};},function(t,n,r){var e=r(7),i=r(1),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(t.exports=function(t,n){return o[t]||(o[t]=void 0!==n?n:{});})("versions",[]).push({version:e.version,mode:r(30)?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"});},function(t,n,r){var e=r(15),i=r(6),o=r(32);t.exports=function(t){return function(n,r,u){var c,a=e(n),f=i(a.length),s=o(u,f);if(t&&r!=r){for(;f>s;){if((c=a[s++])!=c)return!0;}}else for(;f>s;s++){if((t||s in a)&&a[s]===r)return t||s||0;}return!t&&-1;};};},function(t,n){n.f=Object.getOwnPropertySymbols;},function(t,n,r){var e=r(23);t.exports=Array.isArray||function(t){return"Array"==e(t);};},function(t,n,r){var e=r(5)("iterator"),i=!1;try{var o=[7][e]();o.return=function(){i=!0;},Array.from(o,function(){throw 2;});}catch(t){}t.exports=function(t,n){if(!n&&!i)return!1;var r=!1;try{var o=[7],u=o[e]();u.next=function(){return{done:r=!0};},o[e]=function(){return u;},t(o);}catch(t){}return r;};},function(t,n,r){"use strict";var e=r(3);t.exports=function(){var t=e(this),n="";return t.global&&(n+="g"),t.ignoreCase&&(n+="i"),t.multiline&&(n+="m"),t.unicode&&(n+="u"),t.sticky&&(n+="y"),n;};},function(t,n,r){"use strict";var e=r(46),i=RegExp.prototype.exec;t.exports=function(t,n){var r=t.exec;if("function"==typeof r){var o=r.call(t,n);if("object"!=_typeof(o))throw new TypeError("RegExp exec method returned something other than an Object or null");return o;}if("RegExp"!==e(t))throw new TypeError("RegExp#exec called on incompatible receiver");return i.call(t,n);};},function(t,n,r){"use strict";r(108);var e=r(11),i=r(14),o=r(2),u=r(24),c=r(5),a=r(81),f=c("species"),s=!o(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t;},"7"!=="".replace(t,"$<a>");}),l=function(){var t=/(?:)/,n=t.exec;t.exec=function(){return n.apply(this,arguments);};var r="ab".split(t);return 2===r.length&&"a"===r[0]&&"b"===r[1];}();t.exports=function(t,n,r){var h=c(t),p=!o(function(){var n={};return n[h]=function(){return 7;},7!=""[t](n);}),v=p?!o(function(){var n=!1,r=/a/;return r.exec=function(){return n=!0,null;},"split"===t&&(r.constructor={},r.constructor[f]=function(){return r;}),r[h](""),!n;}):void 0;if(!p||!v||"replace"===t&&!s||"split"===t&&!l){var d=/./[h],y=r(u,h,""[t],function(t,n,r,e,i){return n.exec===a?p&&!i?{done:!0,value:d.call(n,r,e)}:{done:!0,value:t.call(r,n,e)}:{done:!1};}),g=y[0],m=y[1];e(String.prototype,t,g),i(RegExp.prototype,h,2==n?function(t,n){return m.call(t,this,n);}:function(t){return m.call(t,this);});}};},function(t,n,r){var e=r(17),i=r(103),o=r(76),u=r(3),c=r(6),a=r(78),f={},s={};(n=t.exports=function(t,n,r,l,h){var p,v,d,y,g=h?function(){return t;}:a(t),m=e(r,l,n?2:1),b=0;if("function"!=typeof g)throw TypeError(t+" is not iterable!");if(o(g)){for(p=c(t.length);p>b;b++){if((y=n?m(u(v=t[b])[0],v[1]):m(t[b]))===f||y===s)return y;}}else for(d=g.call(t);!(v=d.next()).done;){if((y=i(d,m,v.value,n))===f||y===s)return y;}}).BREAK=f,n.RETURN=s;},function(t,n,r){var e=r(1).navigator;t.exports=e&&e.userAgent||"";},function(t,n,r){"use strict";var e=r(1),i=r(0),o=r(11),u=r(43),c=r(27),a=r(56),f=r(42),s=r(4),l=r(2),h=r(52),p=r(38),v=r(67);t.exports=function(t,n,r,d,y,g){var m=e[t],b=m,x=y?"set":"add",w=b&&b.prototype,S={},_=function _(t){var n=w[t];o(w,t,"delete"==t||"has"==t?function(t){return!(g&&!s(t))&&n.call(this,0===t?0:t);}:"get"==t?function(t){return g&&!s(t)?void 0:n.call(this,0===t?0:t);}:"add"==t?function(t){return n.call(this,0===t?0:t),this;}:function(t,r){return n.call(this,0===t?0:t,r),this;});};if("function"==typeof b&&(g||w.forEach&&!l(function(){new b().entries().next();}))){var E=new b(),O=E[x](g?{}:-0,1)!=E,A=l(function(){E.has(1);}),P=h(function(t){new b(t);}),M=!g&&l(function(){for(var t=new b(),n=5;n--;){t[x](n,n);}return!t.has(-0);});P||((b=n(function(n,r){f(n,b,t);var e=v(new m(),n,b);return null!=r&&a(r,y,e[x],e),e;})).prototype=w,w.constructor=b),(A||M)&&(_("delete"),_("has"),y&&_("get")),(M||O)&&_(x),g&&w.clear&&delete w.clear;}else b=d.getConstructor(n,t,y,x),u(b.prototype,r),c.NEED=!0;return p(b,t),S[t]=b,i(i.G+i.W+i.F*(b!=m),S),g||d.setStrong(b,t,y),b;};},function(t,n,r){for(var e,i=r(1),o=r(14),u=r(29),c=u("typed_array"),a=u("view"),f=!(!i.ArrayBuffer||!i.DataView),s=f,l=0,h="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");l<9;){(e=i[h[l++]])?(o(e.prototype,c,!0),o(e.prototype,a,!0)):s=!1;}t.exports={ABV:f,CONSTR:s,TYPED:c,VIEW:a};},function(t,n,r){var e=r(4),i=r(1).document,o=e(i)&&e(i.createElement);t.exports=function(t){return o?i.createElement(t):{};};},function(t,n,r){n.f=r(5);},function(t,n,r){var e=r(48)("keys"),i=r(29);t.exports=function(t){return e[t]||(e[t]=i(t));};},function(t,n){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");},function(t,n,r){var e=r(1).document;t.exports=e&&e.documentElement;},function(t,n,r){var e=r(4),i=r(3),o=function o(t,n){if(i(t),!e(n)&&null!==n)throw TypeError(n+": can't set as prototype!");};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,n,e){try{(e=r(17)(Function.call,r(20).f(Object.prototype,"__proto__").set,2))(t,[]),n=!(t instanceof Array);}catch(t){n=!0;}return function(t,r){return o(t,r),n?t.__proto__=r:e(t,r),t;};}({},!1):void 0),check:o};},function(t,n){t.exports="\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";},function(t,n,r){var e=r(4),i=r(65).set;t.exports=function(t,n,r){var o,u=n.constructor;return u!==r&&"function"==typeof u&&(o=u.prototype)!==r.prototype&&e(o)&&i&&i(t,o),t;};},function(t,n,r){"use strict";var e=r(19),i=r(24);t.exports=function(t){var n=String(i(this)),r="",o=e(t);if(o<0||o==1/0)throw RangeError("Count can't be negative");for(;o>0;(o>>>=1)&&(n+=n)){1&o&&(r+=n);}return r;};},function(t,n){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1;};},function(t,n){var r=Math.expm1;t.exports=!r||r(10)>22025.465794806718||r(10)<22025.465794806718||-2e-17!=r(-2e-17)?function(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:Math.exp(t)-1;}:r;},function(t,n,r){var e=r(19),i=r(24);t.exports=function(t){return function(n,r){var o,u,c=String(i(n)),a=e(r),f=c.length;return a<0||a>=f?t?"":void 0:(o=c.charCodeAt(a))<55296||o>56319||a+1===f||(u=c.charCodeAt(a+1))<56320||u>57343?t?c.charAt(a):o:t?c.slice(a,a+2):u-56320+(o-55296<<10)+65536;};};},function(t,n,r){"use strict";var e=r(30),i=r(0),o=r(11),u=r(14),c=r(40),a=r(102),f=r(38),s=r(35),l=r(5)("iterator"),h=!([].keys&&"next"in[].keys()),p=function p(){return this;};t.exports=function(t,n,r,v,d,y,g){a(r,n,v);var m,b,x,w=function w(t){if(!h&&t in O)return O[t];switch(t){case"keys":case"values":return function(){return new r(this,t);};}return function(){return new r(this,t);};},S=n+" Iterator",_="values"==d,E=!1,O=t.prototype,A=O[l]||O["@@iterator"]||d&&O[d],P=A||w(d),M=d?_?w("entries"):P:void 0,F="Array"==n&&O.entries||A;if(F&&(x=s(F.call(new t())))!==Object.prototype&&x.next&&(f(x,S,!0),e||"function"==typeof x[l]||u(x,l,p)),_&&A&&"values"!==A.name&&(E=!0,P=function P(){return A.call(this);}),e&&!g||!h&&!E&&O[l]||u(O,l,P),c[n]=P,c[S]=p,d)if(m={values:_?P:w("values"),keys:y?P:w("keys"),entries:M},g)for(b in m){b in O||o(O,b,m[b]);}else i(i.P+i.F*(h||E),n,m);return m;};},function(t,n,r){var e=r(74),i=r(24);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(i(t));};},function(t,n,r){var e=r(4),i=r(23),o=r(5)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[o])?!!n:"RegExp"==i(t));};},function(t,n,r){var e=r(5)("match");t.exports=function(t){var n=/./;try{"/./"[t](n);}catch(r){try{return n[e]=!1,!"/./"[t](n);}catch(t){}}return!0;};},function(t,n,r){var e=r(40),i=r(5)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(e.Array===t||o[i]===t);};},function(t,n,r){"use strict";var e=r(9),i=r(28);t.exports=function(t,n,r){n in t?e.f(t,n,i(0,r)):t[n]=r;};},function(t,n,r){var e=r(46),i=r(5)("iterator"),o=r(40);t.exports=r(7).getIteratorMethod=function(t){if(null!=t)return t[i]||t["@@iterator"]||o[e(t)];};},function(t,n,r){"use strict";var e=r(10),i=r(32),o=r(6);t.exports=function(t){for(var n=e(this),r=o(n.length),u=arguments.length,c=i(u>1?arguments[1]:void 0,r),a=u>2?arguments[2]:void 0,f=void 0===a?r:i(a,r);f>c;){n[c++]=t;}return n;};},function(t,n,r){"use strict";var e=r(36),i=r(107),o=r(40),u=r(15);t.exports=r(72)(Array,"Array",function(t,n){this._t=u(t),this._i=0,this._k=n;},function(){var t=this._t,n=this._k,r=this._i++;return!t||r>=t.length?(this._t=void 0,i(1)):i(0,"keys"==n?r:"values"==n?t[r]:[r,t[r]]);},"values"),o.Arguments=o.Array,e("keys"),e("values"),e("entries");},function(t,n,r){"use strict";var e,i,o=r(53),u=RegExp.prototype.exec,c=String.prototype.replace,a=u,f=(e=/a/,i=/b*/g,u.call(e,"a"),u.call(i,"a"),0!==e.lastIndex||0!==i.lastIndex),s=void 0!==/()??/.exec("")[1];(f||s)&&(a=function a(t){var n,r,e,i,a=this;return s&&(r=new RegExp("^"+a.source+"$(?!\\s)",o.call(a))),f&&(n=a.lastIndex),e=u.call(a,t),f&&e&&(a.lastIndex=a.global?e.index+e[0].length:n),s&&e&&e.length>1&&c.call(e[0],r,function(){for(i=1;i<arguments.length-2;i++){void 0===arguments[i]&&(e[i]=void 0);}}),e;}),t.exports=a;},function(t,n,r){"use strict";var e=r(71)(!0);t.exports=function(t,n,r){return n+(r?e(t,n).length:1);};},function(t,n,r){var e,i,o,u=r(17),c=r(96),a=r(64),f=r(60),s=r(1),l=s.process,h=s.setImmediate,p=s.clearImmediate,v=s.MessageChannel,d=s.Dispatch,y=0,g={},m=function m(){var t=+this;if(g.hasOwnProperty(t)){var n=g[t];delete g[t],n();}},b=function b(t){m.call(t.data);};h&&p||(h=function h(t){for(var n=[],r=1;arguments.length>r;){n.push(arguments[r++]);}return g[++y]=function(){c("function"==typeof t?t:Function(t),n);},e(y),y;},p=function p(t){delete g[t];},"process"==r(23)(l)?e=function e(t){l.nextTick(u(m,t,1));}:d&&d.now?e=function e(t){d.now(u(m,t,1));}:v?(o=(i=new v()).port2,i.port1.onmessage=b,e=u(o.postMessage,o,1)):s.addEventListener&&"function"==typeof postMessage&&!s.importScripts?(e=function e(t){s.postMessage(t+"","*");},s.addEventListener("message",b,!1)):e="onreadystatechange"in f("script")?function(t){a.appendChild(f("script")).onreadystatechange=function(){a.removeChild(this),m.call(t);};}:function(t){setTimeout(u(m,t,1),0);}),t.exports={set:h,clear:p};},function(t,n,r){"use strict";var e=r(1),i=r(8),o=r(30),u=r(59),c=r(14),a=r(43),f=r(2),s=r(42),l=r(19),h=r(6),p=r(115),v=r(34).f,d=r(9).f,y=r(79),g=r(38),_m2=e.ArrayBuffer,_b=e.DataView,x=e.Math,w=e.RangeError,S=e.Infinity,_=_m2,E=x.abs,O=x.pow,A=x.floor,P=x.log,M=x.LN2,F=i?"_b":"buffer",j=i?"_l":"byteLength",I=i?"_o":"byteOffset";function N(t,n,r){var e,i,o,u=new Array(r),c=8*r-n-1,a=(1<<c)-1,f=a>>1,s=23===n?O(2,-24)-O(2,-77):0,l=0,h=t<0||0===t&&1/t<0?1:0;for((t=E(t))!=t||t===S?(i=t!=t?1:0,e=a):(e=A(P(t)/M),t*(o=O(2,-e))<1&&(e--,o*=2),(t+=e+f>=1?s/o:s*O(2,1-f))*o>=2&&(e++,o/=2),e+f>=a?(i=0,e=a):e+f>=1?(i=(t*o-1)*O(2,n),e+=f):(i=t*O(2,f-1)*O(2,n),e=0));n>=8;u[l++]=255&i,i/=256,n-=8){;}for(e=e<<n|i,c+=n;c>0;u[l++]=255&e,e/=256,c-=8){;}return u[--l]|=128*h,u;}function T(t,n,r){var e,i=8*r-n-1,o=(1<<i)-1,u=o>>1,c=i-7,a=r-1,f=t[a--],s=127&f;for(f>>=7;c>0;s=256*s+t[a],a--,c-=8){;}for(e=s&(1<<-c)-1,s>>=-c,c+=n;c>0;e=256*e+t[a],a--,c-=8){;}if(0===s)s=1-u;else{if(s===o)return e?NaN:f?-S:S;e+=O(2,n),s-=u;}return(f?-1:1)*e*O(2,s-n);}function L(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0];}function R(t){return[255&t];}function k(t){return[255&t,t>>8&255];}function C(t){return[255&t,t>>8&255,t>>16&255,t>>24&255];}function D(t){return N(t,52,8);}function W(t){return N(t,23,4);}function G(t,n,r){d(t.prototype,n,{get:function get(){return this[r];}});}function U(t,n,r,e){var i=p(+r);if(i+n>t[j])throw w("Wrong index!");var o=t[F]._b,u=i+t[I],c=o.slice(u,u+n);return e?c:c.reverse();}function B(t,n,r,e,i,o){var u=p(+r);if(u+n>t[j])throw w("Wrong index!");for(var c=t[F]._b,a=u+t[I],f=e(+i),s=0;s<n;s++){c[a+s]=f[o?s:n-s-1];}}if(u.ABV){if(!f(function(){_m2(1);})||!f(function(){new _m2(-1);})||f(function(){return new _m2(),new _m2(1.5),new _m2(NaN),"ArrayBuffer"!=_m2.name;})){for(var V,z=(_m2=function m(t){return s(this,_m2),new _(p(t));}).prototype=_.prototype,Y=v(_),$=0;Y.length>$;){(V=Y[$++])in _m2||c(_m2,V,_[V]);}o||(z.constructor=_m2);}var q=new _b(new _m2(2)),J=_b.prototype.setInt8;q.setInt8(0,2147483648),q.setInt8(1,2147483649),!q.getInt8(0)&&q.getInt8(1)||a(_b.prototype,{setInt8:function setInt8(t,n){J.call(this,t,n<<24>>24);},setUint8:function setUint8(t,n){J.call(this,t,n<<24>>24);}},!0);}else _m2=function _m(t){s(this,_m2,"ArrayBuffer");var n=p(t);this._b=y.call(new Array(n),0),this[j]=n;},_b=function b(t,n,r){s(this,_b,"DataView"),s(t,_m2,"DataView");var e=t[j],i=l(n);if(i<0||i>e)throw w("Wrong offset!");if(i+(r=void 0===r?e-i:h(r))>e)throw w("Wrong length!");this[F]=t,this[I]=i,this[j]=r;},i&&(G(_m2,"byteLength","_l"),G(_b,"buffer","_b"),G(_b,"byteLength","_l"),G(_b,"byteOffset","_o")),a(_b.prototype,{getInt8:function getInt8(t){return U(this,1,t)[0]<<24>>24;},getUint8:function getUint8(t){return U(this,1,t)[0];},getInt16:function getInt16(t){var n=U(this,2,t,arguments[1]);return(n[1]<<8|n[0])<<16>>16;},getUint16:function getUint16(t){var n=U(this,2,t,arguments[1]);return n[1]<<8|n[0];},getInt32:function getInt32(t){return L(U(this,4,t,arguments[1]));},getUint32:function getUint32(t){return L(U(this,4,t,arguments[1]))>>>0;},getFloat32:function getFloat32(t){return T(U(this,4,t,arguments[1]),23,4);},getFloat64:function getFloat64(t){return T(U(this,8,t,arguments[1]),52,8);},setInt8:function setInt8(t,n){B(this,1,t,R,n);},setUint8:function setUint8(t,n){B(this,1,t,R,n);},setInt16:function setInt16(t,n){B(this,2,t,k,n,arguments[2]);},setUint16:function setUint16(t,n){B(this,2,t,k,n,arguments[2]);},setInt32:function setInt32(t,n){B(this,4,t,C,n,arguments[2]);},setUint32:function setUint32(t,n){B(this,4,t,C,n,arguments[2]);},setFloat32:function setFloat32(t,n){B(this,4,t,W,n,arguments[2]);},setFloat64:function setFloat64(t,n){B(this,8,t,D,n,arguments[2]);}});g(_m2,"ArrayBuffer"),g(_b,"DataView"),c(_b.prototype,u.VIEW,!0),n.ArrayBuffer=_m2,n.DataView=_b;},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},function(t,n){t.exports=function(t){return"object"==_typeof(t)?null!==t:"function"==typeof t;};},function(t,n,r){t.exports=!r(120)(function(){return 7!=Object.defineProperty({},"a",{get:function get(){return 7;}}).a;});},function(t,n,r){t.exports=!r(8)&&!r(2)(function(){return 7!=Object.defineProperty(r(60)("div"),"a",{get:function get(){return 7;}}).a;});},function(t,n,r){var e=r(1),i=r(7),o=r(30),u=r(61),c=r(9).f;t.exports=function(t){var n=i.Symbol||(i.Symbol=o?{}:e.Symbol||{});"_"==t.charAt(0)||t in n||c(n,t,{value:u.f(t)});};},function(t,n,r){var e=r(13),i=r(15),o=r(49)(!1),u=r(62)("IE_PROTO");t.exports=function(t,n){var r,c=i(t),a=0,f=[];for(r in c){r!=u&&e(c,r)&&f.push(r);}for(;n.length>a;){e(c,r=n[a++])&&(~o(f,r)||f.push(r));}return f;};},function(t,n,r){var e=r(9),i=r(3),o=r(31);t.exports=r(8)?Object.defineProperties:function(t,n){i(t);for(var r,u=o(n),c=u.length,a=0;c>a;){e.f(t,r=u[a++],n[r]);}return t;};},function(t,n,r){var e=r(15),i=r(34).f,o={}.toString,u="object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return u&&"[object Window]"==o.call(t)?function(t){try{return i(t);}catch(t){return u.slice();}}(t):i(e(t));};},function(t,n,r){"use strict";var e=r(8),i=r(31),o=r(50),u=r(45),c=r(10),a=r(44),f=Object.assign;t.exports=!f||r(2)(function(){var t={},n={},r=Symbol(),e="abcdefghijklmnopqrst";return t[r]=7,e.split("").forEach(function(t){n[t]=t;}),7!=f({},t)[r]||Object.keys(f({},n)).join("")!=e;})?function(t,n){for(var r=c(t),f=arguments.length,s=1,l=o.f,h=u.f;f>s;){for(var p,v=a(arguments[s++]),d=l?i(v).concat(l(v)):i(v),y=d.length,g=0;y>g;){p=d[g++],e&&!h.call(v,p)||(r[p]=v[p]);}}return r;}:f;},function(t,n){t.exports=Object.is||function(t,n){return t===n?0!==t||1/t==1/n:t!=t&&n!=n;};},function(t,n,r){"use strict";var e=r(18),i=r(4),o=r(96),u=[].slice,c={},a=function a(t,n,r){if(!(n in c)){for(var e=[],i=0;i<n;i++){e[i]="a["+i+"]";}c[n]=Function("F,a","return new F("+e.join(",")+")");}return c[n](t,r);};t.exports=Function.bind||function(t){var n=e(this),r=u.call(arguments,1),c=function c(){var e=r.concat(u.call(arguments));return this instanceof c?a(n,e.length,e):o(n,e,t);};return i(n.prototype)&&(c.prototype=n.prototype),c;};},function(t,n){t.exports=function(t,n,r){var e=void 0===r;switch(n.length){case 0:return e?t():t.call(r);case 1:return e?t(n[0]):t.call(r,n[0]);case 2:return e?t(n[0],n[1]):t.call(r,n[0],n[1]);case 3:return e?t(n[0],n[1],n[2]):t.call(r,n[0],n[1],n[2]);case 4:return e?t(n[0],n[1],n[2],n[3]):t.call(r,n[0],n[1],n[2],n[3]);}return t.apply(r,n);};},function(t,n,r){var e=r(1).parseInt,i=r(39).trim,o=r(66),u=/^[-+]?0[xX]/;t.exports=8!==e(o+"08")||22!==e(o+"0x16")?function(t,n){var r=i(String(t),3);return e(r,n>>>0||(u.test(r)?16:10));}:e;},function(t,n,r){var e=r(1).parseFloat,i=r(39).trim;t.exports=1/e(r(66)+"-0")!=-1/0?function(t){var n=i(String(t),3),r=e(n);return 0===r&&"-"==n.charAt(0)?-0:r;}:e;},function(t,n,r){var e=r(23);t.exports=function(t,n){if("number"!=typeof t&&"Number"!=e(t))throw TypeError(n);return+t;};},function(t,n,r){var e=r(4),i=Math.floor;t.exports=function(t){return!e(t)&&isFinite(t)&&i(t)===t;};},function(t,n){t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:Math.log(1+t);};},function(t,n,r){"use strict";var e=r(33),i=r(28),o=r(38),u={};r(14)(u,r(5)("iterator"),function(){return this;}),t.exports=function(t,n,r){t.prototype=e(u,{next:i(1,r)}),o(t,n+" Iterator");};},function(t,n,r){var e=r(3);t.exports=function(t,n,r,i){try{return i?n(e(r)[0],r[1]):n(r);}catch(n){var o=t.return;throw void 0!==o&&e(o.call(t)),n;}};},function(t,n,r){var e=r(225);t.exports=function(t,n){return new(e(t))(n);};},function(t,n,r){var e=r(18),i=r(10),o=r(44),u=r(6);t.exports=function(t,n,r,c,a){e(n);var f=i(t),s=o(f),l=u(f.length),h=a?l-1:0,p=a?-1:1;if(r<2)for(;;){if(h in s){c=s[h],h+=p;break;}if(h+=p,a?h<0:l<=h)throw TypeError("Reduce of empty array with no initial value");}for(;a?h>=0:l>h;h+=p){h in s&&(c=n(c,s[h],h,f));}return c;};},function(t,n,r){"use strict";var e=r(10),i=r(32),o=r(6);t.exports=[].copyWithin||function(t,n){var r=e(this),u=o(r.length),c=i(t,u),a=i(n,u),f=arguments.length>2?arguments[2]:void 0,s=Math.min((void 0===f?u:i(f,u))-a,u-c),l=1;for(a<c&&c<a+s&&(l=-1,a+=s-1,c+=s-1);s-->0;){a in r?r[c]=r[a]:delete r[c],c+=l,a+=l;}return r;};},function(t,n){t.exports=function(t,n){return{value:n,done:!!t};};},function(t,n,r){"use strict";var e=r(81);r(0)({target:"RegExp",proto:!0,forced:e!==/./.exec},{exec:e});},function(t,n,r){r(8)&&"g"!=/./g.flags&&r(9).f(RegExp.prototype,"flags",{configurable:!0,get:r(53)});},function(t,n,r){"use strict";var e,i,o,u,c=r(30),a=r(1),f=r(17),s=r(46),l=r(0),h=r(4),p=r(18),v=r(42),d=r(56),y=r(47),g=r(83).set,m=r(245)(),b=r(111),x=r(246),w=r(57),S=r(112),_=a.TypeError,E=a.process,O=E&&E.versions,A=O&&O.v8||"",_P=a.Promise,M="process"==s(E),F=function F(){},j=i=b.f,I=!!function(){try{var t=_P.resolve(1),n=(t.constructor={})[r(5)("species")]=function(t){t(F,F);};return(M||"function"==typeof PromiseRejectionEvent)&&t.then(F)instanceof n&&0!==A.indexOf("6.6")&&-1===w.indexOf("Chrome/66");}catch(t){}}(),N=function N(t){var n;return!(!h(t)||"function"!=typeof(n=t.then))&&n;},T=function T(t,n){if(!t._n){t._n=!0;var r=t._c;m(function(){for(var e=t._v,i=1==t._s,o=0,u=function u(n){var r,o,u,c=i?n.ok:n.fail,a=n.resolve,f=n.reject,s=n.domain;try{c?(i||(2==t._h&&k(t),t._h=1),!0===c?r=e:(s&&s.enter(),r=c(e),s&&(s.exit(),u=!0)),r===n.promise?f(_("Promise-chain cycle")):(o=N(r))?o.call(r,a,f):a(r)):f(e);}catch(t){s&&!u&&s.exit(),f(t);}};r.length>o;){u(r[o++]);}t._c=[],t._n=!1,n&&!t._h&&L(t);});}},L=function L(t){g.call(a,function(){var n,r,e,i=t._v,o=R(t);if(o&&(n=x(function(){M?E.emit("unhandledRejection",i,t):(r=a.onunhandledrejection)?r({promise:t,reason:i}):(e=a.console)&&e.error&&e.error("Unhandled promise rejection",i);}),t._h=M||R(t)?2:1),t._a=void 0,o&&n.e)throw n.v;});},R=function R(t){return 1!==t._h&&0===(t._a||t._c).length;},k=function k(t){g.call(a,function(){var n;M?E.emit("rejectionHandled",t):(n=a.onrejectionhandled)&&n({promise:t,reason:t._v});});},C=function C(t){var n=this;n._d||(n._d=!0,(n=n._w||n)._v=t,n._s=2,n._a||(n._a=n._c.slice()),T(n,!0));},D=function D(t){var n,r=this;if(!r._d){r._d=!0,r=r._w||r;try{if(r===t)throw _("Promise can't be resolved itself");(n=N(t))?m(function(){var e={_w:r,_d:!1};try{n.call(t,f(D,e,1),f(C,e,1));}catch(t){C.call(e,t);}}):(r._v=t,r._s=1,T(r,!1));}catch(t){C.call({_w:r,_d:!1},t);}}};I||(_P=function P(t){v(this,_P,"Promise","_h"),p(t),e.call(this);try{t(f(D,this,1),f(C,this,1));}catch(t){C.call(this,t);}},(e=function e(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1;}).prototype=r(43)(_P.prototype,{then:function then(t,n){var r=j(y(this,_P));return r.ok="function"!=typeof t||t,r.fail="function"==typeof n&&n,r.domain=M?E.domain:void 0,this._c.push(r),this._a&&this._a.push(r),this._s&&T(this,!1),r.promise;},catch:function _catch(t){return this.then(void 0,t);}}),o=function o(){var t=new e();this.promise=t,this.resolve=f(D,t,1),this.reject=f(C,t,1);},b.f=j=function j(t){return t===_P||t===u?new o(t):i(t);}),l(l.G+l.W+l.F*!I,{Promise:_P}),r(38)(_P,"Promise"),r(41)("Promise"),u=r(7).Promise,l(l.S+l.F*!I,"Promise",{reject:function reject(t){var n=j(this);return(0,n.reject)(t),n.promise;}}),l(l.S+l.F*(c||!I),"Promise",{resolve:function resolve(t){return S(c&&this===u?_P:this,t);}}),l(l.S+l.F*!(I&&r(52)(function(t){_P.all(t).catch(F);})),"Promise",{all:function all(t){var n=this,r=j(n),e=r.resolve,i=r.reject,o=x(function(){var r=[],o=0,u=1;d(t,!1,function(t){var c=o++,a=!1;r.push(void 0),u++,n.resolve(t).then(function(t){a||(a=!0,r[c]=t,--u||e(r));},i);}),--u||e(r);});return o.e&&i(o.v),r.promise;},race:function race(t){var n=this,r=j(n),e=r.reject,i=x(function(){d(t,!1,function(t){n.resolve(t).then(r.resolve,e);});});return i.e&&e(i.v),r.promise;}});},function(t,n,r){"use strict";var e=r(18);function i(t){var n,r;this.promise=new t(function(t,e){if(void 0!==n||void 0!==r)throw TypeError("Bad Promise constructor");n=t,r=e;}),this.resolve=e(n),this.reject=e(r);}t.exports.f=function(t){return new i(t);};},function(t,n,r){var e=r(3),i=r(4),o=r(111);t.exports=function(t,n){if(e(t),i(n)&&n.constructor===t)return n;var r=o.f(t);return(0,r.resolve)(n),r.promise;};},function(t,n,r){"use strict";var e=r(9).f,i=r(33),o=r(43),u=r(17),c=r(42),a=r(56),f=r(72),s=r(107),l=r(41),h=r(8),p=r(27).fastKey,v=r(37),d=h?"_s":"size",y=function y(t,n){var r,e=p(n);if("F"!==e)return t._i[e];for(r=t._f;r;r=r.n){if(r.k==n)return r;}};t.exports={getConstructor:function getConstructor(t,n,r,f){var s=t(function(t,e){c(t,s,n,"_i"),t._t=n,t._i=i(null),t._f=void 0,t._l=void 0,t[d]=0,null!=e&&a(e,r,t[f],t);});return o(s.prototype,{clear:function clear(){for(var t=v(this,n),r=t._i,e=t._f;e;e=e.n){e.r=!0,e.p&&(e.p=e.p.n=void 0),delete r[e.i];}t._f=t._l=void 0,t[d]=0;},delete:function _delete(t){var r=v(this,n),e=y(r,t);if(e){var i=e.n,o=e.p;delete r._i[e.i],e.r=!0,o&&(o.n=i),i&&(i.p=o),r._f==e&&(r._f=i),r._l==e&&(r._l=o),r[d]--;}return!!e;},forEach:function forEach(t){v(this,n);for(var r,e=u(t,arguments.length>1?arguments[1]:void 0,3);r=r?r.n:this._f;){for(e(r.v,r.k,this);r&&r.r;){r=r.p;}}},has:function has(t){return!!y(v(this,n),t);}}),h&&e(s.prototype,"size",{get:function get(){return v(this,n)[d];}}),s;},def:function def(t,n,r){var e,i,o=y(t,n);return o?o.v=r:(t._l=o={i:i=p(n,!0),k:n,v:r,p:e=t._l,n:void 0,r:!1},t._f||(t._f=o),e&&(e.n=o),t[d]++,"F"!==i&&(t._i[i]=o)),t;},getEntry:y,setStrong:function setStrong(t,n,r){f(t,n,function(t,r){this._t=v(t,n),this._k=r,this._l=void 0;},function(){for(var t=this._k,n=this._l;n&&n.r;){n=n.p;}return this._t&&(this._l=n=n?n.n:this._t._f)?s(0,"keys"==t?n.k:"values"==t?n.v:[n.k,n.v]):(this._t=void 0,s(1));},r?"entries":"values",!r,!0),l(n);}};},function(t,n,r){"use strict";var e=r(43),i=r(27).getWeak,o=r(3),u=r(4),c=r(42),a=r(56),f=r(22),s=r(13),l=r(37),h=f(5),p=f(6),v=0,d=function d(t){return t._l||(t._l=new y());},y=function y(){this.a=[];},g=function g(t,n){return h(t.a,function(t){return t[0]===n;});};y.prototype={get:function get(t){var n=g(this,t);if(n)return n[1];},has:function has(t){return!!g(this,t);},set:function set(t,n){var r=g(this,t);r?r[1]=n:this.a.push([t,n]);},delete:function _delete(t){var n=p(this.a,function(n){return n[0]===t;});return~n&&this.a.splice(n,1),!!~n;}},t.exports={getConstructor:function getConstructor(t,n,r,o){var f=t(function(t,e){c(t,f,n,"_i"),t._t=n,t._i=v++,t._l=void 0,null!=e&&a(e,r,t[o],t);});return e(f.prototype,{delete:function _delete(t){if(!u(t))return!1;var r=i(t);return!0===r?d(l(this,n)).delete(t):r&&s(r,this._i)&&delete r[this._i];},has:function has(t){if(!u(t))return!1;var r=i(t);return!0===r?d(l(this,n)).has(t):r&&s(r,this._i);}}),f;},def:function def(t,n,r){var e=i(o(n),!0);return!0===e?d(t).set(n,r):e[t._i]=r,t;},ufstore:d};},function(t,n,r){var e=r(19),i=r(6);t.exports=function(t){if(void 0===t)return 0;var n=e(t),r=i(n);if(n!==r)throw RangeError("Wrong length!");return r;};},function(t,n,r){var e=r(34),i=r(50),o=r(3),u=r(1).Reflect;t.exports=u&&u.ownKeys||function(t){var n=e.f(o(t)),r=i.f;return r?n.concat(r(t)):n;};},function(t,n,r){var e=r(6),i=r(68),o=r(24);t.exports=function(t,n,r,u){var c=String(o(t)),a=c.length,f=void 0===r?" ":String(r),s=e(n);if(s<=a||""==f)return c;var l=s-a,h=i.call(f,Math.ceil(l/f.length));return h.length>l&&(h=h.slice(0,l)),u?h+c:c+h;};},function(t,n,r){var e=r(8),i=r(31),o=r(15),u=r(45).f;t.exports=function(t){return function(n){for(var r,c=o(n),a=i(c),f=a.length,s=0,l=[];f>s;){r=a[s++],e&&!u.call(c,r)||l.push(t?[r,c[r]]:c[r]);}return l;};};},function(t,n){var r=t.exports={version:"2.6.12"};"number"==typeof __e&&(__e=r);},function(t,n){t.exports=function(t){try{return!!t();}catch(t){return!0;}};},,,,,,,,,,function(t,n,r){"use strict";r.r(n);r(131);!_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var t,n,e,i,_n;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:t=[],n=document.getElementsByClassName("js-module");e=0;case 2:if(!(e<n.length)){_context.next=18;break;}i=n[e].dataset.module;if(!(!t.includes(i)&&!window.Acr.hasOwnProperty(i))){_context.next=15;break;}_context.prev=5;_context.next=8;return r(317)("./".concat(i,"/").concat(i));case 8:_n=_context.sent;console.log("Imported "+i),window.Acr[i]=_n[i],t.push(i);_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](5);console.error("Unable to import ".concat(i,": ").concat(_context.t0));case 15:e++;_context.next=2;break;case 18:case"end":return _context.stop();}}},_callee,null,[[5,12]]);}))();},function(t,n,r){"use strict";r(132);var e,i=(e=r(304))&&e.__esModule?e:{default:e};i.default._babelPolyfill&&"undefined"!=typeof console&&console.warn&&console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."),i.default._babelPolyfill=!0;},function(t,n,r){"use strict";r(133),r(276),r(278),r(281),r(283),r(285),r(287),r(289),r(291),r(293),r(295),r(297),r(299),r(303);},function(t,n,r){r(134),r(137),r(138),r(139),r(140),r(141),r(142),r(143),r(144),r(145),r(146),r(147),r(148),r(149),r(150),r(151),r(152),r(153),r(154),r(155),r(156),r(157),r(158),r(159),r(160),r(161),r(162),r(163),r(164),r(165),r(166),r(167),r(168),r(169),r(170),r(171),r(172),r(173),r(174),r(175),r(176),r(177),r(178),r(180),r(181),r(182),r(183),r(184),r(185),r(186),r(187),r(188),r(189),r(190),r(191),r(192),r(193),r(194),r(195),r(196),r(197),r(198),r(199),r(200),r(201),r(202),r(203),r(204),r(205),r(206),r(207),r(208),r(209),r(210),r(211),r(212),r(213),r(215),r(216),r(218),r(219),r(220),r(221),r(222),r(223),r(224),r(226),r(227),r(228),r(229),r(230),r(231),r(232),r(233),r(234),r(235),r(236),r(237),r(238),r(80),r(239),r(108),r(240),r(109),r(241),r(242),r(243),r(244),r(110),r(247),r(248),r(249),r(250),r(251),r(252),r(253),r(254),r(255),r(256),r(257),r(258),r(259),r(260),r(261),r(262),r(263),r(264),r(265),r(266),r(267),r(268),r(269),r(270),r(271),r(272),r(273),r(274),r(275),t.exports=r(7);},function(t,n,r){"use strict";var e=r(1),i=r(13),o=r(8),u=r(0),c=r(11),a=r(27).KEY,f=r(2),s=r(48),l=r(38),h=r(29),p=r(5),v=r(61),d=r(89),y=r(136),g=r(51),m=r(3),b=r(4),x=r(10),w=r(15),S=r(26),_=r(28),E=r(33),O=r(92),A=r(20),P=r(50),M=r(9),F=r(31),j=A.f,I=M.f,N=O.f,_T=e.Symbol,L=e.JSON,R=L&&L.stringify,k=p("_hidden"),C=p("toPrimitive"),D={}.propertyIsEnumerable,W=s("symbol-registry"),G=s("symbols"),U=s("op-symbols"),B=Object.prototype,V="function"==typeof _T&&!!P.f,z=e.QObject,Y=!z||!z.prototype||!z.prototype.findChild,$=o&&f(function(){return 7!=E(I({},"a",{get:function get(){return I(this,"a",{value:7}).a;}})).a;})?function(t,n,r){var e=j(B,n);e&&delete B[n],I(t,n,r),e&&t!==B&&I(B,n,e);}:I,q=function q(t){var n=G[t]=E(_T.prototype);return n._k=t,n;},J=V&&"symbol"==_typeof(_T.iterator)?function(t){return"symbol"==_typeof(t);}:function(t){return t instanceof _T;},K=function K(t,n,r){return t===B&&K(U,n,r),m(t),n=S(n,!0),m(r),i(G,n)?(r.enumerable?(i(t,k)&&t[k][n]&&(t[k][n]=!1),r=E(r,{enumerable:_(0,!1)})):(i(t,k)||I(t,k,_(1,{})),t[k][n]=!0),$(t,n,r)):I(t,n,r);},X=function X(t,n){m(t);for(var r,e=y(n=w(n)),i=0,o=e.length;o>i;){K(t,r=e[i++],n[r]);}return t;},H=function H(t){var n=D.call(this,t=S(t,!0));return!(this===B&&i(G,t)&&!i(U,t))&&(!(n||!i(this,t)||!i(G,t)||i(this,k)&&this[k][t])||n);},Z=function Z(t,n){if(t=w(t),n=S(n,!0),t!==B||!i(G,n)||i(U,n)){var r=j(t,n);return!r||!i(G,n)||i(t,k)&&t[k][n]||(r.enumerable=!0),r;}},Q=function Q(t){for(var n,r=N(w(t)),e=[],o=0;r.length>o;){i(G,n=r[o++])||n==k||n==a||e.push(n);}return e;},tt=function tt(t){for(var n,r=t===B,e=N(r?U:w(t)),o=[],u=0;e.length>u;){!i(G,n=e[u++])||r&&!i(B,n)||o.push(G[n]);}return o;};V||(c((_T=function T(){if(this instanceof _T)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),n=function n(r){this===B&&n.call(U,r),i(this,k)&&i(this[k],t)&&(this[k][t]=!1),$(this,t,_(1,r));};return o&&Y&&$(B,t,{configurable:!0,set:n}),q(t);}).prototype,"toString",function(){return this._k;}),A.f=Z,M.f=K,r(34).f=O.f=Q,r(45).f=H,P.f=tt,o&&!r(30)&&c(B,"propertyIsEnumerable",H,!0),v.f=function(t){return q(p(t));}),u(u.G+u.W+u.F*!V,{Symbol:_T});for(var nt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),rt=0;nt.length>rt;){p(nt[rt++]);}for(var et=F(p.store),it=0;et.length>it;){d(et[it++]);}u(u.S+u.F*!V,"Symbol",{for:function _for(t){return i(W,t+="")?W[t]:W[t]=_T(t);},keyFor:function keyFor(t){if(!J(t))throw TypeError(t+" is not a symbol!");for(var n in W){if(W[n]===t)return n;}},useSetter:function useSetter(){Y=!0;},useSimple:function useSimple(){Y=!1;}}),u(u.S+u.F*!V,"Object",{create:function create(t,n){return void 0===n?E(t):X(E(t),n);},defineProperty:K,defineProperties:X,getOwnPropertyDescriptor:Z,getOwnPropertyNames:Q,getOwnPropertySymbols:tt});var ot=f(function(){P.f(1);});u(u.S+u.F*ot,"Object",{getOwnPropertySymbols:function getOwnPropertySymbols(t){return P.f(x(t));}}),L&&u(u.S+u.F*(!V||f(function(){var t=_T();return"[null]"!=R([t])||"{}"!=R({a:t})||"{}"!=R(Object(t));})),"JSON",{stringify:function stringify(t){for(var n,r,e=[t],i=1;arguments.length>i;){e.push(arguments[i++]);}if(r=n=e[1],(b(n)||void 0!==t)&&!J(t))return g(n)||(n=function n(t,_n2){if("function"==typeof r&&(_n2=r.call(this,t,_n2)),!J(_n2))return _n2;}),e[1]=n,R.apply(L,e);}}),_T.prototype[C]||r(14)(_T.prototype,C,_T.prototype.valueOf),l(_T,"Symbol"),l(Math,"Math",!0),l(e.JSON,"JSON",!0);},function(t,n,r){t.exports=r(48)("native-function-to-string",Function.toString);},function(t,n,r){var e=r(31),i=r(50),o=r(45);t.exports=function(t){var n=e(t),r=i.f;if(r)for(var u,c=r(t),a=o.f,f=0;c.length>f;){a.call(t,u=c[f++])&&n.push(u);}return n;};},function(t,n,r){var e=r(0);e(e.S,"Object",{create:r(33)});},function(t,n,r){var e=r(0);e(e.S+e.F*!r(8),"Object",{defineProperty:r(9).f});},function(t,n,r){var e=r(0);e(e.S+e.F*!r(8),"Object",{defineProperties:r(91)});},function(t,n,r){var e=r(15),i=r(20).f;r(21)("getOwnPropertyDescriptor",function(){return function(t,n){return i(e(t),n);};});},function(t,n,r){var e=r(10),i=r(35);r(21)("getPrototypeOf",function(){return function(t){return i(e(t));};});},function(t,n,r){var e=r(10),i=r(31);r(21)("keys",function(){return function(t){return i(e(t));};});},function(t,n,r){r(21)("getOwnPropertyNames",function(){return r(92).f;});},function(t,n,r){var e=r(4),i=r(27).onFreeze;r(21)("freeze",function(t){return function(n){return t&&e(n)?t(i(n)):n;};});},function(t,n,r){var e=r(4),i=r(27).onFreeze;r(21)("seal",function(t){return function(n){return t&&e(n)?t(i(n)):n;};});},function(t,n,r){var e=r(4),i=r(27).onFreeze;r(21)("preventExtensions",function(t){return function(n){return t&&e(n)?t(i(n)):n;};});},function(t,n,r){var e=r(4);r(21)("isFrozen",function(t){return function(n){return!e(n)||!!t&&t(n);};});},function(t,n,r){var e=r(4);r(21)("isSealed",function(t){return function(n){return!e(n)||!!t&&t(n);};});},function(t,n,r){var e=r(4);r(21)("isExtensible",function(t){return function(n){return!!e(n)&&(!t||t(n));};});},function(t,n,r){var e=r(0);e(e.S+e.F,"Object",{assign:r(93)});},function(t,n,r){var e=r(0);e(e.S,"Object",{is:r(94)});},function(t,n,r){var e=r(0);e(e.S,"Object",{setPrototypeOf:r(65).set});},function(t,n,r){"use strict";var e=r(46),i={};i[r(5)("toStringTag")]="z",i+""!="[object z]"&&r(11)(Object.prototype,"toString",function(){return"[object "+e(this)+"]";},!0);},function(t,n,r){var e=r(0);e(e.P,"Function",{bind:r(95)});},function(t,n,r){var e=r(9).f,i=Function.prototype,o=/^\s*function ([^ (]*)/;"name"in i||r(8)&&e(i,"name",{configurable:!0,get:function get(){try{return(""+this).match(o)[1];}catch(t){return"";}}});},function(t,n,r){"use strict";var e=r(4),i=r(35),o=r(5)("hasInstance"),u=Function.prototype;o in u||r(9).f(u,o,{value:function value(t){if("function"!=typeof this||!e(t))return!1;if(!e(this.prototype))return t instanceof this;for(;t=i(t);){if(this.prototype===t)return!0;}return!1;}});},function(t,n,r){var e=r(0),i=r(97);e(e.G+e.F*(parseInt!=i),{parseInt:i});},function(t,n,r){var e=r(0),i=r(98);e(e.G+e.F*(parseFloat!=i),{parseFloat:i});},function(t,n,r){"use strict";var e=r(1),i=r(13),o=r(23),u=r(67),c=r(26),a=r(2),f=r(34).f,s=r(20).f,l=r(9).f,h=r(39).trim,_p=e.Number,v=_p,d=_p.prototype,y="Number"==o(r(33)(d)),g=("trim"in String.prototype),m=function m(t){var n=c(t,!1);if("string"==typeof n&&n.length>2){var r,e,i,o=(n=g?n.trim():h(n,3)).charCodeAt(0);if(43===o||45===o){if(88===(r=n.charCodeAt(2))||120===r)return NaN;}else if(48===o){switch(n.charCodeAt(1)){case 66:case 98:e=2,i=49;break;case 79:case 111:e=8,i=55;break;default:return+n;}for(var u,a=n.slice(2),f=0,s=a.length;f<s;f++){if((u=a.charCodeAt(f))<48||u>i)return NaN;}return parseInt(a,e);}}return+n;};if(!_p(" 0o1")||!_p("0b1")||_p("+0x1")){_p=function p(t){var n=arguments.length<1?0:t,r=this;return r instanceof _p&&(y?a(function(){d.valueOf.call(r);}):"Number"!=o(r))?u(new v(m(n)),r,_p):m(n);};for(var b,x=r(8)?f(v):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),w=0;x.length>w;w++){i(v,b=x[w])&&!i(_p,b)&&l(_p,b,s(v,b));}_p.prototype=d,d.constructor=_p,r(11)(e,"Number",_p);}},function(t,n,r){"use strict";var e=r(0),i=r(19),o=r(99),u=r(68),c=1..toFixed,a=Math.floor,f=[0,0,0,0,0,0],s="Number.toFixed: incorrect invocation!",l=function l(t,n){for(var r=-1,e=n;++r<6;){e+=t*f[r],f[r]=e%1e7,e=a(e/1e7);}},h=function h(t){for(var n=6,r=0;--n>=0;){r+=f[n],f[n]=a(r/t),r=r%t*1e7;}},p=function p(){for(var t=6,n="";--t>=0;){if(""!==n||0===t||0!==f[t]){var r=String(f[t]);n=""===n?r:n+u.call("0",7-r.length)+r;}}return n;},v=function v(t,n,r){return 0===n?r:n%2==1?v(t,n-1,r*t):v(t*t,n/2,r);};e(e.P+e.F*(!!c&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==0xde0b6b3a7640080.toFixed(0))||!r(2)(function(){c.call({});})),"Number",{toFixed:function toFixed(t){var n,r,e,c,a=o(this,s),f=i(t),d="",y="0";if(f<0||f>20)throw RangeError(s);if(a!=a)return"NaN";if(a<=-1e21||a>=1e21)return String(a);if(a<0&&(d="-",a=-a),a>1e-21)if(r=(n=function(t){for(var n=0,r=t;r>=4096;){n+=12,r/=4096;}for(;r>=2;){n+=1,r/=2;}return n;}(a*v(2,69,1))-69)<0?a*v(2,-n,1):a/v(2,n,1),r*=4503599627370496,(n=52-n)>0){for(l(0,r),e=f;e>=7;){l(1e7,0),e-=7;}for(l(v(10,e,1),0),e=n-1;e>=23;){h(1<<23),e-=23;}h(1<<e),l(1,1),h(2),y=p();}else l(0,r),l(1<<-n,0),y=p()+u.call("0",f);return y=f>0?d+((c=y.length)<=f?"0."+u.call("0",f-c)+y:y.slice(0,c-f)+"."+y.slice(c-f)):d+y;}});},function(t,n,r){"use strict";var e=r(0),i=r(2),o=r(99),u=1..toPrecision;e(e.P+e.F*(i(function(){return"1"!==u.call(1,void 0);})||!i(function(){u.call({});})),"Number",{toPrecision:function toPrecision(t){var n=o(this,"Number#toPrecision: incorrect invocation!");return void 0===t?u.call(n):u.call(n,t);}});},function(t,n,r){var e=r(0);e(e.S,"Number",{EPSILON:Math.pow(2,-52)});},function(t,n,r){var e=r(0),i=r(1).isFinite;e(e.S,"Number",{isFinite:function isFinite(t){return"number"==typeof t&&i(t);}});},function(t,n,r){var e=r(0);e(e.S,"Number",{isInteger:r(100)});},function(t,n,r){var e=r(0);e(e.S,"Number",{isNaN:function isNaN(t){return t!=t;}});},function(t,n,r){var e=r(0),i=r(100),o=Math.abs;e(e.S,"Number",{isSafeInteger:function isSafeInteger(t){return i(t)&&o(t)<=9007199254740991;}});},function(t,n,r){var e=r(0);e(e.S,"Number",{MAX_SAFE_INTEGER:9007199254740991});},function(t,n,r){var e=r(0);e(e.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991});},function(t,n,r){var e=r(0),i=r(98);e(e.S+e.F*(Number.parseFloat!=i),"Number",{parseFloat:i});},function(t,n,r){var e=r(0),i=r(97);e(e.S+e.F*(Number.parseInt!=i),"Number",{parseInt:i});},function(t,n,r){var e=r(0),i=r(101),o=Math.sqrt,u=Math.acosh;e(e.S+e.F*!(u&&710==Math.floor(u(Number.MAX_VALUE))&&u(1/0)==1/0),"Math",{acosh:function acosh(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:i(t-1+o(t-1)*o(t+1));}});},function(t,n,r){var e=r(0),i=Math.asinh;e(e.S+e.F*!(i&&1/i(0)>0),"Math",{asinh:function t(n){return isFinite(n=+n)&&0!=n?n<0?-t(-n):Math.log(n+Math.sqrt(n*n+1)):n;}});},function(t,n,r){var e=r(0),i=Math.atanh;e(e.S+e.F*!(i&&1/i(-0)<0),"Math",{atanh:function atanh(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2;}});},function(t,n,r){var e=r(0),i=r(69);e(e.S,"Math",{cbrt:function cbrt(t){return i(t=+t)*Math.pow(Math.abs(t),1/3);}});},function(t,n,r){var e=r(0);e(e.S,"Math",{clz32:function clz32(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32;}});},function(t,n,r){var e=r(0),i=Math.exp;e(e.S,"Math",{cosh:function cosh(t){return(i(t=+t)+i(-t))/2;}});},function(t,n,r){var e=r(0),i=r(70);e(e.S+e.F*(i!=Math.expm1),"Math",{expm1:i});},function(t,n,r){var e=r(0);e(e.S,"Math",{fround:r(179)});},function(t,n,r){var e=r(69),i=Math.pow,o=i(2,-52),u=i(2,-23),c=i(2,127)*(2-u),a=i(2,-126);t.exports=Math.fround||function(t){var n,r,i=Math.abs(t),f=e(t);return i<a?f*(i/a/u+1/o-1/o)*a*u:(r=(n=(1+u/o)*i)-(n-i))>c||r!=r?f*(1/0):f*r;};},function(t,n,r){var e=r(0),i=Math.abs;e(e.S,"Math",{hypot:function hypot(t,n){for(var r,e,o=0,u=0,c=arguments.length,a=0;u<c;){a<(r=i(arguments[u++]))?(o=o*(e=a/r)*e+1,a=r):o+=r>0?(e=r/a)*e:r;}return a===1/0?1/0:a*Math.sqrt(o);}});},function(t,n,r){var e=r(0),i=Math.imul;e(e.S+e.F*r(2)(function(){return-5!=i(4294967295,5)||2!=i.length;}),"Math",{imul:function imul(t,n){var r=+t,e=+n,i=65535&r,o=65535&e;return 0|i*o+((65535&r>>>16)*o+i*(65535&e>>>16)<<16>>>0);}});},function(t,n,r){var e=r(0);e(e.S,"Math",{log10:function log10(t){return Math.log(t)*Math.LOG10E;}});},function(t,n,r){var e=r(0);e(e.S,"Math",{log1p:r(101)});},function(t,n,r){var e=r(0);e(e.S,"Math",{log2:function log2(t){return Math.log(t)/Math.LN2;}});},function(t,n,r){var e=r(0);e(e.S,"Math",{sign:r(69)});},function(t,n,r){var e=r(0),i=r(70),o=Math.exp;e(e.S+e.F*r(2)(function(){return-2e-17!=!Math.sinh(-2e-17);}),"Math",{sinh:function sinh(t){return Math.abs(t=+t)<1?(i(t)-i(-t))/2:(o(t-1)-o(-t-1))*(Math.E/2);}});},function(t,n,r){var e=r(0),i=r(70),o=Math.exp;e(e.S,"Math",{tanh:function tanh(t){var n=i(t=+t),r=i(-t);return n==1/0?1:r==1/0?-1:(n-r)/(o(t)+o(-t));}});},function(t,n,r){var e=r(0);e(e.S,"Math",{trunc:function trunc(t){return(t>0?Math.floor:Math.ceil)(t);}});},function(t,n,r){var e=r(0),i=r(32),o=String.fromCharCode,u=String.fromCodePoint;e(e.S+e.F*(!!u&&1!=u.length),"String",{fromCodePoint:function fromCodePoint(t){for(var n,r=[],e=arguments.length,u=0;e>u;){if(n=+arguments[u++],i(n,1114111)!==n)throw RangeError(n+" is not a valid code point");r.push(n<65536?o(n):o(55296+((n-=65536)>>10),n%1024+56320));}return r.join("");}});},function(t,n,r){var e=r(0),i=r(15),o=r(6);e(e.S,"String",{raw:function raw(t){for(var n=i(t.raw),r=o(n.length),e=arguments.length,u=[],c=0;r>c;){u.push(String(n[c++])),c<e&&u.push(String(arguments[c]));}return u.join("");}});},function(t,n,r){"use strict";r(39)("trim",function(t){return function(){return t(this,3);};});},function(t,n,r){"use strict";var e=r(71)(!0);r(72)(String,"String",function(t){this._t=String(t),this._i=0;},function(){var t,n=this._t,r=this._i;return r>=n.length?{value:void 0,done:!0}:(t=e(n,r),this._i+=t.length,{value:t,done:!1});});},function(t,n,r){"use strict";var e=r(0),i=r(71)(!1);e(e.P,"String",{codePointAt:function codePointAt(t){return i(this,t);}});},function(t,n,r){"use strict";var e=r(0),i=r(6),o=r(73),u="".endsWith;e(e.P+e.F*r(75)("endsWith"),"String",{endsWith:function endsWith(t){var n=o(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=i(n.length),c=void 0===r?e:Math.min(i(r),e),a=String(t);return u?u.call(n,a,c):n.slice(c-a.length,c)===a;}});},function(t,n,r){"use strict";var e=r(0),i=r(73);e(e.P+e.F*r(75)("includes"),"String",{includes:function includes(t){return!!~i(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0);}});},function(t,n,r){var e=r(0);e(e.P,"String",{repeat:r(68)});},function(t,n,r){"use strict";var e=r(0),i=r(6),o=r(73),u="".startsWith;e(e.P+e.F*r(75)("startsWith"),"String",{startsWith:function startsWith(t){var n=o(this,t,"startsWith"),r=i(Math.min(arguments.length>1?arguments[1]:void 0,n.length)),e=String(t);return u?u.call(n,e,r):n.slice(r,r+e.length)===e;}});},function(t,n,r){"use strict";r(12)("anchor",function(t){return function(n){return t(this,"a","name",n);};});},function(t,n,r){"use strict";r(12)("big",function(t){return function(){return t(this,"big","","");};});},function(t,n,r){"use strict";r(12)("blink",function(t){return function(){return t(this,"blink","","");};});},function(t,n,r){"use strict";r(12)("bold",function(t){return function(){return t(this,"b","","");};});},function(t,n,r){"use strict";r(12)("fixed",function(t){return function(){return t(this,"tt","","");};});},function(t,n,r){"use strict";r(12)("fontcolor",function(t){return function(n){return t(this,"font","color",n);};});},function(t,n,r){"use strict";r(12)("fontsize",function(t){return function(n){return t(this,"font","size",n);};});},function(t,n,r){"use strict";r(12)("italics",function(t){return function(){return t(this,"i","","");};});},function(t,n,r){"use strict";r(12)("link",function(t){return function(n){return t(this,"a","href",n);};});},function(t,n,r){"use strict";r(12)("small",function(t){return function(){return t(this,"small","","");};});},function(t,n,r){"use strict";r(12)("strike",function(t){return function(){return t(this,"strike","","");};});},function(t,n,r){"use strict";r(12)("sub",function(t){return function(){return t(this,"sub","","");};});},function(t,n,r){"use strict";r(12)("sup",function(t){return function(){return t(this,"sup","","");};});},function(t,n,r){var e=r(0);e(e.S,"Date",{now:function now(){return new Date().getTime();}});},function(t,n,r){"use strict";var e=r(0),i=r(10),o=r(26);e(e.P+e.F*r(2)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function toISOString(){return 1;}});}),"Date",{toJSON:function toJSON(t){var n=i(this),r=o(n);return"number"!=typeof r||isFinite(r)?n.toISOString():null;}});},function(t,n,r){var e=r(0),i=r(214);e(e.P+e.F*(Date.prototype.toISOString!==i),"Date",{toISOString:i});},function(t,n,r){"use strict";var e=r(2),i=Date.prototype.getTime,o=Date.prototype.toISOString,u=function u(t){return t>9?t:"0"+t;};t.exports=e(function(){return"0385-07-25T07:06:39.999Z"!=o.call(new Date(-50000000000001));})||!e(function(){o.call(new Date(NaN));})?function(){if(!isFinite(i.call(this)))throw RangeError("Invalid time value");var t=this,n=t.getUTCFullYear(),r=t.getUTCMilliseconds(),e=n<0?"-":n>9999?"+":"";return e+("00000"+Math.abs(n)).slice(e?-6:-4)+"-"+u(t.getUTCMonth()+1)+"-"+u(t.getUTCDate())+"T"+u(t.getUTCHours())+":"+u(t.getUTCMinutes())+":"+u(t.getUTCSeconds())+"."+(r>99?r:"0"+u(r))+"Z";}:o;},function(t,n,r){var e=Date.prototype,i=e.toString,o=e.getTime;new Date(NaN)+""!="Invalid Date"&&r(11)(e,"toString",function(){var t=o.call(this);return t==t?i.call(this):"Invalid Date";});},function(t,n,r){var e=r(5)("toPrimitive"),i=Date.prototype;e in i||r(14)(i,e,r(217));},function(t,n,r){"use strict";var e=r(3),i=r(26);t.exports=function(t){if("string"!==t&&"number"!==t&&"default"!==t)throw TypeError("Incorrect hint");return i(e(this),"number"!=t);};},function(t,n,r){var e=r(0);e(e.S,"Array",{isArray:r(51)});},function(t,n,r){"use strict";var e=r(17),i=r(0),o=r(10),u=r(103),c=r(76),a=r(6),f=r(77),s=r(78);i(i.S+i.F*!r(52)(function(t){Array.from(t);}),"Array",{from:function from(t){var n,r,i,l,h=o(t),p="function"==typeof this?this:Array,v=arguments.length,d=v>1?arguments[1]:void 0,y=void 0!==d,g=0,m=s(h);if(y&&(d=e(d,v>2?arguments[2]:void 0,2)),null==m||p==Array&&c(m))for(r=new p(n=a(h.length));n>g;g++){f(r,g,y?d(h[g],g):h[g]);}else for(l=m.call(h),r=new p();!(i=l.next()).done;g++){f(r,g,y?u(l,d,[i.value,g],!0):i.value);}return r.length=g,r;}});},function(t,n,r){"use strict";var e=r(0),i=r(77);e(e.S+e.F*r(2)(function(){function t(){}return!(Array.of.call(t)instanceof t);}),"Array",{of:function of(){for(var t=0,n=arguments.length,r=new("function"==typeof this?this:Array)(n);n>t;){i(r,t,arguments[t++]);}return r.length=n,r;}});},function(t,n,r){"use strict";var e=r(0),i=r(15),o=[].join;e(e.P+e.F*(r(44)!=Object||!r(16)(o)),"Array",{join:function join(t){return o.call(i(this),void 0===t?",":t);}});},function(t,n,r){"use strict";var e=r(0),i=r(64),o=r(23),u=r(32),c=r(6),a=[].slice;e(e.P+e.F*r(2)(function(){i&&a.call(i);}),"Array",{slice:function slice(t,n){var r=c(this.length),e=o(this);if(n=void 0===n?r:n,"Array"==e)return a.call(this,t,n);for(var i=u(t,r),f=u(n,r),s=c(f-i),l=new Array(s),h=0;h<s;h++){l[h]="String"==e?this.charAt(i+h):this[i+h];}return l;}});},function(t,n,r){"use strict";var e=r(0),i=r(18),o=r(10),u=r(2),c=[].sort,a=[1,2,3];e(e.P+e.F*(u(function(){a.sort(void 0);})||!u(function(){a.sort(null);})||!r(16)(c)),"Array",{sort:function sort(t){return void 0===t?c.call(o(this)):c.call(o(this),i(t));}});},function(t,n,r){"use strict";var e=r(0),i=r(22)(0),o=r(16)([].forEach,!0);e(e.P+e.F*!o,"Array",{forEach:function forEach(t){return i(this,t,arguments[1]);}});},function(t,n,r){var e=r(4),i=r(51),o=r(5)("species");t.exports=function(t){var n;return i(t)&&("function"!=typeof(n=t.constructor)||n!==Array&&!i(n.prototype)||(n=void 0),e(n)&&null===(n=n[o])&&(n=void 0)),void 0===n?Array:n;};},function(t,n,r){"use strict";var e=r(0),i=r(22)(1);e(e.P+e.F*!r(16)([].map,!0),"Array",{map:function map(t){return i(this,t,arguments[1]);}});},function(t,n,r){"use strict";var e=r(0),i=r(22)(2);e(e.P+e.F*!r(16)([].filter,!0),"Array",{filter:function filter(t){return i(this,t,arguments[1]);}});},function(t,n,r){"use strict";var e=r(0),i=r(22)(3);e(e.P+e.F*!r(16)([].some,!0),"Array",{some:function some(t){return i(this,t,arguments[1]);}});},function(t,n,r){"use strict";var e=r(0),i=r(22)(4);e(e.P+e.F*!r(16)([].every,!0),"Array",{every:function every(t){return i(this,t,arguments[1]);}});},function(t,n,r){"use strict";var e=r(0),i=r(105);e(e.P+e.F*!r(16)([].reduce,!0),"Array",{reduce:function reduce(t){return i(this,t,arguments.length,arguments[1],!1);}});},function(t,n,r){"use strict";var e=r(0),i=r(105);e(e.P+e.F*!r(16)([].reduceRight,!0),"Array",{reduceRight:function reduceRight(t){return i(this,t,arguments.length,arguments[1],!0);}});},function(t,n,r){"use strict";var e=r(0),i=r(49)(!1),o=[].indexOf,u=!!o&&1/[1].indexOf(1,-0)<0;e(e.P+e.F*(u||!r(16)(o)),"Array",{indexOf:function indexOf(t){return u?o.apply(this,arguments)||0:i(this,t,arguments[1]);}});},function(t,n,r){"use strict";var e=r(0),i=r(15),o=r(19),u=r(6),c=[].lastIndexOf,a=!!c&&1/[1].lastIndexOf(1,-0)<0;e(e.P+e.F*(a||!r(16)(c)),"Array",{lastIndexOf:function lastIndexOf(t){if(a)return c.apply(this,arguments)||0;var n=i(this),r=u(n.length),e=r-1;for(arguments.length>1&&(e=Math.min(e,o(arguments[1]))),e<0&&(e=r+e);e>=0;e--){if(e in n&&n[e]===t)return e||0;}return-1;}});},function(t,n,r){var e=r(0);e(e.P,"Array",{copyWithin:r(106)}),r(36)("copyWithin");},function(t,n,r){var e=r(0);e(e.P,"Array",{fill:r(79)}),r(36)("fill");},function(t,n,r){"use strict";var e=r(0),i=r(22)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1;}),e(e.P+e.F*o,"Array",{find:function find(t){return i(this,t,arguments.length>1?arguments[1]:void 0);}}),r(36)("find");},function(t,n,r){"use strict";var e=r(0),i=r(22)(6),o="findIndex",u=!0;o in[]&&Array(1)[o](function(){u=!1;}),e(e.P+e.F*u,"Array",{findIndex:function findIndex(t){return i(this,t,arguments.length>1?arguments[1]:void 0);}}),r(36)(o);},function(t,n,r){r(41)("Array");},function(t,n,r){var e=r(1),i=r(67),o=r(9).f,u=r(34).f,c=r(74),a=r(53),_f=e.RegExp,s=_f,l=_f.prototype,h=/a/g,p=/a/g,v=new _f(h)!==h;if(r(8)&&(!v||r(2)(function(){return p[r(5)("match")]=!1,_f(h)!=h||_f(p)==p||"/a/i"!=_f(h,"i");}))){_f=function f(t,n){var r=this instanceof _f,e=c(t),o=void 0===n;return!r&&e&&t.constructor===_f&&o?t:i(v?new s(e&&!o?t.source:t,n):s((e=t instanceof _f)?t.source:t,e&&o?a.call(t):n),r?this:l,_f);};for(var d=function d(t){(t in _f)||o(_f,t,{configurable:!0,get:function get(){return s[t];},set:function set(n){s[t]=n;}});},y=u(s),g=0;y.length>g;){d(y[g++]);}l.constructor=_f,_f.prototype=l,r(11)(e,"RegExp",_f);}r(41)("RegExp");},function(t,n,r){"use strict";r(109);var e=r(3),i=r(53),o=r(8),u=/./.toString,c=function c(t){r(11)(RegExp.prototype,"toString",t,!0);};r(2)(function(){return"/a/b"!=u.call({source:"a",flags:"b"});})?c(function(){var t=e(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?i.call(t):void 0);}):"toString"!=u.name&&c(function(){return u.call(this);});},function(t,n,r){"use strict";var e=r(3),i=r(6),o=r(82),u=r(54);r(55)("match",1,function(t,n,r,c){return[function(r){var e=t(this),i=null==r?void 0:r[n];return void 0!==i?i.call(r,e):new RegExp(r)[n](String(e));},function(t){var n=c(r,t,this);if(n.done)return n.value;var a=e(t),f=String(this);if(!a.global)return u(a,f);var s=a.unicode;a.lastIndex=0;for(var l,h=[],p=0;null!==(l=u(a,f));){var v=String(l[0]);h[p]=v,""===v&&(a.lastIndex=o(f,i(a.lastIndex),s)),p++;}return 0===p?null:h;}];});},function(t,n,r){"use strict";var e=r(3),i=r(10),o=r(6),u=r(19),c=r(82),a=r(54),f=Math.max,s=Math.min,l=Math.floor,h=/\$([$&`']|\d\d?|<[^>]*>)/g,p=/\$([$&`']|\d\d?)/g;r(55)("replace",2,function(t,n,r,v){return[function(e,i){var o=t(this),u=null==e?void 0:e[n];return void 0!==u?u.call(e,o,i):r.call(String(o),e,i);},function(t,n){var i=v(r,t,this,n);if(i.done)return i.value;var l=e(t),h=String(this),p="function"==typeof n;p||(n=String(n));var y=l.global;if(y){var g=l.unicode;l.lastIndex=0;}for(var m=[];;){var b=a(l,h);if(null===b)break;if(m.push(b),!y)break;""===String(b[0])&&(l.lastIndex=c(h,o(l.lastIndex),g));}for(var x,w="",S=0,_=0;_<m.length;_++){b=m[_];for(var E=String(b[0]),O=f(s(u(b.index),h.length),0),A=[],P=1;P<b.length;P++){A.push(void 0===(x=b[P])?x:String(x));}var M=b.groups;if(p){var F=[E].concat(A,O,h);void 0!==M&&F.push(M);var j=String(n.apply(void 0,F));}else j=d(E,h,O,A,M,n);O>=S&&(w+=h.slice(S,O)+j,S=O+E.length);}return w+h.slice(S);}];function d(t,n,e,o,u,c){var a=e+t.length,f=o.length,s=p;return void 0!==u&&(u=i(u),s=h),r.call(c,s,function(r,i){var c;switch(i.charAt(0)){case"$":return"$";case"&":return t;case"`":return n.slice(0,e);case"'":return n.slice(a);case"<":c=u[i.slice(1,-1)];break;default:var s=+i;if(0===s)return r;if(s>f){var h=l(s/10);return 0===h?r:h<=f?void 0===o[h-1]?i.charAt(1):o[h-1]+i.charAt(1):r;}c=o[s-1];}return void 0===c?"":c;});}});},function(t,n,r){"use strict";var e=r(3),i=r(94),o=r(54);r(55)("search",1,function(t,n,r,u){return[function(r){var e=t(this),i=null==r?void 0:r[n];return void 0!==i?i.call(r,e):new RegExp(r)[n](String(e));},function(t){var n=u(r,t,this);if(n.done)return n.value;var c=e(t),a=String(this),f=c.lastIndex;i(f,0)||(c.lastIndex=0);var s=o(c,a);return i(c.lastIndex,f)||(c.lastIndex=f),null===s?-1:s.index;}];});},function(t,n,r){"use strict";var e=r(74),i=r(3),o=r(47),u=r(82),c=r(6),a=r(54),f=r(81),s=r(2),l=Math.min,h=[].push,p="length",v=!s(function(){RegExp(4294967295,"y");});r(55)("split",2,function(t,n,r,s){var d;return d="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1)[p]||2!="ab".split(/(?:ab)*/)[p]||4!=".".split(/(.?)(.?)/)[p]||".".split(/()()/)[p]>1||"".split(/.?/)[p]?function(t,n){var i=String(this);if(void 0===t&&0===n)return[];if(!e(t))return r.call(i,t,n);for(var o,u,c,a=[],s=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),l=0,v=void 0===n?4294967295:n>>>0,d=new RegExp(t.source,s+"g");(o=f.call(d,i))&&!((u=d.lastIndex)>l&&(a.push(i.slice(l,o.index)),o[p]>1&&o.index<i[p]&&h.apply(a,o.slice(1)),c=o[0][p],l=u,a[p]>=v));){d.lastIndex===o.index&&d.lastIndex++;}return l===i[p]?!c&&d.test("")||a.push(""):a.push(i.slice(l)),a[p]>v?a.slice(0,v):a;}:"0".split(void 0,0)[p]?function(t,n){return void 0===t&&0===n?[]:r.call(this,t,n);}:r,[function(r,e){var i=t(this),o=null==r?void 0:r[n];return void 0!==o?o.call(r,i,e):d.call(String(i),r,e);},function(t,n){var e=s(d,t,this,n,d!==r);if(e.done)return e.value;var f=i(t),h=String(this),p=o(f,RegExp),y=f.unicode,g=(f.ignoreCase?"i":"")+(f.multiline?"m":"")+(f.unicode?"u":"")+(v?"y":"g"),m=new p(v?f:"^(?:"+f.source+")",g),b=void 0===n?4294967295:n>>>0;if(0===b)return[];if(0===h.length)return null===a(m,h)?[h]:[];for(var x=0,w=0,S=[];w<h.length;){m.lastIndex=v?w:0;var _,E=a(m,v?h:h.slice(w));if(null===E||(_=l(c(m.lastIndex+(v?0:w)),h.length))===x)w=u(h,w,y);else{if(S.push(h.slice(x,w)),S.length===b)return S;for(var O=1;O<=E.length-1;O++){if(S.push(E[O]),S.length===b)return S;}w=x=_;}}return S.push(h.slice(x)),S;}];});},function(t,n,r){var e=r(1),i=r(83).set,o=e.MutationObserver||e.WebKitMutationObserver,u=e.process,c=e.Promise,a="process"==r(23)(u);t.exports=function(){var t,n,r,f=function f(){var e,i;for(a&&(e=u.domain)&&e.exit();t;){i=t.fn,t=t.next;try{i();}catch(e){throw t?r():n=void 0,e;}}n=void 0,e&&e.enter();};if(a)r=function r(){u.nextTick(f);};else if(!o||e.navigator&&e.navigator.standalone){if(c&&c.resolve){var s=c.resolve(void 0);r=function r(){s.then(f);};}else r=function r(){i.call(e,f);};}else{var l=!0,h=document.createTextNode("");new o(f).observe(h,{characterData:!0}),r=function r(){h.data=l=!l;};}return function(e){var i={fn:e,next:void 0};n&&(n.next=i),t||(t=i,r()),n=i;};};},function(t,n){t.exports=function(t){try{return{e:!1,v:t()};}catch(t){return{e:!0,v:t};}};},function(t,n,r){"use strict";var e=r(113),i=r(37);t.exports=r(58)("Map",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0);};},{get:function get(t){var n=e.getEntry(i(this,"Map"),t);return n&&n.v;},set:function set(t,n){return e.def(i(this,"Map"),0===t?0:t,n);}},e,!0);},function(t,n,r){"use strict";var e=r(113),i=r(37);t.exports=r(58)("Set",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0);};},{add:function add(t){return e.def(i(this,"Set"),t=0===t?0:t,t);}},e);},function(t,n,r){"use strict";var e,i=r(1),o=r(22)(0),u=r(11),c=r(27),a=r(93),f=r(114),s=r(4),l=r(37),h=r(37),p=!i.ActiveXObject&&"ActiveXObject"in i,v=c.getWeak,d=Object.isExtensible,y=f.ufstore,g=function g(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0);};},m={get:function get(t){if(s(t)){var n=v(t);return!0===n?y(l(this,"WeakMap")).get(t):n?n[this._i]:void 0;}},set:function set(t,n){return f.def(l(this,"WeakMap"),t,n);}},b=t.exports=r(58)("WeakMap",g,m,f,!0,!0);h&&p&&(a((e=f.getConstructor(g,"WeakMap")).prototype,m),c.NEED=!0,o(["delete","has","get","set"],function(t){var n=b.prototype,r=n[t];u(n,t,function(n,i){if(s(n)&&!d(n)){this._f||(this._f=new e());var o=this._f[t](n,i);return"set"==t?this:o;}return r.call(this,n,i);});}));},function(t,n,r){"use strict";var e=r(114),i=r(37);r(58)("WeakSet",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0);};},{add:function add(t){return e.def(i(this,"WeakSet"),t,!0);}},e,!1,!0);},function(t,n,r){"use strict";var e=r(0),i=r(59),o=r(84),u=r(3),c=r(32),a=r(6),f=r(4),s=r(1).ArrayBuffer,l=r(47),h=o.ArrayBuffer,p=o.DataView,v=i.ABV&&s.isView,d=h.prototype.slice,y=i.VIEW;e(e.G+e.W+e.F*(s!==h),{ArrayBuffer:h}),e(e.S+e.F*!i.CONSTR,"ArrayBuffer",{isView:function isView(t){return v&&v(t)||f(t)&&y in t;}}),e(e.P+e.U+e.F*r(2)(function(){return!new h(2).slice(1,void 0).byteLength;}),"ArrayBuffer",{slice:function slice(t,n){if(void 0!==d&&void 0===n)return d.call(u(this),t);for(var r=u(this).byteLength,e=c(t,r),i=c(void 0===n?r:n,r),o=new(l(this,h))(a(i-e)),f=new p(this),s=new p(o),v=0;e<i;){s.setUint8(v++,f.getUint8(e++));}return o;}}),r(41)("ArrayBuffer");},function(t,n,r){var e=r(0);e(e.G+e.W+e.F*!r(59).ABV,{DataView:r(84).DataView});},function(t,n,r){r(25)("Int8",1,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Uint8",1,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Uint8",1,function(t){return function(n,r,e){return t(this,n,r,e);};},!0);},function(t,n,r){r(25)("Int16",2,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Uint16",2,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Int32",4,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Uint32",4,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Float32",4,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){r(25)("Float64",8,function(t){return function(n,r,e){return t(this,n,r,e);};});},function(t,n,r){var e=r(0),i=r(18),o=r(3),u=(r(1).Reflect||{}).apply,c=Function.apply;e(e.S+e.F*!r(2)(function(){u(function(){});}),"Reflect",{apply:function apply(t,n,r){var e=i(t),a=o(r);return u?u(e,n,a):c.call(e,n,a);}});},function(t,n,r){var e=r(0),i=r(33),o=r(18),u=r(3),c=r(4),a=r(2),f=r(95),s=(r(1).Reflect||{}).construct,l=a(function(){function t(){}return!(s(function(){},[],t)instanceof t);}),h=!a(function(){s(function(){});});e(e.S+e.F*(l||h),"Reflect",{construct:function construct(t,n){o(t),u(n);var r=arguments.length<3?t:o(arguments[2]);if(h&&!l)return s(t,n,r);if(t==r){switch(n.length){case 0:return new t();case 1:return new t(n[0]);case 2:return new t(n[0],n[1]);case 3:return new t(n[0],n[1],n[2]);case 4:return new t(n[0],n[1],n[2],n[3]);}var e=[null];return e.push.apply(e,n),new(f.apply(t,e))();}var a=r.prototype,p=i(c(a)?a:Object.prototype),v=Function.apply.call(t,p,n);return c(v)?v:p;}});},function(t,n,r){var e=r(9),i=r(0),o=r(3),u=r(26);i(i.S+i.F*r(2)(function(){Reflect.defineProperty(e.f({},1,{value:1}),1,{value:2});}),"Reflect",{defineProperty:function defineProperty(t,n,r){o(t),n=u(n,!0),o(r);try{return e.f(t,n,r),!0;}catch(t){return!1;}}});},function(t,n,r){var e=r(0),i=r(20).f,o=r(3);e(e.S,"Reflect",{deleteProperty:function deleteProperty(t,n){var r=i(o(t),n);return!(r&&!r.configurable)&&delete t[n];}});},function(t,n,r){"use strict";var e=r(0),i=r(3),o=function o(t){this._t=i(t),this._i=0;var n,r=this._k=[];for(n in t){r.push(n);}};r(102)(o,"Object",function(){var t,n=this._k;do{if(this._i>=n.length)return{value:void 0,done:!0};}while(!((t=n[this._i++])in this._t));return{value:t,done:!1};}),e(e.S,"Reflect",{enumerate:function enumerate(t){return new o(t);}});},function(t,n,r){var e=r(20),i=r(35),o=r(13),u=r(0),c=r(4),a=r(3);u(u.S,"Reflect",{get:function t(n,r){var u,f,s=arguments.length<3?n:arguments[2];return a(n)===s?n[r]:(u=e.f(n,r))?o(u,"value")?u.value:void 0!==u.get?u.get.call(s):void 0:c(f=i(n))?t(f,r,s):void 0;}});},function(t,n,r){var e=r(20),i=r(0),o=r(3);i(i.S,"Reflect",{getOwnPropertyDescriptor:function getOwnPropertyDescriptor(t,n){return e.f(o(t),n);}});},function(t,n,r){var e=r(0),i=r(35),o=r(3);e(e.S,"Reflect",{getPrototypeOf:function getPrototypeOf(t){return i(o(t));}});},function(t,n,r){var e=r(0);e(e.S,"Reflect",{has:function has(t,n){return n in t;}});},function(t,n,r){var e=r(0),i=r(3),o=Object.isExtensible;e(e.S,"Reflect",{isExtensible:function isExtensible(t){return i(t),!o||o(t);}});},function(t,n,r){var e=r(0);e(e.S,"Reflect",{ownKeys:r(116)});},function(t,n,r){var e=r(0),i=r(3),o=Object.preventExtensions;e(e.S,"Reflect",{preventExtensions:function preventExtensions(t){i(t);try{return o&&o(t),!0;}catch(t){return!1;}}});},function(t,n,r){var e=r(9),i=r(20),o=r(35),u=r(13),c=r(0),a=r(28),f=r(3),s=r(4);c(c.S,"Reflect",{set:function t(n,r,c){var l,h,p=arguments.length<4?n:arguments[3],v=i.f(f(n),r);if(!v){if(s(h=o(n)))return t(h,r,c,p);v=a(0);}if(u(v,"value")){if(!1===v.writable||!s(p))return!1;if(l=i.f(p,r)){if(l.get||l.set||!1===l.writable)return!1;l.value=c,e.f(p,r,l);}else e.f(p,r,a(0,c));return!0;}return void 0!==v.set&&(v.set.call(p,c),!0);}});},function(t,n,r){var e=r(0),i=r(65);i&&e(e.S,"Reflect",{setPrototypeOf:function setPrototypeOf(t,n){i.check(t,n);try{return i.set(t,n),!0;}catch(t){return!1;}}});},function(t,n,r){r(277),t.exports=r(7).Array.includes;},function(t,n,r){"use strict";var e=r(0),i=r(49)(!0);e(e.P,"Array",{includes:function includes(t){return i(this,t,arguments.length>1?arguments[1]:void 0);}}),r(36)("includes");},function(t,n,r){r(279),t.exports=r(7).Array.flatMap;},function(t,n,r){"use strict";var e=r(0),i=r(280),o=r(10),u=r(6),c=r(18),a=r(104);e(e.P,"Array",{flatMap:function flatMap(t){var n,r,e=o(this);return c(t),n=u(e.length),r=a(e,0),i(r,e,e,n,0,1,t,arguments[1]),r;}}),r(36)("flatMap");},function(t,n,r){"use strict";var e=r(51),i=r(4),o=r(6),u=r(17),c=r(5)("isConcatSpreadable");t.exports=function t(n,r,a,f,s,l,h,p){for(var v,d,y=s,g=0,m=!!h&&u(h,p,3);g<f;){if(g in a){if(v=m?m(a[g],g,r):a[g],d=!1,i(v)&&(d=void 0!==(d=v[c])?!!d:e(v)),d&&l>0)y=t(n,r,v,o(v.length),y,l-1)-1;else{if(y>=9007199254740991)throw TypeError();n[y]=v;}y++;}g++;}return y;};},function(t,n,r){r(282),t.exports=r(7).String.padStart;},function(t,n,r){"use strict";var e=r(0),i=r(117),o=r(57),u=/Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);e(e.P+e.F*u,"String",{padStart:function padStart(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!0);}});},function(t,n,r){r(284),t.exports=r(7).String.padEnd;},function(t,n,r){"use strict";var e=r(0),i=r(117),o=r(57),u=/Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);e(e.P+e.F*u,"String",{padEnd:function padEnd(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!1);}});},function(t,n,r){r(286),t.exports=r(7).String.trimLeft;},function(t,n,r){"use strict";r(39)("trimLeft",function(t){return function(){return t(this,1);};},"trimStart");},function(t,n,r){r(288),t.exports=r(7).String.trimRight;},function(t,n,r){"use strict";r(39)("trimRight",function(t){return function(){return t(this,2);};},"trimEnd");},function(t,n,r){r(290),t.exports=r(61).f("asyncIterator");},function(t,n,r){r(89)("asyncIterator");},function(t,n,r){r(292),t.exports=r(7).Object.getOwnPropertyDescriptors;},function(t,n,r){var e=r(0),i=r(116),o=r(15),u=r(20),c=r(77);e(e.S,"Object",{getOwnPropertyDescriptors:function getOwnPropertyDescriptors(t){for(var n,r,e=o(t),a=u.f,f=i(e),s={},l=0;f.length>l;){void 0!==(r=a(e,n=f[l++]))&&c(s,n,r);}return s;}});},function(t,n,r){r(294),t.exports=r(7).Object.values;},function(t,n,r){var e=r(0),i=r(118)(!1);e(e.S,"Object",{values:function values(t){return i(t);}});},function(t,n,r){r(296),t.exports=r(7).Object.entries;},function(t,n,r){var e=r(0),i=r(118)(!0);e(e.S,"Object",{entries:function entries(t){return i(t);}});},function(t,n,r){"use strict";r(110),r(298),t.exports=r(7).Promise.finally;},function(t,n,r){"use strict";var e=r(0),i=r(7),o=r(1),u=r(47),c=r(112);e(e.P+e.R,"Promise",{finally:function _finally(t){var n=u(this,i.Promise||o.Promise),r="function"==typeof t;return this.then(r?function(r){return c(n,t()).then(function(){return r;});}:t,r?function(r){return c(n,t()).then(function(){throw r;});}:t);}});},function(t,n,r){r(300),r(301),r(302),t.exports=r(7);},function(t,n,r){var e=r(1),i=r(0),o=r(57),u=[].slice,c=/MSIE .\./.test(o),a=function a(t){return function(n,r){var e=arguments.length>2,i=!!e&&u.call(arguments,2);return t(e?function(){("function"==typeof n?n:Function(n)).apply(this,i);}:n,r);};};i(i.G+i.B+i.F*c,{setTimeout:a(e.setTimeout),setInterval:a(e.setInterval)});},function(t,n,r){var e=r(0),i=r(83);e(e.G+e.B,{setImmediate:i.set,clearImmediate:i.clear});},function(t,n,r){for(var e=r(80),i=r(31),o=r(11),u=r(1),c=r(14),a=r(40),f=r(5),s=f("iterator"),l=f("toStringTag"),h=a.Array,p={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},v=i(p),d=0;d<v.length;d++){var y,g=v[d],m=p[g],b=u[g],x=b&&b.prototype;if(x&&(x[s]||c(x,s,h),x[l]||c(x,l,g),a[g]=h,m))for(y in e){x[y]||o(x,y,e[y],!0);}}},function(t,n,r){var e=function(t){"use strict";var n=Object.prototype,r=n.hasOwnProperty,e="function"==typeof Symbol?Symbol:{},i=e.iterator||"@@iterator",o=e.asyncIterator||"@@asyncIterator",u=e.toStringTag||"@@toStringTag";function c(t,n,r){return Object.defineProperty(t,n,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[n];}try{c({},"");}catch(t){c=function c(t,n,r){return t[n]=r;};}function a(t,n,r,e){var i=n&&n.prototype instanceof l?n:l,o=Object.create(i.prototype),u=new _(e||[]);return o._invoke=function(t,n,r){var e="suspendedStart";return function(i,o){if("executing"===e)throw new Error("Generator is already running");if("completed"===e){if("throw"===i)throw o;return O();}for(r.method=i,r.arg=o;;){var u=r.delegate;if(u){var c=x(u,r);if(c){if(c===s)continue;return c;}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===e)throw e="completed",r.arg;r.dispatchException(r.arg);}else"return"===r.method&&r.abrupt("return",r.arg);e="executing";var a=f(t,n,r);if("normal"===a.type){if(e=r.done?"completed":"suspendedYield",a.arg===s)continue;return{value:a.arg,done:r.done};}"throw"===a.type&&(e="completed",r.method="throw",r.arg=a.arg);}};}(t,r,u),o;}function f(t,n,r){try{return{type:"normal",arg:t.call(n,r)};}catch(t){return{type:"throw",arg:t};}}t.wrap=a;var s={};function l(){}function h(){}function p(){}var v={};c(v,i,function(){return this;});var d=Object.getPrototypeOf,y=d&&d(d(E([])));y&&y!==n&&r.call(y,i)&&(v=y);var g=p.prototype=l.prototype=Object.create(v);function m(t){["next","throw","return"].forEach(function(n){c(t,n,function(t){return this._invoke(n,t);});});}function b(t,n){var e;this._invoke=function(i,o){function u(){return new n(function(e,u){!function e(i,o,u,c){var a=f(t[i],t,o);if("throw"!==a.type){var s=a.arg,l=s.value;return l&&"object"==_typeof(l)&&r.call(l,"__await")?n.resolve(l.__await).then(function(t){e("next",t,u,c);},function(t){e("throw",t,u,c);}):n.resolve(l).then(function(t){s.value=t,u(s);},function(t){return e("throw",t,u,c);});}c(a.arg);}(i,o,e,u);});}return e=e?e.then(u,u):u();};}function x(t,n){var r=t.iterator[n.method];if(void 0===r){if(n.delegate=null,"throw"===n.method){if(t.iterator.return&&(n.method="return",n.arg=void 0,x(t,n),"throw"===n.method))return s;n.method="throw",n.arg=new TypeError("The iterator does not provide a 'throw' method");}return s;}var e=f(r,t.iterator,n.arg);if("throw"===e.type)return n.method="throw",n.arg=e.arg,n.delegate=null,s;var i=e.arg;return i?i.done?(n[t.resultName]=i.value,n.next=t.nextLoc,"return"!==n.method&&(n.method="next",n.arg=void 0),n.delegate=null,s):i:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,s);}function w(t){var n={tryLoc:t[0]};1 in t&&(n.catchLoc=t[1]),2 in t&&(n.finallyLoc=t[2],n.afterLoc=t[3]),this.tryEntries.push(n);}function S(t){var n=t.completion||{};n.type="normal",delete n.arg,t.completion=n;}function _(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(w,this),this.reset(!0);}function E(t){if(t){var n=t[i];if(n)return n.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var e=-1,o=function n(){for(;++e<t.length;){if(r.call(t,e))return n.value=t[e],n.done=!1,n;}return n.value=void 0,n.done=!0,n;};return o.next=o;}}return{next:O};}function O(){return{value:void 0,done:!0};}return h.prototype=p,c(g,"constructor",p),c(p,"constructor",h),h.displayName=c(p,u,"GeneratorFunction"),t.isGeneratorFunction=function(t){var n="function"==typeof t&&t.constructor;return!!n&&(n===h||"GeneratorFunction"===(n.displayName||n.name));},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,u,"GeneratorFunction")),t.prototype=Object.create(g),t;},t.awrap=function(t){return{__await:t};},m(b.prototype),c(b.prototype,o,function(){return this;}),t.AsyncIterator=b,t.async=function(n,r,e,i,o){void 0===o&&(o=Promise);var u=new b(a(n,r,e,i),o);return t.isGeneratorFunction(r)?u:u.next().then(function(t){return t.done?t.value:u.next();});},m(g),c(g,u,"Generator"),c(g,i,function(){return this;}),c(g,"toString",function(){return"[object Generator]";}),t.keys=function(t){var n=[];for(var r in t){n.push(r);}return n.reverse(),function r(){for(;n.length;){var e=n.pop();if(e in t)return r.value=e,r.done=!1,r;}return r.done=!0,r;};},t.values=E,_.prototype={constructor:_,reset:function reset(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(S),!t)for(var n in this){"t"===n.charAt(0)&&r.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=void 0);}},stop:function stop(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval;},dispatchException:function dispatchException(t){if(this.done)throw t;var n=this;function e(r,e){return u.type="throw",u.arg=t,n.next=r,e&&(n.method="next",n.arg=void 0),!!e;}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],u=o.completion;if("root"===o.tryLoc)return e("end");if(o.tryLoc<=this.prev){var c=r.call(o,"catchLoc"),a=r.call(o,"finallyLoc");if(c&&a){if(this.prev<o.catchLoc)return e(o.catchLoc,!0);if(this.prev<o.finallyLoc)return e(o.finallyLoc);}else if(c){if(this.prev<o.catchLoc)return e(o.catchLoc,!0);}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return e(o.finallyLoc);}}}},abrupt:function abrupt(t,n){for(var e=this.tryEntries.length-1;e>=0;--e){var i=this.tryEntries[e];if(i.tryLoc<=this.prev&&r.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break;}}o&&("break"===t||"continue"===t)&&o.tryLoc<=n&&n<=o.finallyLoc&&(o=null);var u=o?o.completion:{};return u.type=t,u.arg=n,o?(this.method="next",this.next=o.finallyLoc,s):this.complete(u);},complete:function complete(t,n){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&n&&(this.next=n),s;},finish:function finish(t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),S(r),s;}},catch:function _catch(t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc===t){var e=r.completion;if("throw"===e.type){var i=e.arg;S(r);}return i;}}throw new Error("illegal catch attempt");},delegateYield:function delegateYield(t,n,r){return this.delegate={iterator:E(t),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=void 0),s;}},t;}(t.exports);try{regeneratorRuntime=e;}catch(t){"object"==(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))?globalThis.regeneratorRuntime=e:Function("r","regeneratorRuntime = r")(e);}},function(t,n,r){r(305),t.exports=r(119).global;},function(t,n,r){var e=r(306);e(e.G,{global:r(85)});},function(t,n,r){var e=r(85),i=r(119),o=r(307),u=r(309),c=r(316),a=function a(t,n,r){var f,s,l,h=t&a.F,p=t&a.G,v=t&a.S,d=t&a.P,y=t&a.B,g=t&a.W,m=p?i:i[n]||(i[n]={}),b=m.prototype,x=p?e:v?e[n]:(e[n]||{}).prototype;for(f in p&&(r=n),r){(s=!h&&x&&void 0!==x[f])&&c(m,f)||(l=s?x[f]:r[f],m[f]=p&&"function"!=typeof x[f]?r[f]:y&&s?o(l,e):g&&x[f]==l?function(t){var n=function n(_n3,r,e){if(this instanceof t){switch(arguments.length){case 0:return new t();case 1:return new t(_n3);case 2:return new t(_n3,r);}return new t(_n3,r,e);}return t.apply(this,arguments);};return n.prototype=t.prototype,n;}(l):d&&"function"==typeof l?o(Function.call,l):l,d&&((m.virtual||(m.virtual={}))[f]=l,t&a.R&&b&&!b[f]&&u(b,f,l)));}};a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a;},function(t,n,r){var e=r(308);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r);};case 2:return function(r,e){return t.call(n,r,e);};case 3:return function(r,e,i){return t.call(n,r,e,i);};}return function(){return t.apply(n,arguments);};};},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t;};},function(t,n,r){var e=r(310),i=r(315);t.exports=r(87)?function(t,n,r){return e.f(t,n,i(1,r));}:function(t,n,r){return t[n]=r,t;};},function(t,n,r){var e=r(311),i=r(312),o=r(314),u=Object.defineProperty;n.f=r(87)?Object.defineProperty:function(t,n,r){if(e(t),n=o(n,!0),e(r),i)try{return u(t,n,r);}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t;};},function(t,n,r){var e=r(86);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t;};},function(t,n,r){t.exports=!r(87)&&!r(120)(function(){return 7!=Object.defineProperty(r(313)("div"),"a",{get:function get(){return 7;}}).a;});},function(t,n,r){var e=r(86),i=r(85).document,o=e(i)&&e(i.createElement);t.exports=function(t){return o?i.createElement(t):{};};},function(t,n,r){var e=r(86);t.exports=function(t,n){if(!e(t))return t;var r,i;if(n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;if("function"==typeof(r=t.valueOf)&&!e(i=r.call(t)))return i;if(!n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;throw TypeError("Can't convert object to primitive value");};},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n};};},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n);};},function(t,n,r){var e={"./AcrGallery/AcrGallery":[121,9,1,2],"./AcrGallery/AcrGallery.ts":[121,9,1,2],"./AcrMLPNav/AcrMLPNav":[123,9,3],"./AcrMLPNav/AcrMLPNav.test":[122,7,8],"./AcrMLPNav/AcrMLPNav.test.ts":[122,7,8],"./AcrMLPNav/AcrMLPNav.ts":[123,9,3],"./AcrMultiColumn/AcrMultiColumn":[125,9,0,4],"./AcrMultiColumn/AcrMultiColumn.test":[124,7,9],"./AcrMultiColumn/AcrMultiColumn.test.ts":[124,7,9],"./AcrMultiColumn/AcrMultiColumn.ts":[125,9,0,4],"./AcrPackageDetail/AcrPackageDetail":[126,9,0,6],"./AcrPackageDetail/AcrPackageDetail.ts":[126,9,0,6],"./AcrStepSlider/AcrStepSlider":[128,9,0,7],"./AcrStepSlider/AcrStepSlider.test":[127,7,10],"./AcrStepSlider/AcrStepSlider.test.ts":[127,7,10],"./AcrStepSlider/AcrStepSlider.ts":[128,9,0,7],"./AcrTab/AcrTab":[129,9,0,5],"./AcrTab/AcrTab.ts":[129,9,0,5]};function i(t){if(!r.o(e,t))return Promise.resolve().then(function(){var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n;});var n=e[t],i=n[0];return Promise.all(n.slice(2).map(r.e)).then(function(){return r.t(i,n[1]);});}i.keys=function(){return Object.keys(e);},i.id=317,t.exports=i;}]);
"use strict";

var Main = function () {
  console.log('Main.js loaded');
  var Utility = window.Utility || {};
  var Acr = window.Acr || {}; // Zipgate components

  var zipgateElement = document.getElementsByClassName('js-zipgate')[0];

  if (zipgateElement) {
    Acr.zipgateComponent = new Acr.Zipgate();
    Acr.zipgateComponent.init(zipgateElement);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Utility.log('DOMContentLoaded event fired'); // Global Modules

    Acr.LazyLoadingHelper.init();
    Acr.Disclaimer.init();
    Acr.DeferLoadingHelper.init(); // New module Manager

    initializeModules(); // Deprecated: call modules in this way is deprecated

    SlickOverride.init();
    Utility.enableActive();
    Utility.focusDisable();
    Utility.focusEnable();
    Acr.YouTubeManager.init();
    Acr.CampaignManager.init();
    SelectBox.init();
    Acr.DeepLinking.init();
    ResponsiveBackground.init();
    Validation.init();
    Gallery.init();
    PackagesSlider.init();
    Modals.init();
    Chart.init();
    FeatureModal.init();
    GalleryModal.init();
    Acr.boxParallax.init();
    Acr.SignUpForEmails.init();
    ButtonLine.init();
    FSB.init();
    SubHeroPage.init();
    ImageChanger.init();
    Grid.init();
    StyleGuide.init();
    MultiCol.init();
    TextSVGTiles.init();
    GrayAllFeaturesPanel.init();
    GrayContentPanelType3.init();
    GrayMultiTabNavContainer.init();
    GrayBgImageScaler.init();
    PressReleases.init();
    ToutThree.init();
    SearchCTA.init();
    RichTextTableResponsive.init();
    RaqTool.initForms();
    RaqTool.initDealerInfo();
    RaqTool.initDisclaimers();
    OffersTool.init();
    FormEmailSignup.init();
    DealerLocatorTool.init();
    CompareTool.init();
    PeTool.initPe();
    EmailPreferenceCenter.init();
    RequestBrochure.init();
    EmailSubscription.init();
    Acr.LanguageSelector.init();
  }); // Expose the following variables and functions

  return {};
}();